function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebd6a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebd6a"] = parcelRequire;
}
parcelRequire.register("gPLhR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $c4161701ab7821df$export$ffb0004e005737fa, (v) => $c4161701ab7821df$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $c4161701ab7821df$export$34b9dba7ce09269b, (v) => $c4161701ab7821df$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $c4161701ab7821df$export$25062201e9e25d76, (v) => $c4161701ab7821df$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c4161701ab7821df$export$ffb0004e005737fa;
var $c4161701ab7821df$export$34b9dba7ce09269b;
var $c4161701ab7821df$export$25062201e9e25d76;
"use strict";

var $7Pt2h = parcelRequire("7Pt2h");
var $c4161701ab7821df$var$k = Symbol.for("react.element"), $c4161701ab7821df$var$l = Symbol.for("react.fragment"), $c4161701ab7821df$var$m = Object.prototype.hasOwnProperty, $c4161701ab7821df$var$n = $7Pt2h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c4161701ab7821df$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c4161701ab7821df$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c4161701ab7821df$var$m.call(a, b) && !$c4161701ab7821df$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c4161701ab7821df$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c4161701ab7821df$var$n.current
    };
}
$c4161701ab7821df$export$ffb0004e005737fa = $c4161701ab7821df$var$l;
$c4161701ab7821df$export$34b9dba7ce09269b = $c4161701ab7821df$var$q;
$c4161701ab7821df$export$25062201e9e25d76 = $c4161701ab7821df$var$q;

});
parcelRequire.register("7Pt2h", function(module, exports) {
"use strict";

module.exports = (parcelRequire("g5GV9"));

});
parcelRequire.register("g5GV9", function(module, exports) {

$parcel$export(module.exports, "Children", () => $bb6e6823f0ba3b0b$export$dca3b0875bd9a954, (v) => $bb6e6823f0ba3b0b$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $bb6e6823f0ba3b0b$export$16fa2f45be04daa8, (v) => $bb6e6823f0ba3b0b$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $bb6e6823f0ba3b0b$export$ffb0004e005737fa, (v) => $bb6e6823f0ba3b0b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $bb6e6823f0ba3b0b$export$e2c29f18771995cb, (v) => $bb6e6823f0ba3b0b$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $bb6e6823f0ba3b0b$export$221d75b3f55bb0bd, (v) => $bb6e6823f0ba3b0b$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $bb6e6823f0ba3b0b$export$5f8d39834fd61797, (v) => $bb6e6823f0ba3b0b$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bb6e6823f0ba3b0b$export$74bf444e3cd11ea5, (v) => $bb6e6823f0ba3b0b$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $bb6e6823f0ba3b0b$export$ae55be85d98224ed, (v) => $bb6e6823f0ba3b0b$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $bb6e6823f0ba3b0b$export$e530037191fcd5d7, (v) => $bb6e6823f0ba3b0b$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $bb6e6823f0ba3b0b$export$fd42f52fd3ae1109, (v) => $bb6e6823f0ba3b0b$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $bb6e6823f0ba3b0b$export$c8a8987d4410bf2d, (v) => $bb6e6823f0ba3b0b$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $bb6e6823f0ba3b0b$export$d38cd72104c1f0e9, (v) => $bb6e6823f0ba3b0b$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $bb6e6823f0ba3b0b$export$7d1e3a5e95ceca43, (v) => $bb6e6823f0ba3b0b$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $bb6e6823f0ba3b0b$export$257a8862b851cb5b, (v) => $bb6e6823f0ba3b0b$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $bb6e6823f0ba3b0b$export$a8257692ac88316c, (v) => $bb6e6823f0ba3b0b$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $bb6e6823f0ba3b0b$export$488013bae63b21da, (v) => $bb6e6823f0ba3b0b$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $bb6e6823f0ba3b0b$export$7c73462e0d25e514, (v) => $bb6e6823f0ba3b0b$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $bb6e6823f0ba3b0b$export$7568632d0d33d16d, (v) => $bb6e6823f0ba3b0b$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $bb6e6823f0ba3b0b$export$88948ce120ea2619, (v) => $bb6e6823f0ba3b0b$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $bb6e6823f0ba3b0b$export$35808ee640e87ca7, (v) => $bb6e6823f0ba3b0b$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $bb6e6823f0ba3b0b$export$fae74005e78b1a27, (v) => $bb6e6823f0ba3b0b$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $bb6e6823f0ba3b0b$export$dc8fbce3eb94dc1e, (v) => $bb6e6823f0ba3b0b$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $bb6e6823f0ba3b0b$export$6a7bc4e911dc01cf, (v) => $bb6e6823f0ba3b0b$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $bb6e6823f0ba3b0b$export$6d9c69b0de29b591, (v) => $bb6e6823f0ba3b0b$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $bb6e6823f0ba3b0b$export$f680877a34711e37, (v) => $bb6e6823f0ba3b0b$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $bb6e6823f0ba3b0b$export$d5a552a76deda3c2, (v) => $bb6e6823f0ba3b0b$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $bb6e6823f0ba3b0b$export$aaabe4eda9ed9969, (v) => $bb6e6823f0ba3b0b$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $bb6e6823f0ba3b0b$export$e5c5a5f917a5871c, (v) => $bb6e6823f0ba3b0b$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $bb6e6823f0ba3b0b$export$1538c33de8887b59, (v) => $bb6e6823f0ba3b0b$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $bb6e6823f0ba3b0b$export$13e3392192263954, (v) => $bb6e6823f0ba3b0b$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $bb6e6823f0ba3b0b$export$b8f5890fc79d6aca, (v) => $bb6e6823f0ba3b0b$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $bb6e6823f0ba3b0b$export$60241385465d0a34, (v) => $bb6e6823f0ba3b0b$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $bb6e6823f0ba3b0b$export$306c0aa65ff9ec16, (v) => $bb6e6823f0ba3b0b$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $bb6e6823f0ba3b0b$export$7b286972b8d8ccbf, (v) => $bb6e6823f0ba3b0b$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $bb6e6823f0ba3b0b$export$83d89fbfd8236492, (v) => $bb6e6823f0ba3b0b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb6e6823f0ba3b0b$export$dca3b0875bd9a954;
var $bb6e6823f0ba3b0b$export$16fa2f45be04daa8;
var $bb6e6823f0ba3b0b$export$ffb0004e005737fa;
var $bb6e6823f0ba3b0b$export$e2c29f18771995cb;
var $bb6e6823f0ba3b0b$export$221d75b3f55bb0bd;
var $bb6e6823f0ba3b0b$export$5f8d39834fd61797;
var $bb6e6823f0ba3b0b$export$74bf444e3cd11ea5;
var $bb6e6823f0ba3b0b$export$ae55be85d98224ed;
var $bb6e6823f0ba3b0b$export$e530037191fcd5d7;
var $bb6e6823f0ba3b0b$export$fd42f52fd3ae1109;
var $bb6e6823f0ba3b0b$export$c8a8987d4410bf2d;
var $bb6e6823f0ba3b0b$export$d38cd72104c1f0e9;
var $bb6e6823f0ba3b0b$export$7d1e3a5e95ceca43;
var $bb6e6823f0ba3b0b$export$257a8862b851cb5b;
var $bb6e6823f0ba3b0b$export$a8257692ac88316c;
var $bb6e6823f0ba3b0b$export$488013bae63b21da;
var $bb6e6823f0ba3b0b$export$7c73462e0d25e514;
var $bb6e6823f0ba3b0b$export$7568632d0d33d16d;
var $bb6e6823f0ba3b0b$export$88948ce120ea2619;
var $bb6e6823f0ba3b0b$export$35808ee640e87ca7;
var $bb6e6823f0ba3b0b$export$fae74005e78b1a27;
var $bb6e6823f0ba3b0b$export$dc8fbce3eb94dc1e;
var $bb6e6823f0ba3b0b$export$6a7bc4e911dc01cf;
var $bb6e6823f0ba3b0b$export$6d9c69b0de29b591;
var $bb6e6823f0ba3b0b$export$f680877a34711e37;
var $bb6e6823f0ba3b0b$export$d5a552a76deda3c2;
var $bb6e6823f0ba3b0b$export$aaabe4eda9ed9969;
var $bb6e6823f0ba3b0b$export$e5c5a5f917a5871c;
var $bb6e6823f0ba3b0b$export$1538c33de8887b59;
var $bb6e6823f0ba3b0b$export$13e3392192263954;
var $bb6e6823f0ba3b0b$export$b8f5890fc79d6aca;
var $bb6e6823f0ba3b0b$export$60241385465d0a34;
var $bb6e6823f0ba3b0b$export$306c0aa65ff9ec16;
var $bb6e6823f0ba3b0b$export$7b286972b8d8ccbf;
var $bb6e6823f0ba3b0b$export$83d89fbfd8236492;
"use strict";
var $bb6e6823f0ba3b0b$var$l = Symbol.for("react.element"), $bb6e6823f0ba3b0b$var$n = Symbol.for("react.portal"), $bb6e6823f0ba3b0b$var$p = Symbol.for("react.fragment"), $bb6e6823f0ba3b0b$var$q = Symbol.for("react.strict_mode"), $bb6e6823f0ba3b0b$var$r = Symbol.for("react.profiler"), $bb6e6823f0ba3b0b$var$t = Symbol.for("react.provider"), $bb6e6823f0ba3b0b$var$u = Symbol.for("react.context"), $bb6e6823f0ba3b0b$var$v = Symbol.for("react.forward_ref"), $bb6e6823f0ba3b0b$var$w = Symbol.for("react.suspense"), $bb6e6823f0ba3b0b$var$x = Symbol.for("react.memo"), $bb6e6823f0ba3b0b$var$y = Symbol.for("react.lazy"), $bb6e6823f0ba3b0b$var$z = Symbol.iterator;
function $bb6e6823f0ba3b0b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bb6e6823f0ba3b0b$var$z && a[$bb6e6823f0ba3b0b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bb6e6823f0ba3b0b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bb6e6823f0ba3b0b$var$C = Object.assign, $bb6e6823f0ba3b0b$var$D = {};
function $bb6e6823f0ba3b0b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb6e6823f0ba3b0b$var$D;
    this.updater = e || $bb6e6823f0ba3b0b$var$B;
}
$bb6e6823f0ba3b0b$var$E.prototype.isReactComponent = {};
$bb6e6823f0ba3b0b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bb6e6823f0ba3b0b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bb6e6823f0ba3b0b$var$F() {}
$bb6e6823f0ba3b0b$var$F.prototype = $bb6e6823f0ba3b0b$var$E.prototype;
function $bb6e6823f0ba3b0b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb6e6823f0ba3b0b$var$D;
    this.updater = e || $bb6e6823f0ba3b0b$var$B;
}
var $bb6e6823f0ba3b0b$var$H = $bb6e6823f0ba3b0b$var$G.prototype = new $bb6e6823f0ba3b0b$var$F;
$bb6e6823f0ba3b0b$var$H.constructor = $bb6e6823f0ba3b0b$var$G;
$bb6e6823f0ba3b0b$var$C($bb6e6823f0ba3b0b$var$H, $bb6e6823f0ba3b0b$var$E.prototype);
$bb6e6823f0ba3b0b$var$H.isPureReactComponent = !0;
var $bb6e6823f0ba3b0b$var$I = Array.isArray, $bb6e6823f0ba3b0b$var$J = Object.prototype.hasOwnProperty, $bb6e6823f0ba3b0b$var$K = {
    current: null
}, $bb6e6823f0ba3b0b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bb6e6823f0ba3b0b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bb6e6823f0ba3b0b$var$J.call(b, d) && !$bb6e6823f0ba3b0b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $bb6e6823f0ba3b0b$var$K.current
    };
}
function $bb6e6823f0ba3b0b$var$N(a, b) {
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bb6e6823f0ba3b0b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb6e6823f0ba3b0b$var$l;
}
function $bb6e6823f0ba3b0b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bb6e6823f0ba3b0b$var$P = /\/+/g;
function $bb6e6823f0ba3b0b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bb6e6823f0ba3b0b$var$escape("" + a.key) : b.toString(36);
}
function $bb6e6823f0ba3b0b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bb6e6823f0ba3b0b$var$l:
                case $bb6e6823f0ba3b0b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $bb6e6823f0ba3b0b$var$Q(h, 0) : d, $bb6e6823f0ba3b0b$var$I(c) ? (e = "", null != a && (e = a.replace($bb6e6823f0ba3b0b$var$P, "$&/") + "/"), $bb6e6823f0ba3b0b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($bb6e6823f0ba3b0b$var$O(c) && (c = $bb6e6823f0ba3b0b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($bb6e6823f0ba3b0b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($bb6e6823f0ba3b0b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $bb6e6823f0ba3b0b$var$Q(k, g);
        h += $bb6e6823f0ba3b0b$var$R(k, b, e, f, c);
    }
    else if (f = $bb6e6823f0ba3b0b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $bb6e6823f0ba3b0b$var$Q(k, g++), h += $bb6e6823f0ba3b0b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $bb6e6823f0ba3b0b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $bb6e6823f0ba3b0b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $bb6e6823f0ba3b0b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $bb6e6823f0ba3b0b$var$U = {
    current: null
}, $bb6e6823f0ba3b0b$var$V = {
    transition: null
}, $bb6e6823f0ba3b0b$var$W = {
    ReactCurrentDispatcher: $bb6e6823f0ba3b0b$var$U,
    ReactCurrentBatchConfig: $bb6e6823f0ba3b0b$var$V,
    ReactCurrentOwner: $bb6e6823f0ba3b0b$var$K
};
$bb6e6823f0ba3b0b$export$dca3b0875bd9a954 = {
    map: $bb6e6823f0ba3b0b$var$S,
    forEach: function(a, b, e) {
        $bb6e6823f0ba3b0b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $bb6e6823f0ba3b0b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bb6e6823f0ba3b0b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bb6e6823f0ba3b0b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$bb6e6823f0ba3b0b$export$16fa2f45be04daa8 = $bb6e6823f0ba3b0b$var$E;
$bb6e6823f0ba3b0b$export$ffb0004e005737fa = $bb6e6823f0ba3b0b$var$p;
$bb6e6823f0ba3b0b$export$e2c29f18771995cb = $bb6e6823f0ba3b0b$var$r;
$bb6e6823f0ba3b0b$export$221d75b3f55bb0bd = $bb6e6823f0ba3b0b$var$G;
$bb6e6823f0ba3b0b$export$5f8d39834fd61797 = $bb6e6823f0ba3b0b$var$q;
$bb6e6823f0ba3b0b$export$74bf444e3cd11ea5 = $bb6e6823f0ba3b0b$var$w;
$bb6e6823f0ba3b0b$export$ae55be85d98224ed = $bb6e6823f0ba3b0b$var$W;
$bb6e6823f0ba3b0b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $bb6e6823f0ba3b0b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bb6e6823f0ba3b0b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bb6e6823f0ba3b0b$var$J.call(b, f) && !$bb6e6823f0ba3b0b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$bb6e6823f0ba3b0b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $bb6e6823f0ba3b0b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $bb6e6823f0ba3b0b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$bb6e6823f0ba3b0b$export$c8a8987d4410bf2d = $bb6e6823f0ba3b0b$var$M;
$bb6e6823f0ba3b0b$export$d38cd72104c1f0e9 = function(a) {
    var b = $bb6e6823f0ba3b0b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bb6e6823f0ba3b0b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bb6e6823f0ba3b0b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$v,
        render: a
    };
};
$bb6e6823f0ba3b0b$export$a8257692ac88316c = $bb6e6823f0ba3b0b$var$O;
$bb6e6823f0ba3b0b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bb6e6823f0ba3b0b$var$T
    };
};
$bb6e6823f0ba3b0b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bb6e6823f0ba3b0b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bb6e6823f0ba3b0b$export$7568632d0d33d16d = function(a) {
    var b = $bb6e6823f0ba3b0b$var$V.transition;
    $bb6e6823f0ba3b0b$var$V.transition = {};
    try {
        a();
    } finally{
        $bb6e6823f0ba3b0b$var$V.transition = b;
    }
};
$bb6e6823f0ba3b0b$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bb6e6823f0ba3b0b$export$35808ee640e87ca7 = function(a, b) {
    return $bb6e6823f0ba3b0b$var$U.current.useCallback(a, b);
};
$bb6e6823f0ba3b0b$export$fae74005e78b1a27 = function(a) {
    return $bb6e6823f0ba3b0b$var$U.current.useContext(a);
};
$bb6e6823f0ba3b0b$export$dc8fbce3eb94dc1e = function() {};
$bb6e6823f0ba3b0b$export$6a7bc4e911dc01cf = function(a) {
    return $bb6e6823f0ba3b0b$var$U.current.useDeferredValue(a);
};
$bb6e6823f0ba3b0b$export$6d9c69b0de29b591 = function(a, b) {
    return $bb6e6823f0ba3b0b$var$U.current.useEffect(a, b);
};
$bb6e6823f0ba3b0b$export$f680877a34711e37 = function() {
    return $bb6e6823f0ba3b0b$var$U.current.useId();
};
$bb6e6823f0ba3b0b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $bb6e6823f0ba3b0b$var$U.current.useImperativeHandle(a, b, e);
};
$bb6e6823f0ba3b0b$export$aaabe4eda9ed9969 = function(a, b) {
    return $bb6e6823f0ba3b0b$var$U.current.useInsertionEffect(a, b);
};
$bb6e6823f0ba3b0b$export$e5c5a5f917a5871c = function(a, b) {
    return $bb6e6823f0ba3b0b$var$U.current.useLayoutEffect(a, b);
};
$bb6e6823f0ba3b0b$export$1538c33de8887b59 = function(a, b) {
    return $bb6e6823f0ba3b0b$var$U.current.useMemo(a, b);
};
$bb6e6823f0ba3b0b$export$13e3392192263954 = function(a, b, e) {
    return $bb6e6823f0ba3b0b$var$U.current.useReducer(a, b, e);
};
$bb6e6823f0ba3b0b$export$b8f5890fc79d6aca = function(a) {
    return $bb6e6823f0ba3b0b$var$U.current.useRef(a);
};
$bb6e6823f0ba3b0b$export$60241385465d0a34 = function(a) {
    return $bb6e6823f0ba3b0b$var$U.current.useState(a);
};
$bb6e6823f0ba3b0b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $bb6e6823f0ba3b0b$var$U.current.useSyncExternalStore(a, b, e);
};
$bb6e6823f0ba3b0b$export$7b286972b8d8ccbf = function() {
    return $bb6e6823f0ba3b0b$var$U.current.useTransition();
};
$bb6e6823f0ba3b0b$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("cAs60", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $929ea41031b225e3$export$ae55be85d98224ed, (v) => $929ea41031b225e3$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $929ea41031b225e3$export$d39a5bbd09211389, (v) => $929ea41031b225e3$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $929ea41031b225e3$export$882461b6382ed46c, (v) => $929ea41031b225e3$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $929ea41031b225e3$export$466bfc07425424d5, (v) => $929ea41031b225e3$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $929ea41031b225e3$export$cd75ccfd720a3cd4, (v) => $929ea41031b225e3$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $929ea41031b225e3$export$fa8d919ba61d84db, (v) => $929ea41031b225e3$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $929ea41031b225e3$export$757ceba2d55c277e, (v) => $929ea41031b225e3$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $929ea41031b225e3$export$b3890eb0ae9dca99, (v) => $929ea41031b225e3$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $929ea41031b225e3$export$502457920280e6be, (v) => $929ea41031b225e3$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $929ea41031b225e3$export$c78a37762a8d58e1, (v) => $929ea41031b225e3$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $929ea41031b225e3$export$dc54d992c10e8a18, (v) => $929ea41031b225e3$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $929ea41031b225e3$export$83d89fbfd8236492, (v) => $929ea41031b225e3$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $929ea41031b225e3$export$ae55be85d98224ed;
var $929ea41031b225e3$export$d39a5bbd09211389;
var $929ea41031b225e3$export$882461b6382ed46c;
var $929ea41031b225e3$export$466bfc07425424d5;
var $929ea41031b225e3$export$cd75ccfd720a3cd4;
var $929ea41031b225e3$export$fa8d919ba61d84db;
var $929ea41031b225e3$export$757ceba2d55c277e;
var $929ea41031b225e3$export$b3890eb0ae9dca99;
var $929ea41031b225e3$export$502457920280e6be;
var $929ea41031b225e3$export$c78a37762a8d58e1;
var $929ea41031b225e3$export$dc54d992c10e8a18;
var $929ea41031b225e3$export$83d89fbfd8236492;
"use strict";

var $7Pt2h = parcelRequire("7Pt2h");

var $3gHSJ = parcelRequire("3gHSJ");
function $929ea41031b225e3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $929ea41031b225e3$var$da = new Set, $929ea41031b225e3$var$ea = {};
function $929ea41031b225e3$var$fa(a, b) {
    $929ea41031b225e3$var$ha(a, b);
    $929ea41031b225e3$var$ha(a + "Capture", b);
}
function $929ea41031b225e3$var$ha(a, b) {
    $929ea41031b225e3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$929ea41031b225e3$var$da.add(b[a]);
}
var $929ea41031b225e3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $929ea41031b225e3$var$ja = Object.prototype.hasOwnProperty, $929ea41031b225e3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $929ea41031b225e3$var$la = {}, $929ea41031b225e3$var$ma = {};
function $929ea41031b225e3$var$oa(a) {
    if ($929ea41031b225e3$var$ja.call($929ea41031b225e3$var$ma, a)) return !0;
    if ($929ea41031b225e3$var$ja.call($929ea41031b225e3$var$la, a)) return !1;
    if ($929ea41031b225e3$var$ka.test(a)) return $929ea41031b225e3$var$ma[a] = !0;
    $929ea41031b225e3$var$la[a] = !0;
    return !1;
}
function $929ea41031b225e3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $929ea41031b225e3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $929ea41031b225e3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $929ea41031b225e3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $929ea41031b225e3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $929ea41031b225e3$var$z[b] = new $929ea41031b225e3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $929ea41031b225e3$var$ra = /[\-:]([a-z])/g;
function $929ea41031b225e3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($929ea41031b225e3$var$ra, $929ea41031b225e3$var$sa);
    $929ea41031b225e3$var$z[b] = new $929ea41031b225e3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($929ea41031b225e3$var$ra, $929ea41031b225e3$var$sa);
    $929ea41031b225e3$var$z[b] = new $929ea41031b225e3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($929ea41031b225e3$var$ra, $929ea41031b225e3$var$sa);
    $929ea41031b225e3$var$z[b] = new $929ea41031b225e3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$929ea41031b225e3$var$z.xlinkHref = new $929ea41031b225e3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $929ea41031b225e3$var$z[a] = new $929ea41031b225e3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $929ea41031b225e3$var$ta(a, b, c, d) {
    var e = $929ea41031b225e3$var$z.hasOwnProperty(b) ? $929ea41031b225e3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $929ea41031b225e3$var$qa(b, c, e, d) && (c = null), d || null === e ? $929ea41031b225e3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $929ea41031b225e3$var$ua = $7Pt2h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $929ea41031b225e3$var$va = Symbol.for("react.element"), $929ea41031b225e3$var$wa = Symbol.for("react.portal"), $929ea41031b225e3$var$ya = Symbol.for("react.fragment"), $929ea41031b225e3$var$za = Symbol.for("react.strict_mode"), $929ea41031b225e3$var$Aa = Symbol.for("react.profiler"), $929ea41031b225e3$var$Ba = Symbol.for("react.provider"), $929ea41031b225e3$var$Ca = Symbol.for("react.context"), $929ea41031b225e3$var$Da = Symbol.for("react.forward_ref"), $929ea41031b225e3$var$Ea = Symbol.for("react.suspense"), $929ea41031b225e3$var$Fa = Symbol.for("react.suspense_list"), $929ea41031b225e3$var$Ga = Symbol.for("react.memo"), $929ea41031b225e3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $929ea41031b225e3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $929ea41031b225e3$var$Ja = Symbol.iterator;
function $929ea41031b225e3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $929ea41031b225e3$var$Ja && a[$929ea41031b225e3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $929ea41031b225e3$var$A = Object.assign, $929ea41031b225e3$var$La;
function $929ea41031b225e3$var$Ma(a) {
    if (void 0 === $929ea41031b225e3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $929ea41031b225e3$var$La = b && b[1] || "";
    }
    return "\n" + $929ea41031b225e3$var$La + a;
}
var $929ea41031b225e3$var$Na = !1;
function $929ea41031b225e3$var$Oa(a, b) {
    if (!a || $929ea41031b225e3$var$Na) return "";
    $929ea41031b225e3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $929ea41031b225e3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $929ea41031b225e3$var$Ma(a) : "";
}
function $929ea41031b225e3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $929ea41031b225e3$var$Ma(a.type);
        case 16:
            return $929ea41031b225e3$var$Ma("Lazy");
        case 13:
            return $929ea41031b225e3$var$Ma("Suspense");
        case 19:
            return $929ea41031b225e3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $929ea41031b225e3$var$Oa(a.type, !1), a;
        case 11:
            return a = $929ea41031b225e3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $929ea41031b225e3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $929ea41031b225e3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $929ea41031b225e3$var$ya:
            return "Fragment";
        case $929ea41031b225e3$var$wa:
            return "Portal";
        case $929ea41031b225e3$var$Aa:
            return "Profiler";
        case $929ea41031b225e3$var$za:
            return "StrictMode";
        case $929ea41031b225e3$var$Ea:
            return "Suspense";
        case $929ea41031b225e3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $929ea41031b225e3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $929ea41031b225e3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $929ea41031b225e3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $929ea41031b225e3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $929ea41031b225e3$var$Qa(a.type) || "Memo";
        case $929ea41031b225e3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $929ea41031b225e3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $929ea41031b225e3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $929ea41031b225e3$var$Qa(b);
        case 8:
            return b === $929ea41031b225e3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $929ea41031b225e3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $929ea41031b225e3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $929ea41031b225e3$var$Ua(a) {
    var b = $929ea41031b225e3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $929ea41031b225e3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $929ea41031b225e3$var$Ua(a));
}
function $929ea41031b225e3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $929ea41031b225e3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $929ea41031b225e3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $929ea41031b225e3$var$Ya(a, b) {
    var c = b.checked;
    return $929ea41031b225e3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $929ea41031b225e3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $929ea41031b225e3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $929ea41031b225e3$var$ab(a, b) {
    b = b.checked;
    null != b && $929ea41031b225e3$var$ta(a, "checked", b, !1);
}
function $929ea41031b225e3$var$bb(a, b) {
    $929ea41031b225e3$var$ab(a, b);
    var c = $929ea41031b225e3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $929ea41031b225e3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $929ea41031b225e3$var$cb(a, b.type, $929ea41031b225e3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $929ea41031b225e3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $929ea41031b225e3$var$cb(a, b, c) {
    if ("number" !== b || $929ea41031b225e3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $929ea41031b225e3$var$eb = Array.isArray;
function $929ea41031b225e3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $929ea41031b225e3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $929ea41031b225e3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($929ea41031b225e3$var$p(91));
    return $929ea41031b225e3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $929ea41031b225e3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($929ea41031b225e3$var$p(92));
            if ($929ea41031b225e3$var$eb(c)) {
                if (1 < c.length) throw Error($929ea41031b225e3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $929ea41031b225e3$var$Sa(c)
    };
}
function $929ea41031b225e3$var$ib(a, b) {
    var c = $929ea41031b225e3$var$Sa(b.value), d = $929ea41031b225e3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $929ea41031b225e3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $929ea41031b225e3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $929ea41031b225e3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $929ea41031b225e3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $929ea41031b225e3$var$mb, $929ea41031b225e3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $929ea41031b225e3$var$mb = $929ea41031b225e3$var$mb || document.createElement("div");
        $929ea41031b225e3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $929ea41031b225e3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $929ea41031b225e3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $929ea41031b225e3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $929ea41031b225e3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($929ea41031b225e3$var$pb).forEach(function(a) {
    $929ea41031b225e3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $929ea41031b225e3$var$pb[b] = $929ea41031b225e3$var$pb[a];
    });
});
function $929ea41031b225e3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $929ea41031b225e3$var$pb.hasOwnProperty(a) && $929ea41031b225e3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $929ea41031b225e3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $929ea41031b225e3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $929ea41031b225e3$var$tb = $929ea41031b225e3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $929ea41031b225e3$var$ub(a, b) {
    if (b) {
        if ($929ea41031b225e3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($929ea41031b225e3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($929ea41031b225e3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($929ea41031b225e3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($929ea41031b225e3$var$p(62));
    }
}
function $929ea41031b225e3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $929ea41031b225e3$var$wb = null;
function $929ea41031b225e3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $929ea41031b225e3$var$yb = null, $929ea41031b225e3$var$zb = null, $929ea41031b225e3$var$Ab = null;
function $929ea41031b225e3$var$Bb(a) {
    if (a = $929ea41031b225e3$var$Cb(a)) {
        if ("function" !== typeof $929ea41031b225e3$var$yb) throw Error($929ea41031b225e3$var$p(280));
        var b = a.stateNode;
        b && (b = $929ea41031b225e3$var$Db(b), $929ea41031b225e3$var$yb(a.stateNode, a.type, b));
    }
}
function $929ea41031b225e3$var$Eb(a) {
    $929ea41031b225e3$var$zb ? $929ea41031b225e3$var$Ab ? $929ea41031b225e3$var$Ab.push(a) : $929ea41031b225e3$var$Ab = [
        a
    ] : $929ea41031b225e3$var$zb = a;
}
function $929ea41031b225e3$var$Fb() {
    if ($929ea41031b225e3$var$zb) {
        var a = $929ea41031b225e3$var$zb, b = $929ea41031b225e3$var$Ab;
        $929ea41031b225e3$var$Ab = $929ea41031b225e3$var$zb = null;
        $929ea41031b225e3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$929ea41031b225e3$var$Bb(b[a]);
    }
}
function $929ea41031b225e3$var$Gb(a, b) {
    return a(b);
}
function $929ea41031b225e3$var$Hb() {}
var $929ea41031b225e3$var$Ib = !1;
function $929ea41031b225e3$var$Jb(a, b, c) {
    if ($929ea41031b225e3$var$Ib) return a(b, c);
    $929ea41031b225e3$var$Ib = !0;
    try {
        return $929ea41031b225e3$var$Gb(a, b, c);
    } finally{
        if ($929ea41031b225e3$var$Ib = !1, null !== $929ea41031b225e3$var$zb || null !== $929ea41031b225e3$var$Ab) $929ea41031b225e3$var$Hb(), $929ea41031b225e3$var$Fb();
    }
}
function $929ea41031b225e3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $929ea41031b225e3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($929ea41031b225e3$var$p(231, b, typeof c));
    return c;
}
var $929ea41031b225e3$var$Lb = !1;
if ($929ea41031b225e3$var$ia) try {
    var $929ea41031b225e3$var$Mb = {};
    Object.defineProperty($929ea41031b225e3$var$Mb, "passive", {
        get: function() {
            $929ea41031b225e3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $929ea41031b225e3$var$Mb, $929ea41031b225e3$var$Mb);
    window.removeEventListener("test", $929ea41031b225e3$var$Mb, $929ea41031b225e3$var$Mb);
} catch (a) {
    $929ea41031b225e3$var$Lb = !1;
}
function $929ea41031b225e3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $929ea41031b225e3$var$Ob = !1, $929ea41031b225e3$var$Pb = null, $929ea41031b225e3$var$Qb = !1, $929ea41031b225e3$var$Rb = null, $929ea41031b225e3$var$Sb = {
    onError: function(a) {
        $929ea41031b225e3$var$Ob = !0;
        $929ea41031b225e3$var$Pb = a;
    }
};
function $929ea41031b225e3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $929ea41031b225e3$var$Ob = !1;
    $929ea41031b225e3$var$Pb = null;
    $929ea41031b225e3$var$Nb.apply($929ea41031b225e3$var$Sb, arguments);
}
function $929ea41031b225e3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $929ea41031b225e3$var$Tb.apply(this, arguments);
    if ($929ea41031b225e3$var$Ob) {
        if ($929ea41031b225e3$var$Ob) {
            var l = $929ea41031b225e3$var$Pb;
            $929ea41031b225e3$var$Ob = !1;
            $929ea41031b225e3$var$Pb = null;
        } else throw Error($929ea41031b225e3$var$p(198));
        $929ea41031b225e3$var$Qb || ($929ea41031b225e3$var$Qb = !0, $929ea41031b225e3$var$Rb = l);
    }
}
function $929ea41031b225e3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $929ea41031b225e3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $929ea41031b225e3$var$Xb(a) {
    if ($929ea41031b225e3$var$Vb(a) !== a) throw Error($929ea41031b225e3$var$p(188));
}
function $929ea41031b225e3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $929ea41031b225e3$var$Vb(a);
        if (null === b) throw Error($929ea41031b225e3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $929ea41031b225e3$var$Xb(e), a;
                if (f === d) return $929ea41031b225e3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($929ea41031b225e3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($929ea41031b225e3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($929ea41031b225e3$var$p(190));
    }
    if (3 !== c.tag) throw Error($929ea41031b225e3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $929ea41031b225e3$var$Zb(a) {
    a = $929ea41031b225e3$var$Yb(a);
    return null !== a ? $929ea41031b225e3$var$$b(a) : null;
}
function $929ea41031b225e3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $929ea41031b225e3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $929ea41031b225e3$var$ac = $3gHSJ.unstable_scheduleCallback, $929ea41031b225e3$var$bc = $3gHSJ.unstable_cancelCallback, $929ea41031b225e3$var$cc = $3gHSJ.unstable_shouldYield, $929ea41031b225e3$var$dc = $3gHSJ.unstable_requestPaint, $929ea41031b225e3$var$B = $3gHSJ.unstable_now, $929ea41031b225e3$var$ec = $3gHSJ.unstable_getCurrentPriorityLevel, $929ea41031b225e3$var$fc = $3gHSJ.unstable_ImmediatePriority, $929ea41031b225e3$var$gc = $3gHSJ.unstable_UserBlockingPriority, $929ea41031b225e3$var$hc = $3gHSJ.unstable_NormalPriority, $929ea41031b225e3$var$ic = $3gHSJ.unstable_LowPriority, $929ea41031b225e3$var$jc = $3gHSJ.unstable_IdlePriority, $929ea41031b225e3$var$kc = null, $929ea41031b225e3$var$lc = null;
function $929ea41031b225e3$var$mc(a) {
    if ($929ea41031b225e3$var$lc && "function" === typeof $929ea41031b225e3$var$lc.onCommitFiberRoot) try {
        $929ea41031b225e3$var$lc.onCommitFiberRoot($929ea41031b225e3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $929ea41031b225e3$var$oc = Math.clz32 ? Math.clz32 : $929ea41031b225e3$var$nc, $929ea41031b225e3$var$pc = Math.log, $929ea41031b225e3$var$qc = Math.LN2;
function $929ea41031b225e3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($929ea41031b225e3$var$pc(a) / $929ea41031b225e3$var$qc | 0) | 0;
}
var $929ea41031b225e3$var$rc = 64, $929ea41031b225e3$var$sc = 4194304;
function $929ea41031b225e3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $929ea41031b225e3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $929ea41031b225e3$var$tc(h) : (f &= g, 0 !== f && (d = $929ea41031b225e3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $929ea41031b225e3$var$tc(g) : 0 !== f && (d = $929ea41031b225e3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $929ea41031b225e3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $929ea41031b225e3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $929ea41031b225e3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $929ea41031b225e3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $929ea41031b225e3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $929ea41031b225e3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $929ea41031b225e3$var$yc() {
    var a = $929ea41031b225e3$var$rc;
    $929ea41031b225e3$var$rc <<= 1;
    0 === ($929ea41031b225e3$var$rc & 4194240) && ($929ea41031b225e3$var$rc = 64);
    return a;
}
function $929ea41031b225e3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $929ea41031b225e3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $929ea41031b225e3$var$oc(b);
    a[b] = c;
}
function $929ea41031b225e3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $929ea41031b225e3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $929ea41031b225e3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $929ea41031b225e3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $929ea41031b225e3$var$C = 0;
function $929ea41031b225e3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $929ea41031b225e3$var$Ec, $929ea41031b225e3$var$Fc, $929ea41031b225e3$var$Gc, $929ea41031b225e3$var$Hc, $929ea41031b225e3$var$Ic, $929ea41031b225e3$var$Jc = !1, $929ea41031b225e3$var$Kc = [], $929ea41031b225e3$var$Lc = null, $929ea41031b225e3$var$Mc = null, $929ea41031b225e3$var$Nc = null, $929ea41031b225e3$var$Oc = new Map, $929ea41031b225e3$var$Pc = new Map, $929ea41031b225e3$var$Qc = [], $929ea41031b225e3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $929ea41031b225e3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $929ea41031b225e3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $929ea41031b225e3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $929ea41031b225e3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $929ea41031b225e3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $929ea41031b225e3$var$Pc.delete(b.pointerId);
    }
}
function $929ea41031b225e3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $929ea41031b225e3$var$Cb(b), null !== b && $929ea41031b225e3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $929ea41031b225e3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $929ea41031b225e3$var$Lc = $929ea41031b225e3$var$Tc($929ea41031b225e3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $929ea41031b225e3$var$Mc = $929ea41031b225e3$var$Tc($929ea41031b225e3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $929ea41031b225e3$var$Nc = $929ea41031b225e3$var$Tc($929ea41031b225e3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $929ea41031b225e3$var$Oc.set(f, $929ea41031b225e3$var$Tc($929ea41031b225e3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $929ea41031b225e3$var$Pc.set(f, $929ea41031b225e3$var$Tc($929ea41031b225e3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $929ea41031b225e3$var$Vc(a) {
    var b = $929ea41031b225e3$var$Wc(a.target);
    if (null !== b) {
        var c = $929ea41031b225e3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $929ea41031b225e3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $929ea41031b225e3$var$Ic(a.priority, function() {
                        $929ea41031b225e3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $929ea41031b225e3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $929ea41031b225e3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $929ea41031b225e3$var$wb = d;
            c.target.dispatchEvent(d);
            $929ea41031b225e3$var$wb = null;
        } else return b = $929ea41031b225e3$var$Cb(c), null !== b && $929ea41031b225e3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $929ea41031b225e3$var$Zc(a, b, c) {
    $929ea41031b225e3$var$Xc(a) && c.delete(b);
}
function $929ea41031b225e3$var$$c() {
    $929ea41031b225e3$var$Jc = !1;
    null !== $929ea41031b225e3$var$Lc && $929ea41031b225e3$var$Xc($929ea41031b225e3$var$Lc) && ($929ea41031b225e3$var$Lc = null);
    null !== $929ea41031b225e3$var$Mc && $929ea41031b225e3$var$Xc($929ea41031b225e3$var$Mc) && ($929ea41031b225e3$var$Mc = null);
    null !== $929ea41031b225e3$var$Nc && $929ea41031b225e3$var$Xc($929ea41031b225e3$var$Nc) && ($929ea41031b225e3$var$Nc = null);
    $929ea41031b225e3$var$Oc.forEach($929ea41031b225e3$var$Zc);
    $929ea41031b225e3$var$Pc.forEach($929ea41031b225e3$var$Zc);
}
function $929ea41031b225e3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $929ea41031b225e3$var$Jc || ($929ea41031b225e3$var$Jc = !0, $3gHSJ.unstable_scheduleCallback($3gHSJ.unstable_NormalPriority, $929ea41031b225e3$var$$c)));
}
function $929ea41031b225e3$var$bd(a) {
    function b(b) {
        return $929ea41031b225e3$var$ad(b, a);
    }
    if (0 < $929ea41031b225e3$var$Kc.length) {
        $929ea41031b225e3$var$ad($929ea41031b225e3$var$Kc[0], a);
        for(var c = 1; c < $929ea41031b225e3$var$Kc.length; c++){
            var d = $929ea41031b225e3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $929ea41031b225e3$var$Lc && $929ea41031b225e3$var$ad($929ea41031b225e3$var$Lc, a);
    null !== $929ea41031b225e3$var$Mc && $929ea41031b225e3$var$ad($929ea41031b225e3$var$Mc, a);
    null !== $929ea41031b225e3$var$Nc && $929ea41031b225e3$var$ad($929ea41031b225e3$var$Nc, a);
    $929ea41031b225e3$var$Oc.forEach(b);
    $929ea41031b225e3$var$Pc.forEach(b);
    for(c = 0; c < $929ea41031b225e3$var$Qc.length; c++)d = $929ea41031b225e3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $929ea41031b225e3$var$Qc.length && (c = $929ea41031b225e3$var$Qc[0], null === c.blockedOn);)$929ea41031b225e3$var$Vc(c), null === c.blockedOn && $929ea41031b225e3$var$Qc.shift();
}
var $929ea41031b225e3$var$cd = $929ea41031b225e3$var$ua.ReactCurrentBatchConfig, $929ea41031b225e3$var$dd = !0;
function $929ea41031b225e3$var$ed(a, b, c, d) {
    var e = $929ea41031b225e3$var$C, f = $929ea41031b225e3$var$cd.transition;
    $929ea41031b225e3$var$cd.transition = null;
    try {
        $929ea41031b225e3$var$C = 1, $929ea41031b225e3$var$fd(a, b, c, d);
    } finally{
        $929ea41031b225e3$var$C = e, $929ea41031b225e3$var$cd.transition = f;
    }
}
function $929ea41031b225e3$var$gd(a, b, c, d) {
    var e = $929ea41031b225e3$var$C, f = $929ea41031b225e3$var$cd.transition;
    $929ea41031b225e3$var$cd.transition = null;
    try {
        $929ea41031b225e3$var$C = 4, $929ea41031b225e3$var$fd(a, b, c, d);
    } finally{
        $929ea41031b225e3$var$C = e, $929ea41031b225e3$var$cd.transition = f;
    }
}
function $929ea41031b225e3$var$fd(a, b, c, d) {
    if ($929ea41031b225e3$var$dd) {
        var e = $929ea41031b225e3$var$Yc(a, b, c, d);
        if (null === e) $929ea41031b225e3$var$hd(a, b, d, $929ea41031b225e3$var$id, c), $929ea41031b225e3$var$Sc(a, d);
        else if ($929ea41031b225e3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($929ea41031b225e3$var$Sc(a, d), b & 4 && -1 < $929ea41031b225e3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $929ea41031b225e3$var$Cb(e);
                null !== f && $929ea41031b225e3$var$Ec(f);
                f = $929ea41031b225e3$var$Yc(a, b, c, d);
                null === f && $929ea41031b225e3$var$hd(a, b, d, $929ea41031b225e3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $929ea41031b225e3$var$hd(a, b, d, null, c);
    }
}
var $929ea41031b225e3$var$id = null;
function $929ea41031b225e3$var$Yc(a, b, c, d) {
    $929ea41031b225e3$var$id = null;
    a = $929ea41031b225e3$var$xb(d);
    a = $929ea41031b225e3$var$Wc(a);
    if (null !== a) {
        if (b = $929ea41031b225e3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $929ea41031b225e3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $929ea41031b225e3$var$id = a;
    return null;
}
function $929ea41031b225e3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($929ea41031b225e3$var$ec()){
                case $929ea41031b225e3$var$fc:
                    return 1;
                case $929ea41031b225e3$var$gc:
                    return 4;
                case $929ea41031b225e3$var$hc:
                case $929ea41031b225e3$var$ic:
                    return 16;
                case $929ea41031b225e3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $929ea41031b225e3$var$kd = null, $929ea41031b225e3$var$ld = null, $929ea41031b225e3$var$md = null;
function $929ea41031b225e3$var$nd() {
    if ($929ea41031b225e3$var$md) return $929ea41031b225e3$var$md;
    var a, b = $929ea41031b225e3$var$ld, c = b.length, d, e = "value" in $929ea41031b225e3$var$kd ? $929ea41031b225e3$var$kd.value : $929ea41031b225e3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $929ea41031b225e3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $929ea41031b225e3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $929ea41031b225e3$var$pd() {
    return !0;
}
function $929ea41031b225e3$var$qd() {
    return !1;
}
function $929ea41031b225e3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $929ea41031b225e3$var$pd : $929ea41031b225e3$var$qd;
        this.isPropagationStopped = $929ea41031b225e3$var$qd;
        return this;
    }
    $929ea41031b225e3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $929ea41031b225e3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $929ea41031b225e3$var$pd);
        },
        persist: function() {},
        isPersistent: $929ea41031b225e3$var$pd
    });
    return b;
}
var $929ea41031b225e3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $929ea41031b225e3$var$td = $929ea41031b225e3$var$rd($929ea41031b225e3$var$sd), $929ea41031b225e3$var$ud = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$sd, {
    view: 0,
    detail: 0
}), $929ea41031b225e3$var$vd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$ud), $929ea41031b225e3$var$wd, $929ea41031b225e3$var$xd, $929ea41031b225e3$var$yd, $929ea41031b225e3$var$Ad = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $929ea41031b225e3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $929ea41031b225e3$var$yd && ($929ea41031b225e3$var$yd && "mousemove" === a.type ? ($929ea41031b225e3$var$wd = a.screenX - $929ea41031b225e3$var$yd.screenX, $929ea41031b225e3$var$xd = a.screenY - $929ea41031b225e3$var$yd.screenY) : $929ea41031b225e3$var$xd = $929ea41031b225e3$var$wd = 0, $929ea41031b225e3$var$yd = a);
        return $929ea41031b225e3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $929ea41031b225e3$var$xd;
    }
}), $929ea41031b225e3$var$Bd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Ad), $929ea41031b225e3$var$Cd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$Ad, {
    dataTransfer: 0
}), $929ea41031b225e3$var$Dd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Cd), $929ea41031b225e3$var$Ed = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$ud, {
    relatedTarget: 0
}), $929ea41031b225e3$var$Fd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Ed), $929ea41031b225e3$var$Gd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $929ea41031b225e3$var$Hd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Gd), $929ea41031b225e3$var$Id = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $929ea41031b225e3$var$Jd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Id), $929ea41031b225e3$var$Kd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$sd, {
    data: 0
}), $929ea41031b225e3$var$Ld = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Kd), $929ea41031b225e3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $929ea41031b225e3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $929ea41031b225e3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $929ea41031b225e3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $929ea41031b225e3$var$Od[a]) ? !!b[a] : !1;
}
function $929ea41031b225e3$var$zd() {
    return $929ea41031b225e3$var$Pd;
}
var $929ea41031b225e3$var$Qd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $929ea41031b225e3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $929ea41031b225e3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $929ea41031b225e3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $929ea41031b225e3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $929ea41031b225e3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $929ea41031b225e3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $929ea41031b225e3$var$Rd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Qd), $929ea41031b225e3$var$Sd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $929ea41031b225e3$var$Td = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Sd), $929ea41031b225e3$var$Ud = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $929ea41031b225e3$var$zd
}), $929ea41031b225e3$var$Vd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Ud), $929ea41031b225e3$var$Wd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $929ea41031b225e3$var$Xd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Wd), $929ea41031b225e3$var$Yd = $929ea41031b225e3$var$A({}, $929ea41031b225e3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $929ea41031b225e3$var$Zd = $929ea41031b225e3$var$rd($929ea41031b225e3$var$Yd), $929ea41031b225e3$var$$d = [
    9,
    13,
    27,
    32
], $929ea41031b225e3$var$ae = $929ea41031b225e3$var$ia && "CompositionEvent" in window, $929ea41031b225e3$var$be = null;
$929ea41031b225e3$var$ia && "documentMode" in document && ($929ea41031b225e3$var$be = document.documentMode);
var $929ea41031b225e3$var$ce = $929ea41031b225e3$var$ia && "TextEvent" in window && !$929ea41031b225e3$var$be, $929ea41031b225e3$var$de = $929ea41031b225e3$var$ia && (!$929ea41031b225e3$var$ae || $929ea41031b225e3$var$be && 8 < $929ea41031b225e3$var$be && 11 >= $929ea41031b225e3$var$be), $929ea41031b225e3$var$ee = String.fromCharCode(32), $929ea41031b225e3$var$fe = !1;
function $929ea41031b225e3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $929ea41031b225e3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $929ea41031b225e3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $929ea41031b225e3$var$ie = !1;
function $929ea41031b225e3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $929ea41031b225e3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $929ea41031b225e3$var$fe = !0;
            return $929ea41031b225e3$var$ee;
        case "textInput":
            return a = b.data, a === $929ea41031b225e3$var$ee && $929ea41031b225e3$var$fe ? null : a;
        default:
            return null;
    }
}
function $929ea41031b225e3$var$ke(a, b) {
    if ($929ea41031b225e3$var$ie) return "compositionend" === a || !$929ea41031b225e3$var$ae && $929ea41031b225e3$var$ge(a, b) ? (a = $929ea41031b225e3$var$nd(), $929ea41031b225e3$var$md = $929ea41031b225e3$var$ld = $929ea41031b225e3$var$kd = null, $929ea41031b225e3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $929ea41031b225e3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $929ea41031b225e3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $929ea41031b225e3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$929ea41031b225e3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $929ea41031b225e3$var$ne(a, b, c, d) {
    $929ea41031b225e3$var$Eb(d);
    b = $929ea41031b225e3$var$oe(b, "onChange");
    0 < b.length && (c = new $929ea41031b225e3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $929ea41031b225e3$var$pe = null, $929ea41031b225e3$var$qe = null;
function $929ea41031b225e3$var$re(a) {
    $929ea41031b225e3$var$se(a, 0);
}
function $929ea41031b225e3$var$te(a) {
    var b = $929ea41031b225e3$var$ue(a);
    if ($929ea41031b225e3$var$Wa(b)) return a;
}
function $929ea41031b225e3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $929ea41031b225e3$var$we = !1;
if ($929ea41031b225e3$var$ia) {
    var $929ea41031b225e3$var$xe;
    if ($929ea41031b225e3$var$ia) {
        var $929ea41031b225e3$var$ye = "oninput" in document;
        if (!$929ea41031b225e3$var$ye) {
            var $929ea41031b225e3$var$ze = document.createElement("div");
            $929ea41031b225e3$var$ze.setAttribute("oninput", "return;");
            $929ea41031b225e3$var$ye = "function" === typeof $929ea41031b225e3$var$ze.oninput;
        }
        $929ea41031b225e3$var$xe = $929ea41031b225e3$var$ye;
    } else $929ea41031b225e3$var$xe = !1;
    $929ea41031b225e3$var$we = $929ea41031b225e3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $929ea41031b225e3$var$Ae() {
    $929ea41031b225e3$var$pe && ($929ea41031b225e3$var$pe.detachEvent("onpropertychange", $929ea41031b225e3$var$Be), $929ea41031b225e3$var$qe = $929ea41031b225e3$var$pe = null);
}
function $929ea41031b225e3$var$Be(a) {
    if ("value" === a.propertyName && $929ea41031b225e3$var$te($929ea41031b225e3$var$qe)) {
        var b = [];
        $929ea41031b225e3$var$ne(b, $929ea41031b225e3$var$qe, a, $929ea41031b225e3$var$xb(a));
        $929ea41031b225e3$var$Jb($929ea41031b225e3$var$re, b);
    }
}
function $929ea41031b225e3$var$Ce(a, b, c) {
    "focusin" === a ? ($929ea41031b225e3$var$Ae(), $929ea41031b225e3$var$pe = b, $929ea41031b225e3$var$qe = c, $929ea41031b225e3$var$pe.attachEvent("onpropertychange", $929ea41031b225e3$var$Be)) : "focusout" === a && $929ea41031b225e3$var$Ae();
}
function $929ea41031b225e3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $929ea41031b225e3$var$te($929ea41031b225e3$var$qe);
}
function $929ea41031b225e3$var$Ee(a, b) {
    if ("click" === a) return $929ea41031b225e3$var$te(b);
}
function $929ea41031b225e3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $929ea41031b225e3$var$te(b);
}
function $929ea41031b225e3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $929ea41031b225e3$var$He = "function" === typeof Object.is ? Object.is : $929ea41031b225e3$var$Ge;
function $929ea41031b225e3$var$Ie(a, b) {
    if ($929ea41031b225e3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$929ea41031b225e3$var$ja.call(b, e) || !$929ea41031b225e3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $929ea41031b225e3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $929ea41031b225e3$var$Ke(a, b) {
    var c = $929ea41031b225e3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $929ea41031b225e3$var$Je(c);
    }
}
function $929ea41031b225e3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $929ea41031b225e3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $929ea41031b225e3$var$Me() {
    for(var a = window, b = $929ea41031b225e3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $929ea41031b225e3$var$Xa(a.document);
    }
    return b;
}
function $929ea41031b225e3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $929ea41031b225e3$var$Oe(a) {
    var b = $929ea41031b225e3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $929ea41031b225e3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $929ea41031b225e3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $929ea41031b225e3$var$Ke(c, f);
                var g = $929ea41031b225e3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $929ea41031b225e3$var$Pe = $929ea41031b225e3$var$ia && "documentMode" in document && 11 >= document.documentMode, $929ea41031b225e3$var$Qe = null, $929ea41031b225e3$var$Re = null, $929ea41031b225e3$var$Se = null, $929ea41031b225e3$var$Te = !1;
function $929ea41031b225e3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $929ea41031b225e3$var$Te || null == $929ea41031b225e3$var$Qe || $929ea41031b225e3$var$Qe !== $929ea41031b225e3$var$Xa(d) || (d = $929ea41031b225e3$var$Qe, "selectionStart" in d && $929ea41031b225e3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $929ea41031b225e3$var$Se && $929ea41031b225e3$var$Ie($929ea41031b225e3$var$Se, d) || ($929ea41031b225e3$var$Se = d, d = $929ea41031b225e3$var$oe($929ea41031b225e3$var$Re, "onSelect"), 0 < d.length && (b = new $929ea41031b225e3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $929ea41031b225e3$var$Qe)));
}
function $929ea41031b225e3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $929ea41031b225e3$var$We = {
    animationend: $929ea41031b225e3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $929ea41031b225e3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $929ea41031b225e3$var$Ve("Animation", "AnimationStart"),
    transitionend: $929ea41031b225e3$var$Ve("Transition", "TransitionEnd")
}, $929ea41031b225e3$var$Xe = {}, $929ea41031b225e3$var$Ye = {};
$929ea41031b225e3$var$ia && ($929ea41031b225e3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $929ea41031b225e3$var$We.animationend.animation, delete $929ea41031b225e3$var$We.animationiteration.animation, delete $929ea41031b225e3$var$We.animationstart.animation), "TransitionEvent" in window || delete $929ea41031b225e3$var$We.transitionend.transition);
function $929ea41031b225e3$var$Ze(a) {
    if ($929ea41031b225e3$var$Xe[a]) return $929ea41031b225e3$var$Xe[a];
    if (!$929ea41031b225e3$var$We[a]) return a;
    var b = $929ea41031b225e3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $929ea41031b225e3$var$Ye) return $929ea41031b225e3$var$Xe[a] = b[c];
    return a;
}
var $929ea41031b225e3$var$$e = $929ea41031b225e3$var$Ze("animationend"), $929ea41031b225e3$var$af = $929ea41031b225e3$var$Ze("animationiteration"), $929ea41031b225e3$var$bf = $929ea41031b225e3$var$Ze("animationstart"), $929ea41031b225e3$var$cf = $929ea41031b225e3$var$Ze("transitionend"), $929ea41031b225e3$var$df = new Map, $929ea41031b225e3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $929ea41031b225e3$var$ff(a, b) {
    $929ea41031b225e3$var$df.set(a, b);
    $929ea41031b225e3$var$fa(b, [
        a
    ]);
}
for(var $929ea41031b225e3$var$gf = 0; $929ea41031b225e3$var$gf < $929ea41031b225e3$var$ef.length; $929ea41031b225e3$var$gf++){
    var $929ea41031b225e3$var$hf = $929ea41031b225e3$var$ef[$929ea41031b225e3$var$gf], $929ea41031b225e3$var$jf = $929ea41031b225e3$var$hf.toLowerCase(), $929ea41031b225e3$var$kf = $929ea41031b225e3$var$hf[0].toUpperCase() + $929ea41031b225e3$var$hf.slice(1);
    $929ea41031b225e3$var$ff($929ea41031b225e3$var$jf, "on" + $929ea41031b225e3$var$kf);
}
$929ea41031b225e3$var$ff($929ea41031b225e3$var$$e, "onAnimationEnd");
$929ea41031b225e3$var$ff($929ea41031b225e3$var$af, "onAnimationIteration");
$929ea41031b225e3$var$ff($929ea41031b225e3$var$bf, "onAnimationStart");
$929ea41031b225e3$var$ff("dblclick", "onDoubleClick");
$929ea41031b225e3$var$ff("focusin", "onFocus");
$929ea41031b225e3$var$ff("focusout", "onBlur");
$929ea41031b225e3$var$ff($929ea41031b225e3$var$cf, "onTransitionEnd");
$929ea41031b225e3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$929ea41031b225e3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$929ea41031b225e3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$929ea41031b225e3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$929ea41031b225e3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$929ea41031b225e3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$929ea41031b225e3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$929ea41031b225e3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$929ea41031b225e3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$929ea41031b225e3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $929ea41031b225e3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $929ea41031b225e3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($929ea41031b225e3$var$lf));
function $929ea41031b225e3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $929ea41031b225e3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $929ea41031b225e3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $929ea41031b225e3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $929ea41031b225e3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($929ea41031b225e3$var$Qb) throw a = $929ea41031b225e3$var$Rb, $929ea41031b225e3$var$Qb = !1, $929ea41031b225e3$var$Rb = null, a;
}
function $929ea41031b225e3$var$D(a, b) {
    var c = b[$929ea41031b225e3$var$of];
    void 0 === c && (c = b[$929ea41031b225e3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($929ea41031b225e3$var$pf(b, a, 2, !1), c.add(d));
}
function $929ea41031b225e3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $929ea41031b225e3$var$pf(c, a, d, b);
}
var $929ea41031b225e3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $929ea41031b225e3$var$sf(a) {
    if (!a[$929ea41031b225e3$var$rf]) {
        a[$929ea41031b225e3$var$rf] = !0;
        $929ea41031b225e3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($929ea41031b225e3$var$mf.has(b) || $929ea41031b225e3$var$qf(b, !1, a), $929ea41031b225e3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$929ea41031b225e3$var$rf] || (b[$929ea41031b225e3$var$rf] = !0, $929ea41031b225e3$var$qf("selectionchange", !1, b));
    }
}
function $929ea41031b225e3$var$pf(a, b, c, d) {
    switch($929ea41031b225e3$var$jd(b)){
        case 1:
            var e = $929ea41031b225e3$var$ed;
            break;
        case 4:
            e = $929ea41031b225e3$var$gd;
            break;
        default:
            e = $929ea41031b225e3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$929ea41031b225e3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $929ea41031b225e3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $929ea41031b225e3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $929ea41031b225e3$var$Jb(function() {
        var d = f, e = $929ea41031b225e3$var$xb(c), g = [];
        a: {
            var h = $929ea41031b225e3$var$df.get(a);
            if (void 0 !== h) {
                var k = $929ea41031b225e3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $929ea41031b225e3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $929ea41031b225e3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $929ea41031b225e3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $929ea41031b225e3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $929ea41031b225e3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $929ea41031b225e3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $929ea41031b225e3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $929ea41031b225e3$var$Vd;
                        break;
                    case $929ea41031b225e3$var$$e:
                    case $929ea41031b225e3$var$af:
                    case $929ea41031b225e3$var$bf:
                        k = $929ea41031b225e3$var$Hd;
                        break;
                    case $929ea41031b225e3$var$cf:
                        k = $929ea41031b225e3$var$Xd;
                        break;
                    case "scroll":
                        k = $929ea41031b225e3$var$vd;
                        break;
                    case "wheel":
                        k = $929ea41031b225e3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $929ea41031b225e3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $929ea41031b225e3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $929ea41031b225e3$var$Kb(w, x), null != F && t.push($929ea41031b225e3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $929ea41031b225e3$var$wb && (n = c.relatedTarget || c.fromElement) && ($929ea41031b225e3$var$Wc(n) || n[$929ea41031b225e3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $929ea41031b225e3$var$Wc(n) : null, null !== n && (J = $929ea41031b225e3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $929ea41031b225e3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $929ea41031b225e3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $929ea41031b225e3$var$ue(k);
                        u = null == n ? h : $929ea41031b225e3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $929ea41031b225e3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $929ea41031b225e3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $929ea41031b225e3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $929ea41031b225e3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $929ea41031b225e3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $929ea41031b225e3$var$vf(t);
                                x = $929ea41031b225e3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $929ea41031b225e3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $929ea41031b225e3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $929ea41031b225e3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $929ea41031b225e3$var$ve;
                else if ($929ea41031b225e3$var$me(h)) {
                    if ($929ea41031b225e3$var$we) na = $929ea41031b225e3$var$Fe;
                    else {
                        na = $929ea41031b225e3$var$De;
                        var xa = $929ea41031b225e3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $929ea41031b225e3$var$Ee);
                if (na && (na = na(a, d))) {
                    $929ea41031b225e3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $929ea41031b225e3$var$cb(h, "number", h.value);
            }
            xa = d ? $929ea41031b225e3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($929ea41031b225e3$var$me(xa) || "true" === xa.contentEditable) $929ea41031b225e3$var$Qe = xa, $929ea41031b225e3$var$Re = d, $929ea41031b225e3$var$Se = null;
                    break;
                case "focusout":
                    $929ea41031b225e3$var$Se = $929ea41031b225e3$var$Re = $929ea41031b225e3$var$Qe = null;
                    break;
                case "mousedown":
                    $929ea41031b225e3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $929ea41031b225e3$var$Te = !1;
                    $929ea41031b225e3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($929ea41031b225e3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $929ea41031b225e3$var$Ue(g, c, e);
            }
            var $a;
            if ($929ea41031b225e3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $929ea41031b225e3$var$ie ? $929ea41031b225e3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($929ea41031b225e3$var$de && "ko" !== c.locale && ($929ea41031b225e3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $929ea41031b225e3$var$ie && ($a = $929ea41031b225e3$var$nd()) : ($929ea41031b225e3$var$kd = e, $929ea41031b225e3$var$ld = "value" in $929ea41031b225e3$var$kd ? $929ea41031b225e3$var$kd.value : $929ea41031b225e3$var$kd.textContent, $929ea41031b225e3$var$ie = !0)), xa = $929ea41031b225e3$var$oe(d, ba), 0 < xa.length && (ba = new $929ea41031b225e3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $929ea41031b225e3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $929ea41031b225e3$var$ce ? $929ea41031b225e3$var$je(a, c) : $929ea41031b225e3$var$ke(a, c)) d = $929ea41031b225e3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $929ea41031b225e3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $929ea41031b225e3$var$se(g, b);
    });
}
function $929ea41031b225e3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $929ea41031b225e3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $929ea41031b225e3$var$Kb(a, c), null != f && d.unshift($929ea41031b225e3$var$tf(a, f, e)), f = $929ea41031b225e3$var$Kb(a, b), null != f && d.push($929ea41031b225e3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $929ea41031b225e3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $929ea41031b225e3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $929ea41031b225e3$var$Kb(c, f), null != k && g.unshift($929ea41031b225e3$var$tf(c, k, h))) : e || (k = $929ea41031b225e3$var$Kb(c, f), null != k && g.push($929ea41031b225e3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $929ea41031b225e3$var$xf = /\r\n?/g, $929ea41031b225e3$var$yf = /\u0000|\uFFFD/g;
function $929ea41031b225e3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($929ea41031b225e3$var$xf, "\n").replace($929ea41031b225e3$var$yf, "");
}
function $929ea41031b225e3$var$Af(a, b, c) {
    b = $929ea41031b225e3$var$zf(b);
    if ($929ea41031b225e3$var$zf(a) !== b && c) throw Error($929ea41031b225e3$var$p(425));
}
function $929ea41031b225e3$var$Bf() {}
var $929ea41031b225e3$var$Cf = null, $929ea41031b225e3$var$Df = null;
function $929ea41031b225e3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $929ea41031b225e3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $929ea41031b225e3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $929ea41031b225e3$var$Hf = "function" === typeof Promise ? Promise : void 0, $929ea41031b225e3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $929ea41031b225e3$var$Hf ? function(a) {
    return $929ea41031b225e3$var$Hf.resolve(null).then(a).catch($929ea41031b225e3$var$If);
} : $929ea41031b225e3$var$Ff;
function $929ea41031b225e3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $929ea41031b225e3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $929ea41031b225e3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $929ea41031b225e3$var$bd(b);
}
function $929ea41031b225e3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $929ea41031b225e3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $929ea41031b225e3$var$Nf = Math.random().toString(36).slice(2), $929ea41031b225e3$var$Of = "__reactFiber$" + $929ea41031b225e3$var$Nf, $929ea41031b225e3$var$Pf = "__reactProps$" + $929ea41031b225e3$var$Nf, $929ea41031b225e3$var$uf = "__reactContainer$" + $929ea41031b225e3$var$Nf, $929ea41031b225e3$var$of = "__reactEvents$" + $929ea41031b225e3$var$Nf, $929ea41031b225e3$var$Qf = "__reactListeners$" + $929ea41031b225e3$var$Nf, $929ea41031b225e3$var$Rf = "__reactHandles$" + $929ea41031b225e3$var$Nf;
function $929ea41031b225e3$var$Wc(a) {
    var b = a[$929ea41031b225e3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$929ea41031b225e3$var$uf] || c[$929ea41031b225e3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $929ea41031b225e3$var$Mf(a); null !== a;){
                if (c = a[$929ea41031b225e3$var$Of]) return c;
                a = $929ea41031b225e3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $929ea41031b225e3$var$Cb(a) {
    a = a[$929ea41031b225e3$var$Of] || a[$929ea41031b225e3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $929ea41031b225e3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($929ea41031b225e3$var$p(33));
}
function $929ea41031b225e3$var$Db(a) {
    return a[$929ea41031b225e3$var$Pf] || null;
}
var $929ea41031b225e3$var$Sf = [], $929ea41031b225e3$var$Tf = -1;
function $929ea41031b225e3$var$Uf(a) {
    return {
        current: a
    };
}
function $929ea41031b225e3$var$E(a) {
    0 > $929ea41031b225e3$var$Tf || (a.current = $929ea41031b225e3$var$Sf[$929ea41031b225e3$var$Tf], $929ea41031b225e3$var$Sf[$929ea41031b225e3$var$Tf] = null, $929ea41031b225e3$var$Tf--);
}
function $929ea41031b225e3$var$G(a, b) {
    $929ea41031b225e3$var$Tf++;
    $929ea41031b225e3$var$Sf[$929ea41031b225e3$var$Tf] = a.current;
    a.current = b;
}
var $929ea41031b225e3$var$Vf = {}, $929ea41031b225e3$var$H = $929ea41031b225e3$var$Uf($929ea41031b225e3$var$Vf), $929ea41031b225e3$var$Wf = $929ea41031b225e3$var$Uf(!1), $929ea41031b225e3$var$Xf = $929ea41031b225e3$var$Vf;
function $929ea41031b225e3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $929ea41031b225e3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $929ea41031b225e3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $929ea41031b225e3$var$$f() {
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf);
    $929ea41031b225e3$var$E($929ea41031b225e3$var$H);
}
function $929ea41031b225e3$var$ag(a, b, c) {
    if ($929ea41031b225e3$var$H.current !== $929ea41031b225e3$var$Vf) throw Error($929ea41031b225e3$var$p(168));
    $929ea41031b225e3$var$G($929ea41031b225e3$var$H, b);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Wf, c);
}
function $929ea41031b225e3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($929ea41031b225e3$var$p(108, $929ea41031b225e3$var$Ra(a) || "Unknown", e));
    return $929ea41031b225e3$var$A({}, c, d);
}
function $929ea41031b225e3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $929ea41031b225e3$var$Vf;
    $929ea41031b225e3$var$Xf = $929ea41031b225e3$var$H.current;
    $929ea41031b225e3$var$G($929ea41031b225e3$var$H, a);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Wf, $929ea41031b225e3$var$Wf.current);
    return !0;
}
function $929ea41031b225e3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($929ea41031b225e3$var$p(169));
    c ? (a = $929ea41031b225e3$var$bg(a, b, $929ea41031b225e3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf), $929ea41031b225e3$var$E($929ea41031b225e3$var$H), $929ea41031b225e3$var$G($929ea41031b225e3$var$H, a)) : $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Wf, c);
}
var $929ea41031b225e3$var$eg = null, $929ea41031b225e3$var$fg = !1, $929ea41031b225e3$var$gg = !1;
function $929ea41031b225e3$var$hg(a) {
    null === $929ea41031b225e3$var$eg ? $929ea41031b225e3$var$eg = [
        a
    ] : $929ea41031b225e3$var$eg.push(a);
}
function $929ea41031b225e3$var$ig(a) {
    $929ea41031b225e3$var$fg = !0;
    $929ea41031b225e3$var$hg(a);
}
function $929ea41031b225e3$var$jg() {
    if (!$929ea41031b225e3$var$gg && null !== $929ea41031b225e3$var$eg) {
        $929ea41031b225e3$var$gg = !0;
        var a = 0, b = $929ea41031b225e3$var$C;
        try {
            var c = $929ea41031b225e3$var$eg;
            for($929ea41031b225e3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $929ea41031b225e3$var$eg = null;
            $929ea41031b225e3$var$fg = !1;
        } catch (e) {
            throw null !== $929ea41031b225e3$var$eg && ($929ea41031b225e3$var$eg = $929ea41031b225e3$var$eg.slice(a + 1)), $929ea41031b225e3$var$ac($929ea41031b225e3$var$fc, $929ea41031b225e3$var$jg), e;
        } finally{
            $929ea41031b225e3$var$C = b, $929ea41031b225e3$var$gg = !1;
        }
    }
    return null;
}
var $929ea41031b225e3$var$kg = [], $929ea41031b225e3$var$lg = 0, $929ea41031b225e3$var$mg = null, $929ea41031b225e3$var$ng = 0, $929ea41031b225e3$var$og = [], $929ea41031b225e3$var$pg = 0, $929ea41031b225e3$var$qg = null, $929ea41031b225e3$var$rg = 1, $929ea41031b225e3$var$sg = "";
function $929ea41031b225e3$var$tg(a, b) {
    $929ea41031b225e3$var$kg[$929ea41031b225e3$var$lg++] = $929ea41031b225e3$var$ng;
    $929ea41031b225e3$var$kg[$929ea41031b225e3$var$lg++] = $929ea41031b225e3$var$mg;
    $929ea41031b225e3$var$mg = a;
    $929ea41031b225e3$var$ng = b;
}
function $929ea41031b225e3$var$ug(a, b, c) {
    $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$rg;
    $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$sg;
    $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$qg;
    $929ea41031b225e3$var$qg = a;
    var d = $929ea41031b225e3$var$rg;
    a = $929ea41031b225e3$var$sg;
    var e = 32 - $929ea41031b225e3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $929ea41031b225e3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $929ea41031b225e3$var$rg = 1 << 32 - $929ea41031b225e3$var$oc(b) + e | c << e | d;
        $929ea41031b225e3$var$sg = f + a;
    } else $929ea41031b225e3$var$rg = 1 << f | c << e | d, $929ea41031b225e3$var$sg = a;
}
function $929ea41031b225e3$var$vg(a) {
    null !== a.return && ($929ea41031b225e3$var$tg(a, 1), $929ea41031b225e3$var$ug(a, 1, 0));
}
function $929ea41031b225e3$var$wg(a) {
    for(; a === $929ea41031b225e3$var$mg;)$929ea41031b225e3$var$mg = $929ea41031b225e3$var$kg[--$929ea41031b225e3$var$lg], $929ea41031b225e3$var$kg[$929ea41031b225e3$var$lg] = null, $929ea41031b225e3$var$ng = $929ea41031b225e3$var$kg[--$929ea41031b225e3$var$lg], $929ea41031b225e3$var$kg[$929ea41031b225e3$var$lg] = null;
    for(; a === $929ea41031b225e3$var$qg;)$929ea41031b225e3$var$qg = $929ea41031b225e3$var$og[--$929ea41031b225e3$var$pg], $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg] = null, $929ea41031b225e3$var$sg = $929ea41031b225e3$var$og[--$929ea41031b225e3$var$pg], $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg] = null, $929ea41031b225e3$var$rg = $929ea41031b225e3$var$og[--$929ea41031b225e3$var$pg], $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg] = null;
}
var $929ea41031b225e3$var$xg = null, $929ea41031b225e3$var$yg = null, $929ea41031b225e3$var$I = !1, $929ea41031b225e3$var$zg = null;
function $929ea41031b225e3$var$Ag(a, b) {
    var c = $929ea41031b225e3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $929ea41031b225e3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $929ea41031b225e3$var$xg = a, $929ea41031b225e3$var$yg = $929ea41031b225e3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $929ea41031b225e3$var$xg = a, $929ea41031b225e3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $929ea41031b225e3$var$qg ? {
                id: $929ea41031b225e3$var$rg,
                overflow: $929ea41031b225e3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $929ea41031b225e3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $929ea41031b225e3$var$xg = a, $929ea41031b225e3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $929ea41031b225e3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $929ea41031b225e3$var$Eg(a) {
    if ($929ea41031b225e3$var$I) {
        var b = $929ea41031b225e3$var$yg;
        if (b) {
            var c = b;
            if (!$929ea41031b225e3$var$Cg(a, b)) {
                if ($929ea41031b225e3$var$Dg(a)) throw Error($929ea41031b225e3$var$p(418));
                b = $929ea41031b225e3$var$Lf(c.nextSibling);
                var d = $929ea41031b225e3$var$xg;
                b && $929ea41031b225e3$var$Cg(a, b) ? $929ea41031b225e3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $929ea41031b225e3$var$I = !1, $929ea41031b225e3$var$xg = a);
            }
        } else {
            if ($929ea41031b225e3$var$Dg(a)) throw Error($929ea41031b225e3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $929ea41031b225e3$var$I = !1;
            $929ea41031b225e3$var$xg = a;
        }
    }
}
function $929ea41031b225e3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $929ea41031b225e3$var$xg = a;
}
function $929ea41031b225e3$var$Gg(a) {
    if (a !== $929ea41031b225e3$var$xg) return !1;
    if (!$929ea41031b225e3$var$I) return $929ea41031b225e3$var$Fg(a), $929ea41031b225e3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$929ea41031b225e3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $929ea41031b225e3$var$yg)) {
        if ($929ea41031b225e3$var$Dg(a)) throw $929ea41031b225e3$var$Hg(), Error($929ea41031b225e3$var$p(418));
        for(; b;)$929ea41031b225e3$var$Ag(a, b), b = $929ea41031b225e3$var$Lf(b.nextSibling);
    }
    $929ea41031b225e3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($929ea41031b225e3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $929ea41031b225e3$var$yg = $929ea41031b225e3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $929ea41031b225e3$var$yg = null;
        }
    } else $929ea41031b225e3$var$yg = $929ea41031b225e3$var$xg ? $929ea41031b225e3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $929ea41031b225e3$var$Hg() {
    for(var a = $929ea41031b225e3$var$yg; a;)a = $929ea41031b225e3$var$Lf(a.nextSibling);
}
function $929ea41031b225e3$var$Ig() {
    $929ea41031b225e3$var$yg = $929ea41031b225e3$var$xg = null;
    $929ea41031b225e3$var$I = !1;
}
function $929ea41031b225e3$var$Jg(a) {
    null === $929ea41031b225e3$var$zg ? $929ea41031b225e3$var$zg = [
        a
    ] : $929ea41031b225e3$var$zg.push(a);
}
var $929ea41031b225e3$var$Kg = $929ea41031b225e3$var$ua.ReactCurrentBatchConfig;
function $929ea41031b225e3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $929ea41031b225e3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $929ea41031b225e3$var$Mg = $929ea41031b225e3$var$Uf(null), $929ea41031b225e3$var$Ng = null, $929ea41031b225e3$var$Og = null, $929ea41031b225e3$var$Pg = null;
function $929ea41031b225e3$var$Qg() {
    $929ea41031b225e3$var$Pg = $929ea41031b225e3$var$Og = $929ea41031b225e3$var$Ng = null;
}
function $929ea41031b225e3$var$Rg(a) {
    var b = $929ea41031b225e3$var$Mg.current;
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Mg);
    a._currentValue = b;
}
function $929ea41031b225e3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $929ea41031b225e3$var$Tg(a, b) {
    $929ea41031b225e3$var$Ng = a;
    $929ea41031b225e3$var$Pg = $929ea41031b225e3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($929ea41031b225e3$var$Ug = !0), a.firstContext = null);
}
function $929ea41031b225e3$var$Vg(a) {
    var b = a._currentValue;
    if ($929ea41031b225e3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $929ea41031b225e3$var$Og) {
            if (null === $929ea41031b225e3$var$Ng) throw Error($929ea41031b225e3$var$p(308));
            $929ea41031b225e3$var$Og = a;
            $929ea41031b225e3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $929ea41031b225e3$var$Og = $929ea41031b225e3$var$Og.next = a;
    }
    return b;
}
var $929ea41031b225e3$var$Wg = null;
function $929ea41031b225e3$var$Xg(a) {
    null === $929ea41031b225e3$var$Wg ? $929ea41031b225e3$var$Wg = [
        a
    ] : $929ea41031b225e3$var$Wg.push(a);
}
function $929ea41031b225e3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $929ea41031b225e3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $929ea41031b225e3$var$Zg(a, d);
}
function $929ea41031b225e3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $929ea41031b225e3$var$$g = !1;
function $929ea41031b225e3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $929ea41031b225e3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $929ea41031b225e3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $929ea41031b225e3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($929ea41031b225e3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $929ea41031b225e3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $929ea41031b225e3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $929ea41031b225e3$var$Zg(a, c);
}
function $929ea41031b225e3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $929ea41031b225e3$var$Cc(a, c);
    }
}
function $929ea41031b225e3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $929ea41031b225e3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $929ea41031b225e3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $929ea41031b225e3$var$A({}, q, r);
                            break a;
                        case 2:
                            $929ea41031b225e3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $929ea41031b225e3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $929ea41031b225e3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($929ea41031b225e3$var$p(191, e));
            e.call(d);
        }
    }
}
var $929ea41031b225e3$var$jh = (new $7Pt2h.Component).refs;
function $929ea41031b225e3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $929ea41031b225e3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $929ea41031b225e3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $929ea41031b225e3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $929ea41031b225e3$var$L(), e = $929ea41031b225e3$var$lh(a), f = $929ea41031b225e3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $929ea41031b225e3$var$dh(a, f, e);
        null !== b && ($929ea41031b225e3$var$mh(b, a, e, d), $929ea41031b225e3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $929ea41031b225e3$var$L(), e = $929ea41031b225e3$var$lh(a), f = $929ea41031b225e3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $929ea41031b225e3$var$dh(a, f, e);
        null !== b && ($929ea41031b225e3$var$mh(b, a, e, d), $929ea41031b225e3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $929ea41031b225e3$var$L(), d = $929ea41031b225e3$var$lh(a), e = $929ea41031b225e3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $929ea41031b225e3$var$dh(a, e, d);
        null !== b && ($929ea41031b225e3$var$mh(b, a, d, c), $929ea41031b225e3$var$eh(b, a, d));
    }
};
function $929ea41031b225e3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$929ea41031b225e3$var$Ie(c, d) || !$929ea41031b225e3$var$Ie(e, f) : !0;
}
function $929ea41031b225e3$var$ph(a, b, c) {
    var d = !1, e = $929ea41031b225e3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $929ea41031b225e3$var$Vg(f) : (e = $929ea41031b225e3$var$Zf(b) ? $929ea41031b225e3$var$Xf : $929ea41031b225e3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $929ea41031b225e3$var$Yf(a, e) : $929ea41031b225e3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $929ea41031b225e3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $929ea41031b225e3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $929ea41031b225e3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $929ea41031b225e3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $929ea41031b225e3$var$jh;
    $929ea41031b225e3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $929ea41031b225e3$var$Vg(f) : (f = $929ea41031b225e3$var$Zf(b) ? $929ea41031b225e3$var$Xf : $929ea41031b225e3$var$H.current, e.context = $929ea41031b225e3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($929ea41031b225e3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $929ea41031b225e3$var$nh.enqueueReplaceState(e, e.state, null), $929ea41031b225e3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $929ea41031b225e3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($929ea41031b225e3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($929ea41031b225e3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $929ea41031b225e3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($929ea41031b225e3$var$p(284));
        if (!c._owner) throw Error($929ea41031b225e3$var$p(290, a));
    }
    return a;
}
function $929ea41031b225e3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($929ea41031b225e3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $929ea41031b225e3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $929ea41031b225e3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $929ea41031b225e3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $929ea41031b225e3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $929ea41031b225e3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $929ea41031b225e3$var$Ha && $929ea41031b225e3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $929ea41031b225e3$var$sh(a, b, c), d.return = a, d;
        d = $929ea41031b225e3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $929ea41031b225e3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $929ea41031b225e3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $929ea41031b225e3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $929ea41031b225e3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $929ea41031b225e3$var$va:
                    return c = $929ea41031b225e3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $929ea41031b225e3$var$sh(a, null, b), c.return = a, c;
                case $929ea41031b225e3$var$wa:
                    return b = $929ea41031b225e3$var$zh(b, a.mode, c), b.return = a, b;
                case $929ea41031b225e3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($929ea41031b225e3$var$eb(b) || $929ea41031b225e3$var$Ka(b)) return b = $929ea41031b225e3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $929ea41031b225e3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $929ea41031b225e3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $929ea41031b225e3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $929ea41031b225e3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($929ea41031b225e3$var$eb(c) || $929ea41031b225e3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $929ea41031b225e3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $929ea41031b225e3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $929ea41031b225e3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $929ea41031b225e3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($929ea41031b225e3$var$eb(d) || $929ea41031b225e3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $929ea41031b225e3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $929ea41031b225e3$var$Ka(h);
        if ("function" !== typeof l) throw Error($929ea41031b225e3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($929ea41031b225e3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $929ea41031b225e3$var$I && $929ea41031b225e3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $929ea41031b225e3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $929ea41031b225e3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $929ea41031b225e3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $929ea41031b225e3$var$Ha && $929ea41031b225e3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $929ea41031b225e3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $929ea41031b225e3$var$ya ? (d = $929ea41031b225e3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $929ea41031b225e3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $929ea41031b225e3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $929ea41031b225e3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $929ea41031b225e3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $929ea41031b225e3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($929ea41031b225e3$var$eb(f)) return n(a, d, f, h);
            if ($929ea41031b225e3$var$Ka(f)) return t(a, d, f, h);
            $929ea41031b225e3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $929ea41031b225e3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $929ea41031b225e3$var$Bh = $929ea41031b225e3$var$vh(!0), $929ea41031b225e3$var$Ch = $929ea41031b225e3$var$vh(!1), $929ea41031b225e3$var$Dh = {}, $929ea41031b225e3$var$Eh = $929ea41031b225e3$var$Uf($929ea41031b225e3$var$Dh), $929ea41031b225e3$var$Fh = $929ea41031b225e3$var$Uf($929ea41031b225e3$var$Dh), $929ea41031b225e3$var$Gh = $929ea41031b225e3$var$Uf($929ea41031b225e3$var$Dh);
function $929ea41031b225e3$var$Hh(a) {
    if (a === $929ea41031b225e3$var$Dh) throw Error($929ea41031b225e3$var$p(174));
    return a;
}
function $929ea41031b225e3$var$Ih(a, b) {
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Gh, b);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Fh, a);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Eh, $929ea41031b225e3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $929ea41031b225e3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $929ea41031b225e3$var$lb(b, a);
    }
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Eh);
    $929ea41031b225e3$var$G($929ea41031b225e3$var$Eh, b);
}
function $929ea41031b225e3$var$Jh() {
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Eh);
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Fh);
    $929ea41031b225e3$var$E($929ea41031b225e3$var$Gh);
}
function $929ea41031b225e3$var$Kh(a) {
    $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Gh.current);
    var b = $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Eh.current);
    var c = $929ea41031b225e3$var$lb(b, a.type);
    b !== c && ($929ea41031b225e3$var$G($929ea41031b225e3$var$Fh, a), $929ea41031b225e3$var$G($929ea41031b225e3$var$Eh, c));
}
function $929ea41031b225e3$var$Lh(a) {
    $929ea41031b225e3$var$Fh.current === a && ($929ea41031b225e3$var$E($929ea41031b225e3$var$Eh), $929ea41031b225e3$var$E($929ea41031b225e3$var$Fh));
}
var $929ea41031b225e3$var$M = $929ea41031b225e3$var$Uf(0);
function $929ea41031b225e3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $929ea41031b225e3$var$Nh = [];
function $929ea41031b225e3$var$Oh() {
    for(var a = 0; a < $929ea41031b225e3$var$Nh.length; a++)$929ea41031b225e3$var$Nh[a]._workInProgressVersionPrimary = null;
    $929ea41031b225e3$var$Nh.length = 0;
}
var $929ea41031b225e3$var$Ph = $929ea41031b225e3$var$ua.ReactCurrentDispatcher, $929ea41031b225e3$var$Qh = $929ea41031b225e3$var$ua.ReactCurrentBatchConfig, $929ea41031b225e3$var$Rh = 0, $929ea41031b225e3$var$N = null, $929ea41031b225e3$var$O = null, $929ea41031b225e3$var$P = null, $929ea41031b225e3$var$Sh = !1, $929ea41031b225e3$var$Th = !1, $929ea41031b225e3$var$Uh = 0, $929ea41031b225e3$var$Vh = 0;
function $929ea41031b225e3$var$Q() {
    throw Error($929ea41031b225e3$var$p(321));
}
function $929ea41031b225e3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$929ea41031b225e3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $929ea41031b225e3$var$Xh(a, b, c, d, e, f) {
    $929ea41031b225e3$var$Rh = f;
    $929ea41031b225e3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $929ea41031b225e3$var$Ph.current = null === a || null === a.memoizedState ? $929ea41031b225e3$var$Yh : $929ea41031b225e3$var$Zh;
    a = c(d, e);
    if ($929ea41031b225e3$var$Th) {
        f = 0;
        do {
            $929ea41031b225e3$var$Th = !1;
            $929ea41031b225e3$var$Uh = 0;
            if (25 <= f) throw Error($929ea41031b225e3$var$p(301));
            f += 1;
            $929ea41031b225e3$var$P = $929ea41031b225e3$var$O = null;
            b.updateQueue = null;
            $929ea41031b225e3$var$Ph.current = $929ea41031b225e3$var$$h;
            a = c(d, e);
        }while ($929ea41031b225e3$var$Th);
    }
    $929ea41031b225e3$var$Ph.current = $929ea41031b225e3$var$ai;
    b = null !== $929ea41031b225e3$var$O && null !== $929ea41031b225e3$var$O.next;
    $929ea41031b225e3$var$Rh = 0;
    $929ea41031b225e3$var$P = $929ea41031b225e3$var$O = $929ea41031b225e3$var$N = null;
    $929ea41031b225e3$var$Sh = !1;
    if (b) throw Error($929ea41031b225e3$var$p(300));
    return a;
}
function $929ea41031b225e3$var$bi() {
    var a = 0 !== $929ea41031b225e3$var$Uh;
    $929ea41031b225e3$var$Uh = 0;
    return a;
}
function $929ea41031b225e3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $929ea41031b225e3$var$P ? $929ea41031b225e3$var$N.memoizedState = $929ea41031b225e3$var$P = a : $929ea41031b225e3$var$P = $929ea41031b225e3$var$P.next = a;
    return $929ea41031b225e3$var$P;
}
function $929ea41031b225e3$var$di() {
    if (null === $929ea41031b225e3$var$O) {
        var a = $929ea41031b225e3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $929ea41031b225e3$var$O.next;
    var b = null === $929ea41031b225e3$var$P ? $929ea41031b225e3$var$N.memoizedState : $929ea41031b225e3$var$P.next;
    if (null !== b) $929ea41031b225e3$var$P = b, $929ea41031b225e3$var$O = a;
    else {
        if (null === a) throw Error($929ea41031b225e3$var$p(310));
        $929ea41031b225e3$var$O = a;
        a = {
            memoizedState: $929ea41031b225e3$var$O.memoizedState,
            baseState: $929ea41031b225e3$var$O.baseState,
            baseQueue: $929ea41031b225e3$var$O.baseQueue,
            queue: $929ea41031b225e3$var$O.queue,
            next: null
        };
        null === $929ea41031b225e3$var$P ? $929ea41031b225e3$var$N.memoizedState = $929ea41031b225e3$var$P = a : $929ea41031b225e3$var$P = $929ea41031b225e3$var$P.next = a;
    }
    return $929ea41031b225e3$var$P;
}
function $929ea41031b225e3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $929ea41031b225e3$var$fi(a) {
    var b = $929ea41031b225e3$var$di(), c = b.queue;
    if (null === c) throw Error($929ea41031b225e3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $929ea41031b225e3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($929ea41031b225e3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $929ea41031b225e3$var$N.lanes |= m;
                $929ea41031b225e3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $929ea41031b225e3$var$He(d, b.memoizedState) || ($929ea41031b225e3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $929ea41031b225e3$var$N.lanes |= f, $929ea41031b225e3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $929ea41031b225e3$var$gi(a) {
    var b = $929ea41031b225e3$var$di(), c = b.queue;
    if (null === c) throw Error($929ea41031b225e3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $929ea41031b225e3$var$He(f, b.memoizedState) || ($929ea41031b225e3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $929ea41031b225e3$var$hi() {}
function $929ea41031b225e3$var$ii(a, b) {
    var c = $929ea41031b225e3$var$N, d = $929ea41031b225e3$var$di(), e = b(), f = !$929ea41031b225e3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $929ea41031b225e3$var$Ug = !0);
    d = d.queue;
    $929ea41031b225e3$var$ji($929ea41031b225e3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $929ea41031b225e3$var$P && $929ea41031b225e3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $929ea41031b225e3$var$li(9, $929ea41031b225e3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $929ea41031b225e3$var$R) throw Error($929ea41031b225e3$var$p(349));
        0 !== ($929ea41031b225e3$var$Rh & 30) || $929ea41031b225e3$var$ni(c, b, e);
    }
    return e;
}
function $929ea41031b225e3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $929ea41031b225e3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $929ea41031b225e3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $929ea41031b225e3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $929ea41031b225e3$var$oi(b) && $929ea41031b225e3$var$pi(a);
}
function $929ea41031b225e3$var$ki(a, b, c) {
    return c(function() {
        $929ea41031b225e3$var$oi(b) && $929ea41031b225e3$var$pi(a);
    });
}
function $929ea41031b225e3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$929ea41031b225e3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $929ea41031b225e3$var$pi(a) {
    var b = $929ea41031b225e3$var$Zg(a, 1);
    null !== b && $929ea41031b225e3$var$mh(b, a, 1, -1);
}
function $929ea41031b225e3$var$qi(a) {
    var b = $929ea41031b225e3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $929ea41031b225e3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $929ea41031b225e3$var$ri.bind(null, $929ea41031b225e3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $929ea41031b225e3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $929ea41031b225e3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $929ea41031b225e3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $929ea41031b225e3$var$si() {
    return $929ea41031b225e3$var$di().memoizedState;
}
function $929ea41031b225e3$var$ti(a, b, c, d) {
    var e = $929ea41031b225e3$var$ci();
    $929ea41031b225e3$var$N.flags |= a;
    e.memoizedState = $929ea41031b225e3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $929ea41031b225e3$var$ui(a, b, c, d) {
    var e = $929ea41031b225e3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $929ea41031b225e3$var$O) {
        var g = $929ea41031b225e3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $929ea41031b225e3$var$Wh(d, g.deps)) {
            e.memoizedState = $929ea41031b225e3$var$li(b, c, f, d);
            return;
        }
    }
    $929ea41031b225e3$var$N.flags |= a;
    e.memoizedState = $929ea41031b225e3$var$li(1 | b, c, f, d);
}
function $929ea41031b225e3$var$vi(a, b) {
    return $929ea41031b225e3$var$ti(8390656, 8, a, b);
}
function $929ea41031b225e3$var$ji(a, b) {
    return $929ea41031b225e3$var$ui(2048, 8, a, b);
}
function $929ea41031b225e3$var$wi(a, b) {
    return $929ea41031b225e3$var$ui(4, 2, a, b);
}
function $929ea41031b225e3$var$xi(a, b) {
    return $929ea41031b225e3$var$ui(4, 4, a, b);
}
function $929ea41031b225e3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $929ea41031b225e3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $929ea41031b225e3$var$ui(4, 4, $929ea41031b225e3$var$yi.bind(null, b, a), c);
}
function $929ea41031b225e3$var$Ai() {}
function $929ea41031b225e3$var$Bi(a, b) {
    var c = $929ea41031b225e3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $929ea41031b225e3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $929ea41031b225e3$var$Ci(a, b) {
    var c = $929ea41031b225e3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $929ea41031b225e3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $929ea41031b225e3$var$Di(a, b, c) {
    if (0 === ($929ea41031b225e3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $929ea41031b225e3$var$Ug = !0), a.memoizedState = c;
    $929ea41031b225e3$var$He(c, b) || (c = $929ea41031b225e3$var$yc(), $929ea41031b225e3$var$N.lanes |= c, $929ea41031b225e3$var$hh |= c, a.baseState = !0);
    return b;
}
function $929ea41031b225e3$var$Ei(a, b) {
    var c = $929ea41031b225e3$var$C;
    $929ea41031b225e3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $929ea41031b225e3$var$Qh.transition;
    $929ea41031b225e3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $929ea41031b225e3$var$C = c, $929ea41031b225e3$var$Qh.transition = d;
    }
}
function $929ea41031b225e3$var$Fi() {
    return $929ea41031b225e3$var$di().memoizedState;
}
function $929ea41031b225e3$var$Gi(a, b, c) {
    var d = $929ea41031b225e3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($929ea41031b225e3$var$Hi(a)) $929ea41031b225e3$var$Ii(b, c);
    else if (c = $929ea41031b225e3$var$Yg(a, b, c, d), null !== c) {
        var e = $929ea41031b225e3$var$L();
        $929ea41031b225e3$var$mh(c, a, d, e);
        $929ea41031b225e3$var$Ji(c, b, d);
    }
}
function $929ea41031b225e3$var$ri(a, b, c) {
    var d = $929ea41031b225e3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($929ea41031b225e3$var$Hi(a)) $929ea41031b225e3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($929ea41031b225e3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $929ea41031b225e3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $929ea41031b225e3$var$Yg(a, b, e, d);
        null !== c && (e = $929ea41031b225e3$var$L(), $929ea41031b225e3$var$mh(c, a, d, e), $929ea41031b225e3$var$Ji(c, b, d));
    }
}
function $929ea41031b225e3$var$Hi(a) {
    var b = a.alternate;
    return a === $929ea41031b225e3$var$N || null !== b && b === $929ea41031b225e3$var$N;
}
function $929ea41031b225e3$var$Ii(a, b) {
    $929ea41031b225e3$var$Th = $929ea41031b225e3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $929ea41031b225e3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $929ea41031b225e3$var$Cc(a, c);
    }
}
var $929ea41031b225e3$var$ai = {
    readContext: $929ea41031b225e3$var$Vg,
    useCallback: $929ea41031b225e3$var$Q,
    useContext: $929ea41031b225e3$var$Q,
    useEffect: $929ea41031b225e3$var$Q,
    useImperativeHandle: $929ea41031b225e3$var$Q,
    useInsertionEffect: $929ea41031b225e3$var$Q,
    useLayoutEffect: $929ea41031b225e3$var$Q,
    useMemo: $929ea41031b225e3$var$Q,
    useReducer: $929ea41031b225e3$var$Q,
    useRef: $929ea41031b225e3$var$Q,
    useState: $929ea41031b225e3$var$Q,
    useDebugValue: $929ea41031b225e3$var$Q,
    useDeferredValue: $929ea41031b225e3$var$Q,
    useTransition: $929ea41031b225e3$var$Q,
    useMutableSource: $929ea41031b225e3$var$Q,
    useSyncExternalStore: $929ea41031b225e3$var$Q,
    useId: $929ea41031b225e3$var$Q,
    unstable_isNewReconciler: !1
}, $929ea41031b225e3$var$Yh = {
    readContext: $929ea41031b225e3$var$Vg,
    useCallback: function(a, b) {
        $929ea41031b225e3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $929ea41031b225e3$var$Vg,
    useEffect: $929ea41031b225e3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $929ea41031b225e3$var$ti(4194308, 4, $929ea41031b225e3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $929ea41031b225e3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $929ea41031b225e3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $929ea41031b225e3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $929ea41031b225e3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $929ea41031b225e3$var$Gi.bind(null, $929ea41031b225e3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $929ea41031b225e3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $929ea41031b225e3$var$qi,
    useDebugValue: $929ea41031b225e3$var$Ai,
    useDeferredValue: function(a) {
        return $929ea41031b225e3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $929ea41031b225e3$var$qi(!1), b = a[0];
        a = $929ea41031b225e3$var$Ei.bind(null, a[1]);
        $929ea41031b225e3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $929ea41031b225e3$var$N, e = $929ea41031b225e3$var$ci();
        if ($929ea41031b225e3$var$I) {
            if (void 0 === c) throw Error($929ea41031b225e3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $929ea41031b225e3$var$R) throw Error($929ea41031b225e3$var$p(349));
            0 !== ($929ea41031b225e3$var$Rh & 30) || $929ea41031b225e3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $929ea41031b225e3$var$vi($929ea41031b225e3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $929ea41031b225e3$var$li(9, $929ea41031b225e3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $929ea41031b225e3$var$ci(), b = $929ea41031b225e3$var$R.identifierPrefix;
        if ($929ea41031b225e3$var$I) {
            var c = $929ea41031b225e3$var$sg;
            var d = $929ea41031b225e3$var$rg;
            c = (d & ~(1 << 32 - $929ea41031b225e3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $929ea41031b225e3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $929ea41031b225e3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $929ea41031b225e3$var$Zh = {
    readContext: $929ea41031b225e3$var$Vg,
    useCallback: $929ea41031b225e3$var$Bi,
    useContext: $929ea41031b225e3$var$Vg,
    useEffect: $929ea41031b225e3$var$ji,
    useImperativeHandle: $929ea41031b225e3$var$zi,
    useInsertionEffect: $929ea41031b225e3$var$wi,
    useLayoutEffect: $929ea41031b225e3$var$xi,
    useMemo: $929ea41031b225e3$var$Ci,
    useReducer: $929ea41031b225e3$var$fi,
    useRef: $929ea41031b225e3$var$si,
    useState: function() {
        return $929ea41031b225e3$var$fi($929ea41031b225e3$var$ei);
    },
    useDebugValue: $929ea41031b225e3$var$Ai,
    useDeferredValue: function(a) {
        var b = $929ea41031b225e3$var$di();
        return $929ea41031b225e3$var$Di(b, $929ea41031b225e3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $929ea41031b225e3$var$fi($929ea41031b225e3$var$ei)[0], b = $929ea41031b225e3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $929ea41031b225e3$var$hi,
    useSyncExternalStore: $929ea41031b225e3$var$ii,
    useId: $929ea41031b225e3$var$Fi,
    unstable_isNewReconciler: !1
}, $929ea41031b225e3$var$$h = {
    readContext: $929ea41031b225e3$var$Vg,
    useCallback: $929ea41031b225e3$var$Bi,
    useContext: $929ea41031b225e3$var$Vg,
    useEffect: $929ea41031b225e3$var$ji,
    useImperativeHandle: $929ea41031b225e3$var$zi,
    useInsertionEffect: $929ea41031b225e3$var$wi,
    useLayoutEffect: $929ea41031b225e3$var$xi,
    useMemo: $929ea41031b225e3$var$Ci,
    useReducer: $929ea41031b225e3$var$gi,
    useRef: $929ea41031b225e3$var$si,
    useState: function() {
        return $929ea41031b225e3$var$gi($929ea41031b225e3$var$ei);
    },
    useDebugValue: $929ea41031b225e3$var$Ai,
    useDeferredValue: function(a) {
        var b = $929ea41031b225e3$var$di();
        return null === $929ea41031b225e3$var$O ? b.memoizedState = a : $929ea41031b225e3$var$Di(b, $929ea41031b225e3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $929ea41031b225e3$var$gi($929ea41031b225e3$var$ei)[0], b = $929ea41031b225e3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $929ea41031b225e3$var$hi,
    useSyncExternalStore: $929ea41031b225e3$var$ii,
    useId: $929ea41031b225e3$var$Fi,
    unstable_isNewReconciler: !1
};
function $929ea41031b225e3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $929ea41031b225e3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $929ea41031b225e3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $929ea41031b225e3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $929ea41031b225e3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $929ea41031b225e3$var$Oi(a, b, c) {
    c = $929ea41031b225e3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $929ea41031b225e3$var$Pi || ($929ea41031b225e3$var$Pi = !0, $929ea41031b225e3$var$Qi = d);
        $929ea41031b225e3$var$Mi(a, b);
    };
    return c;
}
function $929ea41031b225e3$var$Ri(a, b, c) {
    c = $929ea41031b225e3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $929ea41031b225e3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $929ea41031b225e3$var$Mi(a, b);
        "function" !== typeof d && (null === $929ea41031b225e3$var$Si ? $929ea41031b225e3$var$Si = new Set([
            this
        ]) : $929ea41031b225e3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $929ea41031b225e3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $929ea41031b225e3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $929ea41031b225e3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $929ea41031b225e3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $929ea41031b225e3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $929ea41031b225e3$var$ch(-1, 1), b.tag = 2, $929ea41031b225e3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $929ea41031b225e3$var$Xi = $929ea41031b225e3$var$ua.ReactCurrentOwner, $929ea41031b225e3$var$Ug = !1;
function $929ea41031b225e3$var$Yi(a, b, c, d) {
    b.child = null === a ? $929ea41031b225e3$var$Ch(b, null, c, d) : $929ea41031b225e3$var$Bh(b, a.child, c, d);
}
function $929ea41031b225e3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $929ea41031b225e3$var$Tg(b, e);
    d = $929ea41031b225e3$var$Xh(a, b, c, d, f, e);
    c = $929ea41031b225e3$var$bi();
    if (null !== a && !$929ea41031b225e3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $929ea41031b225e3$var$$i(a, b, e);
    $929ea41031b225e3$var$I && c && $929ea41031b225e3$var$vg(b);
    b.flags |= 1;
    $929ea41031b225e3$var$Yi(a, b, d, e);
    return b.child;
}
function $929ea41031b225e3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$929ea41031b225e3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $929ea41031b225e3$var$cj(a, b, f, d, e);
        a = $929ea41031b225e3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $929ea41031b225e3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $929ea41031b225e3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $929ea41031b225e3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $929ea41031b225e3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($929ea41031b225e3$var$Ie(f, d) && a.ref === b.ref) {
            if ($929ea41031b225e3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($929ea41031b225e3$var$Ug = !0);
            else return b.lanes = a.lanes, $929ea41031b225e3$var$$i(a, b, e);
        }
    }
    return $929ea41031b225e3$var$dj(a, b, c, d, e);
}
function $929ea41031b225e3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $929ea41031b225e3$var$G($929ea41031b225e3$var$fj, $929ea41031b225e3$var$gj), $929ea41031b225e3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $929ea41031b225e3$var$G($929ea41031b225e3$var$fj, $929ea41031b225e3$var$gj), $929ea41031b225e3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $929ea41031b225e3$var$G($929ea41031b225e3$var$fj, $929ea41031b225e3$var$gj);
            $929ea41031b225e3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $929ea41031b225e3$var$G($929ea41031b225e3$var$fj, $929ea41031b225e3$var$gj), $929ea41031b225e3$var$gj |= d;
    $929ea41031b225e3$var$Yi(a, b, e, c);
    return b.child;
}
function $929ea41031b225e3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $929ea41031b225e3$var$dj(a, b, c, d, e) {
    var f = $929ea41031b225e3$var$Zf(c) ? $929ea41031b225e3$var$Xf : $929ea41031b225e3$var$H.current;
    f = $929ea41031b225e3$var$Yf(b, f);
    $929ea41031b225e3$var$Tg(b, e);
    c = $929ea41031b225e3$var$Xh(a, b, c, d, f, e);
    d = $929ea41031b225e3$var$bi();
    if (null !== a && !$929ea41031b225e3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $929ea41031b225e3$var$$i(a, b, e);
    $929ea41031b225e3$var$I && d && $929ea41031b225e3$var$vg(b);
    b.flags |= 1;
    $929ea41031b225e3$var$Yi(a, b, c, e);
    return b.child;
}
function $929ea41031b225e3$var$ij(a, b, c, d, e) {
    if ($929ea41031b225e3$var$Zf(c)) {
        var f = !0;
        $929ea41031b225e3$var$cg(b);
    } else f = !1;
    $929ea41031b225e3$var$Tg(b, e);
    if (null === b.stateNode) $929ea41031b225e3$var$jj(a, b), $929ea41031b225e3$var$ph(b, c, d), $929ea41031b225e3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $929ea41031b225e3$var$Vg(l) : (l = $929ea41031b225e3$var$Zf(c) ? $929ea41031b225e3$var$Xf : $929ea41031b225e3$var$H.current, l = $929ea41031b225e3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $929ea41031b225e3$var$qh(b, g, d, l);
        $929ea41031b225e3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $929ea41031b225e3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $929ea41031b225e3$var$Wf.current || $929ea41031b225e3$var$$g ? ("function" === typeof m && ($929ea41031b225e3$var$kh(b, c, m, d), k = b.memoizedState), (h = $929ea41031b225e3$var$$g || $929ea41031b225e3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $929ea41031b225e3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $929ea41031b225e3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $929ea41031b225e3$var$Vg(k) : (k = $929ea41031b225e3$var$Zf(c) ? $929ea41031b225e3$var$Xf : $929ea41031b225e3$var$H.current, k = $929ea41031b225e3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $929ea41031b225e3$var$qh(b, g, d, k);
        $929ea41031b225e3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $929ea41031b225e3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $929ea41031b225e3$var$Wf.current || $929ea41031b225e3$var$$g ? ("function" === typeof y && ($929ea41031b225e3$var$kh(b, c, y, d), n = b.memoizedState), (l = $929ea41031b225e3$var$$g || $929ea41031b225e3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $929ea41031b225e3$var$kj(a, b, c, d, f, e);
}
function $929ea41031b225e3$var$kj(a, b, c, d, e, f) {
    $929ea41031b225e3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $929ea41031b225e3$var$dg(b, c, !1), $929ea41031b225e3$var$$i(a, b, f);
    d = b.stateNode;
    $929ea41031b225e3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $929ea41031b225e3$var$Bh(b, a.child, null, f), b.child = $929ea41031b225e3$var$Bh(b, null, h, f)) : $929ea41031b225e3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $929ea41031b225e3$var$dg(b, c, !0);
    return b.child;
}
function $929ea41031b225e3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $929ea41031b225e3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $929ea41031b225e3$var$ag(a, b.context, !1);
    $929ea41031b225e3$var$Ih(a, b.containerInfo);
}
function $929ea41031b225e3$var$mj(a, b, c, d, e) {
    $929ea41031b225e3$var$Ig();
    $929ea41031b225e3$var$Jg(e);
    b.flags |= 256;
    $929ea41031b225e3$var$Yi(a, b, c, d);
    return b.child;
}
var $929ea41031b225e3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $929ea41031b225e3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $929ea41031b225e3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $929ea41031b225e3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $929ea41031b225e3$var$G($929ea41031b225e3$var$M, e & 1);
    if (null === a) {
        $929ea41031b225e3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $929ea41031b225e3$var$qj(g, d, 0, null), a = $929ea41031b225e3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $929ea41031b225e3$var$oj(c), b.memoizedState = $929ea41031b225e3$var$nj, a) : $929ea41031b225e3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $929ea41031b225e3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $929ea41031b225e3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $929ea41031b225e3$var$wh(h, f) : (f = $929ea41031b225e3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $929ea41031b225e3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $929ea41031b225e3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $929ea41031b225e3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $929ea41031b225e3$var$rj(a, b) {
    b = $929ea41031b225e3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $929ea41031b225e3$var$tj(a, b, c, d) {
    null !== d && $929ea41031b225e3$var$Jg(d);
    $929ea41031b225e3$var$Bh(b, a.child, null, c);
    a = $929ea41031b225e3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $929ea41031b225e3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $929ea41031b225e3$var$Li(Error($929ea41031b225e3$var$p(422))), $929ea41031b225e3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $929ea41031b225e3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $929ea41031b225e3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $929ea41031b225e3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $929ea41031b225e3$var$oj(g);
        b.memoizedState = $929ea41031b225e3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $929ea41031b225e3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($929ea41031b225e3$var$p(419));
        d = $929ea41031b225e3$var$Li(f, d, void 0);
        return $929ea41031b225e3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($929ea41031b225e3$var$Ug || h) {
        d = $929ea41031b225e3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $929ea41031b225e3$var$Zg(a, e), $929ea41031b225e3$var$mh(d, a, e, -1));
        }
        $929ea41031b225e3$var$uj();
        d = $929ea41031b225e3$var$Li(Error($929ea41031b225e3$var$p(421)));
        return $929ea41031b225e3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $929ea41031b225e3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $929ea41031b225e3$var$yg = $929ea41031b225e3$var$Lf(e.nextSibling);
    $929ea41031b225e3$var$xg = b;
    $929ea41031b225e3$var$I = !0;
    $929ea41031b225e3$var$zg = null;
    null !== a && ($929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$rg, $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$sg, $929ea41031b225e3$var$og[$929ea41031b225e3$var$pg++] = $929ea41031b225e3$var$qg, $929ea41031b225e3$var$rg = a.id, $929ea41031b225e3$var$sg = a.overflow, $929ea41031b225e3$var$qg = b);
    b = $929ea41031b225e3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $929ea41031b225e3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $929ea41031b225e3$var$Sg(a.return, b, c);
}
function $929ea41031b225e3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $929ea41031b225e3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $929ea41031b225e3$var$Yi(a, b, d.children, c);
    d = $929ea41031b225e3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $929ea41031b225e3$var$wj(a, c, b);
            else if (19 === a.tag) $929ea41031b225e3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $929ea41031b225e3$var$G($929ea41031b225e3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $929ea41031b225e3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $929ea41031b225e3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $929ea41031b225e3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $929ea41031b225e3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $929ea41031b225e3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $929ea41031b225e3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $929ea41031b225e3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $929ea41031b225e3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($929ea41031b225e3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $929ea41031b225e3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $929ea41031b225e3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $929ea41031b225e3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $929ea41031b225e3$var$lj(b);
            $929ea41031b225e3$var$Ig();
            break;
        case 5:
            $929ea41031b225e3$var$Kh(b);
            break;
        case 1:
            $929ea41031b225e3$var$Zf(b.type) && $929ea41031b225e3$var$cg(b);
            break;
        case 4:
            $929ea41031b225e3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $929ea41031b225e3$var$G($929ea41031b225e3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $929ea41031b225e3$var$G($929ea41031b225e3$var$M, $929ea41031b225e3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $929ea41031b225e3$var$pj(a, b, c);
                $929ea41031b225e3$var$G($929ea41031b225e3$var$M, $929ea41031b225e3$var$M.current & 1);
                a = $929ea41031b225e3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $929ea41031b225e3$var$G($929ea41031b225e3$var$M, $929ea41031b225e3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $929ea41031b225e3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $929ea41031b225e3$var$G($929ea41031b225e3$var$M, $929ea41031b225e3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $929ea41031b225e3$var$ej(a, b, c);
    }
    return $929ea41031b225e3$var$$i(a, b, c);
}
var $929ea41031b225e3$var$Aj, $929ea41031b225e3$var$Bj, $929ea41031b225e3$var$Cj, $929ea41031b225e3$var$Dj;
$929ea41031b225e3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$929ea41031b225e3$var$Bj = function() {};
$929ea41031b225e3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $929ea41031b225e3$var$Ya(a, e);
                d = $929ea41031b225e3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $929ea41031b225e3$var$A({}, e, {
                    value: void 0
                });
                d = $929ea41031b225e3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $929ea41031b225e3$var$gb(a, e);
                d = $929ea41031b225e3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $929ea41031b225e3$var$Bf);
        }
        $929ea41031b225e3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($929ea41031b225e3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($929ea41031b225e3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $929ea41031b225e3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$929ea41031b225e3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $929ea41031b225e3$var$Ej(a, b) {
    if (!$929ea41031b225e3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $929ea41031b225e3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $929ea41031b225e3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $929ea41031b225e3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $929ea41031b225e3$var$S(b), null;
        case 1:
            return $929ea41031b225e3$var$Zf(b.type) && $929ea41031b225e3$var$$f(), $929ea41031b225e3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $929ea41031b225e3$var$Jh();
            $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf);
            $929ea41031b225e3$var$E($929ea41031b225e3$var$H);
            $929ea41031b225e3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $929ea41031b225e3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $929ea41031b225e3$var$zg && ($929ea41031b225e3$var$Gj($929ea41031b225e3$var$zg), $929ea41031b225e3$var$zg = null));
            $929ea41031b225e3$var$Bj(a, b);
            $929ea41031b225e3$var$S(b);
            return null;
        case 5:
            $929ea41031b225e3$var$Lh(b);
            var e = $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $929ea41031b225e3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($929ea41031b225e3$var$p(166));
                    $929ea41031b225e3$var$S(b);
                    return null;
                }
                a = $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Eh.current);
                if ($929ea41031b225e3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$929ea41031b225e3$var$Of] = b;
                    d[$929ea41031b225e3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $929ea41031b225e3$var$D("cancel", d);
                            $929ea41031b225e3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $929ea41031b225e3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $929ea41031b225e3$var$lf.length; e++)$929ea41031b225e3$var$D($929ea41031b225e3$var$lf[e], d);
                            break;
                        case "source":
                            $929ea41031b225e3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $929ea41031b225e3$var$D("error", d);
                            $929ea41031b225e3$var$D("load", d);
                            break;
                        case "details":
                            $929ea41031b225e3$var$D("toggle", d);
                            break;
                        case "input":
                            $929ea41031b225e3$var$Za(d, f);
                            $929ea41031b225e3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $929ea41031b225e3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $929ea41031b225e3$var$hb(d, f), $929ea41031b225e3$var$D("invalid", d);
                    }
                    $929ea41031b225e3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $929ea41031b225e3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $929ea41031b225e3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $929ea41031b225e3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $929ea41031b225e3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $929ea41031b225e3$var$Va(d);
                            $929ea41031b225e3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $929ea41031b225e3$var$Va(d);
                            $929ea41031b225e3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $929ea41031b225e3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $929ea41031b225e3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$929ea41031b225e3$var$Of] = b;
                    a[$929ea41031b225e3$var$Pf] = d;
                    $929ea41031b225e3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $929ea41031b225e3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $929ea41031b225e3$var$D("cancel", a);
                                $929ea41031b225e3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $929ea41031b225e3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $929ea41031b225e3$var$lf.length; e++)$929ea41031b225e3$var$D($929ea41031b225e3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $929ea41031b225e3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $929ea41031b225e3$var$D("error", a);
                                $929ea41031b225e3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $929ea41031b225e3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $929ea41031b225e3$var$Za(a, d);
                                e = $929ea41031b225e3$var$Ya(a, d);
                                $929ea41031b225e3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $929ea41031b225e3$var$A({}, d, {
                                    value: void 0
                                });
                                $929ea41031b225e3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $929ea41031b225e3$var$hb(a, d);
                                e = $929ea41031b225e3$var$gb(a, d);
                                $929ea41031b225e3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $929ea41031b225e3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $929ea41031b225e3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $929ea41031b225e3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $929ea41031b225e3$var$ob(a, k) : "number" === typeof k && $929ea41031b225e3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($929ea41031b225e3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $929ea41031b225e3$var$D("scroll", a) : null != k && $929ea41031b225e3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $929ea41031b225e3$var$Va(a);
                                $929ea41031b225e3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $929ea41031b225e3$var$Va(a);
                                $929ea41031b225e3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $929ea41031b225e3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $929ea41031b225e3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $929ea41031b225e3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $929ea41031b225e3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $929ea41031b225e3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $929ea41031b225e3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($929ea41031b225e3$var$p(166));
                c = $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Gh.current);
                $929ea41031b225e3$var$Hh($929ea41031b225e3$var$Eh.current);
                if ($929ea41031b225e3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$929ea41031b225e3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $929ea41031b225e3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $929ea41031b225e3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $929ea41031b225e3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$929ea41031b225e3$var$Of] = b, b.stateNode = d;
            }
            $929ea41031b225e3$var$S(b);
            return null;
        case 13:
            $929ea41031b225e3$var$E($929ea41031b225e3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($929ea41031b225e3$var$I && null !== $929ea41031b225e3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $929ea41031b225e3$var$Hg(), $929ea41031b225e3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $929ea41031b225e3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($929ea41031b225e3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($929ea41031b225e3$var$p(317));
                        f[$929ea41031b225e3$var$Of] = b;
                    } else $929ea41031b225e3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $929ea41031b225e3$var$S(b);
                    f = !1;
                } else null !== $929ea41031b225e3$var$zg && ($929ea41031b225e3$var$Gj($929ea41031b225e3$var$zg), $929ea41031b225e3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($929ea41031b225e3$var$M.current & 1) ? 0 === $929ea41031b225e3$var$T && ($929ea41031b225e3$var$T = 3) : $929ea41031b225e3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $929ea41031b225e3$var$S(b);
            return null;
        case 4:
            return $929ea41031b225e3$var$Jh(), $929ea41031b225e3$var$Bj(a, b), null === a && $929ea41031b225e3$var$sf(b.stateNode.containerInfo), $929ea41031b225e3$var$S(b), null;
        case 10:
            return $929ea41031b225e3$var$Rg(b.type._context), $929ea41031b225e3$var$S(b), null;
        case 17:
            return $929ea41031b225e3$var$Zf(b.type) && $929ea41031b225e3$var$$f(), $929ea41031b225e3$var$S(b), null;
        case 19:
            $929ea41031b225e3$var$E($929ea41031b225e3$var$M);
            f = b.memoizedState;
            if (null === f) return $929ea41031b225e3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $929ea41031b225e3$var$Ej(f, !1);
                else {
                    if (0 !== $929ea41031b225e3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $929ea41031b225e3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $929ea41031b225e3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $929ea41031b225e3$var$G($929ea41031b225e3$var$M, $929ea41031b225e3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $929ea41031b225e3$var$B() > $929ea41031b225e3$var$Hj && (b.flags |= 128, d = !0, $929ea41031b225e3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $929ea41031b225e3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $929ea41031b225e3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$929ea41031b225e3$var$I) return $929ea41031b225e3$var$S(b), null;
                    } else 2 * $929ea41031b225e3$var$B() - f.renderingStartTime > $929ea41031b225e3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $929ea41031b225e3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $929ea41031b225e3$var$B(), b.sibling = null, c = $929ea41031b225e3$var$M.current, $929ea41031b225e3$var$G($929ea41031b225e3$var$M, d ? c & 1 | 2 : c & 1), b;
            $929ea41031b225e3$var$S(b);
            return null;
        case 22:
        case 23:
            return $929ea41031b225e3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($929ea41031b225e3$var$gj & 1073741824) && ($929ea41031b225e3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $929ea41031b225e3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($929ea41031b225e3$var$p(156, b.tag));
}
function $929ea41031b225e3$var$Jj(a, b) {
    $929ea41031b225e3$var$wg(b);
    switch(b.tag){
        case 1:
            return $929ea41031b225e3$var$Zf(b.type) && $929ea41031b225e3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $929ea41031b225e3$var$Jh(), $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf), $929ea41031b225e3$var$E($929ea41031b225e3$var$H), $929ea41031b225e3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $929ea41031b225e3$var$Lh(b), null;
        case 13:
            $929ea41031b225e3$var$E($929ea41031b225e3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($929ea41031b225e3$var$p(340));
                $929ea41031b225e3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $929ea41031b225e3$var$E($929ea41031b225e3$var$M), null;
        case 4:
            return $929ea41031b225e3$var$Jh(), null;
        case 10:
            return $929ea41031b225e3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $929ea41031b225e3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $929ea41031b225e3$var$Kj = !1, $929ea41031b225e3$var$U = !1, $929ea41031b225e3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $929ea41031b225e3$var$V = null;
function $929ea41031b225e3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $929ea41031b225e3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $929ea41031b225e3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $929ea41031b225e3$var$W(a, b, d);
    }
}
var $929ea41031b225e3$var$Oj = !1;
function $929ea41031b225e3$var$Pj(a, b) {
    $929ea41031b225e3$var$Cf = $929ea41031b225e3$var$dd;
    a = $929ea41031b225e3$var$Me();
    if ($929ea41031b225e3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $929ea41031b225e3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $929ea41031b225e3$var$dd = !1;
    for($929ea41031b225e3$var$V = b; null !== $929ea41031b225e3$var$V;)if (b = $929ea41031b225e3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $929ea41031b225e3$var$V = a;
    else for(; null !== $929ea41031b225e3$var$V;){
        b = $929ea41031b225e3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $929ea41031b225e3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($929ea41031b225e3$var$p(163));
            }
        } catch (F) {
            $929ea41031b225e3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $929ea41031b225e3$var$V = a;
            break;
        }
        $929ea41031b225e3$var$V = b.return;
    }
    n = $929ea41031b225e3$var$Oj;
    $929ea41031b225e3$var$Oj = !1;
    return n;
}
function $929ea41031b225e3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $929ea41031b225e3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $929ea41031b225e3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $929ea41031b225e3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $929ea41031b225e3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $929ea41031b225e3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$929ea41031b225e3$var$Of], delete b[$929ea41031b225e3$var$Pf], delete b[$929ea41031b225e3$var$of], delete b[$929ea41031b225e3$var$Qf], delete b[$929ea41031b225e3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $929ea41031b225e3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $929ea41031b225e3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $929ea41031b225e3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $929ea41031b225e3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $929ea41031b225e3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($929ea41031b225e3$var$Wj(a, b, c), a = a.sibling; null !== a;)$929ea41031b225e3$var$Wj(a, b, c), a = a.sibling;
}
function $929ea41031b225e3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($929ea41031b225e3$var$Xj(a, b, c), a = a.sibling; null !== a;)$929ea41031b225e3$var$Xj(a, b, c), a = a.sibling;
}
var $929ea41031b225e3$var$X = null, $929ea41031b225e3$var$Yj = !1;
function $929ea41031b225e3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$929ea41031b225e3$var$ak(a, b, c), c = c.sibling;
}
function $929ea41031b225e3$var$ak(a, b, c) {
    if ($929ea41031b225e3$var$lc && "function" === typeof $929ea41031b225e3$var$lc.onCommitFiberUnmount) try {
        $929ea41031b225e3$var$lc.onCommitFiberUnmount($929ea41031b225e3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $929ea41031b225e3$var$U || $929ea41031b225e3$var$Mj(c, b);
        case 6:
            var d = $929ea41031b225e3$var$X, e = $929ea41031b225e3$var$Yj;
            $929ea41031b225e3$var$X = null;
            $929ea41031b225e3$var$Zj(a, b, c);
            $929ea41031b225e3$var$X = d;
            $929ea41031b225e3$var$Yj = e;
            null !== $929ea41031b225e3$var$X && ($929ea41031b225e3$var$Yj ? (a = $929ea41031b225e3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $929ea41031b225e3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $929ea41031b225e3$var$X && ($929ea41031b225e3$var$Yj ? (a = $929ea41031b225e3$var$X, c = c.stateNode, 8 === a.nodeType ? $929ea41031b225e3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $929ea41031b225e3$var$Kf(a, c), $929ea41031b225e3$var$bd(a)) : $929ea41031b225e3$var$Kf($929ea41031b225e3$var$X, c.stateNode));
            break;
        case 4:
            d = $929ea41031b225e3$var$X;
            e = $929ea41031b225e3$var$Yj;
            $929ea41031b225e3$var$X = c.stateNode.containerInfo;
            $929ea41031b225e3$var$Yj = !0;
            $929ea41031b225e3$var$Zj(a, b, c);
            $929ea41031b225e3$var$X = d;
            $929ea41031b225e3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$929ea41031b225e3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $929ea41031b225e3$var$Nj(c, b, g) : 0 !== (f & 4) && $929ea41031b225e3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $929ea41031b225e3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$929ea41031b225e3$var$U && ($929ea41031b225e3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $929ea41031b225e3$var$W(c, b, h);
            }
            $929ea41031b225e3$var$Zj(a, b, c);
            break;
        case 21:
            $929ea41031b225e3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($929ea41031b225e3$var$U = (d = $929ea41031b225e3$var$U) || null !== c.memoizedState, $929ea41031b225e3$var$Zj(a, b, c), $929ea41031b225e3$var$U = d) : $929ea41031b225e3$var$Zj(a, b, c);
            break;
        default:
            $929ea41031b225e3$var$Zj(a, b, c);
    }
}
function $929ea41031b225e3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $929ea41031b225e3$var$Lj);
        b.forEach(function(b) {
            var d = $929ea41031b225e3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $929ea41031b225e3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $929ea41031b225e3$var$X = h.stateNode;
                        $929ea41031b225e3$var$Yj = !1;
                        break a;
                    case 3:
                        $929ea41031b225e3$var$X = h.stateNode.containerInfo;
                        $929ea41031b225e3$var$Yj = !0;
                        break a;
                    case 4:
                        $929ea41031b225e3$var$X = h.stateNode.containerInfo;
                        $929ea41031b225e3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $929ea41031b225e3$var$X) throw Error($929ea41031b225e3$var$p(160));
            $929ea41031b225e3$var$ak(f, g, e);
            $929ea41031b225e3$var$X = null;
            $929ea41031b225e3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $929ea41031b225e3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$929ea41031b225e3$var$ek(b, a), b = b.sibling;
}
function $929ea41031b225e3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            if (d & 4) {
                try {
                    $929ea41031b225e3$var$Qj(3, a, a.return), $929ea41031b225e3$var$Rj(3, a);
                } catch (t) {
                    $929ea41031b225e3$var$W(a, a.return, t);
                }
                try {
                    $929ea41031b225e3$var$Qj(5, a, a.return);
                } catch (t) {
                    $929ea41031b225e3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            d & 512 && null !== c && $929ea41031b225e3$var$Mj(c, c.return);
            break;
        case 5:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            d & 512 && null !== c && $929ea41031b225e3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $929ea41031b225e3$var$ob(e, "");
                } catch (t) {
                    $929ea41031b225e3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $929ea41031b225e3$var$ab(e, f);
                    $929ea41031b225e3$var$vb(h, g);
                    var l = $929ea41031b225e3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $929ea41031b225e3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $929ea41031b225e3$var$nb(e, q) : "children" === m ? $929ea41031b225e3$var$ob(e, q) : $929ea41031b225e3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $929ea41031b225e3$var$bb(e, f);
                            break;
                        case "textarea":
                            $929ea41031b225e3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $929ea41031b225e3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $929ea41031b225e3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $929ea41031b225e3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$929ea41031b225e3$var$Pf] = f;
                } catch (t) {
                    $929ea41031b225e3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($929ea41031b225e3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $929ea41031b225e3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $929ea41031b225e3$var$bd(b.containerInfo);
            } catch (t) {
                $929ea41031b225e3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            break;
        case 13:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($929ea41031b225e3$var$gk = $929ea41031b225e3$var$B()));
            d & 4 && $929ea41031b225e3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($929ea41031b225e3$var$U = (l = $929ea41031b225e3$var$U) || m, $929ea41031b225e3$var$dk(b, a), $929ea41031b225e3$var$U = l) : $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($929ea41031b225e3$var$V = a, m = a.child; null !== m;){
                    for(q = $929ea41031b225e3$var$V = m; null !== $929ea41031b225e3$var$V;){
                        r = $929ea41031b225e3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $929ea41031b225e3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $929ea41031b225e3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $929ea41031b225e3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $929ea41031b225e3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $929ea41031b225e3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $929ea41031b225e3$var$V = y) : $929ea41031b225e3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $929ea41031b225e3$var$rb("display", g));
                            } catch (t) {
                                $929ea41031b225e3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $929ea41031b225e3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $929ea41031b225e3$var$dk(b, a);
            $929ea41031b225e3$var$fk(a);
            d & 4 && $929ea41031b225e3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $929ea41031b225e3$var$dk(b, a), $929ea41031b225e3$var$fk(a);
    }
}
function $929ea41031b225e3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($929ea41031b225e3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($929ea41031b225e3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($929ea41031b225e3$var$ob(e, ""), d.flags &= -33);
                    var f = $929ea41031b225e3$var$Vj(a);
                    $929ea41031b225e3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $929ea41031b225e3$var$Vj(a);
                    $929ea41031b225e3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($929ea41031b225e3$var$p(161));
            }
        } catch (k) {
            $929ea41031b225e3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $929ea41031b225e3$var$ik(a, b, c) {
    $929ea41031b225e3$var$V = a;
    $929ea41031b225e3$var$jk(a, b, c);
}
function $929ea41031b225e3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $929ea41031b225e3$var$V;){
        var e = $929ea41031b225e3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $929ea41031b225e3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $929ea41031b225e3$var$U;
                h = $929ea41031b225e3$var$Kj;
                var l = $929ea41031b225e3$var$U;
                $929ea41031b225e3$var$Kj = g;
                if (($929ea41031b225e3$var$U = k) && !l) for($929ea41031b225e3$var$V = e; null !== $929ea41031b225e3$var$V;)g = $929ea41031b225e3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $929ea41031b225e3$var$kk(e) : null !== k ? (k.return = g, $929ea41031b225e3$var$V = k) : $929ea41031b225e3$var$kk(e);
                for(; null !== f;)$929ea41031b225e3$var$V = f, $929ea41031b225e3$var$jk(f, b, c), f = f.sibling;
                $929ea41031b225e3$var$V = e;
                $929ea41031b225e3$var$Kj = h;
                $929ea41031b225e3$var$U = l;
            }
            $929ea41031b225e3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $929ea41031b225e3$var$V = f) : $929ea41031b225e3$var$lk(a, b, c);
    }
}
function $929ea41031b225e3$var$lk(a) {
    for(; null !== $929ea41031b225e3$var$V;){
        var b = $929ea41031b225e3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $929ea41031b225e3$var$U || $929ea41031b225e3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$929ea41031b225e3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $929ea41031b225e3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $929ea41031b225e3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $929ea41031b225e3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $929ea41031b225e3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($929ea41031b225e3$var$p(163));
                }
                $929ea41031b225e3$var$U || b.flags & 512 && $929ea41031b225e3$var$Sj(b);
            } catch (r) {
                $929ea41031b225e3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $929ea41031b225e3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $929ea41031b225e3$var$V = c;
            break;
        }
        $929ea41031b225e3$var$V = b.return;
    }
}
function $929ea41031b225e3$var$hk(a) {
    for(; null !== $929ea41031b225e3$var$V;){
        var b = $929ea41031b225e3$var$V;
        if (b === a) {
            $929ea41031b225e3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $929ea41031b225e3$var$V = c;
            break;
        }
        $929ea41031b225e3$var$V = b.return;
    }
}
function $929ea41031b225e3$var$kk(a) {
    for(; null !== $929ea41031b225e3$var$V;){
        var b = $929ea41031b225e3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $929ea41031b225e3$var$Rj(4, b);
                    } catch (k) {
                        $929ea41031b225e3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $929ea41031b225e3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $929ea41031b225e3$var$Sj(b);
                    } catch (k) {
                        $929ea41031b225e3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $929ea41031b225e3$var$Sj(b);
                    } catch (k) {
                        $929ea41031b225e3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $929ea41031b225e3$var$W(b, b.return, k);
        }
        if (b === a) {
            $929ea41031b225e3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $929ea41031b225e3$var$V = h;
            break;
        }
        $929ea41031b225e3$var$V = b.return;
    }
}
var $929ea41031b225e3$var$mk = Math.ceil, $929ea41031b225e3$var$nk = $929ea41031b225e3$var$ua.ReactCurrentDispatcher, $929ea41031b225e3$var$ok = $929ea41031b225e3$var$ua.ReactCurrentOwner, $929ea41031b225e3$var$pk = $929ea41031b225e3$var$ua.ReactCurrentBatchConfig, $929ea41031b225e3$var$K = 0, $929ea41031b225e3$var$R = null, $929ea41031b225e3$var$Y = null, $929ea41031b225e3$var$Z = 0, $929ea41031b225e3$var$gj = 0, $929ea41031b225e3$var$fj = $929ea41031b225e3$var$Uf(0), $929ea41031b225e3$var$T = 0, $929ea41031b225e3$var$qk = null, $929ea41031b225e3$var$hh = 0, $929ea41031b225e3$var$rk = 0, $929ea41031b225e3$var$sk = 0, $929ea41031b225e3$var$tk = null, $929ea41031b225e3$var$uk = null, $929ea41031b225e3$var$gk = 0, $929ea41031b225e3$var$Hj = Infinity, $929ea41031b225e3$var$vk = null, $929ea41031b225e3$var$Pi = !1, $929ea41031b225e3$var$Qi = null, $929ea41031b225e3$var$Si = null, $929ea41031b225e3$var$wk = !1, $929ea41031b225e3$var$xk = null, $929ea41031b225e3$var$yk = 0, $929ea41031b225e3$var$zk = 0, $929ea41031b225e3$var$Ak = null, $929ea41031b225e3$var$Bk = -1, $929ea41031b225e3$var$Ck = 0;
function $929ea41031b225e3$var$L() {
    return 0 !== ($929ea41031b225e3$var$K & 6) ? $929ea41031b225e3$var$B() : -1 !== $929ea41031b225e3$var$Bk ? $929ea41031b225e3$var$Bk : $929ea41031b225e3$var$Bk = $929ea41031b225e3$var$B();
}
function $929ea41031b225e3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($929ea41031b225e3$var$K & 2) && 0 !== $929ea41031b225e3$var$Z) return $929ea41031b225e3$var$Z & -$929ea41031b225e3$var$Z;
    if (null !== $929ea41031b225e3$var$Kg.transition) return 0 === $929ea41031b225e3$var$Ck && ($929ea41031b225e3$var$Ck = $929ea41031b225e3$var$yc()), $929ea41031b225e3$var$Ck;
    a = $929ea41031b225e3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $929ea41031b225e3$var$jd(a.type);
    return a;
}
function $929ea41031b225e3$var$mh(a, b, c, d) {
    if (50 < $929ea41031b225e3$var$zk) throw $929ea41031b225e3$var$zk = 0, $929ea41031b225e3$var$Ak = null, Error($929ea41031b225e3$var$p(185));
    $929ea41031b225e3$var$Ac(a, c, d);
    if (0 === ($929ea41031b225e3$var$K & 2) || a !== $929ea41031b225e3$var$R) a === $929ea41031b225e3$var$R && (0 === ($929ea41031b225e3$var$K & 2) && ($929ea41031b225e3$var$rk |= c), 4 === $929ea41031b225e3$var$T && $929ea41031b225e3$var$Dk(a, $929ea41031b225e3$var$Z)), $929ea41031b225e3$var$Ek(a, d), 1 === c && 0 === $929ea41031b225e3$var$K && 0 === (b.mode & 1) && ($929ea41031b225e3$var$Hj = $929ea41031b225e3$var$B() + 500, $929ea41031b225e3$var$fg && $929ea41031b225e3$var$jg());
}
function $929ea41031b225e3$var$Ek(a, b) {
    var c = a.callbackNode;
    $929ea41031b225e3$var$wc(a, b);
    var d = $929ea41031b225e3$var$uc(a, a === $929ea41031b225e3$var$R ? $929ea41031b225e3$var$Z : 0);
    if (0 === d) null !== c && $929ea41031b225e3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $929ea41031b225e3$var$bc(c);
        if (1 === b) 0 === a.tag ? $929ea41031b225e3$var$ig($929ea41031b225e3$var$Fk.bind(null, a)) : $929ea41031b225e3$var$hg($929ea41031b225e3$var$Fk.bind(null, a)), $929ea41031b225e3$var$Jf(function() {
            0 === ($929ea41031b225e3$var$K & 6) && $929ea41031b225e3$var$jg();
        }), c = null;
        else {
            switch($929ea41031b225e3$var$Dc(d)){
                case 1:
                    c = $929ea41031b225e3$var$fc;
                    break;
                case 4:
                    c = $929ea41031b225e3$var$gc;
                    break;
                case 16:
                    c = $929ea41031b225e3$var$hc;
                    break;
                case 536870912:
                    c = $929ea41031b225e3$var$jc;
                    break;
                default:
                    c = $929ea41031b225e3$var$hc;
            }
            c = $929ea41031b225e3$var$Gk(c, $929ea41031b225e3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $929ea41031b225e3$var$Hk(a, b) {
    $929ea41031b225e3$var$Bk = -1;
    $929ea41031b225e3$var$Ck = 0;
    if (0 !== ($929ea41031b225e3$var$K & 6)) throw Error($929ea41031b225e3$var$p(327));
    var c = a.callbackNode;
    if ($929ea41031b225e3$var$Ik() && a.callbackNode !== c) return null;
    var d = $929ea41031b225e3$var$uc(a, a === $929ea41031b225e3$var$R ? $929ea41031b225e3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $929ea41031b225e3$var$Jk(a, d);
    else {
        b = d;
        var e = $929ea41031b225e3$var$K;
        $929ea41031b225e3$var$K |= 2;
        var f = $929ea41031b225e3$var$Kk();
        if ($929ea41031b225e3$var$R !== a || $929ea41031b225e3$var$Z !== b) $929ea41031b225e3$var$vk = null, $929ea41031b225e3$var$Hj = $929ea41031b225e3$var$B() + 500, $929ea41031b225e3$var$Lk(a, b);
        for(;;)try {
            $929ea41031b225e3$var$Mk();
            break;
        } catch (h) {
            $929ea41031b225e3$var$Nk(a, h);
        }
        $929ea41031b225e3$var$Qg();
        $929ea41031b225e3$var$nk.current = f;
        $929ea41031b225e3$var$K = e;
        null !== $929ea41031b225e3$var$Y ? b = 0 : ($929ea41031b225e3$var$R = null, $929ea41031b225e3$var$Z = 0, b = $929ea41031b225e3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $929ea41031b225e3$var$xc(a), 0 !== e && (d = e, b = $929ea41031b225e3$var$Ok(a, e)));
        if (1 === b) throw c = $929ea41031b225e3$var$qk, $929ea41031b225e3$var$Lk(a, 0), $929ea41031b225e3$var$Dk(a, d), $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B()), c;
        if (6 === b) $929ea41031b225e3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$929ea41031b225e3$var$Pk(e) && (b = $929ea41031b225e3$var$Jk(a, d), 2 === b && (f = $929ea41031b225e3$var$xc(a), 0 !== f && (d = f, b = $929ea41031b225e3$var$Ok(a, f))), 1 === b)) throw c = $929ea41031b225e3$var$qk, $929ea41031b225e3$var$Lk(a, 0), $929ea41031b225e3$var$Dk(a, d), $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($929ea41031b225e3$var$p(345));
                case 2:
                    $929ea41031b225e3$var$Qk(a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk);
                    break;
                case 3:
                    $929ea41031b225e3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $929ea41031b225e3$var$gk + 500 - $929ea41031b225e3$var$B(), 10 < b)) {
                        if (0 !== $929ea41031b225e3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $929ea41031b225e3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $929ea41031b225e3$var$Ff($929ea41031b225e3$var$Qk.bind(null, a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk), b);
                        break;
                    }
                    $929ea41031b225e3$var$Qk(a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk);
                    break;
                case 4:
                    $929ea41031b225e3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $929ea41031b225e3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $929ea41031b225e3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $929ea41031b225e3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $929ea41031b225e3$var$Ff($929ea41031b225e3$var$Qk.bind(null, a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk), d);
                        break;
                    }
                    $929ea41031b225e3$var$Qk(a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk);
                    break;
                case 5:
                    $929ea41031b225e3$var$Qk(a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk);
                    break;
                default:
                    throw Error($929ea41031b225e3$var$p(329));
            }
        }
    }
    $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B());
    return a.callbackNode === c ? $929ea41031b225e3$var$Hk.bind(null, a) : null;
}
function $929ea41031b225e3$var$Ok(a, b) {
    var c = $929ea41031b225e3$var$tk;
    a.current.memoizedState.isDehydrated && ($929ea41031b225e3$var$Lk(a, b).flags |= 256);
    a = $929ea41031b225e3$var$Jk(a, b);
    2 !== a && (b = $929ea41031b225e3$var$uk, $929ea41031b225e3$var$uk = c, null !== b && $929ea41031b225e3$var$Gj(b));
    return a;
}
function $929ea41031b225e3$var$Gj(a) {
    null === $929ea41031b225e3$var$uk ? $929ea41031b225e3$var$uk = a : $929ea41031b225e3$var$uk.push.apply($929ea41031b225e3$var$uk, a);
}
function $929ea41031b225e3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$929ea41031b225e3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $929ea41031b225e3$var$Dk(a, b) {
    b &= ~$929ea41031b225e3$var$sk;
    b &= ~$929ea41031b225e3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $929ea41031b225e3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $929ea41031b225e3$var$Fk(a) {
    if (0 !== ($929ea41031b225e3$var$K & 6)) throw Error($929ea41031b225e3$var$p(327));
    $929ea41031b225e3$var$Ik();
    var b = $929ea41031b225e3$var$uc(a, 0);
    if (0 === (b & 1)) return $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B()), null;
    var c = $929ea41031b225e3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $929ea41031b225e3$var$xc(a);
        0 !== d && (b = d, c = $929ea41031b225e3$var$Ok(a, d));
    }
    if (1 === c) throw c = $929ea41031b225e3$var$qk, $929ea41031b225e3$var$Lk(a, 0), $929ea41031b225e3$var$Dk(a, b), $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B()), c;
    if (6 === c) throw Error($929ea41031b225e3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $929ea41031b225e3$var$Qk(a, $929ea41031b225e3$var$uk, $929ea41031b225e3$var$vk);
    $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B());
    return null;
}
function $929ea41031b225e3$var$Rk(a, b) {
    var c = $929ea41031b225e3$var$K;
    $929ea41031b225e3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $929ea41031b225e3$var$K = c, 0 === $929ea41031b225e3$var$K && ($929ea41031b225e3$var$Hj = $929ea41031b225e3$var$B() + 500, $929ea41031b225e3$var$fg && $929ea41031b225e3$var$jg());
    }
}
function $929ea41031b225e3$var$Sk(a) {
    null !== $929ea41031b225e3$var$xk && 0 === $929ea41031b225e3$var$xk.tag && 0 === ($929ea41031b225e3$var$K & 6) && $929ea41031b225e3$var$Ik();
    var b = $929ea41031b225e3$var$K;
    $929ea41031b225e3$var$K |= 1;
    var c = $929ea41031b225e3$var$pk.transition, d = $929ea41031b225e3$var$C;
    try {
        if ($929ea41031b225e3$var$pk.transition = null, $929ea41031b225e3$var$C = 1, a) return a();
    } finally{
        $929ea41031b225e3$var$C = d, $929ea41031b225e3$var$pk.transition = c, $929ea41031b225e3$var$K = b, 0 === ($929ea41031b225e3$var$K & 6) && $929ea41031b225e3$var$jg();
    }
}
function $929ea41031b225e3$var$Ij() {
    $929ea41031b225e3$var$gj = $929ea41031b225e3$var$fj.current;
    $929ea41031b225e3$var$E($929ea41031b225e3$var$fj);
}
function $929ea41031b225e3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $929ea41031b225e3$var$Gf(c));
    if (null !== $929ea41031b225e3$var$Y) for(c = $929ea41031b225e3$var$Y.return; null !== c;){
        var d = c;
        $929ea41031b225e3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $929ea41031b225e3$var$$f();
                break;
            case 3:
                $929ea41031b225e3$var$Jh();
                $929ea41031b225e3$var$E($929ea41031b225e3$var$Wf);
                $929ea41031b225e3$var$E($929ea41031b225e3$var$H);
                $929ea41031b225e3$var$Oh();
                break;
            case 5:
                $929ea41031b225e3$var$Lh(d);
                break;
            case 4:
                $929ea41031b225e3$var$Jh();
                break;
            case 13:
                $929ea41031b225e3$var$E($929ea41031b225e3$var$M);
                break;
            case 19:
                $929ea41031b225e3$var$E($929ea41031b225e3$var$M);
                break;
            case 10:
                $929ea41031b225e3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $929ea41031b225e3$var$Ij();
        }
        c = c.return;
    }
    $929ea41031b225e3$var$R = a;
    $929ea41031b225e3$var$Y = a = $929ea41031b225e3$var$wh(a.current, null);
    $929ea41031b225e3$var$Z = $929ea41031b225e3$var$gj = b;
    $929ea41031b225e3$var$T = 0;
    $929ea41031b225e3$var$qk = null;
    $929ea41031b225e3$var$sk = $929ea41031b225e3$var$rk = $929ea41031b225e3$var$hh = 0;
    $929ea41031b225e3$var$uk = $929ea41031b225e3$var$tk = null;
    if (null !== $929ea41031b225e3$var$Wg) {
        for(b = 0; b < $929ea41031b225e3$var$Wg.length; b++)if (c = $929ea41031b225e3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $929ea41031b225e3$var$Wg = null;
    }
    return a;
}
function $929ea41031b225e3$var$Nk(a, b) {
    do {
        var c = $929ea41031b225e3$var$Y;
        try {
            $929ea41031b225e3$var$Qg();
            $929ea41031b225e3$var$Ph.current = $929ea41031b225e3$var$ai;
            if ($929ea41031b225e3$var$Sh) {
                for(var d = $929ea41031b225e3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $929ea41031b225e3$var$Sh = !1;
            }
            $929ea41031b225e3$var$Rh = 0;
            $929ea41031b225e3$var$P = $929ea41031b225e3$var$O = $929ea41031b225e3$var$N = null;
            $929ea41031b225e3$var$Th = !1;
            $929ea41031b225e3$var$Uh = 0;
            $929ea41031b225e3$var$ok.current = null;
            if (null === c || null === c.return) {
                $929ea41031b225e3$var$T = 1;
                $929ea41031b225e3$var$qk = b;
                $929ea41031b225e3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $929ea41031b225e3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $929ea41031b225e3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $929ea41031b225e3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $929ea41031b225e3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $929ea41031b225e3$var$Ti(f, l, b);
                            $929ea41031b225e3$var$uj();
                            break a;
                        }
                        k = Error($929ea41031b225e3$var$p(426));
                    }
                } else if ($929ea41031b225e3$var$I && h.mode & 1) {
                    var J = $929ea41031b225e3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $929ea41031b225e3$var$Wi(J, g, h, f, b);
                        $929ea41031b225e3$var$Jg($929ea41031b225e3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $929ea41031b225e3$var$Ki(k, h);
                4 !== $929ea41031b225e3$var$T && ($929ea41031b225e3$var$T = 2);
                null === $929ea41031b225e3$var$tk ? $929ea41031b225e3$var$tk = [
                    f
                ] : $929ea41031b225e3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $929ea41031b225e3$var$Oi(f, k, b);
                            $929ea41031b225e3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $929ea41031b225e3$var$Si || !$929ea41031b225e3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $929ea41031b225e3$var$Ri(f, h, b);
                                $929ea41031b225e3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $929ea41031b225e3$var$Tk(c);
        } catch (na) {
            b = na;
            $929ea41031b225e3$var$Y === c && null !== c && ($929ea41031b225e3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $929ea41031b225e3$var$Kk() {
    var a = $929ea41031b225e3$var$nk.current;
    $929ea41031b225e3$var$nk.current = $929ea41031b225e3$var$ai;
    return null === a ? $929ea41031b225e3$var$ai : a;
}
function $929ea41031b225e3$var$uj() {
    if (0 === $929ea41031b225e3$var$T || 3 === $929ea41031b225e3$var$T || 2 === $929ea41031b225e3$var$T) $929ea41031b225e3$var$T = 4;
    null === $929ea41031b225e3$var$R || 0 === ($929ea41031b225e3$var$hh & 268435455) && 0 === ($929ea41031b225e3$var$rk & 268435455) || $929ea41031b225e3$var$Dk($929ea41031b225e3$var$R, $929ea41031b225e3$var$Z);
}
function $929ea41031b225e3$var$Jk(a, b) {
    var c = $929ea41031b225e3$var$K;
    $929ea41031b225e3$var$K |= 2;
    var d = $929ea41031b225e3$var$Kk();
    if ($929ea41031b225e3$var$R !== a || $929ea41031b225e3$var$Z !== b) $929ea41031b225e3$var$vk = null, $929ea41031b225e3$var$Lk(a, b);
    for(;;)try {
        $929ea41031b225e3$var$Uk();
        break;
    } catch (e) {
        $929ea41031b225e3$var$Nk(a, e);
    }
    $929ea41031b225e3$var$Qg();
    $929ea41031b225e3$var$K = c;
    $929ea41031b225e3$var$nk.current = d;
    if (null !== $929ea41031b225e3$var$Y) throw Error($929ea41031b225e3$var$p(261));
    $929ea41031b225e3$var$R = null;
    $929ea41031b225e3$var$Z = 0;
    return $929ea41031b225e3$var$T;
}
function $929ea41031b225e3$var$Uk() {
    for(; null !== $929ea41031b225e3$var$Y;)$929ea41031b225e3$var$Vk($929ea41031b225e3$var$Y);
}
function $929ea41031b225e3$var$Mk() {
    for(; null !== $929ea41031b225e3$var$Y && !$929ea41031b225e3$var$cc();)$929ea41031b225e3$var$Vk($929ea41031b225e3$var$Y);
}
function $929ea41031b225e3$var$Vk(a) {
    var b = $929ea41031b225e3$var$Wk(a.alternate, a, $929ea41031b225e3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $929ea41031b225e3$var$Tk(a) : $929ea41031b225e3$var$Y = b;
    $929ea41031b225e3$var$ok.current = null;
}
function $929ea41031b225e3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $929ea41031b225e3$var$Fj(c, b, $929ea41031b225e3$var$gj), null !== c) {
                $929ea41031b225e3$var$Y = c;
                return;
            }
        } else {
            c = $929ea41031b225e3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $929ea41031b225e3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $929ea41031b225e3$var$T = 6;
                $929ea41031b225e3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $929ea41031b225e3$var$Y = b;
            return;
        }
        $929ea41031b225e3$var$Y = b = a;
    }while (null !== b);
    0 === $929ea41031b225e3$var$T && ($929ea41031b225e3$var$T = 5);
}
function $929ea41031b225e3$var$Qk(a, b, c) {
    var d = $929ea41031b225e3$var$C, e = $929ea41031b225e3$var$pk.transition;
    try {
        $929ea41031b225e3$var$pk.transition = null, $929ea41031b225e3$var$C = 1, $929ea41031b225e3$var$Xk(a, b, c, d);
    } finally{
        $929ea41031b225e3$var$pk.transition = e, $929ea41031b225e3$var$C = d;
    }
    return null;
}
function $929ea41031b225e3$var$Xk(a, b, c, d) {
    do $929ea41031b225e3$var$Ik();
    while (null !== $929ea41031b225e3$var$xk);
    if (0 !== ($929ea41031b225e3$var$K & 6)) throw Error($929ea41031b225e3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($929ea41031b225e3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $929ea41031b225e3$var$Bc(a, f);
    a === $929ea41031b225e3$var$R && ($929ea41031b225e3$var$Y = $929ea41031b225e3$var$R = null, $929ea41031b225e3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $929ea41031b225e3$var$wk || ($929ea41031b225e3$var$wk = !0, $929ea41031b225e3$var$Gk($929ea41031b225e3$var$hc, function() {
        $929ea41031b225e3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $929ea41031b225e3$var$pk.transition;
        $929ea41031b225e3$var$pk.transition = null;
        var g = $929ea41031b225e3$var$C;
        $929ea41031b225e3$var$C = 1;
        var h = $929ea41031b225e3$var$K;
        $929ea41031b225e3$var$K |= 4;
        $929ea41031b225e3$var$ok.current = null;
        $929ea41031b225e3$var$Pj(a, c);
        $929ea41031b225e3$var$ek(c, a);
        $929ea41031b225e3$var$Oe($929ea41031b225e3$var$Df);
        $929ea41031b225e3$var$dd = !!$929ea41031b225e3$var$Cf;
        $929ea41031b225e3$var$Df = $929ea41031b225e3$var$Cf = null;
        a.current = c;
        $929ea41031b225e3$var$ik(c, a, e);
        $929ea41031b225e3$var$dc();
        $929ea41031b225e3$var$K = h;
        $929ea41031b225e3$var$C = g;
        $929ea41031b225e3$var$pk.transition = f;
    } else a.current = c;
    $929ea41031b225e3$var$wk && ($929ea41031b225e3$var$wk = !1, $929ea41031b225e3$var$xk = a, $929ea41031b225e3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($929ea41031b225e3$var$Si = null);
    $929ea41031b225e3$var$mc(c.stateNode, d);
    $929ea41031b225e3$var$Ek(a, $929ea41031b225e3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($929ea41031b225e3$var$Pi) throw $929ea41031b225e3$var$Pi = !1, a = $929ea41031b225e3$var$Qi, $929ea41031b225e3$var$Qi = null, a;
    0 !== ($929ea41031b225e3$var$yk & 1) && 0 !== a.tag && $929ea41031b225e3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $929ea41031b225e3$var$Ak ? $929ea41031b225e3$var$zk++ : ($929ea41031b225e3$var$zk = 0, $929ea41031b225e3$var$Ak = a) : $929ea41031b225e3$var$zk = 0;
    $929ea41031b225e3$var$jg();
    return null;
}
function $929ea41031b225e3$var$Ik() {
    if (null !== $929ea41031b225e3$var$xk) {
        var a = $929ea41031b225e3$var$Dc($929ea41031b225e3$var$yk), b = $929ea41031b225e3$var$pk.transition, c = $929ea41031b225e3$var$C;
        try {
            $929ea41031b225e3$var$pk.transition = null;
            $929ea41031b225e3$var$C = 16 > a ? 16 : a;
            if (null === $929ea41031b225e3$var$xk) var d = !1;
            else {
                a = $929ea41031b225e3$var$xk;
                $929ea41031b225e3$var$xk = null;
                $929ea41031b225e3$var$yk = 0;
                if (0 !== ($929ea41031b225e3$var$K & 6)) throw Error($929ea41031b225e3$var$p(331));
                var e = $929ea41031b225e3$var$K;
                $929ea41031b225e3$var$K |= 4;
                for($929ea41031b225e3$var$V = a.current; null !== $929ea41031b225e3$var$V;){
                    var f = $929ea41031b225e3$var$V, g = f.child;
                    if (0 !== ($929ea41031b225e3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($929ea41031b225e3$var$V = l; null !== $929ea41031b225e3$var$V;){
                                    var m = $929ea41031b225e3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $929ea41031b225e3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $929ea41031b225e3$var$V = q;
                                    else for(; null !== $929ea41031b225e3$var$V;){
                                        m = $929ea41031b225e3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $929ea41031b225e3$var$Tj(m);
                                        if (m === l) {
                                            $929ea41031b225e3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $929ea41031b225e3$var$V = r;
                                            break;
                                        }
                                        $929ea41031b225e3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $929ea41031b225e3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $929ea41031b225e3$var$V = g;
                    else b: for(; null !== $929ea41031b225e3$var$V;){
                        f = $929ea41031b225e3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $929ea41031b225e3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $929ea41031b225e3$var$V = x;
                            break b;
                        }
                        $929ea41031b225e3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($929ea41031b225e3$var$V = w; null !== $929ea41031b225e3$var$V;){
                    g = $929ea41031b225e3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $929ea41031b225e3$var$V = u;
                    else b: for(g = w; null !== $929ea41031b225e3$var$V;){
                        h = $929ea41031b225e3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $929ea41031b225e3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $929ea41031b225e3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $929ea41031b225e3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $929ea41031b225e3$var$V = F;
                            break b;
                        }
                        $929ea41031b225e3$var$V = h.return;
                    }
                }
                $929ea41031b225e3$var$K = e;
                $929ea41031b225e3$var$jg();
                if ($929ea41031b225e3$var$lc && "function" === typeof $929ea41031b225e3$var$lc.onPostCommitFiberRoot) try {
                    $929ea41031b225e3$var$lc.onPostCommitFiberRoot($929ea41031b225e3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $929ea41031b225e3$var$C = c, $929ea41031b225e3$var$pk.transition = b;
        }
    }
    return !1;
}
function $929ea41031b225e3$var$Yk(a, b, c) {
    b = $929ea41031b225e3$var$Ki(c, b);
    b = $929ea41031b225e3$var$Oi(a, b, 1);
    a = $929ea41031b225e3$var$dh(a, b, 1);
    b = $929ea41031b225e3$var$L();
    null !== a && ($929ea41031b225e3$var$Ac(a, 1, b), $929ea41031b225e3$var$Ek(a, b));
}
function $929ea41031b225e3$var$W(a, b, c) {
    if (3 === a.tag) $929ea41031b225e3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $929ea41031b225e3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $929ea41031b225e3$var$Si || !$929ea41031b225e3$var$Si.has(d))) {
                a = $929ea41031b225e3$var$Ki(c, a);
                a = $929ea41031b225e3$var$Ri(b, a, 1);
                b = $929ea41031b225e3$var$dh(b, a, 1);
                a = $929ea41031b225e3$var$L();
                null !== b && ($929ea41031b225e3$var$Ac(b, 1, a), $929ea41031b225e3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $929ea41031b225e3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $929ea41031b225e3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $929ea41031b225e3$var$R === a && ($929ea41031b225e3$var$Z & c) === c && (4 === $929ea41031b225e3$var$T || 3 === $929ea41031b225e3$var$T && ($929ea41031b225e3$var$Z & 130023424) === $929ea41031b225e3$var$Z && 500 > $929ea41031b225e3$var$B() - $929ea41031b225e3$var$gk ? $929ea41031b225e3$var$Lk(a, 0) : $929ea41031b225e3$var$sk |= c);
    $929ea41031b225e3$var$Ek(a, b);
}
function $929ea41031b225e3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $929ea41031b225e3$var$sc, $929ea41031b225e3$var$sc <<= 1, 0 === ($929ea41031b225e3$var$sc & 130023424) && ($929ea41031b225e3$var$sc = 4194304)));
    var c = $929ea41031b225e3$var$L();
    a = $929ea41031b225e3$var$Zg(a, b);
    null !== a && ($929ea41031b225e3$var$Ac(a, b, c), $929ea41031b225e3$var$Ek(a, c));
}
function $929ea41031b225e3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $929ea41031b225e3$var$Zk(a, c);
}
function $929ea41031b225e3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($929ea41031b225e3$var$p(314));
    }
    null !== d && d.delete(b);
    $929ea41031b225e3$var$Zk(a, c);
}
var $929ea41031b225e3$var$Wk;
$929ea41031b225e3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $929ea41031b225e3$var$Wf.current) $929ea41031b225e3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $929ea41031b225e3$var$Ug = !1, $929ea41031b225e3$var$zj(a, b, c);
            $929ea41031b225e3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $929ea41031b225e3$var$Ug = !1, $929ea41031b225e3$var$I && 0 !== (b.flags & 1048576) && $929ea41031b225e3$var$ug(b, $929ea41031b225e3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $929ea41031b225e3$var$jj(a, b);
            a = b.pendingProps;
            var e = $929ea41031b225e3$var$Yf(b, $929ea41031b225e3$var$H.current);
            $929ea41031b225e3$var$Tg(b, c);
            e = $929ea41031b225e3$var$Xh(null, b, d, a, e, c);
            var f = $929ea41031b225e3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $929ea41031b225e3$var$Zf(d) ? (f = !0, $929ea41031b225e3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $929ea41031b225e3$var$ah(b), e.updater = $929ea41031b225e3$var$nh, b.stateNode = e, e._reactInternals = b, $929ea41031b225e3$var$rh(b, d, a, c), b = $929ea41031b225e3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $929ea41031b225e3$var$I && f && $929ea41031b225e3$var$vg(b), $929ea41031b225e3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $929ea41031b225e3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $929ea41031b225e3$var$$k(d);
                a = $929ea41031b225e3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $929ea41031b225e3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $929ea41031b225e3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $929ea41031b225e3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $929ea41031b225e3$var$aj(null, b, d, $929ea41031b225e3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($929ea41031b225e3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $929ea41031b225e3$var$Lg(d, e), $929ea41031b225e3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $929ea41031b225e3$var$Lg(d, e), $929ea41031b225e3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $929ea41031b225e3$var$lj(b);
                if (null === a) throw Error($929ea41031b225e3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $929ea41031b225e3$var$bh(a, b);
                $929ea41031b225e3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $929ea41031b225e3$var$Ki(Error($929ea41031b225e3$var$p(423)), b);
                        b = $929ea41031b225e3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $929ea41031b225e3$var$Ki(Error($929ea41031b225e3$var$p(424)), b);
                        b = $929ea41031b225e3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($929ea41031b225e3$var$yg = $929ea41031b225e3$var$Lf(b.stateNode.containerInfo.firstChild), $929ea41031b225e3$var$xg = b, $929ea41031b225e3$var$I = !0, $929ea41031b225e3$var$zg = null, c = $929ea41031b225e3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $929ea41031b225e3$var$Ig();
                    if (d === e) {
                        b = $929ea41031b225e3$var$$i(a, b, c);
                        break a;
                    }
                    $929ea41031b225e3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $929ea41031b225e3$var$Kh(b), null === a && $929ea41031b225e3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $929ea41031b225e3$var$Ef(d, e) ? g = null : null !== f && $929ea41031b225e3$var$Ef(d, f) && (b.flags |= 32), $929ea41031b225e3$var$hj(a, b), $929ea41031b225e3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $929ea41031b225e3$var$Eg(b), null;
        case 13:
            return $929ea41031b225e3$var$pj(a, b, c);
        case 4:
            return $929ea41031b225e3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $929ea41031b225e3$var$Bh(b, null, d, c) : $929ea41031b225e3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $929ea41031b225e3$var$Lg(d, e), $929ea41031b225e3$var$Zi(a, b, d, e, c);
        case 7:
            return $929ea41031b225e3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $929ea41031b225e3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $929ea41031b225e3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $929ea41031b225e3$var$G($929ea41031b225e3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($929ea41031b225e3$var$He(f.value, g)) {
                        if (f.children === e.children && !$929ea41031b225e3$var$Wf.current) {
                            b = $929ea41031b225e3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $929ea41031b225e3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $929ea41031b225e3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($929ea41031b225e3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $929ea41031b225e3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $929ea41031b225e3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $929ea41031b225e3$var$Tg(b, c), e = $929ea41031b225e3$var$Vg(e), d = d(e), b.flags |= 1, $929ea41031b225e3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $929ea41031b225e3$var$Lg(d, b.pendingProps), e = $929ea41031b225e3$var$Lg(d.type, e), $929ea41031b225e3$var$aj(a, b, d, e, c);
        case 15:
            return $929ea41031b225e3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $929ea41031b225e3$var$Lg(d, e), $929ea41031b225e3$var$jj(a, b), b.tag = 1, $929ea41031b225e3$var$Zf(d) ? (a = !0, $929ea41031b225e3$var$cg(b)) : a = !1, $929ea41031b225e3$var$Tg(b, c), $929ea41031b225e3$var$ph(b, d, e), $929ea41031b225e3$var$rh(b, d, e, c), $929ea41031b225e3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $929ea41031b225e3$var$yj(a, b, c);
        case 22:
            return $929ea41031b225e3$var$ej(a, b, c);
    }
    throw Error($929ea41031b225e3$var$p(156, b.tag));
};
function $929ea41031b225e3$var$Gk(a, b) {
    return $929ea41031b225e3$var$ac(a, b);
}
function $929ea41031b225e3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $929ea41031b225e3$var$Bg(a, b, c, d) {
    return new $929ea41031b225e3$var$al(a, b, c, d);
}
function $929ea41031b225e3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $929ea41031b225e3$var$$k(a) {
    if ("function" === typeof a) return $929ea41031b225e3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $929ea41031b225e3$var$Da) return 11;
        if (a === $929ea41031b225e3$var$Ga) return 14;
    }
    return 2;
}
function $929ea41031b225e3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $929ea41031b225e3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $929ea41031b225e3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $929ea41031b225e3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $929ea41031b225e3$var$ya:
            return $929ea41031b225e3$var$Ah(c.children, e, f, b);
        case $929ea41031b225e3$var$za:
            g = 8;
            e |= 8;
            break;
        case $929ea41031b225e3$var$Aa:
            return a = $929ea41031b225e3$var$Bg(12, c, b, e | 2), a.elementType = $929ea41031b225e3$var$Aa, a.lanes = f, a;
        case $929ea41031b225e3$var$Ea:
            return a = $929ea41031b225e3$var$Bg(13, c, b, e), a.elementType = $929ea41031b225e3$var$Ea, a.lanes = f, a;
        case $929ea41031b225e3$var$Fa:
            return a = $929ea41031b225e3$var$Bg(19, c, b, e), a.elementType = $929ea41031b225e3$var$Fa, a.lanes = f, a;
        case $929ea41031b225e3$var$Ia:
            return $929ea41031b225e3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $929ea41031b225e3$var$Ba:
                    g = 10;
                    break a;
                case $929ea41031b225e3$var$Ca:
                    g = 9;
                    break a;
                case $929ea41031b225e3$var$Da:
                    g = 11;
                    break a;
                case $929ea41031b225e3$var$Ga:
                    g = 14;
                    break a;
                case $929ea41031b225e3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($929ea41031b225e3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $929ea41031b225e3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $929ea41031b225e3$var$Ah(a, b, c, d) {
    a = $929ea41031b225e3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $929ea41031b225e3$var$qj(a, b, c, d) {
    a = $929ea41031b225e3$var$Bg(22, a, d, b);
    a.elementType = $929ea41031b225e3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $929ea41031b225e3$var$xh(a, b, c) {
    a = $929ea41031b225e3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $929ea41031b225e3$var$zh(a, b, c) {
    b = $929ea41031b225e3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $929ea41031b225e3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $929ea41031b225e3$var$zc(0);
    this.expirationTimes = $929ea41031b225e3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $929ea41031b225e3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $929ea41031b225e3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $929ea41031b225e3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $929ea41031b225e3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $929ea41031b225e3$var$ah(f);
    return a;
}
function $929ea41031b225e3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $929ea41031b225e3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $929ea41031b225e3$var$el(a) {
    if (!a) return $929ea41031b225e3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($929ea41031b225e3$var$Vb(a) !== a || 1 !== a.tag) throw Error($929ea41031b225e3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($929ea41031b225e3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($929ea41031b225e3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($929ea41031b225e3$var$Zf(c)) return $929ea41031b225e3$var$bg(a, c, b);
    }
    return b;
}
function $929ea41031b225e3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $929ea41031b225e3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $929ea41031b225e3$var$el(null);
    c = a.current;
    d = $929ea41031b225e3$var$L();
    e = $929ea41031b225e3$var$lh(c);
    f = $929ea41031b225e3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $929ea41031b225e3$var$dh(c, f, e);
    a.current.lanes = e;
    $929ea41031b225e3$var$Ac(a, e, d);
    $929ea41031b225e3$var$Ek(a, d);
    return a;
}
function $929ea41031b225e3$var$gl(a, b, c, d) {
    var e = b.current, f = $929ea41031b225e3$var$L(), g = $929ea41031b225e3$var$lh(e);
    c = $929ea41031b225e3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $929ea41031b225e3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $929ea41031b225e3$var$dh(e, b, g);
    null !== a && ($929ea41031b225e3$var$mh(a, e, g, f), $929ea41031b225e3$var$eh(a, e, g));
    return g;
}
function $929ea41031b225e3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $929ea41031b225e3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $929ea41031b225e3$var$jl(a, b) {
    $929ea41031b225e3$var$il(a, b);
    (a = a.alternate) && $929ea41031b225e3$var$il(a, b);
}
function $929ea41031b225e3$var$kl() {
    return null;
}
var $929ea41031b225e3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $929ea41031b225e3$var$ml(a) {
    this._internalRoot = a;
}
$929ea41031b225e3$var$nl.prototype.render = $929ea41031b225e3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($929ea41031b225e3$var$p(409));
    $929ea41031b225e3$var$gl(a, b, null, null);
};
$929ea41031b225e3$var$nl.prototype.unmount = $929ea41031b225e3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $929ea41031b225e3$var$Sk(function() {
            $929ea41031b225e3$var$gl(null, a, null, null);
        });
        b[$929ea41031b225e3$var$uf] = null;
    }
};
function $929ea41031b225e3$var$nl(a) {
    this._internalRoot = a;
}
$929ea41031b225e3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $929ea41031b225e3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $929ea41031b225e3$var$Qc.length && 0 !== b && b < $929ea41031b225e3$var$Qc[c].priority; c++);
        $929ea41031b225e3$var$Qc.splice(c, 0, a);
        0 === c && $929ea41031b225e3$var$Vc(a);
    }
};
function $929ea41031b225e3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $929ea41031b225e3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $929ea41031b225e3$var$ql() {}
function $929ea41031b225e3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $929ea41031b225e3$var$hl(g);
                f.call(a);
            };
        }
        var g = $929ea41031b225e3$var$fl(b, d, a, 0, null, !1, !1, "", $929ea41031b225e3$var$ql);
        a._reactRootContainer = g;
        a[$929ea41031b225e3$var$uf] = g.current;
        $929ea41031b225e3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $929ea41031b225e3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $929ea41031b225e3$var$hl(k);
            h.call(a);
        };
    }
    var k = $929ea41031b225e3$var$cl(a, 0, !1, null, null, !1, !1, "", $929ea41031b225e3$var$ql);
    a._reactRootContainer = k;
    a[$929ea41031b225e3$var$uf] = k.current;
    $929ea41031b225e3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $929ea41031b225e3$var$Sk(function() {
        $929ea41031b225e3$var$gl(b, k, c, d);
    });
    return k;
}
function $929ea41031b225e3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $929ea41031b225e3$var$hl(g);
                h.call(a);
            };
        }
        $929ea41031b225e3$var$gl(b, g, a, e);
    } else g = $929ea41031b225e3$var$rl(c, b, a, e, d);
    return $929ea41031b225e3$var$hl(g);
}
$929ea41031b225e3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $929ea41031b225e3$var$tc(b.pendingLanes);
                0 !== c && ($929ea41031b225e3$var$Cc(b, c | 1), $929ea41031b225e3$var$Ek(b, $929ea41031b225e3$var$B()), 0 === ($929ea41031b225e3$var$K & 6) && ($929ea41031b225e3$var$Hj = $929ea41031b225e3$var$B() + 500, $929ea41031b225e3$var$jg()));
            }
            break;
        case 13:
            $929ea41031b225e3$var$Sk(function() {
                var b = $929ea41031b225e3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $929ea41031b225e3$var$L();
                    $929ea41031b225e3$var$mh(b, a, 1, c);
                }
            }), $929ea41031b225e3$var$jl(a, 1);
    }
};
$929ea41031b225e3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $929ea41031b225e3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $929ea41031b225e3$var$L();
            $929ea41031b225e3$var$mh(b, a, 134217728, c);
        }
        $929ea41031b225e3$var$jl(a, 134217728);
    }
};
$929ea41031b225e3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $929ea41031b225e3$var$lh(a), c = $929ea41031b225e3$var$Zg(a, b);
        if (null !== c) {
            var d = $929ea41031b225e3$var$L();
            $929ea41031b225e3$var$mh(c, a, b, d);
        }
        $929ea41031b225e3$var$jl(a, b);
    }
};
$929ea41031b225e3$var$Hc = function() {
    return $929ea41031b225e3$var$C;
};
$929ea41031b225e3$var$Ic = function(a, b) {
    var c = $929ea41031b225e3$var$C;
    try {
        return $929ea41031b225e3$var$C = a, b();
    } finally{
        $929ea41031b225e3$var$C = c;
    }
};
$929ea41031b225e3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $929ea41031b225e3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $929ea41031b225e3$var$Db(d);
                        if (!e) throw Error($929ea41031b225e3$var$p(90));
                        $929ea41031b225e3$var$Wa(d);
                        $929ea41031b225e3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $929ea41031b225e3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $929ea41031b225e3$var$fb(a, !!c.multiple, b, !1);
    }
};
$929ea41031b225e3$var$Gb = $929ea41031b225e3$var$Rk;
$929ea41031b225e3$var$Hb = $929ea41031b225e3$var$Sk;
var $929ea41031b225e3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $929ea41031b225e3$var$Cb,
        $929ea41031b225e3$var$ue,
        $929ea41031b225e3$var$Db,
        $929ea41031b225e3$var$Eb,
        $929ea41031b225e3$var$Fb,
        $929ea41031b225e3$var$Rk
    ]
}, $929ea41031b225e3$var$ul = {
    findFiberByHostInstance: $929ea41031b225e3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $929ea41031b225e3$var$vl = {
    bundleType: $929ea41031b225e3$var$ul.bundleType,
    version: $929ea41031b225e3$var$ul.version,
    rendererPackageName: $929ea41031b225e3$var$ul.rendererPackageName,
    rendererConfig: $929ea41031b225e3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $929ea41031b225e3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $929ea41031b225e3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $929ea41031b225e3$var$ul.findFiberByHostInstance || $929ea41031b225e3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $929ea41031b225e3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$929ea41031b225e3$var$wl.isDisabled && $929ea41031b225e3$var$wl.supportsFiber) try {
        $929ea41031b225e3$var$kc = $929ea41031b225e3$var$wl.inject($929ea41031b225e3$var$vl), $929ea41031b225e3$var$lc = $929ea41031b225e3$var$wl;
    } catch (a) {}
}
$929ea41031b225e3$export$ae55be85d98224ed = $929ea41031b225e3$var$tl;
$929ea41031b225e3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$929ea41031b225e3$var$ol(b)) throw Error($929ea41031b225e3$var$p(200));
    return $929ea41031b225e3$var$dl(a, b, null, c);
};
$929ea41031b225e3$export$882461b6382ed46c = function(a, b) {
    if (!$929ea41031b225e3$var$ol(a)) throw Error($929ea41031b225e3$var$p(299));
    var c = !1, d = "", e = $929ea41031b225e3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $929ea41031b225e3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$929ea41031b225e3$var$uf] = b.current;
    $929ea41031b225e3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $929ea41031b225e3$var$ml(b);
};
$929ea41031b225e3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($929ea41031b225e3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($929ea41031b225e3$var$p(268, a));
    }
    a = $929ea41031b225e3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$929ea41031b225e3$export$cd75ccfd720a3cd4 = function(a) {
    return $929ea41031b225e3$var$Sk(a);
};
$929ea41031b225e3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$929ea41031b225e3$var$pl(b)) throw Error($929ea41031b225e3$var$p(200));
    return $929ea41031b225e3$var$sl(null, a, b, !0, c);
};
$929ea41031b225e3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$929ea41031b225e3$var$ol(a)) throw Error($929ea41031b225e3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $929ea41031b225e3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $929ea41031b225e3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$929ea41031b225e3$var$uf] = b.current;
    $929ea41031b225e3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $929ea41031b225e3$var$nl(b);
};
$929ea41031b225e3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$929ea41031b225e3$var$pl(b)) throw Error($929ea41031b225e3$var$p(200));
    return $929ea41031b225e3$var$sl(null, a, b, !1, c);
};
$929ea41031b225e3$export$502457920280e6be = function(a) {
    if (!$929ea41031b225e3$var$pl(a)) throw Error($929ea41031b225e3$var$p(40));
    return a._reactRootContainer ? ($929ea41031b225e3$var$Sk(function() {
        $929ea41031b225e3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$929ea41031b225e3$var$uf] = null;
        });
    }), !0) : !1;
};
$929ea41031b225e3$export$c78a37762a8d58e1 = $929ea41031b225e3$var$Rk;
$929ea41031b225e3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$929ea41031b225e3$var$pl(c)) throw Error($929ea41031b225e3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($929ea41031b225e3$var$p(38));
    return $929ea41031b225e3$var$sl(a, b, c, !1, d);
};
$929ea41031b225e3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("3gHSJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eqXTt"));

});
parcelRequire.register("eqXTt", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a821f405c172eb9e$export$c4744153514ff05d, (v) => $a821f405c172eb9e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a821f405c172eb9e$export$3e506c1ccc9cc1a7, (v) => $a821f405c172eb9e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a821f405c172eb9e$export$e26fe2ed2fa76875, (v) => $a821f405c172eb9e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a821f405c172eb9e$export$502329bbf4b505b1, (v) => $a821f405c172eb9e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a821f405c172eb9e$export$6e3807111c4874c4, (v) => $a821f405c172eb9e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a821f405c172eb9e$export$c27134553091fb3a, (v) => $a821f405c172eb9e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a821f405c172eb9e$export$33ee1acdc04fd2a2, (v) => $a821f405c172eb9e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a821f405c172eb9e$export$b00a404bbd5edef2, (v) => $a821f405c172eb9e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a821f405c172eb9e$export$8352ce38b91d0c62, (v) => $a821f405c172eb9e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a821f405c172eb9e$export$d66a1c1c77bd778b, (v) => $a821f405c172eb9e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a821f405c172eb9e$export$d3dfb8e4810cb555, (v) => $a821f405c172eb9e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a821f405c172eb9e$export$839f9183b0465a69, (v) => $a821f405c172eb9e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a821f405c172eb9e$export$72fdf0e06517287b, (v) => $a821f405c172eb9e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a821f405c172eb9e$export$4b844e58a3e414b4, (v) => $a821f405c172eb9e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a821f405c172eb9e$export$816d2913ae6b83b1, (v) => $a821f405c172eb9e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a821f405c172eb9e$export$61bcfe829111a1d0, (v) => $a821f405c172eb9e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a821f405c172eb9e$export$7ee8c9beb337bc3f, (v) => $a821f405c172eb9e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a821f405c172eb9e$export$b5836b71941fa3ed, (v) => $a821f405c172eb9e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a821f405c172eb9e$export$cf845f2c119da08a, (v) => $a821f405c172eb9e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a821f405c172eb9e$export$c4744153514ff05d;
var $a821f405c172eb9e$export$3e506c1ccc9cc1a7;
var $a821f405c172eb9e$export$e26fe2ed2fa76875;
var $a821f405c172eb9e$export$502329bbf4b505b1;
var $a821f405c172eb9e$export$6e3807111c4874c4;
var $a821f405c172eb9e$export$c27134553091fb3a;
var $a821f405c172eb9e$export$33ee1acdc04fd2a2;
var $a821f405c172eb9e$export$b00a404bbd5edef2;
var $a821f405c172eb9e$export$8352ce38b91d0c62;
var $a821f405c172eb9e$export$d66a1c1c77bd778b;
var $a821f405c172eb9e$export$d3dfb8e4810cb555;
var $a821f405c172eb9e$export$839f9183b0465a69;
var $a821f405c172eb9e$export$72fdf0e06517287b;
var $a821f405c172eb9e$export$4b844e58a3e414b4;
var $a821f405c172eb9e$export$816d2913ae6b83b1;
var $a821f405c172eb9e$export$61bcfe829111a1d0;
var $a821f405c172eb9e$export$7ee8c9beb337bc3f;
var $a821f405c172eb9e$export$b5836b71941fa3ed;
var $a821f405c172eb9e$export$cf845f2c119da08a;
"use strict";
function $a821f405c172eb9e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a821f405c172eb9e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a821f405c172eb9e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a821f405c172eb9e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a821f405c172eb9e$var$g(C, c)) n < e && 0 > $a821f405c172eb9e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a821f405c172eb9e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a821f405c172eb9e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a821f405c172eb9e$var$l = performance;
    $a821f405c172eb9e$export$c4744153514ff05d = function() {
        return $a821f405c172eb9e$var$l.now();
    };
} else {
    var $a821f405c172eb9e$var$p = Date, $a821f405c172eb9e$var$q = $a821f405c172eb9e$var$p.now();
    $a821f405c172eb9e$export$c4744153514ff05d = function() {
        return $a821f405c172eb9e$var$p.now() - $a821f405c172eb9e$var$q;
    };
}
var $a821f405c172eb9e$var$r = [], $a821f405c172eb9e$var$t = [], $a821f405c172eb9e$var$u = 1, $a821f405c172eb9e$var$v = null, $a821f405c172eb9e$var$y = 3, $a821f405c172eb9e$var$z = !1, $a821f405c172eb9e$var$A = !1, $a821f405c172eb9e$var$B = !1, $a821f405c172eb9e$var$D = "function" === typeof setTimeout ? setTimeout : null, $a821f405c172eb9e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a821f405c172eb9e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a821f405c172eb9e$var$G(a) {
    for(var b = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$t); null !== b;){
        if (null === b.callback) $a821f405c172eb9e$var$k($a821f405c172eb9e$var$t);
        else if (b.startTime <= a) $a821f405c172eb9e$var$k($a821f405c172eb9e$var$t), b.sortIndex = b.expirationTime, $a821f405c172eb9e$var$f($a821f405c172eb9e$var$r, b);
        else break;
        b = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$t);
    }
}
function $a821f405c172eb9e$var$H(a) {
    $a821f405c172eb9e$var$B = !1;
    $a821f405c172eb9e$var$G(a);
    if (!$a821f405c172eb9e$var$A) {
        if (null !== $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r)) $a821f405c172eb9e$var$A = !0, $a821f405c172eb9e$var$I($a821f405c172eb9e$var$J);
        else {
            var b = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$t);
            null !== b && $a821f405c172eb9e$var$K($a821f405c172eb9e$var$H, b.startTime - a);
        }
    }
}
function $a821f405c172eb9e$var$J(a, b) {
    $a821f405c172eb9e$var$A = !1;
    $a821f405c172eb9e$var$B && ($a821f405c172eb9e$var$B = !1, $a821f405c172eb9e$var$E($a821f405c172eb9e$var$L), $a821f405c172eb9e$var$L = -1);
    $a821f405c172eb9e$var$z = !0;
    var c = $a821f405c172eb9e$var$y;
    try {
        $a821f405c172eb9e$var$G(b);
        for($a821f405c172eb9e$var$v = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r); null !== $a821f405c172eb9e$var$v && (!($a821f405c172eb9e$var$v.expirationTime > b) || a && !$a821f405c172eb9e$var$M());){
            var d = $a821f405c172eb9e$var$v.callback;
            if ("function" === typeof d) {
                $a821f405c172eb9e$var$v.callback = null;
                $a821f405c172eb9e$var$y = $a821f405c172eb9e$var$v.priorityLevel;
                var e = d($a821f405c172eb9e$var$v.expirationTime <= b);
                b = $a821f405c172eb9e$export$c4744153514ff05d();
                "function" === typeof e ? $a821f405c172eb9e$var$v.callback = e : $a821f405c172eb9e$var$v === $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r) && $a821f405c172eb9e$var$k($a821f405c172eb9e$var$r);
                $a821f405c172eb9e$var$G(b);
            } else $a821f405c172eb9e$var$k($a821f405c172eb9e$var$r);
            $a821f405c172eb9e$var$v = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r);
        }
        if (null !== $a821f405c172eb9e$var$v) var w = !0;
        else {
            var m = $a821f405c172eb9e$var$h($a821f405c172eb9e$var$t);
            null !== m && $a821f405c172eb9e$var$K($a821f405c172eb9e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a821f405c172eb9e$var$v = null, $a821f405c172eb9e$var$y = c, $a821f405c172eb9e$var$z = !1;
    }
}
var $a821f405c172eb9e$var$N = !1, $a821f405c172eb9e$var$O = null, $a821f405c172eb9e$var$L = -1, $a821f405c172eb9e$var$P = 5, $a821f405c172eb9e$var$Q = -1;
function $a821f405c172eb9e$var$M() {
    return $a821f405c172eb9e$export$c4744153514ff05d() - $a821f405c172eb9e$var$Q < $a821f405c172eb9e$var$P ? !1 : !0;
}
function $a821f405c172eb9e$var$R() {
    if (null !== $a821f405c172eb9e$var$O) {
        var a = $a821f405c172eb9e$export$c4744153514ff05d();
        $a821f405c172eb9e$var$Q = a;
        var b = !0;
        try {
            b = $a821f405c172eb9e$var$O(!0, a);
        } finally{
            b ? $a821f405c172eb9e$var$S() : ($a821f405c172eb9e$var$N = !1, $a821f405c172eb9e$var$O = null);
        }
    } else $a821f405c172eb9e$var$N = !1;
}
var $a821f405c172eb9e$var$S;
if ("function" === typeof $a821f405c172eb9e$var$F) $a821f405c172eb9e$var$S = function() {
    $a821f405c172eb9e$var$F($a821f405c172eb9e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a821f405c172eb9e$var$T = new MessageChannel, $a821f405c172eb9e$var$U = $a821f405c172eb9e$var$T.port2;
    $a821f405c172eb9e$var$T.port1.onmessage = $a821f405c172eb9e$var$R;
    $a821f405c172eb9e$var$S = function() {
        $a821f405c172eb9e$var$U.postMessage(null);
    };
} else $a821f405c172eb9e$var$S = function() {
    $a821f405c172eb9e$var$D($a821f405c172eb9e$var$R, 0);
};
function $a821f405c172eb9e$var$I(a) {
    $a821f405c172eb9e$var$O = a;
    $a821f405c172eb9e$var$N || ($a821f405c172eb9e$var$N = !0, $a821f405c172eb9e$var$S());
}
function $a821f405c172eb9e$var$K(a, b) {
    $a821f405c172eb9e$var$L = $a821f405c172eb9e$var$D(function() {
        a($a821f405c172eb9e$export$c4744153514ff05d());
    }, b);
}
$a821f405c172eb9e$export$3e506c1ccc9cc1a7 = 5;
$a821f405c172eb9e$export$e26fe2ed2fa76875 = 1;
$a821f405c172eb9e$export$502329bbf4b505b1 = 4;
$a821f405c172eb9e$export$6e3807111c4874c4 = 3;
$a821f405c172eb9e$export$c27134553091fb3a = null;
$a821f405c172eb9e$export$33ee1acdc04fd2a2 = 2;
$a821f405c172eb9e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a821f405c172eb9e$export$8352ce38b91d0c62 = function() {
    $a821f405c172eb9e$var$A || $a821f405c172eb9e$var$z || ($a821f405c172eb9e$var$A = !0, $a821f405c172eb9e$var$I($a821f405c172eb9e$var$J));
};
$a821f405c172eb9e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a821f405c172eb9e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a821f405c172eb9e$export$d3dfb8e4810cb555 = function() {
    return $a821f405c172eb9e$var$y;
};
$a821f405c172eb9e$export$839f9183b0465a69 = function() {
    return $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r);
};
$a821f405c172eb9e$export$72fdf0e06517287b = function(a) {
    switch($a821f405c172eb9e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a821f405c172eb9e$var$y;
    }
    var c = $a821f405c172eb9e$var$y;
    $a821f405c172eb9e$var$y = b;
    try {
        return a();
    } finally{
        $a821f405c172eb9e$var$y = c;
    }
};
$a821f405c172eb9e$export$4b844e58a3e414b4 = function() {};
$a821f405c172eb9e$export$816d2913ae6b83b1 = function() {};
$a821f405c172eb9e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a821f405c172eb9e$var$y;
    $a821f405c172eb9e$var$y = a;
    try {
        return b();
    } finally{
        $a821f405c172eb9e$var$y = c;
    }
};
$a821f405c172eb9e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a821f405c172eb9e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a821f405c172eb9e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a821f405c172eb9e$var$f($a821f405c172eb9e$var$t, a), null === $a821f405c172eb9e$var$h($a821f405c172eb9e$var$r) && a === $a821f405c172eb9e$var$h($a821f405c172eb9e$var$t) && ($a821f405c172eb9e$var$B ? ($a821f405c172eb9e$var$E($a821f405c172eb9e$var$L), $a821f405c172eb9e$var$L = -1) : $a821f405c172eb9e$var$B = !0, $a821f405c172eb9e$var$K($a821f405c172eb9e$var$H, c - d))) : (a.sortIndex = e, $a821f405c172eb9e$var$f($a821f405c172eb9e$var$r, a), $a821f405c172eb9e$var$A || $a821f405c172eb9e$var$z || ($a821f405c172eb9e$var$A = !0, $a821f405c172eb9e$var$I($a821f405c172eb9e$var$J)));
    return a;
};
$a821f405c172eb9e$export$b5836b71941fa3ed = $a821f405c172eb9e$var$M;
$a821f405c172eb9e$export$cf845f2c119da08a = function(a) {
    var b = $a821f405c172eb9e$var$y;
    return function() {
        var c = $a821f405c172eb9e$var$y;
        $a821f405c172eb9e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a821f405c172eb9e$var$y = c;
        }
    };
};

});



parcelRequire.register("1QieE", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $1578caf16f8fd72c$export$306c0aa65ff9ec16, (v) => $1578caf16f8fd72c$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1578caf16f8fd72c$export$306c0aa65ff9ec16;
"use strict";

var $7Pt2h = parcelRequire("7Pt2h");
function $1578caf16f8fd72c$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1578caf16f8fd72c$var$k = "function" === typeof Object.is ? Object.is : $1578caf16f8fd72c$var$h, $1578caf16f8fd72c$var$l = $7Pt2h.useState, $1578caf16f8fd72c$var$m = $7Pt2h.useEffect, $1578caf16f8fd72c$var$n = $7Pt2h.useLayoutEffect, $1578caf16f8fd72c$var$p = $7Pt2h.useDebugValue;
function $1578caf16f8fd72c$var$q(a, b) {
    var d = b(), f = $1578caf16f8fd72c$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $1578caf16f8fd72c$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $1578caf16f8fd72c$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $1578caf16f8fd72c$var$m(function() {
        $1578caf16f8fd72c$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $1578caf16f8fd72c$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $1578caf16f8fd72c$var$p(d);
    return d;
}
function $1578caf16f8fd72c$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$1578caf16f8fd72c$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $1578caf16f8fd72c$var$t(a, b) {
    return b();
}
var $1578caf16f8fd72c$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $1578caf16f8fd72c$var$t : $1578caf16f8fd72c$var$q;
$1578caf16f8fd72c$export$306c0aa65ff9ec16 = void 0 !== $7Pt2h.useSyncExternalStore ? $7Pt2h.useSyncExternalStore : $1578caf16f8fd72c$var$u;

});

parcelRequire.register("lg7YP", function(module, exports) {

});

var $0f1d8188a7c97c70$exports = {};
"use strict";

$0f1d8188a7c97c70$exports = (parcelRequire("gPLhR"));



var $7Pt2h = parcelRequire("7Pt2h");
var $552e0568a1d67e84$export$882461b6382ed46c;
var $552e0568a1d67e84$export$757ceba2d55c277e;
"use strict";
var $668b5dd624babc60$exports = {};
"use strict";
function $668b5dd624babc60$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($668b5dd624babc60$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$668b5dd624babc60$var$checkDCE();

$668b5dd624babc60$exports = (parcelRequire("cAs60"));


var $552e0568a1d67e84$var$i;
$552e0568a1d67e84$export$882461b6382ed46c = $668b5dd624babc60$exports.createRoot;
$552e0568a1d67e84$export$757ceba2d55c277e = $668b5dd624babc60$exports.hydrateRoot;




var $7Pt2h = parcelRequire("7Pt2h");
var $b67e1dcc423ccb05$exports = {};
"use strict";

$b67e1dcc423ccb05$exports = (parcelRequire("1QieE"));




// React.useInsertionEffect is not available in React <18
const { useEffect: $e1ea994f20c2c607$var$useEffect , useLayoutEffect: $e1ea994f20c2c607$var$useLayoutEffect , useRef: $e1ea994f20c2c607$var$useRef , useInsertionEffect: $e1ea994f20c2c607$var$useBuiltinInsertionEffect  } = $7Pt2h;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $e1ea994f20c2c607$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $e1ea994f20c2c607$export$700979bc83e7db82 = $e1ea994f20c2c607$var$canUseDOM ? $e1ea994f20c2c607$var$useLayoutEffect : $e1ea994f20c2c607$var$useEffect;
const $e1ea994f20c2c607$export$aaabe4eda9ed9969 = $e1ea994f20c2c607$var$useBuiltinInsertionEffect || $e1ea994f20c2c607$export$700979bc83e7db82;
const $e1ea994f20c2c607$export$90fc3a17d93f704c = (fn)=>{
    const ref = $e1ea994f20c2c607$var$useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $e1ea994f20c2c607$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $a5413174b4680a45$var$relativePath = (base = "", path = location.pathname)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
const $a5413174b4680a45$var$absolutePath = (to, base = "")=>to[0] === "~" ? to.slice(1) : base + to;
/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $a5413174b4680a45$var$eventPopstate = "popstate";
const $a5413174b4680a45$var$eventPushState = "pushState";
const $a5413174b4680a45$var$eventReplaceState = "replaceState";
const $a5413174b4680a45$var$eventHashchange = "hashchange";
const $a5413174b4680a45$export$4bf9923669ad6c63 = [
    $a5413174b4680a45$var$eventPopstate,
    $a5413174b4680a45$var$eventPushState,
    $a5413174b4680a45$var$eventReplaceState,
    $a5413174b4680a45$var$eventHashchange
];
const $a5413174b4680a45$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $a5413174b4680a45$export$4bf9923669ad6c63)addEventListener(event, callback);
    return ()=>{
        for (const event of $a5413174b4680a45$export$4bf9923669ad6c63)removeEventListener(event, callback);
    };
};
const $a5413174b4680a45$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $b67e1dcc423ccb05$exports.useSyncExternalStore)($a5413174b4680a45$var$subscribeToLocationUpdates, fn, ssrFn);
const $a5413174b4680a45$var$currentSearch = ()=>location.search;
const $a5413174b4680a45$export$bd221a7c56b93941 = ()=>$a5413174b4680a45$export$3a1ff78c39f8a86($a5413174b4680a45$var$currentSearch);
const $a5413174b4680a45$var$currentPathname = ()=>location.pathname;
const $a5413174b4680a45$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath  } = {})=>$a5413174b4680a45$export$3a1ff78c39f8a86($a5413174b4680a45$var$currentPathname, ssrPath ? ()=>ssrPath : $a5413174b4680a45$var$currentPathname);
const $a5413174b4680a45$export$ff7962acd6052c28 = (to, { replace: replace = false  } = {})=>history[replace ? $a5413174b4680a45$var$eventReplaceState : $a5413174b4680a45$var$eventPushState](null, "", to);
// the 2nd argument of the `useLocation` return value is a function
// that allows to perform a navigation.
//
// the function reference should stay the same between re-renders, so that
// it can be passed down as an element prop without any performance concerns.
// (This is achieved via `useEvent`.)
const $a5413174b4680a45$var$useLocation = (opts = {})=>[
        $a5413174b4680a45$var$relativePath(opts.base, $a5413174b4680a45$export$2a28ef6a9fe822a4(opts)),
        (0, $e1ea994f20c2c607$export$90fc3a17d93f704c)((to, navOpts)=>$a5413174b4680a45$export$ff7962acd6052c28($a5413174b4680a45$var$absolutePath(to, opts.base), navOpts))
    ];
var $a5413174b4680a45$export$2e2bcd8739ae039 = $a5413174b4680a45$var$useLocation;
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined") for (const type of [
    $a5413174b4680a45$var$eventPushState,
    $a5413174b4680a45$var$eventReplaceState
]){
    const original = history[type];
    // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
    // however that will require an additional peer dependency on react-dom.
    // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
    history[type] = function() {
        const result = original.apply(this, arguments);
        const event = new Event(type);
        event.arguments = arguments;
        dispatchEvent(event);
        return result;
    };
}


// creates a matcher function
function $121bd004e03fe227$export$2e2bcd8739ae039(makeRegexpFn = $121bd004e03fe227$var$pathToRegexp) {
    let cache = {};
    // obtains a cached regexp version of the pattern
    const getRegexp = (pattern)=>cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
    return (pattern, path)=>{
        const { regexp: regexp , keys: keys  } = getRegexp(pattern || "");
        const out = regexp.exec(path);
        if (!out) return [
            false,
            null
        ];
        // formats an object with matched params
        const params = keys.reduce((params, key, i)=>{
            params[key.name] = out[i + 1];
            return params;
        }, {});
        return [
            true,
            params
        ];
    };
}
// escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202
const $121bd004e03fe227$var$escapeRx = (str)=>str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
// returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources
const $121bd004e03fe227$var$rxForSegment = (repeat, optional, prefix)=>{
    let capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
    if (optional && prefix) capture = "(?:\\/" + capture + ")";
    return capture + (optional ? "?" : "");
};
const $121bd004e03fe227$var$pathToRegexp = (pattern)=>{
    const groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
    let match = null, lastIndex = 0, keys = [], result = "";
    while((match = groupRx.exec(pattern)) !== null){
        const [_, segment, mod] = match;
        // :foo  [1]      (  )
        // :foo? [0 - 1]  ( o)
        // :foo+ [1 - ∞]  (r )
        // :foo* [0 - ∞]  (ro)
        const repeat = mod === "+" || mod === "*";
        const optional = mod === "?" || mod === "*";
        const prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
        const prev = pattern.substring(lastIndex, match.index - prefix);
        keys.push({
            name: segment
        });
        lastIndex = groupRx.lastIndex;
        result += $121bd004e03fe227$var$escapeRx(prev) + $121bd004e03fe227$var$rxForSegment(repeat, optional, prefix);
    }
    result += $121bd004e03fe227$var$escapeRx(pattern.substring(lastIndex));
    return {
        keys: keys,
        regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
    };
};



var $7Pt2h = parcelRequire("7Pt2h");
/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $6f835274ba21d132$var$defaultRouter = {
    hook: (0, $a5413174b4680a45$export$2e2bcd8739ae039),
    matcher: (0, $121bd004e03fe227$export$2e2bcd8739ae039)(),
    base: ""
};
const $6f835274ba21d132$var$RouterCtx = (0, $7Pt2h.createContext)($6f835274ba21d132$var$defaultRouter);
const $6f835274ba21d132$export$9a302a45f65d0572 = ()=>(0, $7Pt2h.useContext)($6f835274ba21d132$var$RouterCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $6f835274ba21d132$var$useLocationFromRouter = (router)=>router.hook(router);
const $6f835274ba21d132$export$45d76561a5302f2b = ()=>$6f835274ba21d132$var$useLocationFromRouter($6f835274ba21d132$export$9a302a45f65d0572());
const $6f835274ba21d132$export$3f79f0b98112cf57 = (pattern)=>{
    const router = $6f835274ba21d132$export$9a302a45f65d0572();
    const [path] = $6f835274ba21d132$var$useLocationFromRouter(router);
    return router.matcher(pattern, path);
};
const $6f835274ba21d132$export$55185c17a0fcbe46 = ({ hook: hook , matcher: matcher , ssrPath: ssrPath , base: base = "" , parent: parent , children: children  })=>{
    // updates the current router with the props passed down to the component
    const updateRouter = (router, proto = parent || $6f835274ba21d132$var$defaultRouter)=>{
        router.hook = hook || proto.hook;
        router.matcher = matcher || proto.matcher;
        router.ssrPath = ssrPath || proto.ssrPath;
        router.ownBase = base;
        // store reference to parent router
        router.parent = parent;
        return router;
    };
    // we use `useState` here, but it only catches the first render and never changes.
    // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
    const [value] = (0, $7Pt2h.useState)(()=>updateRouter({
            // We must store base as a property accessor because effects
            // somewhat counter-intuitively run in child components *first*!
            // This means that by the time a parent's base is updated in the
            // parent effect, the child effect has already run, and saw
            // the parent's *previous* base during its own execution.
            get base () {
                return (value.parent || $6f835274ba21d132$var$defaultRouter).base + value.ownBase;
            }
        })); // create the object once...
    (0, $e1ea994f20c2c607$export$aaabe4eda9ed9969)(()=>{
        updateRouter(value);
    }); // ...then update it on each render
    return (0, $7Pt2h.createElement)($6f835274ba21d132$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
const $6f835274ba21d132$export$e7b0ac011bb776c6 = ({ path: path , match: match , component: component , children: children  })=>{
    const useRouteMatch = $6f835274ba21d132$export$3f79f0b98112cf57(path);
    // `props.match` is present - Route is controlled by the Switch
    const [matches, params] = match || useRouteMatch;
    if (!matches) return null;
    // React-Router style `component` prop
    if (component) return (0, $7Pt2h.createElement)(component, {
        params: params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
const $6f835274ba21d132$export$a6c7ac8248d6e38a = (0, $7Pt2h.forwardRef)((props, ref)=>{
    const router = $6f835274ba21d132$export$9a302a45f65d0572();
    const [, navigate] = $6f835274ba21d132$var$useLocationFromRouter(router);
    const { to: to , href: href = to , children: children , onClick: onClick  } = props;
    const handleClick = (0, $e1ea994f20c2c607$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        onClick && onClick(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(to || href, props);
        }
    });
    // wraps children in `a` if needed
    const extraProps = {
        // handle nested routers and absolute paths
        href: href[0] === "~" ? href.slice(1) : router.base + href,
        onClick: handleClick,
        to: null,
        ref: ref
    };
    const jsx = (0, $7Pt2h.isValidElement)(children) ? children : (0, $7Pt2h.createElement)("a", props);
    return (0, $7Pt2h.cloneElement)(jsx, extraProps);
});
const $6f835274ba21d132$var$flattenChildren = (children)=>{
    return Array.isArray(children) ? [].concat(...children.map((c)=>c && c.type === (0, $7Pt2h.Fragment) ? $6f835274ba21d132$var$flattenChildren(c.props.children) : $6f835274ba21d132$var$flattenChildren(c))) : [
        children
    ];
};
const $6f835274ba21d132$export$b5d5cf8927ab7262 = ({ children: children , location: location  })=>{
    const router = $6f835274ba21d132$export$9a302a45f65d0572();
    const matcher = router.matcher;
    const [originalLocation] = $6f835274ba21d132$var$useLocationFromRouter(router);
    for (const element of $6f835274ba21d132$var$flattenChildren(children)){
        let match = 0;
        if ((0, $7Pt2h.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = element.props.path ? matcher(element.props.path, location || originalLocation) : [
            true,
            {}
        ])[0]) return (0, $7Pt2h.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $6f835274ba21d132$export$2d8d895a0a0f636e = (props)=>{
    const { to: to , href: href = to  } = props;
    const [, navigate] = $6f835274ba21d132$export$45d76561a5302f2b();
    const redirect = (0, $e1ea994f20c2c607$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $e1ea994f20c2c607$export$700979bc83e7db82)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var $6f835274ba21d132$export$2e2bcd8739ae039 = $6f835274ba21d132$export$3f79f0b98112cf57;




var $7Pt2h = parcelRequire("7Pt2h");
var $7d9ea64bceb18642$export$adb608be33961c98;
var $7d9ea64bceb18642$export$b3219800bda33a1f;
var $7d9ea64bceb18642$export$f22da7240b7add18;
var $7d9ea64bceb18642$export$42c68d6252221cac;
$7d9ea64bceb18642$export$adb608be33961c98 = `Ma4OlW_footer`;
$7d9ea64bceb18642$export$b3219800bda33a1f = `Ma4OlW_layout`;
$7d9ea64bceb18642$export$f22da7240b7add18 = `Ma4OlW_main`;
$7d9ea64bceb18642$export$42c68d6252221cac = `Ma4OlW_topbar`;




var $7Pt2h = parcelRequire("7Pt2h");
var $4c3b30645d1e02f0$export$97691fbb80847c19;
$4c3b30645d1e02f0$export$97691fbb80847c19 = `qvtmNG_flex`;


/**
 * Build a set of CSS classes and assign it to element's className.
 */ class $aeb56eb7cfd854c1$export$3ec9c6f9cd353016 extends Set {
    constructor(...classes){
        super(classes);
    }
    toString() {
        return Array.from(this).filter(Boolean).join(" ");
    }
}


function $650ff5719fa0105d$var$Flex({ as: as , children: children , direction: direction , align: align = direction !== "column" ? "center" : undefined , justify: justify , gap: gap , wrap: wrap , ...props }, ref) {
    const Component = as ?? "div";
    const classList = new (0, $aeb56eb7cfd854c1$export$3ec9c6f9cd353016)();
    classList.add($4c3b30645d1e02f0$export$97691fbb80847c19);
    if (props.className) classList.add(props.className);
    props.className = classList.toString();
    props.style = {
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        gap: gap,
        flexWrap: wrap,
        ...props.style
    };
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)(Component, {
        ref: ref,
        ...props,
        children: children
    });
}
// Fix the type of the forwarded component.
const $650ff5719fa0105d$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $7Pt2h.forwardRef)($650ff5719fa0105d$var$Flex);



var $7Pt2h = parcelRequire("7Pt2h");
function $adfe6d1e67b75ecb$var$createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var $adfe6d1e67b75ecb$var$ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var $adfe6d1e67b75ecb$var$ENCODING_LEN = $adfe6d1e67b75ecb$var$ENCODING.length;
var $adfe6d1e67b75ecb$var$TIME_MAX = Math.pow(2, 48) - 1;
var $adfe6d1e67b75ecb$var$TIME_LEN = 10;
var $adfe6d1e67b75ecb$var$RANDOM_LEN = 16;
function $adfe6d1e67b75ecb$export$40d117de9a146510(str, index, char) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + char + str.substr(index + 1);
}
function $adfe6d1e67b75ecb$export$b089ba7ec6b543fc(str) {
    var done = undefined;
    var index = str.length;
    var char = void 0;
    var charIndex = void 0;
    var maxCharIndex = $adfe6d1e67b75ecb$var$ENCODING_LEN - 1;
    while(!done && index-- >= 0){
        char = str[index];
        charIndex = $adfe6d1e67b75ecb$var$ENCODING.indexOf(char);
        if (charIndex === -1) throw $adfe6d1e67b75ecb$var$createError("incorrectly encoded string");
        if (charIndex === maxCharIndex) {
            str = $adfe6d1e67b75ecb$export$40d117de9a146510(str, index, $adfe6d1e67b75ecb$var$ENCODING[0]);
            continue;
        }
        done = $adfe6d1e67b75ecb$export$40d117de9a146510(str, index, $adfe6d1e67b75ecb$var$ENCODING[charIndex + 1]);
    }
    if (typeof done === "string") return done;
    throw $adfe6d1e67b75ecb$var$createError("cannot increment this string");
}
function $adfe6d1e67b75ecb$export$56a5088d7e2cd06f(prng) {
    var rand = Math.floor(prng() * $adfe6d1e67b75ecb$var$ENCODING_LEN);
    if (rand === $adfe6d1e67b75ecb$var$ENCODING_LEN) rand = $adfe6d1e67b75ecb$var$ENCODING_LEN - 1;
    return $adfe6d1e67b75ecb$var$ENCODING.charAt(rand);
}
function $adfe6d1e67b75ecb$export$91c76fd67c04a444(now, len) {
    if (isNaN(now)) throw new Error(now + " must be a number");
    if (now > $adfe6d1e67b75ecb$var$TIME_MAX) throw $adfe6d1e67b75ecb$var$createError("cannot encode time greater than " + $adfe6d1e67b75ecb$var$TIME_MAX);
    if (now < 0) throw $adfe6d1e67b75ecb$var$createError("time must be positive");
    if (Number.isInteger(now) === false) throw $adfe6d1e67b75ecb$var$createError("time must be an integer");
    var mod = void 0;
    var str = "";
    for(; len > 0; len--){
        mod = now % $adfe6d1e67b75ecb$var$ENCODING_LEN;
        str = $adfe6d1e67b75ecb$var$ENCODING.charAt(mod) + str;
        now = (now - mod) / $adfe6d1e67b75ecb$var$ENCODING_LEN;
    }
    return str;
}
function $adfe6d1e67b75ecb$export$d96791a95d181796(len, prng) {
    var str = "";
    for(; len > 0; len--)str = $adfe6d1e67b75ecb$export$56a5088d7e2cd06f(prng) + str;
    return str;
}
function $adfe6d1e67b75ecb$export$76a67a2fca092822(id) {
    if (id.length !== $adfe6d1e67b75ecb$var$TIME_LEN + $adfe6d1e67b75ecb$var$RANDOM_LEN) throw $adfe6d1e67b75ecb$var$createError("malformed ulid");
    var time = id.substr(0, $adfe6d1e67b75ecb$var$TIME_LEN).split("").reverse().reduce(function(carry, char, index) {
        var encodingIndex = $adfe6d1e67b75ecb$var$ENCODING.indexOf(char);
        if (encodingIndex === -1) throw $adfe6d1e67b75ecb$var$createError("invalid character found: " + char);
        return carry += encodingIndex * Math.pow($adfe6d1e67b75ecb$var$ENCODING_LEN, index);
    }, 0);
    if (time > $adfe6d1e67b75ecb$var$TIME_MAX) throw $adfe6d1e67b75ecb$var$createError("malformed ulid, timestamp too large");
    return time;
}

function $adfe6d1e67b75ecb$export$5dcc08b8fc2f5e10() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];
    if (!root) root = typeof window !== "undefined" ? window : null;
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) return function() {
        var buffer = new Uint8Array(1);
        browserCrypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
    else try {
        var nodeCrypto = (parcelRequire("lg7YP"));
        return function() {
            return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
        };
    } catch (e) {}
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function() {
            return Math.random();
        };
    }
    throw $adfe6d1e67b75ecb$var$createError("secure crypto unusable, insecure Math.random not allowed");
}
function $adfe6d1e67b75ecb$export$e9008f2713103c6c(currPrng) {
    if (!currPrng) currPrng = $adfe6d1e67b75ecb$export$5dcc08b8fc2f5e10();
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        return $adfe6d1e67b75ecb$export$91c76fd67c04a444(seedTime, $adfe6d1e67b75ecb$var$TIME_LEN) + $adfe6d1e67b75ecb$export$d96791a95d181796($adfe6d1e67b75ecb$var$RANDOM_LEN, currPrng);
    };
}
function $adfe6d1e67b75ecb$export$bfbf0de1a73cdfc7(currPrng) {
    if (!currPrng) currPrng = $adfe6d1e67b75ecb$export$5dcc08b8fc2f5e10();
    var lastTime = 0;
    var lastRandom = void 0;
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        if (seedTime <= lastTime) {
            var incrementedRandom = lastRandom = $adfe6d1e67b75ecb$export$b089ba7ec6b543fc(lastRandom);
            return $adfe6d1e67b75ecb$export$91c76fd67c04a444(lastTime, $adfe6d1e67b75ecb$var$TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        var newRandom = lastRandom = $adfe6d1e67b75ecb$export$d96791a95d181796($adfe6d1e67b75ecb$var$RANDOM_LEN, currPrng);
        return $adfe6d1e67b75ecb$export$91c76fd67c04a444(seedTime, $adfe6d1e67b75ecb$var$TIME_LEN) + newRandom;
    };
}
var $adfe6d1e67b75ecb$export$c34778236461ea95 = $adfe6d1e67b75ecb$export$e9008f2713103c6c();


/* eslint-disable react-refresh/only-export-components */ 

var $7Pt2h = parcelRequire("7Pt2h");
/* eslint-env browser */ /**
 * Tiny websocket connection handler.
 *
 * Implements exponential backoff reconnects, ping/pong, and a nice event system using [lib0/observable].
 *
 * @module websocket
 */ /**
 * Observable class prototype.
 *
 * @module observable
 */ /**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $b5584d8615cd2038$export$185802fd694ee1f5 = ()=>new Map();
const $b5584d8615cd2038$export$784d13d8ee351f07 = (m)=>{
    const r = $b5584d8615cd2038$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $b5584d8615cd2038$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $b5584d8615cd2038$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $b5584d8615cd2038$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $b5584d8615cd2038$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};


/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $9ea3ff85accf439d$export$185802fd694ee1f5 = ()=>new Set();
const $9ea3ff85accf439d$export$45b10814cc054894 = (set)=>Array.from(set);
const $9ea3ff85accf439d$export$43128fadae87b74a = (set)=>set.values().next().value || undefined;
const $9ea3ff85accf439d$export$6788812c4e6611e6 = (entries)=>new Set(entries);


/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
const $5e5c19b0ad9b04d4$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $5e5c19b0ad9b04d4$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $5e5c19b0ad9b04d4$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $5e5c19b0ad9b04d4$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $5e5c19b0ad9b04d4$export$6788812c4e6611e6 = Array.from;
const $5e5c19b0ad9b04d4$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $5e5c19b0ad9b04d4$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $5e5c19b0ad9b04d4$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $5e5c19b0ad9b04d4$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $5e5c19b0ad9b04d4$export$bffa455ba8c619a6 = (arr)=>$5e5c19b0ad9b04d4$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $5e5c19b0ad9b04d4$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $5e5c19b0ad9b04d4$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $5e5c19b0ad9b04d4$export$43bee75e5e14138e = Array.isArray;
const $5e5c19b0ad9b04d4$export$7a5d5c156e7dc406 = (arr)=>$5e5c19b0ad9b04d4$export$6788812c4e6611e6($9ea3ff85accf439d$export$6788812c4e6611e6(arr));
const $5e5c19b0ad9b04d4$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $9ea3ff85accf439d$export$185802fd694ee1f5();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};


class $63276599c498ea37$export$77cea355fa80b5f4 {
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $b5584d8615cd2038$export$185802fd694ee1f5();
    }
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $b5584d8615cd2038$export$dccd489362a8619(this._observers, name, $9ea3ff85accf439d$export$185802fd694ee1f5).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $5e5c19b0ad9b04d4$export$6788812c4e6611e6((this._observers.get(name) || $b5584d8615cd2038$export$185802fd694ee1f5()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $b5584d8615cd2038$export$185802fd694ee1f5();
    }
}


/**
 * Utility module to work with time.
 *
 * @module time
 */ /**
 * Utility module to convert metric values.
 *
 * @module metric
 */ /**
 * Common Math expressions.
 *
 * @module math
 */ const $e8fac97060e7c35b$export$a3fe094919f356fd = Math.floor;
const $e8fac97060e7c35b$export$803ce6b71a0a94b2 = Math.ceil;
const $e8fac97060e7c35b$export$2335f513bbd82c6d = Math.abs;
const $e8fac97060e7c35b$export$46de3d998ca9a030 = Math.imul;
const $e8fac97060e7c35b$export$2077e0241d6afd3c = Math.round;
const $e8fac97060e7c35b$export$75e08744a3ff8516 = Math.log10;
const $e8fac97060e7c35b$export$b9fae0bba9d9094d = Math.log2;
const $e8fac97060e7c35b$export$bef1f36f5486a6a3 = Math.log;
const $e8fac97060e7c35b$export$eba8049fb5020b81 = Math.sqrt;
const $e8fac97060e7c35b$export$e16d8520af44a096 = (a, b)=>a + b;
const $e8fac97060e7c35b$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $e8fac97060e7c35b$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $e8fac97060e7c35b$export$c9f5652083b8129d = Number.isNaN;
const $e8fac97060e7c35b$export$9c297f60e22e3389 = Math.pow;
const $e8fac97060e7c35b$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $e8fac97060e7c35b$export$c5552dfdbc7cec71 = Math.sign;
const $e8fac97060e7c35b$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;


const $ec616bce8fff99c5$export$3c3f39195836e927 = 1e24;
const $ec616bce8fff99c5$export$bc1fc8bc8e1895cf = 1e21;
const $ec616bce8fff99c5$export$91377b751fc464a0 = 1e18;
const $ec616bce8fff99c5$export$fc10d2598c9417a5 = 1e15;
const $ec616bce8fff99c5$export$ce366dc9d5abf7ac = 1e12;
const $ec616bce8fff99c5$export$197e40aa3a484017 = 1e9;
const $ec616bce8fff99c5$export$580f1e8cf64f2815 = 1e6;
const $ec616bce8fff99c5$export$a3ed9693cfbf67fa = 1e3;
const $ec616bce8fff99c5$export$6ec17edd70114a88 = 1e2;
const $ec616bce8fff99c5$export$6ffbaf3528ca9f3f = 10;
const $ec616bce8fff99c5$export$ec5800edbd9f0b69 = 0.1;
const $ec616bce8fff99c5$export$9faf718fe58aaa35 = 0.01;
const $ec616bce8fff99c5$export$fab274f99578ceb6 = 1e-3;
const $ec616bce8fff99c5$export$77bd0ce503b87b26 = 1e-6;
const $ec616bce8fff99c5$export$ddef5c050164e23e = 1e-9;
const $ec616bce8fff99c5$export$e10c52a2ab594201 = 1e-12;
const $ec616bce8fff99c5$export$c49f04803481822 = 1e-15;
const $ec616bce8fff99c5$export$5510a0bcf77f39 = 1e-18;
const $ec616bce8fff99c5$export$2b85cc24af20b7fe = 1e-21;
const $ec616bce8fff99c5$export$a2878e23774b59ce = 1e-24;
const $ec616bce8fff99c5$var$prefixUp = [
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
const $ec616bce8fff99c5$var$prefixDown = [
    "",
    "m",
    "μ",
    "n",
    "p",
    "f",
    "a",
    "z",
    "y"
];
const $ec616bce8fff99c5$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $e8fac97060e7c35b$export$75e08744a3ff8516(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $ec616bce8fff99c5$var$prefixDown[-baseMultiplier] : $ec616bce8fff99c5$var$prefixUp[baseMultiplier];
    return {
        n: $e8fac97060e7c35b$export$2077e0241d6afd3c((mult > 0 ? n / $e8fac97060e7c35b$export$1bb2a14208c790f7(mult * 3) : n * $e8fac97060e7c35b$export$1bb2a14208c790f7(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};



const $a69ef2806e7968d3$export$aa350b96d91cd94 = ()=>new Date();
const $a69ef2806e7968d3$export$1f77c0008d16313 = Date.now;
const $a69ef2806e7968d3$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $ec616bce8fff99c5$export$82e9f45cca5ba907(d, -1);
        return $e8fac97060e7c35b$export$2077e0241d6afd3c(p.n * 100) / 100 + p.prefix + "s";
    }
    d = $e8fac97060e7c35b$export$a3fe094919f356fd(d / 1000);
    const seconds = d % 60;
    const minutes = $e8fac97060e7c35b$export$a3fe094919f356fd(d / 60) % 60;
    const hours = $e8fac97060e7c35b$export$a3fe094919f356fd(d / 3600) % 24;
    const days = $e8fac97060e7c35b$export$a3fe094919f356fd(d / 86400);
    if (days > 0) return days + "d" + (hours > 0 || minutes > 30 ? " " + (minutes > 30 ? hours + 1 : hours) + "h" : "");
    if (hours > 0) /* c8 ignore next */ return hours + "h" + (minutes > 0 || seconds > 30 ? " " + (seconds > 30 ? minutes + 1 : minutes) + "min" : "");
    return minutes + "min" + (seconds > 0 ? " " + seconds + "s" : "");
};



const $f1811bf482b3826c$var$reconnectTimeoutBase = 1200;
const $f1811bf482b3826c$var$maxReconnectTimeout = 2500;
// @todo - this should depend on awareness.outdatedTime
const $f1811bf482b3826c$var$messageReconnectTimeout = 30000;
/**
 * @param {WebsocketClient} wsclient
 */ const $f1811bf482b3826c$var$setupWS = (wsclient)=>{
    if (wsclient.shouldConnect && wsclient.ws === null) {
        const websocket = new WebSocket(wsclient.url);
        const binaryType = wsclient.binaryType;
        /**
     * @type {any}
     */ let pingTimeout = null;
        if (binaryType) websocket.binaryType = binaryType;
        wsclient.ws = websocket;
        wsclient.connecting = true;
        wsclient.connected = false;
        websocket.onmessage = (event)=>{
            wsclient.lastMessageReceived = $a69ef2806e7968d3$export$1f77c0008d16313();
            const data = event.data;
            const message = typeof data === "string" ? JSON.parse(data) : data;
            if (message && message.type === "pong") {
                clearTimeout(pingTimeout);
                pingTimeout = setTimeout(sendPing, $f1811bf482b3826c$var$messageReconnectTimeout / 2);
            }
            wsclient.emit("message", [
                message,
                wsclient
            ]);
        };
        /**
     * @param {any} error
     */ const onclose = (error)=>{
            if (wsclient.ws !== null) {
                wsclient.ws = null;
                wsclient.connecting = false;
                if (wsclient.connected) {
                    wsclient.connected = false;
                    wsclient.emit("disconnect", [
                        {
                            type: "disconnect",
                            error: error
                        },
                        wsclient
                    ]);
                } else wsclient.unsuccessfulReconnects++;
                // Start with no reconnect timeout and increase timeout by
                // log10(wsUnsuccessfulReconnects).
                // The idea is to increase reconnect timeout slowly and have no reconnect
                // timeout at the beginning (log(1) = 0)
                setTimeout($f1811bf482b3826c$var$setupWS, $e8fac97060e7c35b$export$96ec731ed4dcb222($e8fac97060e7c35b$export$75e08744a3ff8516(wsclient.unsuccessfulReconnects + 1) * $f1811bf482b3826c$var$reconnectTimeoutBase, $f1811bf482b3826c$var$maxReconnectTimeout), wsclient);
            }
            clearTimeout(pingTimeout);
        };
        const sendPing = ()=>{
            if (wsclient.ws === websocket) wsclient.send({
                type: "ping"
            });
        };
        websocket.onclose = ()=>onclose(null);
        websocket.onerror = (error)=>onclose(error);
        websocket.onopen = ()=>{
            wsclient.lastMessageReceived = $a69ef2806e7968d3$export$1f77c0008d16313();
            wsclient.connecting = false;
            wsclient.connected = true;
            wsclient.unsuccessfulReconnects = 0;
            wsclient.emit("connect", [
                {
                    type: "connect"
                },
                wsclient
            ]);
            // set ping
            pingTimeout = setTimeout(sendPing, $f1811bf482b3826c$var$messageReconnectTimeout / 2);
        };
    }
};
class $f1811bf482b3826c$export$4d57ced7551703ba extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {string} url
   * @param {object} opts
   * @param {'arraybuffer' | 'blob' | null} [opts.binaryType] Set `ws.binaryType`
   */ constructor(url, { binaryType: binaryType  } = {}){
        super();
        this.url = url;
        /**
     * @type {WebSocket?}
     */ this.ws = null;
        this.binaryType = binaryType || null;
        this.connected = false;
        this.connecting = false;
        this.unsuccessfulReconnects = 0;
        this.lastMessageReceived = 0;
        /**
     * Whether to connect to other peers or not
     * @type {boolean}
     */ this.shouldConnect = true;
        this._checkInterval = setInterval(()=>{
            if (this.connected && $f1811bf482b3826c$var$messageReconnectTimeout < $a69ef2806e7968d3$export$1f77c0008d16313() - this.lastMessageReceived) // no message received in a long time - not even your own awareness
            // updates (which are updated every 15 seconds)
            /** @type {WebSocket} */ this.ws.close();
        }, $f1811bf482b3826c$var$messageReconnectTimeout / 2);
        $f1811bf482b3826c$var$setupWS(this);
    }
    /**
   * @param {any} message
   */ send(message) {
        if (this.ws) this.ws.send(JSON.stringify(message));
    }
    destroy() {
        clearInterval(this._checkInterval);
        this.disconnect();
        super.destroy();
    }
    disconnect() {
        this.shouldConnect = false;
        if (this.ws !== null) this.ws.close();
    }
    connect() {
        this.shouldConnect = true;
        if (!this.connected && this.ws === null) $f1811bf482b3826c$var$setupWS(this);
    }
}



/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $a12da43118d917e2$export$185802fd694ee1f5 = (s)=>new Error(s);
const $a12da43118d917e2$export$73ced5c7e10d6d0f = ()=>{
    throw $a12da43118d917e2$export$185802fd694ee1f5("Method unimplemented");
};
const $a12da43118d917e2$export$965b6bccecbd9673 = ()=>{
    throw $a12da43118d917e2$export$185802fd694ee1f5("Unexpected case");
};


/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $8d6ba0cc01579050$export$ee2c6657cb286da4 = 1;
const $8d6ba0cc01579050$export$1f117f3b0edc2676 = 2;
const $8d6ba0cc01579050$export$e5294f8c78cf7711 = 4;
const $8d6ba0cc01579050$export$873ae8db4cef5125 = 8;
const $8d6ba0cc01579050$export$b6e6496517dfbd31 = 16;
const $8d6ba0cc01579050$export$daf23f774967089 = 32;
const $8d6ba0cc01579050$export$eb5a8e0006ab4bb5 = 64;
const $8d6ba0cc01579050$export$e25597372303a045 = 128;
const $8d6ba0cc01579050$export$f15587807021fe79 = 256;
const $8d6ba0cc01579050$export$70939d57ba836c5 = 512;
const $8d6ba0cc01579050$export$9ec47920d80e8c85 = 1024;
const $8d6ba0cc01579050$export$bc5dd16b35d4584b = 2048;
const $8d6ba0cc01579050$export$76a85e893e6d6ecc = 4096;
const $8d6ba0cc01579050$export$fb6ca64a3ffa3aa9 = 8192;
const $8d6ba0cc01579050$export$e7adc86ee9ea4b00 = 16384;
const $8d6ba0cc01579050$export$6aa68b9346d558bb = 32768;
const $8d6ba0cc01579050$export$5d7aab37466c79ea = 65536;
const $8d6ba0cc01579050$export$3aa401309ff3940 = 131072;
const $8d6ba0cc01579050$export$1fd8467d3320465f = 262144;
const $8d6ba0cc01579050$export$d1dceb84a396f684 = 524288;
const $8d6ba0cc01579050$export$ef62e7729d79baec = 1048576;
const $8d6ba0cc01579050$export$40651ae3846a7710 = 2097152;
const $8d6ba0cc01579050$export$e03976987cb0b818 = 4194304;
const $8d6ba0cc01579050$export$dd5dceb22223d8ef = 8388608;
const $8d6ba0cc01579050$export$aecaefba6ae044e4 = 16777216;
const $8d6ba0cc01579050$export$6e47d6f6c411c0e1 = 33554432;
const $8d6ba0cc01579050$export$321a8fda0150a18 = 67108864;
const $8d6ba0cc01579050$export$d7843230fff08622 = 134217728;
const $8d6ba0cc01579050$export$9fe7219cb72d1ed8 = 268435456;
const $8d6ba0cc01579050$export$c85121a54e1cc97f = 536870912;
const $8d6ba0cc01579050$export$76075a64dc7c21ef = 1073741824;
const $8d6ba0cc01579050$export$49d5cdcf29800e09 = -2147483648;
const $8d6ba0cc01579050$export$853d99058378c102 = 0;
const $8d6ba0cc01579050$export$b859c32a415b3ec1 = 1;
const $8d6ba0cc01579050$export$decefe6957191373 = 3;
const $8d6ba0cc01579050$export$d1defff3cbd2c6f4 = 7;
const $8d6ba0cc01579050$export$8d2b432c8c02ae65 = 15;
const $8d6ba0cc01579050$export$bc2aba63e4099c09 = 31;
const $8d6ba0cc01579050$export$f39f4e074e983a34 = 63;
const $8d6ba0cc01579050$export$f84d6bebff154ceb = 127;
const $8d6ba0cc01579050$export$c880072ee0e87648 = 255;
const $8d6ba0cc01579050$export$cbbfa5d3c076ad8c = 511;
const $8d6ba0cc01579050$export$e365aa75b5fa7293 = 1023;
const $8d6ba0cc01579050$export$51bfc23c1b7b60c3 = 2047;
const $8d6ba0cc01579050$export$3b0a099b88523ac = 4095;
const $8d6ba0cc01579050$export$8345c1c06d3e5fc1 = 8191;
const $8d6ba0cc01579050$export$e20cffba663a7688 = 16383;
const $8d6ba0cc01579050$export$cd0970fd37b207c6 = 32767;
const $8d6ba0cc01579050$export$250487b182389b6a = 65535;
const $8d6ba0cc01579050$export$9d6e01d73abdaadb = $8d6ba0cc01579050$export$3aa401309ff3940 - 1;
const $8d6ba0cc01579050$export$eedeab0ac4009664 = $8d6ba0cc01579050$export$1fd8467d3320465f - 1;
const $8d6ba0cc01579050$export$e1840c3c33a76ffc = $8d6ba0cc01579050$export$d1dceb84a396f684 - 1;
const $8d6ba0cc01579050$export$f0ae3ba8312e92e3 = $8d6ba0cc01579050$export$ef62e7729d79baec - 1;
const $8d6ba0cc01579050$export$b5ffbef7f0f6f536 = $8d6ba0cc01579050$export$40651ae3846a7710 - 1;
const $8d6ba0cc01579050$export$33ae34bc8e747862 = $8d6ba0cc01579050$export$e03976987cb0b818 - 1;
const $8d6ba0cc01579050$export$3629272792e6a9a0 = $8d6ba0cc01579050$export$dd5dceb22223d8ef - 1;
const $8d6ba0cc01579050$export$a07300a4cc2ba23c = $8d6ba0cc01579050$export$aecaefba6ae044e4 - 1;
const $8d6ba0cc01579050$export$9137f2824b26e02b = $8d6ba0cc01579050$export$6e47d6f6c411c0e1 - 1;
const $8d6ba0cc01579050$export$94d4c3aa7cfbb8dd = $8d6ba0cc01579050$export$321a8fda0150a18 - 1;
const $8d6ba0cc01579050$export$8af89455097efce0 = $8d6ba0cc01579050$export$d7843230fff08622 - 1;
const $8d6ba0cc01579050$export$dee9196bb8567fe9 = $8d6ba0cc01579050$export$9fe7219cb72d1ed8 - 1;
const $8d6ba0cc01579050$export$bd0b5ef1d89e90f = $8d6ba0cc01579050$export$c85121a54e1cc97f - 1;
const $8d6ba0cc01579050$export$e5560e011efa8766 = $8d6ba0cc01579050$export$76075a64dc7c21ef - 1;
const $8d6ba0cc01579050$export$87ec42487f19c66c = 0x7FFFFFFF;
const $8d6ba0cc01579050$export$3ea07c5174cba08a = 0xFFFFFFFF;


/* eslint-env browser */ const $997b3d9040a37925$export$f45422fd2e8042d4 = crypto.subtle;
const $997b3d9040a37925$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);


const $562771b566a9e573$export$bb0a9c36cf454ea0 = Math.random;
const $562771b566a9e573$export$de9ffb9418dd7d0d = ()=>(0, $997b3d9040a37925$export$960b9ff25e7d4257)(new Uint32Array(1))[0];
const $562771b566a9e573$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $997b3d9040a37925$export$960b9ff25e7d4257)(new Uint32Array(8));
    return (arr[0] & $8d6ba0cc01579050$export$b5ffbef7f0f6f536) * ($8d6ba0cc01579050$export$3ea07c5174cba08a + 1) + (arr[1] >>> 0);
};
const $562771b566a9e573$export$a9a18ae5ba42aeab = (arr)=>arr[$e8fac97060e7c35b$export$a3fe094919f356fd($562771b566a9e573$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $562771b566a9e573$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $562771b566a9e573$export$abe4376e1bf796d6 = ()=>$562771b566a9e573$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $562771b566a9e573$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));


/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ /**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
const $8322690016f3fe63$export$30216c0101da0ee0 = String.fromCharCode;
const $8322690016f3fe63$export$73bfc63873071f74 = String.fromCodePoint;
const $8322690016f3fe63$export$e3a9a653b2a11ac1 = $8322690016f3fe63$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $8322690016f3fe63$var$toLowerCase = (s)=>s.toLowerCase();
const $8322690016f3fe63$var$trimLeftRegex = /^\s*/g;
const $8322690016f3fe63$export$c5557f40488c48ec = (s)=>s.replace($8322690016f3fe63$var$trimLeftRegex, "");
const $8322690016f3fe63$var$fromCamelCaseRegex = /([A-Z])/g;
const $8322690016f3fe63$export$87429743646c3257 = (s, separator)=>$8322690016f3fe63$export$c5557f40488c48ec(s.replace($8322690016f3fe63$var$fromCamelCaseRegex, (match)=>`${separator}${$8322690016f3fe63$var$toLowerCase(match)}`));
const $8322690016f3fe63$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $8322690016f3fe63$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $8322690016f3fe63$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== "undefined" ? new TextEncoder() : null;
const $8322690016f3fe63$export$9a0a70804ee285dd = (str)=>$8322690016f3fe63$export$f3ce4806f2484eb.encode(str);
const $8322690016f3fe63$export$8f647c2204da8484 = $8322690016f3fe63$export$f3ce4806f2484eb ? $8322690016f3fe63$export$9a0a70804ee285dd : $8322690016f3fe63$export$83d8cea287b4dfcd;
const $8322690016f3fe63$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = "";
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $8322690016f3fe63$export$f477633695bbbcd = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf-8", {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($8322690016f3fe63$export$f477633695bbbcd && $8322690016f3fe63$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $8322690016f3fe63$export$f477633695bbbcd = null;
const $8322690016f3fe63$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $8322690016f3fe63$export$f477633695bbbcd.decode(buf);
const $8322690016f3fe63$export$72118b85b055afd = $8322690016f3fe63$export$f477633695bbbcd ? $8322690016f3fe63$export$23d5f1ce72f56168 : $8322690016f3fe63$export$154b750182ae32cf;
const $8322690016f3fe63$export$869882364835d202 = (str, index, remove, insert = "")=>str.slice(0, index) + insert + str.slice(index + remove);
const $8322690016f3fe63$export$76d90c956114f2c2 = (source, n)=>$5e5c19b0ad9b04d4$export$c48e357c1a89b78d(n, ()=>source).join("");


/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */ 

/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $899f68220ca100e1$export$43874719a1af321f = (v)=>v === undefined ? null : v;


/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $c97ef499247dea2a$var$VarStoragePolyfill {
    constructor(){
        this.map = new Map();
    }
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $c97ef499247dea2a$var$_localStorage = new $c97ef499247dea2a$var$VarStoragePolyfill();
let $c97ef499247dea2a$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== "undefined") {
        $c97ef499247dea2a$var$_localStorage = localStorage;
        $c97ef499247dea2a$var$usePolyfill = false;
    }
} catch (e) {}
const $c97ef499247dea2a$export$86b84a8d42aa2c65 = $c97ef499247dea2a$var$_localStorage;
const $c97ef499247dea2a$export$bd913411069e59d3 = (eventHandler)=>$c97ef499247dea2a$var$usePolyfill || addEventListener("storage", /** @type {any} */ eventHandler);
const $c97ef499247dea2a$export$ff6a13ad336aa064 = (eventHandler)=>$c97ef499247dea2a$var$usePolyfill || removeEventListener("storage", /** @type {any} */ eventHandler);


/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ const $3f96a8565a5b4a5a$export$185802fd694ee1f5 = ()=>Object.create(null);
const $3f96a8565a5b4a5a$export$e6e34fd1f2686227 = Object.assign;
const $3f96a8565a5b4a5a$export$ed97f33186d4b816 = Object.keys;
const $3f96a8565a5b4a5a$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $3f96a8565a5b4a5a$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $3f96a8565a5b4a5a$export$f24224f1c91d8156 = (obj)=>$3f96a8565a5b4a5a$export$ed97f33186d4b816(obj).length;
const $3f96a8565a5b4a5a$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $3f96a8565a5b4a5a$export$dd1bc94b04021eeb = (obj)=>{
    for(const _k in obj)return false;
    return true;
};
const $3f96a8565a5b4a5a$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $3f96a8565a5b4a5a$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $3f96a8565a5b4a5a$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $3f96a8565a5b4a5a$export$f24224f1c91d8156(a) === $3f96a8565a5b4a5a$export$f24224f1c91d8156(b) && $3f96a8565a5b4a5a$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $3f96a8565a5b4a5a$export$bf9617eaf5d2451(b, key)) && b[key] === val);


const $335a02b91f00a29d$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $335a02b91f00a29d$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $335a02b91f00a29d$export$b5f1cfe7b08e6ed5 = ()=>{};
const $335a02b91f00a29d$export$5635d7ef4b8fee1c = (f)=>f();
const $335a02b91f00a29d$export$d560c7e4a29451c2 = (a)=>a;
const $335a02b91f00a29d$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $335a02b91f00a29d$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($5e5c19b0ad9b04d4$export$43bee75e5e14138e(a) && $5e5c19b0ad9b04d4$export$4f1c34abb2bb4c8(a, /** @type {Array<T>} */ b) || typeof a === "object" && $3f96a8565a5b4a5a$export$4f1c34abb2bb4c8(a, b));
const $335a02b91f00a29d$export$2ca9a723affd5d11 = (a, b)=>{
    if (a == null || b == null) return $335a02b91f00a29d$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$335a02b91f00a29d$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case Object:
            if ($3f96a8565a5b4a5a$export$f24224f1c91d8156(a) !== $3f96a8565a5b4a5a$export$f24224f1c91d8156(b)) return false;
            for(const key in a){
                if (!$3f96a8565a5b4a5a$export$bf9617eaf5d2451(a, key) || !$335a02b91f00a29d$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$335a02b91f00a29d$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $335a02b91f00a29d$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $335a02b91f00a29d$export$43bee75e5e14138e = $5e5c19b0ad9b04d4$export$43bee75e5e14138e;
const $335a02b91f00a29d$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $335a02b91f00a29d$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $335a02b91f00a29d$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $335a02b91f00a29d$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;


var $8422df313e23a2a7$exports = {};
// shim for using process in browser
var $8422df313e23a2a7$var$process = $8422df313e23a2a7$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8422df313e23a2a7$var$cachedSetTimeout;
var $8422df313e23a2a7$var$cachedClearTimeout;
function $8422df313e23a2a7$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8422df313e23a2a7$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8422df313e23a2a7$var$cachedSetTimeout = setTimeout;
        else $8422df313e23a2a7$var$cachedSetTimeout = $8422df313e23a2a7$var$defaultSetTimout;
    } catch (e) {
        $8422df313e23a2a7$var$cachedSetTimeout = $8422df313e23a2a7$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8422df313e23a2a7$var$cachedClearTimeout = clearTimeout;
        else $8422df313e23a2a7$var$cachedClearTimeout = $8422df313e23a2a7$var$defaultClearTimeout;
    } catch (e) {
        $8422df313e23a2a7$var$cachedClearTimeout = $8422df313e23a2a7$var$defaultClearTimeout;
    }
})();
function $8422df313e23a2a7$var$runTimeout(fun) {
    if ($8422df313e23a2a7$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8422df313e23a2a7$var$cachedSetTimeout === $8422df313e23a2a7$var$defaultSetTimout || !$8422df313e23a2a7$var$cachedSetTimeout) && setTimeout) {
        $8422df313e23a2a7$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8422df313e23a2a7$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8422df313e23a2a7$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8422df313e23a2a7$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8422df313e23a2a7$var$runClearTimeout(marker) {
    if ($8422df313e23a2a7$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8422df313e23a2a7$var$cachedClearTimeout === $8422df313e23a2a7$var$defaultClearTimeout || !$8422df313e23a2a7$var$cachedClearTimeout) && clearTimeout) {
        $8422df313e23a2a7$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8422df313e23a2a7$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8422df313e23a2a7$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8422df313e23a2a7$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8422df313e23a2a7$var$queue = [];
var $8422df313e23a2a7$var$draining = false;
var $8422df313e23a2a7$var$currentQueue;
var $8422df313e23a2a7$var$queueIndex = -1;
function $8422df313e23a2a7$var$cleanUpNextTick() {
    if (!$8422df313e23a2a7$var$draining || !$8422df313e23a2a7$var$currentQueue) return;
    $8422df313e23a2a7$var$draining = false;
    if ($8422df313e23a2a7$var$currentQueue.length) $8422df313e23a2a7$var$queue = $8422df313e23a2a7$var$currentQueue.concat($8422df313e23a2a7$var$queue);
    else $8422df313e23a2a7$var$queueIndex = -1;
    if ($8422df313e23a2a7$var$queue.length) $8422df313e23a2a7$var$drainQueue();
}
function $8422df313e23a2a7$var$drainQueue() {
    if ($8422df313e23a2a7$var$draining) return;
    var timeout = $8422df313e23a2a7$var$runTimeout($8422df313e23a2a7$var$cleanUpNextTick);
    $8422df313e23a2a7$var$draining = true;
    var len = $8422df313e23a2a7$var$queue.length;
    while(len){
        $8422df313e23a2a7$var$currentQueue = $8422df313e23a2a7$var$queue;
        $8422df313e23a2a7$var$queue = [];
        while(++$8422df313e23a2a7$var$queueIndex < len)if ($8422df313e23a2a7$var$currentQueue) $8422df313e23a2a7$var$currentQueue[$8422df313e23a2a7$var$queueIndex].run();
        $8422df313e23a2a7$var$queueIndex = -1;
        len = $8422df313e23a2a7$var$queue.length;
    }
    $8422df313e23a2a7$var$currentQueue = null;
    $8422df313e23a2a7$var$draining = false;
    $8422df313e23a2a7$var$runClearTimeout(timeout);
}
$8422df313e23a2a7$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8422df313e23a2a7$var$queue.push(new $8422df313e23a2a7$var$Item(fun, args));
    if ($8422df313e23a2a7$var$queue.length === 1 && !$8422df313e23a2a7$var$draining) $8422df313e23a2a7$var$runTimeout($8422df313e23a2a7$var$drainQueue);
};
// v8 likes predictible objects
function $8422df313e23a2a7$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8422df313e23a2a7$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8422df313e23a2a7$var$process.title = "browser";
$8422df313e23a2a7$var$process.browser = true;
$8422df313e23a2a7$var$process.env = {};
$8422df313e23a2a7$var$process.argv = [];
$8422df313e23a2a7$var$process.version = ""; // empty string to avoid regexp issues
$8422df313e23a2a7$var$process.versions = {};
function $8422df313e23a2a7$var$noop() {}
$8422df313e23a2a7$var$process.on = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.addListener = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.once = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.off = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.removeListener = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.removeAllListeners = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.emit = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.prependListener = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.prependOnceListener = $8422df313e23a2a7$var$noop;
$8422df313e23a2a7$var$process.listeners = function(name) {
    return [];
};
$8422df313e23a2a7$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8422df313e23a2a7$var$process.cwd = function() {
    return "/";
};
$8422df313e23a2a7$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8422df313e23a2a7$var$process.umask = function() {
    return 0;
};


const $ceb445566faa62b1$export$8ee0fc9ee280b4ee = typeof $8422df313e23a2a7$exports !== "undefined" && $8422df313e23a2a7$exports.release && /node|io\.js/.test($8422df313e23a2a7$exports.release.name);
const $ceb445566faa62b1$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof document !== "undefined" && !$ceb445566faa62b1$export$8ee0fc9ee280b4ee;
const $ceb445566faa62b1$export$9ac100e40613ea10 = typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $ceb445566faa62b1$var$params;
const $ceb445566faa62b1$var$args = [];
/* c8 ignore start */ const $ceb445566faa62b1$var$computeParams = ()=>{
    if ($ceb445566faa62b1$var$params === undefined) {
        if ($ceb445566faa62b1$export$8ee0fc9ee280b4ee) {
            $ceb445566faa62b1$var$params = $b5584d8615cd2038$export$185802fd694ee1f5();
            const pargs = $8422df313e23a2a7$exports.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === "-") {
                    if (currParamName !== null) $ceb445566faa62b1$var$params.set(currParamName, "");
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $ceb445566faa62b1$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $ceb445566faa62b1$var$args.push(parg);
            }
            if (currParamName !== null) $ceb445566faa62b1$var$params.set(currParamName, "");
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === "object") {
            $ceb445566faa62b1$var$params = $b5584d8615cd2038$export$185802fd694ee1f5(); // eslint-disable-next-line no-undef
            (location.search || "?").slice(1).split("&").forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split("=");
                    $ceb445566faa62b1$var$params.set(`--${$8322690016f3fe63$export$87429743646c3257(key, "-")}`, value);
                    $ceb445566faa62b1$var$params.set(`-${$8322690016f3fe63$export$87429743646c3257(key, "-")}`, value);
                }
            });
        } else $ceb445566faa62b1$var$params = $b5584d8615cd2038$export$185802fd694ee1f5();
    }
    return $ceb445566faa62b1$var$params;
};
const $ceb445566faa62b1$export$3ad523d4e4ddff75 = (name)=>$ceb445566faa62b1$var$computeParams().has(name);
const $ceb445566faa62b1$export$ecf541e09a511845 = (name, defaultVal)=>$ceb445566faa62b1$var$computeParams().get(name) || defaultVal;
const $ceb445566faa62b1$export$39fb32ac18db3f88 = (name)=>$ceb445566faa62b1$export$8ee0fc9ee280b4ee ? $899f68220ca100e1$export$43874719a1af321f($8422df313e23a2a7$exports.env[name.toUpperCase()]) : $899f68220ca100e1$export$43874719a1af321f($c97ef499247dea2a$export$86b84a8d42aa2c65.getItem(name));
const $ceb445566faa62b1$export$137940a4fd07b923 = (name)=>$ceb445566faa62b1$var$computeParams().get("--" + name) || $ceb445566faa62b1$export$39fb32ac18db3f88(name);
const $ceb445566faa62b1$export$41f29dc169f5b0eb = (name)=>$ceb445566faa62b1$export$3ad523d4e4ddff75("--" + name) || $ceb445566faa62b1$export$39fb32ac18db3f88(name) !== null;
const $ceb445566faa62b1$export$d71d1489bc353e92 = $ceb445566faa62b1$export$41f29dc169f5b0eb("production");
/* c8 ignore next 2 */ const $ceb445566faa62b1$var$forceColor = $ceb445566faa62b1$export$8ee0fc9ee280b4ee && $335a02b91f00a29d$export$532a90c0e5e8e48c(undefined, [
    "true",
    "1",
    "2"
]);
const $ceb445566faa62b1$export$fcbe44f5d6fcebd = !$ceb445566faa62b1$export$3ad523d4e4ddff75("no-colors") && (!$ceb445566faa62b1$export$8ee0fc9ee280b4ee || $8422df313e23a2a7$exports.stdout.isTTY || $ceb445566faa62b1$var$forceColor) && (!$ceb445566faa62b1$export$8ee0fc9ee280b4ee || $ceb445566faa62b1$export$3ad523d4e4ddff75("color") || $ceb445566faa62b1$var$forceColor || $ceb445566faa62b1$export$39fb32ac18db3f88("COLORTERM") !== null || ($ceb445566faa62b1$export$39fb32ac18db3f88("TERM") || "").includes("color") /* c8 ignore stop */ );



/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 


/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 

const $5984a053755878ee$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $5984a053755878ee$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $5984a053755878ee$export$7accc3db8e859605 = -2147483648;
const $5984a053755878ee$export$a5f353c3c14c00d0 = $8d6ba0cc01579050$export$87ec42487f19c66c;
const $5984a053755878ee$export$f055c566d4c0f541 = $8d6ba0cc01579050$export$3ea07c5174cba08a;
const $5984a053755878ee$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === "number" && isFinite(num) && $e8fac97060e7c35b$export$a3fe094919f356fd(num) === num);
const $5984a053755878ee$export$c9f5652083b8129d = Number.isNaN;
const $5984a053755878ee$export$5f87784a266e50a4 = Number.parseInt;





const $902b843224f0f9d8$var$errorUnexpectedEndOfArray = $a12da43118d917e2$export$185802fd694ee1f5("Unexpected end of array");
const $902b843224f0f9d8$var$errorIntegerOutOfRange = $a12da43118d917e2$export$185802fd694ee1f5("Integer out of Range");
class $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $902b843224f0f9d8$export$f8c898e83b60faaa = (uint8Array)=>new $902b843224f0f9d8$export$f9de6ca0bc043724(uint8Array);
const $902b843224f0f9d8$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $902b843224f0f9d8$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $902b843224f0f9d8$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $902b843224f0f9d8$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = $0b91950191e72a08$export$f3c8b5f6d250ec43(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
const $902b843224f0f9d8$export$7418bbc18dee40f3 = (decoder)=>$902b843224f0f9d8$export$e21b2fe168d56a89(decoder, $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder));
const $902b843224f0f9d8$export$8c9f57cb3e3e2d3b = (decoder)=>$902b843224f0f9d8$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $902b843224f0f9d8$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $902b843224f0f9d8$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $902b843224f0f9d8$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $902b843224f0f9d8$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $902b843224f0f9d8$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $902b843224f0f9d8$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $902b843224f0f9d8$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $902b843224f0f9d8$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $902b843224f0f9d8$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $8d6ba0cc01579050$export$f84d6bebff154ceb) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $8d6ba0cc01579050$export$e25597372303a045) return num;
        /* c8 ignore start */ if (num > $5984a053755878ee$export$18510406f204a1b9) throw $902b843224f0f9d8$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $902b843224f0f9d8$var$errorUnexpectedEndOfArray;
};
const $902b843224f0f9d8$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $8d6ba0cc01579050$export$f39f4e074e983a34;
    let mult = 64;
    const sign = (r & $8d6ba0cc01579050$export$eb5a8e0006ab4bb5) > 0 ? -1 : 1;
    if ((r & $8d6ba0cc01579050$export$e25597372303a045) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $8d6ba0cc01579050$export$f84d6bebff154ceb) * mult;
        mult *= 128;
        if (r < $8d6ba0cc01579050$export$e25597372303a045) return sign * num;
        /* c8 ignore start */ if (num > $5984a053755878ee$export$18510406f204a1b9) throw $902b843224f0f9d8$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $902b843224f0f9d8$var$errorUnexpectedEndOfArray;
};
const $902b843224f0f9d8$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $902b843224f0f9d8$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $902b843224f0f9d8$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $902b843224f0f9d8$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return "";
    else {
        let encodedString = String.fromCodePoint($902b843224f0f9d8$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($902b843224f0f9d8$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $902b843224f0f9d8$export$7247eefae50fb91a = (decoder)=>/** @type any */ $8322690016f3fe63$export$f477633695bbbcd.decode($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
const $902b843224f0f9d8$export$3b64b4d753b81ec2 = $8322690016f3fe63$export$f477633695bbbcd ? $902b843224f0f9d8$export$7247eefae50fb91a : $902b843224f0f9d8$export$e73299e6158668bb;
const $902b843224f0f9d8$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    let b;
    while(true){
        b = $902b843224f0f9d8$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
        if (b === 1) b = $902b843224f0f9d8$export$d5778a2beba4ceef(decoder);
        $7f295e825046a0c3$export$68d8715fc104d294(encoder, b);
    }
};
const $902b843224f0f9d8$export$d38ec182b293d566 = (decoder)=>$8322690016f3fe63$export$72118b85b055afd($902b843224f0f9d8$export$23764cfecad9ae2f(decoder));
const $902b843224f0f9d8$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $902b843224f0f9d8$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $902b843224f0f9d8$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $902b843224f0f9d8$export$dbc4aa781d9afe3b = (decoder)=>$902b843224f0f9d8$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $902b843224f0f9d8$export$d89a471990a89a7f = (decoder)=>$902b843224f0f9d8$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $902b843224f0f9d8$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $902b843224f0f9d8$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $902b843224f0f9d8$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $902b843224f0f9d8$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $902b843224f0f9d8$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $902b843224f0f9d8$export$1dd5b9ddf6575ae8,
    $902b843224f0f9d8$export$dbc4aa781d9afe3b,
    $902b843224f0f9d8$export$d89a471990a89a7f,
    $902b843224f0f9d8$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $902b843224f0f9d8$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $902b843224f0f9d8$export$3b64b4d753b81ec2(decoder);
            obj[key] = $902b843224f0f9d8$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($902b843224f0f9d8$export$82863139061f472f(decoder));
        return arr;
    },
    $902b843224f0f9d8$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $902b843224f0f9d8$export$82863139061f472f = (decoder)=>$902b843224f0f9d8$var$readAnyLookupTable[127 - $902b843224f0f9d8$export$d5778a2beba4ceef(decoder)](decoder);
class $902b843224f0f9d8$export$f1f1200492b832af extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($902b843224f0f9d8$export$7ad75c69830b76d7(this)) this.count = $902b843224f0f9d8$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
}
class $902b843224f0f9d8$export$938378143fffe1b4 extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @return {number}
   */ read() {
        this.s += $902b843224f0f9d8$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
}
class $902b843224f0f9d8$export$595b36f1b42934c6 extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $902b843224f0f9d8$export$1dd5b9ddf6575ae8(this);
            if ($902b843224f0f9d8$export$7ad75c69830b76d7(this)) this.count = $902b843224f0f9d8$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $902b843224f0f9d8$export$2dc62fb2f864b82e extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $902b843224f0f9d8$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $e8fac97060e7c35b$export$dc0a61f4a9121f92(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $902b843224f0f9d8$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $902b843224f0f9d8$export$727389af14dfe417 extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $902b843224f0f9d8$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $e8fac97060e7c35b$export$dc0a61f4a9121f92(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $902b843224f0f9d8$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
}
class $902b843224f0f9d8$export$d502ab0bf048a596 extends $902b843224f0f9d8$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $902b843224f0f9d8$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $e8fac97060e7c35b$export$a3fe094919f356fd(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $902b843224f0f9d8$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
}
class $902b843224f0f9d8$export$63a7aa211a91ed69 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $902b843224f0f9d8$export$2dc62fb2f864b82e(uint8Array);
        this.str = $902b843224f0f9d8$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ad299d2484506af2$export$a143d493d941bafc;
var $ad299d2484506af2$export$e4cf37d7f6fb9e0a;
var $ad299d2484506af2$export$f99ded8fe4b79145;
var $ad299d2484506af2$export$599f31c3813fae4d;
"use strict";
var $801b2558ad529618$export$a48f0734ac7c2329;
var $801b2558ad529618$export$d622b2ad8d90c771;
var $801b2558ad529618$export$6100ba28696e12de;
"use strict";
$801b2558ad529618$export$a48f0734ac7c2329 = $801b2558ad529618$var$byteLength;
$801b2558ad529618$export$d622b2ad8d90c771 = $801b2558ad529618$var$toByteArray;
$801b2558ad529618$export$6100ba28696e12de = $801b2558ad529618$var$fromByteArray;
var $801b2558ad529618$var$lookup = [];
var $801b2558ad529618$var$revLookup = [];
var $801b2558ad529618$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $801b2558ad529618$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $801b2558ad529618$var$i = 0, $801b2558ad529618$var$len = $801b2558ad529618$var$code.length; $801b2558ad529618$var$i < $801b2558ad529618$var$len; ++$801b2558ad529618$var$i){
    $801b2558ad529618$var$lookup[$801b2558ad529618$var$i] = $801b2558ad529618$var$code[$801b2558ad529618$var$i];
    $801b2558ad529618$var$revLookup[$801b2558ad529618$var$code.charCodeAt($801b2558ad529618$var$i)] = $801b2558ad529618$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$801b2558ad529618$var$revLookup["-".charCodeAt(0)] = 62;
$801b2558ad529618$var$revLookup["_".charCodeAt(0)] = 63;
function $801b2558ad529618$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $801b2558ad529618$var$byteLength(b64) {
    var lens = $801b2558ad529618$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $801b2558ad529618$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $801b2558ad529618$var$toByteArray(b64) {
    var tmp;
    var lens = $801b2558ad529618$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $801b2558ad529618$var$Arr($801b2558ad529618$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $801b2558ad529618$var$revLookup[b64.charCodeAt(i)] << 18 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $801b2558ad529618$var$revLookup[b64.charCodeAt(i)] << 2 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $801b2558ad529618$var$revLookup[b64.charCodeAt(i)] << 10 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $801b2558ad529618$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $801b2558ad529618$var$tripletToBase64(num) {
    return $801b2558ad529618$var$lookup[num >> 18 & 0x3F] + $801b2558ad529618$var$lookup[num >> 12 & 0x3F] + $801b2558ad529618$var$lookup[num >> 6 & 0x3F] + $801b2558ad529618$var$lookup[num & 0x3F];
}
function $801b2558ad529618$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($801b2558ad529618$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $801b2558ad529618$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($801b2558ad529618$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($801b2558ad529618$var$lookup[tmp >> 2] + $801b2558ad529618$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($801b2558ad529618$var$lookup[tmp >> 10] + $801b2558ad529618$var$lookup[tmp >> 4 & 0x3F] + $801b2558ad529618$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9c01e988fc381a2e$export$aafa59e2e03f2942;
var $9c01e988fc381a2e$export$68d8715fc104d294;
$9c01e988fc381a2e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9c01e988fc381a2e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $ad299d2484506af2$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$ad299d2484506af2$export$a143d493d941bafc = $ad299d2484506af2$var$Buffer;
$ad299d2484506af2$export$e4cf37d7f6fb9e0a = $ad299d2484506af2$var$SlowBuffer;
$ad299d2484506af2$export$f99ded8fe4b79145 = 50;
const $ad299d2484506af2$var$K_MAX_LENGTH = 0x7fffffff;
$ad299d2484506af2$export$599f31c3813fae4d = $ad299d2484506af2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ad299d2484506af2$var$Buffer.TYPED_ARRAY_SUPPORT = $ad299d2484506af2$var$typedArraySupport();
if (!$ad299d2484506af2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ad299d2484506af2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ad299d2484506af2$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$ad299d2484506af2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ad299d2484506af2$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$ad299d2484506af2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ad299d2484506af2$var$createBuffer(length) {
    if (length > $ad299d2484506af2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ad299d2484506af2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ad299d2484506af2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ad299d2484506af2$var$allocUnsafe(arg);
    }
    return $ad299d2484506af2$var$from(arg, encodingOrOffset, length);
}
$ad299d2484506af2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ad299d2484506af2$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $ad299d2484506af2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ad299d2484506af2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ad299d2484506af2$var$isInstance(value, ArrayBuffer) || value && $ad299d2484506af2$var$isInstance(value.buffer, ArrayBuffer)) return $ad299d2484506af2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($ad299d2484506af2$var$isInstance(value, SharedArrayBuffer) || value && $ad299d2484506af2$var$isInstance(value.buffer, SharedArrayBuffer))) return $ad299d2484506af2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ad299d2484506af2$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ad299d2484506af2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $ad299d2484506af2$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ad299d2484506af2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ad299d2484506af2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ad299d2484506af2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ad299d2484506af2$var$Buffer, Uint8Array);
function $ad299d2484506af2$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ad299d2484506af2$var$alloc(size, fill, encoding) {
    $ad299d2484506af2$var$assertSize(size);
    if (size <= 0) return $ad299d2484506af2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $ad299d2484506af2$var$createBuffer(size).fill(fill, encoding) : $ad299d2484506af2$var$createBuffer(size).fill(fill);
    return $ad299d2484506af2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ad299d2484506af2$var$Buffer.alloc = function(size, fill, encoding) {
    return $ad299d2484506af2$var$alloc(size, fill, encoding);
};
function $ad299d2484506af2$var$allocUnsafe(size) {
    $ad299d2484506af2$var$assertSize(size);
    return $ad299d2484506af2$var$createBuffer(size < 0 ? 0 : $ad299d2484506af2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ad299d2484506af2$var$Buffer.allocUnsafe = function(size) {
    return $ad299d2484506af2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ad299d2484506af2$var$Buffer.allocUnsafeSlow = function(size) {
    return $ad299d2484506af2$var$allocUnsafe(size);
};
function $ad299d2484506af2$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$ad299d2484506af2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $ad299d2484506af2$var$byteLength(string, encoding) | 0;
    let buf = $ad299d2484506af2$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ad299d2484506af2$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ad299d2484506af2$var$checked(array.length) | 0;
    const buf = $ad299d2484506af2$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ad299d2484506af2$var$fromArrayView(arrayView) {
    if ($ad299d2484506af2$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ad299d2484506af2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ad299d2484506af2$var$fromArrayLike(arrayView);
}
function $ad299d2484506af2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ad299d2484506af2$var$Buffer.prototype);
    return buf;
}
function $ad299d2484506af2$var$fromObject(obj) {
    if ($ad299d2484506af2$var$Buffer.isBuffer(obj)) {
        const len = $ad299d2484506af2$var$checked(obj.length) | 0;
        const buf = $ad299d2484506af2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $ad299d2484506af2$var$numberIsNaN(obj.length)) return $ad299d2484506af2$var$createBuffer(0);
        return $ad299d2484506af2$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $ad299d2484506af2$var$fromArrayLike(obj.data);
}
function $ad299d2484506af2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ad299d2484506af2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ad299d2484506af2$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $ad299d2484506af2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ad299d2484506af2$var$Buffer.alloc(+length);
}
$ad299d2484506af2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ad299d2484506af2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ad299d2484506af2$var$Buffer.compare = function compare(a, b) {
    if ($ad299d2484506af2$var$isInstance(a, Uint8Array)) a = $ad299d2484506af2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ad299d2484506af2$var$isInstance(b, Uint8Array)) b = $ad299d2484506af2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ad299d2484506af2$var$Buffer.isBuffer(a) || !$ad299d2484506af2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ad299d2484506af2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$ad299d2484506af2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ad299d2484506af2$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ad299d2484506af2$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ad299d2484506af2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ad299d2484506af2$var$Buffer.isBuffer(buf)) buf = $ad299d2484506af2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ad299d2484506af2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ad299d2484506af2$var$byteLength(string, encoding) {
    if ($ad299d2484506af2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ad299d2484506af2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $ad299d2484506af2$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $ad299d2484506af2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ad299d2484506af2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ad299d2484506af2$var$Buffer.byteLength = $ad299d2484506af2$var$byteLength;
function $ad299d2484506af2$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $ad299d2484506af2$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $ad299d2484506af2$var$utf8Slice(this, start, end);
        case "ascii":
            return $ad299d2484506af2$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $ad299d2484506af2$var$latin1Slice(this, start, end);
        case "base64":
            return $ad299d2484506af2$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ad299d2484506af2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ad299d2484506af2$var$Buffer.prototype._isBuffer = true;
function $ad299d2484506af2$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ad299d2484506af2$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$ad299d2484506af2$var$swap(this, i, i + 1);
    return this;
};
$ad299d2484506af2$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $ad299d2484506af2$var$swap(this, i, i + 3);
        $ad299d2484506af2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ad299d2484506af2$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $ad299d2484506af2$var$swap(this, i, i + 7);
        $ad299d2484506af2$var$swap(this, i + 1, i + 6);
        $ad299d2484506af2$var$swap(this, i + 2, i + 5);
        $ad299d2484506af2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ad299d2484506af2$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $ad299d2484506af2$var$utf8Slice(this, 0, length);
    return $ad299d2484506af2$var$slowToString.apply(this, arguments);
};
$ad299d2484506af2$var$Buffer.prototype.toLocaleString = $ad299d2484506af2$var$Buffer.prototype.toString;
$ad299d2484506af2$var$Buffer.prototype.equals = function equals(b) {
    if (!$ad299d2484506af2$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $ad299d2484506af2$var$Buffer.compare(this, b) === 0;
};
$ad299d2484506af2$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $ad299d2484506af2$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($ad299d2484506af2$var$customInspectSymbol) $ad299d2484506af2$var$Buffer.prototype[$ad299d2484506af2$var$customInspectSymbol] = $ad299d2484506af2$var$Buffer.prototype.inspect;
$ad299d2484506af2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ad299d2484506af2$var$isInstance(target, Uint8Array)) target = $ad299d2484506af2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ad299d2484506af2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ad299d2484506af2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ad299d2484506af2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $ad299d2484506af2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ad299d2484506af2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ad299d2484506af2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ad299d2484506af2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $ad299d2484506af2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ad299d2484506af2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ad299d2484506af2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ad299d2484506af2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ad299d2484506af2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ad299d2484506af2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ad299d2484506af2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ad299d2484506af2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ad299d2484506af2$var$utf8Write(buf, string, offset, length) {
    return $ad299d2484506af2$var$blitBuffer($ad299d2484506af2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ad299d2484506af2$var$asciiWrite(buf, string, offset, length) {
    return $ad299d2484506af2$var$blitBuffer($ad299d2484506af2$var$asciiToBytes(string), buf, offset, length);
}
function $ad299d2484506af2$var$base64Write(buf, string, offset, length) {
    return $ad299d2484506af2$var$blitBuffer($ad299d2484506af2$var$base64ToBytes(string), buf, offset, length);
}
function $ad299d2484506af2$var$ucs2Write(buf, string, offset, length) {
    return $ad299d2484506af2$var$blitBuffer($ad299d2484506af2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ad299d2484506af2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $ad299d2484506af2$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $ad299d2484506af2$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $ad299d2484506af2$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $ad299d2484506af2$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ad299d2484506af2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ad299d2484506af2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ad299d2484506af2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $801b2558ad529618$export$6100ba28696e12de(buf);
    else return $801b2558ad529618$export$6100ba28696e12de(buf.slice(start, end));
}
function $ad299d2484506af2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ad299d2484506af2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ad299d2484506af2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ad299d2484506af2$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ad299d2484506af2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ad299d2484506af2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ad299d2484506af2$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ad299d2484506af2$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ad299d2484506af2$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $ad299d2484506af2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ad299d2484506af2$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ad299d2484506af2$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ad299d2484506af2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ad299d2484506af2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$ad299d2484506af2$var$Buffer.prototype.readUintLE = $ad299d2484506af2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ad299d2484506af2$var$Buffer.prototype.readUintBE = $ad299d2484506af2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ad299d2484506af2$var$Buffer.prototype.readUint8 = $ad299d2484506af2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ad299d2484506af2$var$Buffer.prototype.readUint16LE = $ad299d2484506af2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ad299d2484506af2$var$Buffer.prototype.readUint16BE = $ad299d2484506af2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ad299d2484506af2$var$Buffer.prototype.readUint32LE = $ad299d2484506af2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ad299d2484506af2$var$Buffer.prototype.readUint32BE = $ad299d2484506af2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ad299d2484506af2$var$Buffer.prototype.readBigUInt64LE = $ad299d2484506af2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ad299d2484506af2$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ad299d2484506af2$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ad299d2484506af2$var$Buffer.prototype.readBigUInt64BE = $ad299d2484506af2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ad299d2484506af2$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ad299d2484506af2$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ad299d2484506af2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ad299d2484506af2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ad299d2484506af2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ad299d2484506af2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ad299d2484506af2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ad299d2484506af2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ad299d2484506af2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ad299d2484506af2$var$Buffer.prototype.readBigInt64LE = $ad299d2484506af2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ad299d2484506af2$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ad299d2484506af2$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ad299d2484506af2$var$Buffer.prototype.readBigInt64BE = $ad299d2484506af2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ad299d2484506af2$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ad299d2484506af2$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ad299d2484506af2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return $9c01e988fc381a2e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$ad299d2484506af2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 4, this.length);
    return $9c01e988fc381a2e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$ad299d2484506af2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 8, this.length);
    return $9c01e988fc381a2e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$ad299d2484506af2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkOffset(offset, 8, this.length);
    return $9c01e988fc381a2e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $ad299d2484506af2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ad299d2484506af2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$ad299d2484506af2$var$Buffer.prototype.writeUintLE = $ad299d2484506af2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ad299d2484506af2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ad299d2484506af2$var$Buffer.prototype.writeUintBE = $ad299d2484506af2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ad299d2484506af2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ad299d2484506af2$var$Buffer.prototype.writeUint8 = $ad299d2484506af2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ad299d2484506af2$var$Buffer.prototype.writeUint16LE = $ad299d2484506af2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ad299d2484506af2$var$Buffer.prototype.writeUint16BE = $ad299d2484506af2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ad299d2484506af2$var$Buffer.prototype.writeUint32LE = $ad299d2484506af2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ad299d2484506af2$var$Buffer.prototype.writeUint32BE = $ad299d2484506af2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ad299d2484506af2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ad299d2484506af2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ad299d2484506af2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ad299d2484506af2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ad299d2484506af2$var$Buffer.prototype.writeBigUInt64LE = $ad299d2484506af2$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ad299d2484506af2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$ad299d2484506af2$var$Buffer.prototype.writeBigUInt64BE = $ad299d2484506af2$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ad299d2484506af2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$ad299d2484506af2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ad299d2484506af2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ad299d2484506af2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ad299d2484506af2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ad299d2484506af2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ad299d2484506af2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ad299d2484506af2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ad299d2484506af2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ad299d2484506af2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ad299d2484506af2$var$Buffer.prototype.writeBigInt64LE = $ad299d2484506af2$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ad299d2484506af2$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$ad299d2484506af2$var$Buffer.prototype.writeBigInt64BE = $ad299d2484506af2$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ad299d2484506af2$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $ad299d2484506af2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $ad299d2484506af2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9c01e988fc381a2e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ad299d2484506af2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ad299d2484506af2$var$writeFloat(this, value, offset, true, noAssert);
};
$ad299d2484506af2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ad299d2484506af2$var$writeFloat(this, value, offset, false, noAssert);
};
function $ad299d2484506af2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ad299d2484506af2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9c01e988fc381a2e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ad299d2484506af2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ad299d2484506af2$var$writeDouble(this, value, offset, true, noAssert);
};
$ad299d2484506af2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ad299d2484506af2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ad299d2484506af2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ad299d2484506af2$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ad299d2484506af2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$ad299d2484506af2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ad299d2484506af2$var$Buffer.isBuffer(val) ? val : $ad299d2484506af2$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ad299d2484506af2$var$errors = {};
function $ad299d2484506af2$var$E(sym, getMessage, Base) {
    $ad299d2484506af2$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$ad299d2484506af2$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$ad299d2484506af2$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ad299d2484506af2$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ad299d2484506af2$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ad299d2484506af2$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ad299d2484506af2$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ad299d2484506af2$var$checkBounds(buf, offset, byteLength) {
    $ad299d2484506af2$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ad299d2484506af2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ad299d2484506af2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ad299d2484506af2$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $ad299d2484506af2$var$checkBounds(buf, offset, byteLength);
}
function $ad299d2484506af2$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $ad299d2484506af2$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $ad299d2484506af2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ad299d2484506af2$var$validateNumber(value, type);
        throw new $ad299d2484506af2$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $ad299d2484506af2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ad299d2484506af2$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ad299d2484506af2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ad299d2484506af2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ad299d2484506af2$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $ad299d2484506af2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $ad299d2484506af2$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ad299d2484506af2$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ad299d2484506af2$var$base64ToBytes(str) {
    return $801b2558ad529618$export$d622b2ad8d90c771($ad299d2484506af2$var$base64clean(str));
}
function $ad299d2484506af2$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ad299d2484506af2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ad299d2484506af2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ad299d2484506af2$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ad299d2484506af2$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $ad299d2484506af2$var$BufferBigIntNotDefined : fn;
}
function $ad299d2484506af2$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $0b91950191e72a08$require$Buffer = $ad299d2484506af2$export$a143d493d941bafc;
const $0b91950191e72a08$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $0b91950191e72a08$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $0b91950191e72a08$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $0b91950191e72a08$var$toBase64Browser = (bytes)=>{
    let s = "";
    for(let i = 0; i < bytes.byteLength; i++)s += $8322690016f3fe63$export$30216c0101da0ee0(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $0b91950191e72a08$var$toBase64Node = (bytes)=>$0b91950191e72a08$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString("base64");
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ const $0b91950191e72a08$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $0b91950191e72a08$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ const $0b91950191e72a08$var$fromBase64Node = (s)=>{
    const buf = $0b91950191e72a08$require$Buffer.from(s, "base64");
    return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
};
const $0b91950191e72a08$export$37cc283d8fbd3462 = $ceb445566faa62b1$export$4e09c449d6c407f7 ? $0b91950191e72a08$var$toBase64Browser : $0b91950191e72a08$var$toBase64Node;
const $0b91950191e72a08$export$c537b38001c583b7 = $ceb445566faa62b1$export$4e09c449d6c407f7 ? $0b91950191e72a08$var$fromBase64Browser : $0b91950191e72a08$var$fromBase64Node;
const $0b91950191e72a08$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $0b91950191e72a08$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $0b91950191e72a08$export$355ad3726be07997 = (data)=>{
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    $7f295e825046a0c3$export$264b1e8551468ea(encoder, data);
    return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
};
const $0b91950191e72a08$export$929c279cfec29a23 = (buf)=>$902b843224f0f9d8$export$82863139061f472f($902b843224f0f9d8$export$f8c898e83b60faaa(buf));







class $7f295e825046a0c3$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $7f295e825046a0c3$export$4e76eeb6df88c889 = ()=>new $7f295e825046a0c3$export$a50aceb0e02a00aa();
const $7f295e825046a0c3$export$c564cdbbe6da493 = (f)=>{
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    f(encoder);
    return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
};
const $7f295e825046a0c3$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $7f295e825046a0c3$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $7f295e825046a0c3$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($7f295e825046a0c3$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set($0b91950191e72a08$export$f3c8b5f6d250ec43(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $7f295e825046a0c3$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push($0b91950191e72a08$export$f3c8b5f6d250ec43(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($e8fac97060e7c35b$export$8960430cfd85939f(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $7f295e825046a0c3$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $7f295e825046a0c3$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $7f295e825046a0c3$export$826a1a6619653272 = $7f295e825046a0c3$export$68d8715fc104d294;
const $7f295e825046a0c3$export$83964ea8501fbf8 = $7f295e825046a0c3$export$adaa4cf7ef1b65be;
const $7f295e825046a0c3$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $7f295e825046a0c3$export$68d8715fc104d294(encoder, num & $8d6ba0cc01579050$export$c880072ee0e87648);
    $7f295e825046a0c3$export$68d8715fc104d294(encoder, num >>> 8 & $8d6ba0cc01579050$export$c880072ee0e87648);
};
const $7f295e825046a0c3$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $7f295e825046a0c3$export$adaa4cf7ef1b65be(encoder, pos, num & $8d6ba0cc01579050$export$c880072ee0e87648);
    $7f295e825046a0c3$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $8d6ba0cc01579050$export$c880072ee0e87648);
};
const $7f295e825046a0c3$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $7f295e825046a0c3$export$68d8715fc104d294(encoder, num & $8d6ba0cc01579050$export$c880072ee0e87648);
        num >>>= 8;
    }
};
const $7f295e825046a0c3$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$7f295e825046a0c3$export$68d8715fc104d294(encoder, num >>> 8 * i & $8d6ba0cc01579050$export$c880072ee0e87648);
};
const $7f295e825046a0c3$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $7f295e825046a0c3$export$adaa4cf7ef1b65be(encoder, pos + i, num & $8d6ba0cc01579050$export$c880072ee0e87648);
        num >>>= 8;
    }
};
const $7f295e825046a0c3$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $8d6ba0cc01579050$export$f84d6bebff154ceb){
        $7f295e825046a0c3$export$68d8715fc104d294(encoder, $8d6ba0cc01579050$export$e25597372303a045 | $8d6ba0cc01579050$export$f84d6bebff154ceb & num);
        num = $e8fac97060e7c35b$export$a3fe094919f356fd(num / 128) // shift >>> 7
        ;
    }
    $7f295e825046a0c3$export$68d8715fc104d294(encoder, $8d6ba0cc01579050$export$f84d6bebff154ceb & num);
};
const $7f295e825046a0c3$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $e8fac97060e7c35b$export$dc0a61f4a9121f92(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $7f295e825046a0c3$export$68d8715fc104d294(encoder, (num > $8d6ba0cc01579050$export$f39f4e074e983a34 ? $8d6ba0cc01579050$export$e25597372303a045 : 0) | (isNegative ? $8d6ba0cc01579050$export$eb5a8e0006ab4bb5 : 0) | $8d6ba0cc01579050$export$f39f4e074e983a34 & num);
    num = $e8fac97060e7c35b$export$a3fe094919f356fd(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $7f295e825046a0c3$export$68d8715fc104d294(encoder, (num > $8d6ba0cc01579050$export$f84d6bebff154ceb ? $8d6ba0cc01579050$export$e25597372303a045 : 0) | $8d6ba0cc01579050$export$f84d6bebff154ceb & num);
        num = $e8fac97060e7c35b$export$a3fe094919f356fd(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $7f295e825046a0c3$var$_strBuffer = new Uint8Array(30000);
const $7f295e825046a0c3$var$_maxStrBSize = $7f295e825046a0c3$var$_strBuffer.length / 3;
const $7f295e825046a0c3$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $7f295e825046a0c3$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $8322690016f3fe63$export$f3ce4806f2484eb.encodeInto(str, $7f295e825046a0c3$var$_strBuffer).written || 0;
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$7f295e825046a0c3$export$68d8715fc104d294(encoder, $7f295e825046a0c3$var$_strBuffer[i]);
    } else $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $8322690016f3fe63$export$8f647c2204da8484(str));
};
const $7f295e825046a0c3$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$7f295e825046a0c3$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $7f295e825046a0c3$export$dde49cb52d5f1650 = $8322690016f3fe63$export$f3ce4806f2484eb && /** @type {any} */ $8322690016f3fe63$export$f3ce4806f2484eb.encodeInto ? $7f295e825046a0c3$export$dff327976627e12b : $7f295e825046a0c3$export$94cf4193edfe959a;
const $7f295e825046a0c3$export$be5604ffb9fbbd0c = (encoder, str)=>$7f295e825046a0c3$export$6c17d6eec4abdaa6(encoder, $8322690016f3fe63$export$8f647c2204da8484(str));
const $7f295e825046a0c3$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $7f295e825046a0c3$export$68d8715fc104d294(encoder, 1);
        $7f295e825046a0c3$export$68d8715fc104d294(encoder, buf[i]);
    }
    $7f295e825046a0c3$export$68d8715fc104d294(encoder, 0);
};
const $7f295e825046a0c3$export$c029b62321ea3da = (encoder, append)=>$7f295e825046a0c3$export$73b5e63e27d2b4c7(encoder, $7f295e825046a0c3$export$73470fd2221e6aef(append));
const $7f295e825046a0c3$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $e8fac97060e7c35b$export$96ec731ed4dcb222(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($e8fac97060e7c35b$export$8960430cfd85939f(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $7f295e825046a0c3$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $7f295e825046a0c3$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $7f295e825046a0c3$export$1f031ae9c71bd530 = (encoder, len)=>{
    $7f295e825046a0c3$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $7f295e825046a0c3$export$a33455db0a9638a6 = (encoder, num)=>$7f295e825046a0c3$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $7f295e825046a0c3$export$231a04cea676c54c = (encoder, num)=>$7f295e825046a0c3$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $7f295e825046a0c3$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $7f295e825046a0c3$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $7f295e825046a0c3$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $7f295e825046a0c3$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $7f295e825046a0c3$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $7f295e825046a0c3$var$isFloat32 = (num)=>{
    $7f295e825046a0c3$var$floatTestBed.setFloat32(0, num);
    return $7f295e825046a0c3$var$floatTestBed.getFloat32(0) === num;
};
const $7f295e825046a0c3$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case "string":
            // TYPE 119: STRING
            $7f295e825046a0c3$export$68d8715fc104d294(encoder, 119);
            $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, data);
            break;
        case "number":
            if ($5984a053755878ee$export$a287f47fed4544b8(data) && $e8fac97060e7c35b$export$2335f513bbd82c6d(data) <= $8d6ba0cc01579050$export$87ec42487f19c66c) {
                // TYPE 125: INTEGER
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 125);
                $7f295e825046a0c3$export$ff90f819e16cc9bb(encoder, data);
            } else if ($7f295e825046a0c3$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 124);
                $7f295e825046a0c3$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 123);
                $7f295e825046a0c3$export$231a04cea676c54c(encoder, data);
            }
            break;
        case "bigint":
            // TYPE 122: BigInt
            $7f295e825046a0c3$export$68d8715fc104d294(encoder, 122);
            $7f295e825046a0c3$export$4fbfa93dd6e14543(encoder, data);
            break;
        case "object":
            if (data === null) // TYPE 126: null
            $7f295e825046a0c3$export$68d8715fc104d294(encoder, 126);
            else if ($5e5c19b0ad9b04d4$export$43bee75e5e14138e(data)) {
                // TYPE 117: Array
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 117);
                $7f295e825046a0c3$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$7f295e825046a0c3$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 116);
                $7f295e825046a0c3$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $7f295e825046a0c3$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $7f295e825046a0c3$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, key);
                    $7f295e825046a0c3$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case "boolean":
            // TYPE 120/121: boolean (true/false)
            $7f295e825046a0c3$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $7f295e825046a0c3$export$68d8715fc104d294(encoder, 127);
    }
};
class $7f295e825046a0c3$export$8fa72bb4fa9409ff extends $7f295e825046a0c3$export$a50aceb0e02a00aa {
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $7f295e825046a0c3$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
}
class $7f295e825046a0c3$export$c636f3fa46f2752c extends $7f295e825046a0c3$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @param {number} v
   */ write(v) {
        $7f295e825046a0c3$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
}
class $7f295e825046a0c3$export$29917ece4cb403fb extends $7f295e825046a0c3$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $7f295e825046a0c3$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $7f295e825046a0c3$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $7f295e825046a0c3$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $7f295e825046a0c3$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $7f295e825046a0c3$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $7f295e825046a0c3$export$785ebd3312c38061 {
    constructor(){
        this.encoder = new $7f295e825046a0c3$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $7f295e825046a0c3$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    toUint8Array() {
        $7f295e825046a0c3$var$flushUintOptRleEncoder(this);
        return $7f295e825046a0c3$export$73470fd2221e6aef(this.encoder);
    }
}
class $7f295e825046a0c3$export$f460a01fb0702193 {
    constructor(){
        this.encoder = new $7f295e825046a0c3$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $7f295e825046a0c3$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    toUint8Array() {
        $7f295e825046a0c3$var$flushUintOptRleEncoder(this);
        return $7f295e825046a0c3$export$73470fd2221e6aef(this.encoder);
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $7f295e825046a0c3$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $7f295e825046a0c3$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $7f295e825046a0c3$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $7f295e825046a0c3$export$7542c66a59375c6f {
    constructor(){
        this.encoder = new $7f295e825046a0c3$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $7f295e825046a0c3$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    toUint8Array() {
        $7f295e825046a0c3$var$flushIntDiffOptRleEncoder(this);
        return $7f295e825046a0c3$export$73470fd2221e6aef(this.encoder);
    }
}
class $7f295e825046a0c3$export$7dcdc5c32f31c550 {
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = "";
        this.lensE = new $7f295e825046a0c3$export$785ebd3312c38061();
    }
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = "";
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $7f295e825046a0c3$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = "";
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, this.sarr.join(""));
        $7f295e825046a0c3$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
    }
}




/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 

/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $dc626e39159197db$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $dc626e39159197db$export$185802fd694ee1f5 = (left, right)=>new $dc626e39159197db$export$d63d7cff08fe4dc9(left, right);
const $dc626e39159197db$export$ca0ea131672c5a9b = (right, left)=>new $dc626e39159197db$export$d63d7cff08fe4dc9(left, right);
const $dc626e39159197db$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $dc626e39159197db$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));


/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 

const $119aaf8dbc7ea0e0$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== "undefined" ? document : {};
const $119aaf8dbc7ea0e0$export$c8a8987d4410bf2d = (name)=>$119aaf8dbc7ea0e0$export$2a111da947c407d2.createElement(name);
const $119aaf8dbc7ea0e0$export$fb51152cd5328759 = ()=>$119aaf8dbc7ea0e0$export$2a111da947c407d2.createDocumentFragment();
const $119aaf8dbc7ea0e0$export$b2ce9ad90858ed7a = (text)=>$119aaf8dbc7ea0e0$export$2a111da947c407d2.createTextNode(text);
const $119aaf8dbc7ea0e0$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== "undefined" ? new DOMParser() : null;
const $119aaf8dbc7ea0e0$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $119aaf8dbc7ea0e0$export$74da2cba014bdc09 = (el, attrs)=>{
    $dc626e39159197db$export$4b80e395e36b5a56(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $119aaf8dbc7ea0e0$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $119aaf8dbc7ea0e0$export$f00aeb236b6f05af = (children)=>{
    const fragment = $119aaf8dbc7ea0e0$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$119aaf8dbc7ea0e0$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $119aaf8dbc7ea0e0$export$10d8903dec122b9d = (parent, nodes)=>{
    $119aaf8dbc7ea0e0$export$1b8e57c9ea42f1d2(parent, $119aaf8dbc7ea0e0$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $119aaf8dbc7ea0e0$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $119aaf8dbc7ea0e0$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $119aaf8dbc7ea0e0$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $119aaf8dbc7ea0e0$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $dc626e39159197db$export$4b80e395e36b5a56(listeners, (name, f)=>$119aaf8dbc7ea0e0$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $119aaf8dbc7ea0e0$export$8c7b13b21690651d = (node, listeners)=>{
    $dc626e39159197db$export$4b80e395e36b5a56(listeners, (name, f)=>$119aaf8dbc7ea0e0$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $119aaf8dbc7ea0e0$export$8454457683f90105 = (name, attrs = [], children = [])=>$119aaf8dbc7ea0e0$export$10d8903dec122b9d($119aaf8dbc7ea0e0$export$74da2cba014bdc09($119aaf8dbc7ea0e0$export$c8a8987d4410bf2d(name), attrs), children);
const $119aaf8dbc7ea0e0$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $119aaf8dbc7ea0e0$export$c8a8987d4410bf2d("canvas");
    c.height = height;
    c.width = width;
    return c;
};
const $119aaf8dbc7ea0e0$export$6f093cfa640b7166 = $119aaf8dbc7ea0e0$export$b2ce9ad90858ed7a;
const $119aaf8dbc7ea0e0$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $119aaf8dbc7ea0e0$export$3d24a00500154f45 = (pairs)=>pairs.map($119aaf8dbc7ea0e0$export$7f60f118cd3e6292).join("");
const $119aaf8dbc7ea0e0$export$7d9cafe158c3b49 = (m)=>$b5584d8615cd2038$export$871de8747c9eaa88(m, (value, key)=>`${key}:${value};`).join("");
const $119aaf8dbc7ea0e0$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $119aaf8dbc7ea0e0$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $119aaf8dbc7ea0e0$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $119aaf8dbc7ea0e0$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $119aaf8dbc7ea0e0$var$_parse = (html)=>$119aaf8dbc7ea0e0$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, "text/html").body;
const $119aaf8dbc7ea0e0$export$e1152f5efcc82ad = (html)=>$119aaf8dbc7ea0e0$export$f00aeb236b6f05af(/** @type {any} */ $119aaf8dbc7ea0e0$var$_parse(html).childNodes);
const $119aaf8dbc7ea0e0$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $119aaf8dbc7ea0e0$var$_parse(html).firstElementChild;
const $119aaf8dbc7ea0e0$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $119aaf8dbc7ea0e0$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $119aaf8dbc7ea0e0$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $119aaf8dbc7ea0e0$export$51c8a276ee4b8f51 = $119aaf8dbc7ea0e0$export$2a111da947c407d2.ELEMENT_NODE;
const $119aaf8dbc7ea0e0$export$5bcc40203615fc2e = $119aaf8dbc7ea0e0$export$2a111da947c407d2.TEXT_NODE;
const $119aaf8dbc7ea0e0$export$e5fc6332c1c8eb8e = $119aaf8dbc7ea0e0$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $119aaf8dbc7ea0e0$export$3d597a6ef0f08b0a = $119aaf8dbc7ea0e0$export$2a111da947c407d2.COMMENT_NODE;
const $119aaf8dbc7ea0e0$export$4139dcda4f7f83db = $119aaf8dbc7ea0e0$export$2a111da947c407d2.DOCUMENT_NODE;
const $119aaf8dbc7ea0e0$export$e9e7ddfdb004b848 = $119aaf8dbc7ea0e0$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $119aaf8dbc7ea0e0$export$b86725031ae151ee = $119aaf8dbc7ea0e0$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $119aaf8dbc7ea0e0$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $119aaf8dbc7ea0e0$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;


/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $6c095c65fe60003a$export$fac44ee5b035f737 = JSON.stringify;
const $6c095c65fe60003a$export$98e6a39c04603d36 = JSON.parse;



/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $e5616ee4a9023750$var$queue = [];
const $e5616ee4a9023750$var$_runQueue = ()=>{
    for(let i = 0; i < $e5616ee4a9023750$var$queue.length; i++)$e5616ee4a9023750$var$queue[i]();
    $e5616ee4a9023750$var$queue = [];
};
const $e5616ee4a9023750$export$513072ba72100d9c = (f)=>{
    $e5616ee4a9023750$var$queue.push(f);
    if ($e5616ee4a9023750$var$queue.length === 1) setTimeout($e5616ee4a9023750$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $e5616ee4a9023750$var$createTimeoutClass = (clearFunction)=>class TT {
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
        destroy() {
            clearFunction(this._);
        }
    };
const $e5616ee4a9023750$var$Timeout = $e5616ee4a9023750$var$createTimeoutClass(clearTimeout);
const $e5616ee4a9023750$export$83e74882c5df8fe1 = (timeout, callback)=>new $e5616ee4a9023750$var$Timeout(setTimeout(callback, timeout));
const $e5616ee4a9023750$var$Interval = $e5616ee4a9023750$var$createTimeoutClass(clearInterval);
const $e5616ee4a9023750$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $e5616ee4a9023750$var$Interval(setInterval(callback, timeout));
const $e5616ee4a9023750$export$c35d437ae5945fcd = $e5616ee4a9023750$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== "undefined" && cancelAnimationFrame(arg));
const $e5616ee4a9023750$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === "undefined" ? $e5616ee4a9023750$export$83e74882c5df8fe1(0, cb) : new $e5616ee4a9023750$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $e5616ee4a9023750$var$Idle = $e5616ee4a9023750$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== "undefined" && cancelIdleCallback(arg));
const $e5616ee4a9023750$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== "undefined" ? new $e5616ee4a9023750$var$Idle(requestIdleCallback(cb)) : $e5616ee4a9023750$export$83e74882c5df8fe1(1000, cb);
const $e5616ee4a9023750$export$21cd608c50c2ba31 = (timeout)=>{
    let timer = -1;
    return (f)=>{
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};



/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ const $51f84927e5c59abb$export$185802fd694ee1f5 = Symbol;
const $51f84927e5c59abb$export$a244864fd9645c7f = (s)=>typeof s === "symbol";





const $792d43f9d2752e68$export$c1286c4c2a7c066 = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$f0ce1666bb40789b = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$738c3b9a44c87ecc = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$7d278ca694634874 = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$48d4b2cd5bc0e88b = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$aa201224bb439d47 = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$7ffdeca4b2f927a2 = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$3de5e29ed1757f9b = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$b586f81201748dd0 = $51f84927e5c59abb$export$185802fd694ee1f5();
const $792d43f9d2752e68$export$3454091cc3c6c473 = (args)=>{
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) logArgs.push(JSON.stringify(arg));
    }
    return logArgs;
};
/* c8 ignore stop */ const $792d43f9d2752e68$var$loggingColors = [
    $792d43f9d2752e68$export$48d4b2cd5bc0e88b,
    $792d43f9d2752e68$export$7ffdeca4b2f927a2,
    $792d43f9d2752e68$export$3de5e29ed1757f9b,
    $792d43f9d2752e68$export$738c3b9a44c87ecc
];
let $792d43f9d2752e68$var$nextColor = 0;
let $792d43f9d2752e68$var$lastLoggingTime = $a69ef2806e7968d3$export$1f77c0008d16313();
const $792d43f9d2752e68$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $792d43f9d2752e68$var$loggingColors[$792d43f9d2752e68$var$nextColor];
    const debugRegexVar = $ceb445566faa62b1$export$39fb32ac18db3f88("log");
    const doLogging = debugRegexVar !== null && (debugRegexVar === "*" || debugRegexVar === "true" || new RegExp(debugRegexVar, "gi").test(moduleName));
    $792d43f9d2752e68$var$nextColor = ($792d43f9d2752e68$var$nextColor + 1) % $792d43f9d2752e68$var$loggingColors.length;
    moduleName += ": ";
    return !doLogging ? $335a02b91f00a29d$export$b5f1cfe7b08e6ed5 : (...args)=>{
        const timeNow = $a69ef2806e7968d3$export$1f77c0008d16313();
        const timeDiff = timeNow - $792d43f9d2752e68$var$lastLoggingTime;
        $792d43f9d2752e68$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $792d43f9d2752e68$export$b586f81201748dd0, ...args.map((arg)=>typeof arg === "string" || typeof arg === "symbol" ? arg : JSON.stringify(arg)), color, " +" + timeDiff + "ms");
    };
} /* c8 ignore stop */ ;


/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $73ec8bbf24ec5444$var$_browserStyleMap = {
    [$792d43f9d2752e68$export$c1286c4c2a7c066]: $dc626e39159197db$export$185802fd694ee1f5("font-weight", "bold"),
    [$792d43f9d2752e68$export$f0ce1666bb40789b]: $dc626e39159197db$export$185802fd694ee1f5("font-weight", "normal"),
    [$792d43f9d2752e68$export$738c3b9a44c87ecc]: $dc626e39159197db$export$185802fd694ee1f5("color", "blue"),
    [$792d43f9d2752e68$export$48d4b2cd5bc0e88b]: $dc626e39159197db$export$185802fd694ee1f5("color", "green"),
    [$792d43f9d2752e68$export$7d278ca694634874]: $dc626e39159197db$export$185802fd694ee1f5("color", "grey"),
    [$792d43f9d2752e68$export$aa201224bb439d47]: $dc626e39159197db$export$185802fd694ee1f5("color", "red"),
    [$792d43f9d2752e68$export$7ffdeca4b2f927a2]: $dc626e39159197db$export$185802fd694ee1f5("color", "purple"),
    [$792d43f9d2752e68$export$3de5e29ed1757f9b]: $dc626e39159197db$export$185802fd694ee1f5("color", "orange"),
    [$792d43f9d2752e68$export$b586f81201748dd0]: $dc626e39159197db$export$185802fd694ee1f5("color", "black")
};
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $73ec8bbf24ec5444$var$computeBrowserLoggingArgs = (args)=>{
    const strBuilder = [];
    const styles = [];
    const currentStyle = $b5584d8615cd2038$export$185802fd694ee1f5();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $73ec8bbf24ec5444$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $119aaf8dbc7ea0e0$export$7d9cafe158c3b49(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push("%c" + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(""));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $73ec8bbf24ec5444$var$computeLoggingArgs = $ceb445566faa62b1$export$fcbe44f5d6fcebd ? $73ec8bbf24ec5444$var$computeBrowserLoggingArgs : $792d43f9d2752e68$export$3454091cc3c6c473;
const $73ec8bbf24ec5444$export$c2d084dc44961371 = (...args)=>{
    console.log(...$73ec8bbf24ec5444$var$computeLoggingArgs(args));
    /* c8 ignore next */ $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $73ec8bbf24ec5444$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$73ec8bbf24ec5444$var$computeLoggingArgs(args));
    args.unshift($792d43f9d2752e68$export$3de5e29ed1757f9b);
    $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $73ec8bbf24ec5444$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $73ec8bbf24ec5444$export$85acd411250ab137 = (url, height)=>{
    if ($ceb445566faa62b1$export$4e09c449d6c407f7) console.log("%c                      ", `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $73ec8bbf24ec5444$export$fcd48d8a033dbfbf = (base64, height)=>$73ec8bbf24ec5444$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $73ec8bbf24ec5444$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$73ec8bbf24ec5444$var$computeLoggingArgs(args));
    /* c8 ignore next */ $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $73ec8bbf24ec5444$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$73ec8bbf24ec5444$var$computeLoggingArgs(args));
    /* c8 ignore next */ $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $73ec8bbf24ec5444$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $73ec8bbf24ec5444$export$76dff282388623b3 = (createNode)=>$73ec8bbf24ec5444$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $73ec8bbf24ec5444$export$98f2e847362d891 = (canvas, height)=>$73ec8bbf24ec5444$export$85acd411250ab137(canvas.toDataURL(), height);
const $73ec8bbf24ec5444$export$6f0283bff34730a1 = $9ea3ff85accf439d$export$185802fd694ee1f5();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $73ec8bbf24ec5444$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $73ec8bbf24ec5444$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $119aaf8dbc7ea0e0$export$8454457683f90105("span", [
                    $dc626e39159197db$export$185802fd694ee1f5("style", $119aaf8dbc7ea0e0$export$7d9cafe158c3b49(currentStyle))
                ], [
                    $119aaf8dbc7ea0e0$export$6f093cfa640b7166(arg.toString())
                ]);
                if (span.innerHTML === "") span.innerHTML = "&nbsp;";
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = " " + $6c095c65fe60003a$export$fac44ee5b035f737(content) + " ";
            spans.push($119aaf8dbc7ea0e0$export$8454457683f90105("span", [], [
                $119aaf8dbc7ea0e0$export$6f093cfa640b7166(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $73ec8bbf24ec5444$var$lineStyle = "font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;";
class $73ec8bbf24ec5444$export$79dd518d42f6d7a1 {
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $73ec8bbf24ec5444$export$6f0283bff34730a1.add(this);
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            const triangleDown = $119aaf8dbc7ea0e0$export$8454457683f90105("span", [
                $dc626e39159197db$export$185802fd694ee1f5("hidden", collapsed),
                $dc626e39159197db$export$185802fd694ee1f5("style", "color:grey;font-size:120%;")
            ], [
                $119aaf8dbc7ea0e0$export$6f093cfa640b7166("▼")
            ]);
            const triangleRight = $119aaf8dbc7ea0e0$export$8454457683f90105("span", [
                $dc626e39159197db$export$185802fd694ee1f5("hidden", !collapsed),
                $dc626e39159197db$export$185802fd694ee1f5("style", "color:grey;font-size:125%;")
            ], [
                $119aaf8dbc7ea0e0$export$6f093cfa640b7166("▶")
            ]);
            const content = $119aaf8dbc7ea0e0$export$8454457683f90105("div", [
                $dc626e39159197db$export$185802fd694ee1f5("style", `${$73ec8bbf24ec5444$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $119aaf8dbc7ea0e0$export$6f093cfa640b7166(" ")
            ].concat($73ec8bbf24ec5444$var$_computeLineSpans(args)));
            const nextContainer = $119aaf8dbc7ea0e0$export$8454457683f90105("div", [
                $dc626e39159197db$export$185802fd694ee1f5("hidden", collapsed)
            ]);
            const nextLine = $119aaf8dbc7ea0e0$export$8454457683f90105("div", [], [
                content,
                nextContainer
            ]);
            $119aaf8dbc7ea0e0$export$10d8903dec122b9d(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $119aaf8dbc7ea0e0$export$3f65cefe8380dbea(content, "click", (_event)=>{
                nextContainer.toggleAttribute("hidden");
                triangleDown.toggleAttribute("hidden");
                triangleRight.toggleAttribute("hidden");
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            $119aaf8dbc7ea0e0$export$10d8903dec122b9d(this.ccontainer, [
                $119aaf8dbc7ea0e0$export$8454457683f90105("div", [
                    $dc626e39159197db$export$185802fd694ee1f5("style", `${$73ec8bbf24ec5444$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $73ec8bbf24ec5444$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $792d43f9d2752e68$export$aa201224bb439d47,
            $792d43f9d2752e68$export$c1286c4c2a7c066,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            $119aaf8dbc7ea0e0$export$10d8903dec122b9d(this.ccontainer, [
                $119aaf8dbc7ea0e0$export$8454457683f90105("img", [
                    $dc626e39159197db$export$185802fd694ee1f5("src", url),
                    $dc626e39159197db$export$185802fd694ee1f5("height", `${$e8fac97060e7c35b$export$2077e0241d6afd3c(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            $119aaf8dbc7ea0e0$export$10d8903dec122b9d(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $e5616ee4a9023750$export$513072ba72100d9c(()=>{
            $73ec8bbf24ec5444$export$6f0283bff34730a1.delete(this);
        });
    }
}
const $73ec8bbf24ec5444$export$3b589da4ab12cf23 = (dom)=>new $73ec8bbf24ec5444$export$79dd518d42f6d7a1(dom);
const $73ec8bbf24ec5444$export$c2977e725d59a2fd = (moduleName)=>$792d43f9d2752e68$export$c2977e725d59a2fd($73ec8bbf24ec5444$export$c2d084dc44961371, moduleName);


/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
const $5719c92748a1df45$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $5719c92748a1df45$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $5719c92748a1df45$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $5719c92748a1df45$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $5719c92748a1df45$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $5719c92748a1df45$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $5719c92748a1df45$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$5719c92748a1df45$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $a69ef2806e7968d3$export$1f77c0008d16313();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($a69ef2806e7968d3$export$1f77c0008d16313() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error("Timeout"));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $5719c92748a1df45$export$5c069c93d2b7493f = (timeout)=>$5719c92748a1df45$export$185802fd694ee1f5((resolve, reject)=>setTimeout(resolve, timeout));
const $5719c92748a1df45$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;


/* eslint-env browser */ /**
 * Helpers for cross-tab communication using broadcastchannel with LocalStorage fallback.
 *
 * ```js
 * // In browser window A:
 * broadcastchannel.subscribe('my events', data => console.log(data))
 * broadcastchannel.publish('my events', 'Hello world!') // => A: 'Hello world!' fires synchronously in same tab
 *
 * // In browser window B:
 * broadcastchannel.publish('my events', 'hello from tab B') // => A: 'hello from tab B'
 * ```
 *
 * @module broadcastchannel
 */ // @todo before next major: use Uint8Array instead as buffer object




/**
 * @typedef {Object} Channel
 * @property {Set<function(any, any):any>} Channel.subs
 * @property {any} Channel.bc
 */ /**
 * @type {Map<string, Channel>}
 */ const $264c0479ab4113a8$var$channels = new Map();
/* c8 ignore start */ class $264c0479ab4113a8$var$LocalStoragePolyfill {
    /**
   * @param {string} room
   */ constructor(room){
        this.room = room;
        /**
     * @type {null|function({data:ArrayBuffer}):void}
     */ this.onmessage = null;
        /**
     * @param {any} e
     */ this._onChange = (e)=>e.key === room && this.onmessage !== null && this.onmessage({
                data: $0b91950191e72a08$export$c537b38001c583b7(e.newValue || "")
            });
        $c97ef499247dea2a$export$bd913411069e59d3(this._onChange);
    }
    /**
   * @param {ArrayBuffer} buf
   */ postMessage(buf) {
        $c97ef499247dea2a$export$86b84a8d42aa2c65.setItem(this.room, $0b91950191e72a08$export$37cc283d8fbd3462($0b91950191e72a08$export$1b999ddd54e5bed1(buf)));
    }
    close() {
        $c97ef499247dea2a$export$ff6a13ad336aa064(this._onChange);
    }
}
/* c8 ignore stop */ // Use BroadcastChannel or Polyfill
/* c8 ignore next */ const $264c0479ab4113a8$var$BC = typeof BroadcastChannel === "undefined" ? $264c0479ab4113a8$var$LocalStoragePolyfill : BroadcastChannel;
/**
 * @param {string} room
 * @return {Channel}
 */ const $264c0479ab4113a8$var$getChannel = (room)=>$b5584d8615cd2038$export$dccd489362a8619($264c0479ab4113a8$var$channels, room, ()=>{
        const subs = $9ea3ff85accf439d$export$185802fd694ee1f5();
        const bc = new $264c0479ab4113a8$var$BC(room);
        /**
     * @param {{data:ArrayBuffer}} e
     */ /* c8 ignore next */ bc.onmessage = (e)=>subs.forEach((sub)=>sub(e.data, "broadcastchannel"));
        return {
            bc: bc,
            subs: subs
        };
    });
const $264c0479ab4113a8$export$ec068583843480e7 = (room, f)=>{
    $264c0479ab4113a8$var$getChannel(room).subs.add(f);
    return f;
};
const $264c0479ab4113a8$export$f500693cef883ffd = (room, f)=>{
    const channel = $264c0479ab4113a8$var$getChannel(room);
    const unsubscribed = channel.subs.delete(f);
    if (unsubscribed && channel.subs.size === 0) {
        channel.bc.close();
        $264c0479ab4113a8$var$channels.delete(room);
    }
    return unsubscribed;
};
const $264c0479ab4113a8$export$89b472e03be495df = (room, data, origin = null)=>{
    const c = $264c0479ab4113a8$var$getChannel(room);
    c.bc.postMessage(data);
    c.subs.forEach((sub)=>sub(data, origin));
};




/**
 * Mutual exclude for JavaScript.
 *
 * @module mutex
 */ /**
 * @callback mutex
 * @param {function():void} cb Only executed when this mutex is not in the current stack
 * @param {function():void} [elseCb] Executed when this mutex is in the current stack
 */ /**
 * Creates a mutual exclude function with the following property:
 *
 * ```js
 * const mutex = createMutex()
 * mutex(() => {
 *   // This function is immediately executed
 *   mutex(() => {
 *     // This function is not executed, as the mutex is already active.
 *   })
 * })
 * ```
 *
 * @return {mutex} A mutual exclude function
 * @public
 */ const $7c1d0fbe479eb726$export$6cca8a222d1193d7 = ()=>{
    let token = true;
    return (f, g)=>{
        if (token) {
            token = false;
            try {
                f();
            } finally{
                token = true;
            }
        } else if (g !== undefined) g();
    };
};



var $804372685f7be473$exports = {};
(function(e) {
    var t;
    $804372685f7be473$exports = e();
})(function() {
    var t = Math.floor, n = Math.abs, r = Math.pow;
    return (function() {
        function d(s, e, n) {
            function t(o, i) {
                if (!e[o]) {
                    if (!s[o]) {
                        var l = undefined;
                        if (!i && l) return l(o, !0);
                        if (r) return r(o, !0);
                        var c = new Error("Cannot find module '" + o + "'");
                        throw c.code = "MODULE_NOT_FOUND", c;
                    }
                    var a = e[o] = {
                        exports: {}
                    };
                    s[o][0].call(a.exports, function(e) {
                        var r = s[o][1][e];
                        return t(r || e);
                    }, a, a.exports, d, s, e, n);
                }
                return e[o].exports;
            }
            for(var r = undefined, a = 0; a < n.length; a++)t(n[a]);
            return t;
        }
        return d;
    })()({
        1: [
            function(e, t, n) {
                "use strict";
                function r(e) {
                    var t = e.length;
                    if (0 < t % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var n = e.indexOf("=");
                    -1 === n && (n = t);
                    var r = n === t ? 0 : 4 - n % 4;
                    return [
                        n,
                        r
                    ];
                }
                function a(e, t, n) {
                    return 3 * (t + n) / 4 - n;
                }
                function o(e) {
                    var t, n, o = r(e), d = o[0], s = o[1], l = new p(a(e, d, s)), c = 0, f = 0 < s ? d - 4 : d;
                    for(n = 0; n < f; n += 4)t = u[e.charCodeAt(n)] << 18 | u[e.charCodeAt(n + 1)] << 12 | u[e.charCodeAt(n + 2)] << 6 | u[e.charCodeAt(n + 3)], l[c++] = 255 & t >> 16, l[c++] = 255 & t >> 8, l[c++] = 255 & t;
                    return 2 === s && (t = u[e.charCodeAt(n)] << 2 | u[e.charCodeAt(n + 1)] >> 4, l[c++] = 255 & t), 1 === s && (t = u[e.charCodeAt(n)] << 10 | u[e.charCodeAt(n + 1)] << 4 | u[e.charCodeAt(n + 2)] >> 2, l[c++] = 255 & t >> 8, l[c++] = 255 & t), l;
                }
                function d(e) {
                    return c[63 & e >> 18] + c[63 & e >> 12] + c[63 & e >> 6] + c[63 & e];
                }
                function s(e, t, n) {
                    for(var r, a = [], o = t; o < n; o += 3)r = (16711680 & e[o] << 16) + (65280 & e[o + 1] << 8) + (255 & e[o + 2]), a.push(d(r));
                    return a.join("");
                }
                function l(e) {
                    for(var t, n = e.length, r = n % 3, a = [], o = 16383, d = 0, l = n - r; d < l; d += o)a.push(s(e, d, d + o > l ? l : d + o));
                    return 1 === r ? (t = e[n - 1], a.push(c[t >> 2] + c[63 & t << 4] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], a.push(c[t >> 10] + c[63 & t >> 4] + c[63 & t << 2] + "=")), a.join("");
                }
                n.byteLength = function(e) {
                    var t = r(e), n = t[0], a = t[1];
                    return 3 * (n + a) / 4 - a;
                }, n.toByteArray = o, n.fromByteArray = l;
                for(var c = [], u = [], p = "undefined" == typeof Uint8Array ? Array : Uint8Array, f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", g = 0, _ = f.length; g < _; ++g)c[g] = f[g], u[f.charCodeAt(g)] = g;
                u[45] = 62, u[95] = 63;
            },
            {}
        ],
        2: [
            function() {},
            {}
        ],
        3: [
            function(e, t, n) {
                (function() {
                    (function() {
                        "use strict";
                        var t = String.fromCharCode, o = Math.min;
                        function d(e) {
                            if (2147483647 < e) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, n) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return p(e);
                            }
                            return l(e, t, n);
                        }
                        function l(e, t, n) {
                            if ("string" == typeof e) return f(e, t);
                            if (ArrayBuffer.isView(e)) return g(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (K(e, ArrayBuffer) || e && K(e.buffer, ArrayBuffer)) return _(e, t, n);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var r = e.valueOf && e.valueOf();
                            if (null != r && r !== e) return s.from(r, t, n);
                            var a = h(e);
                            if (a) return a;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, n);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function c(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            else if (0 > e) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function u(e, t, n) {
                            return c(e), 0 >= e ? d(e) : void 0 === t ? d(e) : "string" == typeof n ? d(e).fill(t, n) : d(e).fill(t);
                        }
                        function p(e) {
                            return c(e), d(0 > e ? 0 : 0 | m(e));
                        }
                        function f(e, t) {
                            if (("string" != typeof t || "" === t) && (t = "utf8"), !s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                            var n = 0 | b(e, t), r = d(n), a = r.write(e, t);
                            return a !== n && (r = r.slice(0, a)), r;
                        }
                        function g(e) {
                            for(var t = 0 > e.length ? 0 : 0 | m(e.length), n = d(t), r = 0; r < t; r += 1)n[r] = 255 & e[r];
                            return n;
                        }
                        function _(e, t, n) {
                            if (0 > t || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                            if (e.byteLength < t + (n || 0)) throw new RangeError('"length" is outside of buffer bounds');
                            var r;
                            return r = void 0 === t && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, t) : new Uint8Array(e, t, n), r.__proto__ = s.prototype, r;
                        }
                        function h(e) {
                            if (s.isBuffer(e)) {
                                var t = 0 | m(e.length), n = d(t);
                                return 0 === n.length ? n : (e.copy(n, 0, 0, t), n);
                            }
                            return void 0 === e.length ? "Buffer" === e.type && Array.isArray(e.data) ? g(e.data) : void 0 : "number" != typeof e.length || X(e.length) ? d(0) : g(e);
                        }
                        function m(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function b(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || K(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var n = e.length, r = 2 < arguments.length && !0 === arguments[2];
                            if (!r && 0 === n) return 0;
                            for(var a = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return n;
                                case "utf8":
                                case "utf-8":
                                    return H(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * n;
                                case "hex":
                                    return n >>> 1;
                                case "base64":
                                    return z(e).length;
                                default:
                                    if (a) return r ? -1 : H(e).length;
                                    t = ("" + t).toLowerCase(), a = !0;
                            }
                        }
                        function y(e, t, n) {
                            var r = !1;
                            if ((void 0 === t || 0 > t) && (t = 0), t > this.length) return "";
                            if ((void 0 === n || n > this.length) && (n = this.length), 0 >= n) return "";
                            if (n >>>= 0, t >>>= 0, n <= t) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return P(this, t, n);
                                case "utf8":
                                case "utf-8":
                                    return x(this, t, n);
                                case "ascii":
                                    return D(this, t, n);
                                case "latin1":
                                case "binary":
                                    return I(this, t, n);
                                case "base64":
                                    return A(this, t, n);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return M(this, t, n);
                                default:
                                    if (r) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), r = !0;
                            }
                        }
                        function C(e, t, n) {
                            var r = e[t];
                            e[t] = e[n], e[n] = r;
                        }
                        function R(e, t, n, r, a) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof n ? (r = n, n = 0) : 2147483647 < n ? n = 2147483647 : -2147483648 > n && (n = -2147483648), n = +n, X(n) && (n = a ? 0 : e.length - 1), 0 > n && (n = e.length + n), n >= e.length) {
                                if (a) return -1;
                                n = e.length - 1;
                            } else if (0 > n) {
                                if (a) n = 0;
                                else return -1;
                            }
                            if ("string" == typeof t && (t = s.from(t, r)), s.isBuffer(t)) return 0 === t.length ? -1 : E(e, t, n, r, a);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? a ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : E(e, [
                                t
                            ], n, r, a);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function E(e, t, n, r, a) {
                            function o(e, t) {
                                return 1 === d ? e[t] : e.readUInt16BE(t * d);
                            }
                            var d = 1, s = e.length, l = t.length;
                            if (void 0 !== r && (r = (r + "").toLowerCase(), "ucs2" === r || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
                                if (2 > e.length || 2 > t.length) return -1;
                                d = 2, s /= 2, l /= 2, n /= 2;
                            }
                            var c;
                            if (a) {
                                var u = -1;
                                for(c = n; c < s; c++)if (o(e, c) !== o(t, -1 === u ? 0 : c - u)) -1 !== u && (c -= c - u), u = -1;
                                else if (-1 === u && (u = c), c - u + 1 === l) return u * d;
                            } else for(n + l > s && (n = s - l), c = n; 0 <= c; c--){
                                for(var p = !0, f = 0; f < l; f++)if (o(e, c + f) !== o(t, f)) {
                                    p = !1;
                                    break;
                                }
                                if (p) return c;
                            }
                            return -1;
                        }
                        function w(e, t, n, r) {
                            n = +n || 0;
                            var a = e.length - n;
                            r ? (r = +r, r > a && (r = a)) : r = a;
                            var o = t.length;
                            r > o / 2 && (r = o / 2);
                            for(var d, s = 0; s < r; ++s){
                                if (d = parseInt(t.substr(2 * s, 2), 16), X(d)) return s;
                                e[n + s] = d;
                            }
                            return s;
                        }
                        function S(e, t, n, r) {
                            return G(H(t, e.length - n), e, n, r);
                        }
                        function T(e, t, n, r) {
                            return G(Y(t), e, n, r);
                        }
                        function v(e, t, n, r) {
                            return T(e, t, n, r);
                        }
                        function k(e, t, n, r) {
                            return G(z(t), e, n, r);
                        }
                        function L(e, t, n, r) {
                            return G(V(t, e.length - n), e, n, r);
                        }
                        function A(e, t, n) {
                            return 0 === t && n === e.length ? $.fromByteArray(e) : $.fromByteArray(e.slice(t, n));
                        }
                        function x(e, t, n) {
                            n = o(e.length, n);
                            for(var r = [], a = t; a < n;){
                                var d = e[a], s = null, l = 239 < d ? 4 : 223 < d ? 3 : 191 < d ? 2 : 1;
                                if (a + l <= n) {
                                    var c, u, p, f;
                                    1 === l ? 128 > d && (s = d) : 2 === l ? (c = e[a + 1], 128 == (192 & c) && (f = (31 & d) << 6 | 63 & c, 127 < f && (s = f))) : 3 === l ? (c = e[a + 1], u = e[a + 2], 128 == (192 & c) && 128 == (192 & u) && (f = (15 & d) << 12 | (63 & c) << 6 | 63 & u, 2047 < f && (55296 > f || 57343 < f) && (s = f))) : 4 === l && (c = e[a + 1], u = e[a + 2], p = e[a + 3], 128 == (192 & c) && 128 == (192 & u) && 128 == (192 & p) && (f = (15 & d) << 18 | (63 & c) << 12 | (63 & u) << 6 | 63 & p, 65535 < f && 1114112 > f && (s = f)));
                                }
                                null === s ? (s = 65533, l = 1) : 65535 < s && (s -= 65536, r.push(55296 | 1023 & s >>> 10), s = 56320 | 1023 & s), r.push(s), a += l;
                            }
                            return N(r);
                        }
                        function N(e) {
                            var n = e.length;
                            if (n <= 4096) return t.apply(String, e);
                            for(var r = "", a = 0; a < n;)r += t.apply(String, e.slice(a, a += 4096));
                            return r;
                        }
                        function D(e, n, r) {
                            var a = "";
                            r = o(e.length, r);
                            for(var d = n; d < r; ++d)a += t(127 & e[d]);
                            return a;
                        }
                        function I(e, n, r) {
                            var a = "";
                            r = o(e.length, r);
                            for(var d = n; d < r; ++d)a += t(e[d]);
                            return a;
                        }
                        function P(e, t, n) {
                            var r = e.length;
                            (!t || 0 > t) && (t = 0), (!n || 0 > n || n > r) && (n = r);
                            for(var a = "", o = t; o < n; ++o)a += W(e[o]);
                            return a;
                        }
                        function M(e, n, r) {
                            for(var a = e.slice(n, r), o = "", d = 0; d < a.length; d += 2)o += t(a[d] + 256 * a[d + 1]);
                            return o;
                        }
                        function O(e, t, n) {
                            if (0 != e % 1 || 0 > e) throw new RangeError("offset is not uint");
                            if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function F(e, t, n, r, a, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > a || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (n + r > e.length) throw new RangeError("Index out of range");
                        }
                        function B(e, t, n, r) {
                            if (n + r > e.length) throw new RangeError("Index out of range");
                            if (0 > n) throw new RangeError("Index out of range");
                        }
                        function U(e, t, n, r, a) {
                            return t = +t, n >>>= 0, a || B(e, t, n, 4, 34028234663852886e22, -340282346638528860000000000000000000000), J.write(e, t, n, r, 23, 4), n + 4;
                        }
                        function j(e, t, n, r, a) {
                            return t = +t, n >>>= 0, a || B(e, t, n, 8, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), J.write(e, t, n, r, 52, 8), n + 8;
                        }
                        function q(e) {
                            if (e = e.split("=")[0], e = e.trim().replace(Q, ""), 2 > e.length) return "";
                            for(; 0 != e.length % 4;)e += "=";
                            return e;
                        }
                        function W(e) {
                            return 16 > e ? "0" + e.toString(16) : e.toString(16);
                        }
                        function H(e, t) {
                            t = t || 1 / 0;
                            for(var n, r = e.length, a = null, o = [], d = 0; d < r; ++d){
                                if (n = e.charCodeAt(d), 55295 < n && 57344 > n) {
                                    if (!a) {
                                        if (56319 < n) {
                                            -1 < (t -= 3) && o.push(239, 191, 189);
                                            continue;
                                        } else if (d + 1 === r) {
                                            -1 < (t -= 3) && o.push(239, 191, 189);
                                            continue;
                                        }
                                        a = n;
                                        continue;
                                    }
                                    if (56320 > n) {
                                        -1 < (t -= 3) && o.push(239, 191, 189), a = n;
                                        continue;
                                    }
                                    n = (a - 55296 << 10 | n - 56320) + 65536;
                                } else a && -1 < (t -= 3) && o.push(239, 191, 189);
                                if (a = null, 128 > n) {
                                    if (0 > (t -= 1)) break;
                                    o.push(n);
                                } else if (2048 > n) {
                                    if (0 > (t -= 2)) break;
                                    o.push(192 | n >> 6, 128 | 63 & n);
                                } else if (65536 > n) {
                                    if (0 > (t -= 3)) break;
                                    o.push(224 | n >> 12, 128 | 63 & n >> 6, 128 | 63 & n);
                                } else if (1114112 > n) {
                                    if (0 > (t -= 4)) break;
                                    o.push(240 | n >> 18, 128 | 63 & n >> 12, 128 | 63 & n >> 6, 128 | 63 & n);
                                } else throw new Error("Invalid code point");
                            }
                            return o;
                        }
                        function Y(e) {
                            for(var t = [], n = 0; n < e.length; ++n)t.push(255 & e.charCodeAt(n));
                            return t;
                        }
                        function V(e, t) {
                            for(var n, r, a, o = [], d = 0; d < e.length && !(0 > (t -= 2)); ++d)n = e.charCodeAt(d), r = n >> 8, a = n % 256, o.push(a), o.push(r);
                            return o;
                        }
                        function z(e) {
                            return $.toByteArray(q(e));
                        }
                        function G(e, t, n, r) {
                            for(var a = 0; a < r && !(a + n >= t.length || a >= e.length); ++a)t[a + n] = e[a];
                            return a;
                        }
                        function K(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function X(e) {
                            return e !== e;
                        }
                        var $ = e("base64-js"), J = e("ieee754");
                        n.Buffer = s, n.SlowBuffer = function(e) {
                            return +e != e && (e = 0), s.alloc(+e);
                        }, n.INSPECT_MAX_BYTES = 50;
                        n.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (t) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                return s.isBuffer(this) ? this.buffer : void 0;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                return s.isBuffer(this) ? this.byteOffset : void 0;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, n) {
                            return l(e, t, n);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, n) {
                            return u(e, t, n);
                        }, s.allocUnsafe = function(e) {
                            return p(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return p(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (K(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), K(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var n = e.length, r = t.length, d = 0, l = o(n, r); d < l; ++d)if (e[d] !== t[d]) {
                                n = e[d], r = t[d];
                                break;
                            }
                            return n < r ? -1 : r < n ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch((e + "").toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var n;
                            if (t === void 0) for(t = 0, n = 0; n < e.length; ++n)t += e[n].length;
                            var r = s.allocUnsafe(t), a = 0;
                            for(n = 0; n < e.length; ++n){
                                var o = e[n];
                                if (K(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(r, a), a += o.length;
                            }
                            return r;
                        }, s.byteLength = b, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (0 != e % 2) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)C(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (0 != e % 4) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)C(this, t, t + 3), C(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (0 != e % 8) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)C(this, t, t + 7), C(this, t + 1, t + 6), C(this, t + 2, t + 5), C(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? x(this, 0, e) : y.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = n.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, n, r, a) {
                            if (K(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === a && (a = this.length), 0 > t || n > e.length || 0 > r || a > this.length) throw new RangeError("out of range index");
                            if (r >= a && t >= n) return 0;
                            if (r >= a) return -1;
                            if (t >= n) return 1;
                            if (t >>>= 0, n >>>= 0, r >>>= 0, a >>>= 0, this === e) return 0;
                            for(var d = a - r, l = n - t, c = o(d, l), u = this.slice(r, a), p = e.slice(t, n), f = 0; f < c; ++f)if (u[f] !== p[f]) {
                                d = u[f], l = p[f];
                                break;
                            }
                            return d < l ? -1 : l < d ? 1 : 0;
                        }, s.prototype.includes = function(e, t, n) {
                            return -1 !== this.indexOf(e, t, n);
                        }, s.prototype.indexOf = function(e, t, n) {
                            return R(this, e, t, n, !0);
                        }, s.prototype.lastIndexOf = function(e, t, n) {
                            return R(this, e, t, n, !1);
                        }, s.prototype.write = function(e, t, n, r) {
                            if (void 0 === t) r = "utf8", n = this.length, t = 0;
                            else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;
                            else if (isFinite(t)) t >>>= 0, isFinite(n) ? (n >>>= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
                            else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            var a = this.length - t;
                            if ((void 0 === n || n > a) && (n = a), 0 < e.length && (0 > n || 0 > t) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            r || (r = "utf8");
                            for(var o = !1;;)switch(r){
                                case "hex":
                                    return w(this, e, t, n);
                                case "utf8":
                                case "utf-8":
                                    return S(this, e, t, n);
                                case "ascii":
                                    return T(this, e, t, n);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, n);
                                case "base64":
                                    return k(this, e, t, n);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return L(this, e, t, n);
                                default:
                                    if (o) throw new TypeError("Unknown encoding: " + r);
                                    r = ("" + r).toLowerCase(), o = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        s.prototype.slice = function(e, t) {
                            var n = this.length;
                            e = ~~e, t = t === void 0 ? n : ~~t, 0 > e ? (e += n, 0 > e && (e = 0)) : e > n && (e = n), 0 > t ? (t += n, 0 > t && (t = 0)) : t > n && (t = n), t < e && (t = e);
                            var r = this.subarray(e, t);
                            return r.__proto__ = s.prototype, r;
                        }, s.prototype.readUIntLE = function(e, t, n) {
                            e >>>= 0, t >>>= 0, n || O(e, t, this.length);
                            for(var r = this[e], a = 1, o = 0; ++o < t && (a *= 256);)r += this[e + o] * a;
                            return r;
                        }, s.prototype.readUIntBE = function(e, t, n) {
                            e >>>= 0, t >>>= 0, n || O(e, t, this.length);
                            for(var r = this[e + --t], a = 1; 0 < t && (a *= 256);)r += this[e + --t] * a;
                            return r;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || O(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || O(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || O(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, n) {
                            e >>>= 0, t >>>= 0, n || O(e, t, this.length);
                            for(var a = this[e], o = 1, d = 0; ++d < t && (o *= 256);)a += this[e + d] * o;
                            return o *= 128, a >= o && (a -= r(2, 8 * t)), a;
                        }, s.prototype.readIntBE = function(e, t, n) {
                            e >>>= 0, t >>>= 0, n || O(e, t, this.length);
                            for(var a = t, o = 1, d = this[e + --a]; 0 < a && (o *= 256);)d += this[e + --a] * o;
                            return o *= 128, d >= o && (d -= r(2, 8 * t)), d;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || O(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || O(e, 2, this.length);
                            var n = this[e] | this[e + 1] << 8;
                            return 32768 & n ? 4294901760 | n : n;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || O(e, 2, this.length);
                            var n = this[e + 1] | this[e] << 8;
                            return 32768 & n ? 4294901760 | n : n;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), J.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || O(e, 4, this.length), J.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || O(e, 8, this.length), J.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || O(e, 8, this.length), J.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, n, a) {
                            if (e = +e, t >>>= 0, n >>>= 0, !a) {
                                var o = r(2, 8 * n) - 1;
                                F(this, e, t, n, o, 0);
                            }
                            var d = 1, s = 0;
                            for(this[t] = 255 & e; ++s < n && (d *= 256);)this[t + s] = 255 & e / d;
                            return t + n;
                        }, s.prototype.writeUIntBE = function(e, t, n, a) {
                            if (e = +e, t >>>= 0, n >>>= 0, !a) {
                                var o = r(2, 8 * n) - 1;
                                F(this, e, t, n, o, 0);
                            }
                            var d = n - 1, s = 1;
                            for(this[t + d] = 255 & e; 0 <= --d && (s *= 256);)this[t + d] = 255 & e / s;
                            return t + n;
                        }, s.prototype.writeUInt8 = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, n, a) {
                            if (e = +e, t >>>= 0, !a) {
                                var o = r(2, 8 * n - 1);
                                F(this, e, t, n, o - 1, -o);
                            }
                            var d = 0, s = 1, l = 0;
                            for(this[t] = 255 & e; ++d < n && (s *= 256);)0 > e && 0 === l && 0 !== this[t + d - 1] && (l = 1), this[t + d] = 255 & (e / s >> 0) - l;
                            return t + n;
                        }, s.prototype.writeIntBE = function(e, t, n, a) {
                            if (e = +e, t >>>= 0, !a) {
                                var o = r(2, 8 * n - 1);
                                F(this, e, t, n, o - 1, -o);
                            }
                            var d = n - 1, s = 1, l = 0;
                            for(this[t + d] = 255 & e; 0 <= --d && (s *= 256);)0 > e && 0 === l && 0 !== this[t + d + 1] && (l = 1), this[t + d] = 255 & (e / s >> 0) - l;
                            return t + n;
                        }, s.prototype.writeInt8 = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 1, 127, -128), 0 > e && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, n) {
                            return e = +e, t >>>= 0, n || F(this, e, t, 4, 2147483647, -2147483648), 0 > e && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, n) {
                            return U(this, e, t, !0, n);
                        }, s.prototype.writeFloatBE = function(e, t, n) {
                            return U(this, e, t, !1, n);
                        }, s.prototype.writeDoubleLE = function(e, t, n) {
                            return j(this, e, t, !0, n);
                        }, s.prototype.writeDoubleBE = function(e, t, n) {
                            return j(this, e, t, !1, n);
                        }, s.prototype.copy = function(e, t, n, r) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), 0 < r && r < n && (r = n), r === n) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (0 > t) throw new RangeError("targetStart out of bounds");
                            if (0 > n || n >= this.length) throw new RangeError("Index out of range");
                            if (0 > r) throw new RangeError("sourceEnd out of bounds");
                            r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
                            var a = r - n;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, n, r);
                            else if (this === e && n < t && t < r) for(var o = a - 1; 0 <= o; --o)e[o + t] = this[o + n];
                            else Uint8Array.prototype.set.call(e, this.subarray(n, r), t);
                            return a;
                        }, s.prototype.fill = function(e, t, n, r) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
                                if ("string" == typeof r && !s.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
                                if (1 === e.length) {
                                    var a = e.charCodeAt(0);
                                    ("utf8" === r && 128 > a || "latin1" === r) && (e = a);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (0 > t || this.length < t || this.length < n) throw new RangeError("Out of range index");
                            if (n <= t) return this;
                            t >>>= 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
                            var o;
                            if ("number" == typeof e) for(o = t; o < n; ++o)this[o] = e;
                            else {
                                var d = s.isBuffer(e) ? e : s.from(e, r), l = d.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < n - t; ++o)this[o + t] = d[o % l];
                            }
                            return this;
                        };
                        var Q = /[^+/0-9A-Za-z-_]/g;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 1,
                buffer: 3,
                ieee754: 9
            }
        ],
        4: [
            function(e, t, n) {
                (function(a) {
                    (function() {
                        function r() {
                            let e;
                            try {
                                e = n.storage.getItem("debug");
                            } catch (e) {}
                            return !e && "undefined" != typeof a && "env" in a && (e = a.env.DEBUG), e;
                        }
                        n.formatArgs = function(e) {
                            if (e[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + e[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors) return;
                            const n = "color: " + this.color;
                            e.splice(1, 0, n, "color: inherit");
                            let r = 0, a = 0;
                            e[0].replace(/%[a-zA-Z%]/g, (e)=>{
                                "%%" === e || (r++, "%c" === e && (a = r));
                            }), e.splice(a, 0, n);
                        }, n.save = function(e) {
                            try {
                                e ? n.storage.setItem("debug", e) : n.storage.removeItem("debug");
                            } catch (e) {}
                        }, n.load = r, n.useColors = function() {
                            return !!("undefined" != typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) || !("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && 31 <= parseInt(RegExp.$1, 10) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
                        }, n.storage = function() {
                            try {
                                return localStorage;
                            } catch (e) {}
                        }(), n.destroy = (()=>{
                            let e = !1;
                            return ()=>{
                                e || (e = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
                            };
                        })(), n.colors = [
                            "#0000CC",
                            "#0000FF",
                            "#0033CC",
                            "#0033FF",
                            "#0066CC",
                            "#0066FF",
                            "#0099CC",
                            "#0099FF",
                            "#00CC00",
                            "#00CC33",
                            "#00CC66",
                            "#00CC99",
                            "#00CCCC",
                            "#00CCFF",
                            "#3300CC",
                            "#3300FF",
                            "#3333CC",
                            "#3333FF",
                            "#3366CC",
                            "#3366FF",
                            "#3399CC",
                            "#3399FF",
                            "#33CC00",
                            "#33CC33",
                            "#33CC66",
                            "#33CC99",
                            "#33CCCC",
                            "#33CCFF",
                            "#6600CC",
                            "#6600FF",
                            "#6633CC",
                            "#6633FF",
                            "#66CC00",
                            "#66CC33",
                            "#9900CC",
                            "#9900FF",
                            "#9933CC",
                            "#9933FF",
                            "#99CC00",
                            "#99CC33",
                            "#CC0000",
                            "#CC0033",
                            "#CC0066",
                            "#CC0099",
                            "#CC00CC",
                            "#CC00FF",
                            "#CC3300",
                            "#CC3333",
                            "#CC3366",
                            "#CC3399",
                            "#CC33CC",
                            "#CC33FF",
                            "#CC6600",
                            "#CC6633",
                            "#CC9900",
                            "#CC9933",
                            "#CCCC00",
                            "#CCCC33",
                            "#FF0000",
                            "#FF0033",
                            "#FF0066",
                            "#FF0099",
                            "#FF00CC",
                            "#FF00FF",
                            "#FF3300",
                            "#FF3333",
                            "#FF3366",
                            "#FF3399",
                            "#FF33CC",
                            "#FF33FF",
                            "#FF6600",
                            "#FF6633",
                            "#FF9900",
                            "#FF9933",
                            "#FFCC00",
                            "#FFCC33"
                        ], n.log = console.debug || console.log || (()=>{}), t.exports = e("./common")(n);
                        const { formatters: o  } = t.exports;
                        o.j = function(e) {
                            try {
                                return JSON.stringify(e);
                            } catch (e) {
                                return "[UnexpectedJSONParseError]: " + e.message;
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./common": 5,
                _process: 12
            }
        ],
        5: [
            function(e, t) {
                t.exports = function(t) {
                    function r(e) {
                        function t(...e) {
                            if (!t.enabled) return;
                            const a = t, o = +new Date, i = o - (n || o);
                            a.diff = i, a.prev = n, a.curr = o, n = o, e[0] = r.coerce(e[0]), "string" != typeof e[0] && e.unshift("%O");
                            let d = 0;
                            e[0] = e[0].replace(/%([a-zA-Z%])/g, (t, n)=>{
                                if ("%%" === t) return "%";
                                d++;
                                const o = r.formatters[n];
                                if ("function" == typeof o) {
                                    const n = e[d];
                                    t = o.call(a, n), e.splice(d, 1), d--;
                                }
                                return t;
                            }), r.formatArgs.call(a, e);
                            const s = a.log || r.log;
                            s.apply(a, e);
                        }
                        let n, o = null;
                        return t.namespace = e, t.useColors = r.useColors(), t.color = r.selectColor(e), t.extend = a, t.destroy = r.destroy, Object.defineProperty(t, "enabled", {
                            enumerable: !0,
                            configurable: !1,
                            get: ()=>null === o ? r.enabled(e) : o,
                            set: (e)=>{
                                o = e;
                            }
                        }), "function" == typeof r.init && r.init(t), t;
                    }
                    function a(e, t) {
                        const n = r(this.namespace + ("undefined" == typeof t ? ":" : t) + e);
                        return n.log = this.log, n;
                    }
                    function o(e) {
                        return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
                    }
                    return r.debug = r, r.default = r, r.coerce = function(e) {
                        return e instanceof Error ? e.stack || e.message : e;
                    }, r.disable = function() {
                        const e = [
                            ...r.names.map(o),
                            ...r.skips.map(o).map((e)=>"-" + e)
                        ].join(",");
                        return r.enable(""), e;
                    }, r.enable = function(e) {
                        r.save(e), r.names = [], r.skips = [];
                        let t;
                        const n = ("string" == typeof e ? e : "").split(/[\s,]+/), a = n.length;
                        for(t = 0; t < a; t++)n[t] && (e = n[t].replace(/\*/g, ".*?"), "-" === e[0] ? r.skips.push(new RegExp("^" + e.substr(1) + "$")) : r.names.push(new RegExp("^" + e + "$")));
                    }, r.enabled = function(e) {
                        if ("*" === e[e.length - 1]) return !0;
                        let t, n;
                        for(t = 0, n = r.skips.length; t < n; t++)if (r.skips[t].test(e)) return !1;
                        for(t = 0, n = r.names.length; t < n; t++)if (r.names[t].test(e)) return !0;
                        return !1;
                    }, r.humanize = e("ms"), r.destroy = function() {
                        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
                    }, Object.keys(t).forEach((e)=>{
                        r[e] = t[e];
                    }), r.names = [], r.skips = [], r.formatters = {}, r.selectColor = function(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++)t = (t << 5) - t + e.charCodeAt(n), t |= 0;
                        return r.colors[n(t) % r.colors.length];
                    }, r.enable(r.load()), r;
                };
            },
            {
                ms: 11
            }
        ],
        6: [
            function(e, t) {
                "use strict";
                function n(e, t) {
                    for(const n in t)Object.defineProperty(e, n, {
                        value: t[n],
                        enumerable: !0,
                        configurable: !0
                    });
                    return e;
                }
                t.exports = function(e, t, r) {
                    if (!e || "string" == typeof e) throw new TypeError("Please pass an Error to err-code");
                    r || (r = {}), "object" == typeof t && (r = t, t = ""), t && (r.code = t);
                    try {
                        return n(e, r);
                    } catch (t) {
                        r.message = e.message, r.stack = e.stack;
                        const a = function() {};
                        a.prototype = Object.create(Object.getPrototypeOf(e));
                        const o = n(new a, r);
                        return o;
                    }
                };
            },
            {}
        ],
        7: [
            function(e, t) {
                "use strict";
                function n(e) {
                    console && console.warn && console.warn(e);
                }
                function r() {
                    r.init.call(this);
                }
                function a(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function o(e) {
                    return void 0 === e._maxListeners ? r.defaultMaxListeners : e._maxListeners;
                }
                function i(e, t, r, i) {
                    var d, s, l;
                    if (a(r), s = e._events, void 0 === s ? (s = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== s.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), s = e._events), l = s[t]), void 0 === l) l = s[t] = r, ++e._eventsCount;
                    else if ("function" == typeof l ? l = s[t] = i ? [
                        r,
                        l
                    ] : [
                        l,
                        r
                    ] : i ? l.unshift(r) : l.push(r), d = o(e), 0 < d && l.length > d && !l.warned) {
                        l.warned = !0;
                        var c = new Error("Possible EventEmitter memory leak detected. " + l.length + " " + (t + " listeners added. Use emitter.setMaxListeners() to increase limit"));
                        c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = l.length, n(c);
                    }
                    return e;
                }
                function d() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function s(e, t, n) {
                    var r = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: n
                    }, a = d.bind(r);
                    return a.listener = n, r.wrapFn = a, a;
                }
                function l(e, t, n) {
                    var r = e._events;
                    if (r === void 0) return [];
                    var a = r[t];
                    return void 0 === a ? [] : "function" == typeof a ? n ? [
                        a.listener || a
                    ] : [
                        a
                    ] : n ? f(a) : u(a, a.length);
                }
                function c(e) {
                    var t = this._events;
                    if (t !== void 0) {
                        var n = t[e];
                        if ("function" == typeof n) return 1;
                        if (void 0 !== n) return n.length;
                    }
                    return 0;
                }
                function u(e, t) {
                    for(var n = Array(t), r = 0; r < t; ++r)n[r] = e[r];
                    return n;
                }
                function p(e, t) {
                    for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                    e.pop();
                }
                function f(e) {
                    for(var t = Array(e.length), n = 0; n < t.length; ++n)t[n] = e[n].listener || e[n];
                    return t;
                }
                function g(e, t, n) {
                    "function" == typeof e.on && _(e, "error", t, n);
                }
                function _(e, t, n, r) {
                    if ("function" == typeof e.on) r.once ? e.once(t, n) : e.on(t, n);
                    else if ("function" == typeof e.addEventListener) e.addEventListener(t, function a(o) {
                        r.once && e.removeEventListener(t, a), n(o);
                    });
                    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                }
                var h, m = "object" == typeof Reflect ? Reflect : null, b = m && "function" == typeof m.apply ? m.apply : function(e, t, n) {
                    return Function.prototype.apply.call(e, t, n);
                };
                h = m && "function" == typeof m.ownKeys ? m.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var y = Number.isNaN || function(e) {
                    return e !== e;
                };
                t.exports = r, t.exports.once = function(e, t) {
                    return new Promise(function(n, r) {
                        function a(n) {
                            e.removeListener(t, o), r(n);
                        }
                        function o() {
                            "function" == typeof e.removeListener && e.removeListener("error", a), n([].slice.call(arguments));
                        }
                        _(e, t, o, {
                            once: !0
                        }), "error" !== t && g(e, a, {
                            once: !0
                        });
                    });
                }, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._eventsCount = 0, r.prototype._maxListeners = void 0;
                var C = 10;
                Object.defineProperty(r, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return C;
                    },
                    set: function(e) {
                        if ("number" != typeof e || 0 > e || y(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        C = e;
                    }
                }), r.init = function() {
                    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, r.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || 0 > e || y(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, r.prototype.getMaxListeners = function() {
                    return o(this);
                }, r.prototype.emit = function(e) {
                    for(var t = [], n = 1; n < arguments.length; n++)t.push(arguments[n]);
                    var r = "error" === e, a = this._events;
                    if (a !== void 0) r = r && a.error === void 0;
                    else if (!r) return !1;
                    if (r) {
                        var o;
                        if (0 < t.length && (o = t[0]), o instanceof Error) throw o;
                        var d = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                        throw d.context = o, d;
                    }
                    var s = a[e];
                    if (s === void 0) return !1;
                    if ("function" == typeof s) b(s, this, t);
                    else for(var l = s.length, c = u(s, l), n = 0; n < l; ++n)b(c[n], this, t);
                    return !0;
                }, r.prototype.addListener = function(e, t) {
                    return i(this, e, t, !1);
                }, r.prototype.on = r.prototype.addListener, r.prototype.prependListener = function(e, t) {
                    return i(this, e, t, !0);
                }, r.prototype.once = function(e, t) {
                    return a(t), this.on(e, s(this, e, t)), this;
                }, r.prototype.prependOnceListener = function(e, t) {
                    return a(t), this.prependListener(e, s(this, e, t)), this;
                }, r.prototype.removeListener = function(e, t) {
                    var n, r, o, d, s;
                    if (a(t), r = this._events, void 0 === r) return this;
                    if (n = r[e], void 0 === n) return this;
                    if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
                    else if ("function" != typeof n) {
                        for(o = -1, d = n.length - 1; 0 <= d; d--)if (n[d] === t || n[d].listener === t) {
                            s = n[d].listener, o = d;
                            break;
                        }
                        if (0 > o) return this;
                        0 === o ? n.shift() : p(n, o), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t);
                    }
                    return this;
                }, r.prototype.off = r.prototype.removeListener, r.prototype.removeAllListeners = function(e) {
                    var t, n, r;
                    if (n = this._events, void 0 === n) return this;
                    if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
                    if (0 === arguments.length) {
                        var a, o = Object.keys(n);
                        for(r = 0; r < o.length; ++r)a = o[r], "removeListener" !== a && this.removeAllListeners(a);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if (t = n[e], "function" == typeof t) this.removeListener(e, t);
                    else if (void 0 !== t) for(r = t.length - 1; 0 <= r; r--)this.removeListener(e, t[r]);
                    return this;
                }, r.prototype.listeners = function(e) {
                    return l(this, e, !0);
                }, r.prototype.rawListeners = function(e) {
                    return l(this, e, !1);
                }, r.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : c.call(e, t);
                }, r.prototype.listenerCount = c, r.prototype.eventNames = function() {
                    return 0 < this._eventsCount ? h(this._events) : [];
                };
            },
            {}
        ],
        8: [
            function(e, t) {
                t.exports = function() {
                    if ("undefined" == typeof globalThis) return null;
                    var e = {
                        RTCPeerConnection: globalThis.RTCPeerConnection || globalThis.mozRTCPeerConnection || globalThis.webkitRTCPeerConnection,
                        RTCSessionDescription: globalThis.RTCSessionDescription || globalThis.mozRTCSessionDescription || globalThis.webkitRTCSessionDescription,
                        RTCIceCandidate: globalThis.RTCIceCandidate || globalThis.mozRTCIceCandidate || globalThis.webkitRTCIceCandidate
                    };
                    return e.RTCPeerConnection ? e : null;
                };
            },
            {}
        ],
        9: [
            function(e, a, o) {
                o.read = function(t, n, a, o, l) {
                    var c, u, p = 8 * l - o - 1, f = (1 << p) - 1, g = f >> 1, _ = -7, h = a ? l - 1 : 0, b = a ? -1 : 1, d = t[n + h];
                    for(h += b, c = d & (1 << -_) - 1, d >>= -_, _ += p; 0 < _; c = 256 * c + t[n + h], h += b, _ -= 8);
                    for(u = c & (1 << -_) - 1, c >>= -_, _ += o; 0 < _; u = 256 * u + t[n + h], h += b, _ -= 8);
                    if (0 === c) c = 1 - g;
                    else {
                        if (c === f) return u ? NaN : (d ? -1 : 1) * (1 / 0);
                        u += r(2, o), c -= g;
                    }
                    return (d ? -1 : 1) * u * r(2, c - o);
                }, o.write = function(a, o, l, u, p, f) {
                    var h, b, y, g = Math.LN2, _ = Math.log, C = 8 * f - p - 1, R = (1 << C) - 1, E = R >> 1, w = 23 === p ? r(2, -24) - r(2, -77) : 0, S = u ? 0 : f - 1, T = u ? 1 : -1, d = 0 > o || 0 === o && 0 > 1 / o ? 1 : 0;
                    for(o = n(o), isNaN(o) || o === 1 / 0 ? (b = isNaN(o) ? 1 : 0, h = R) : (h = t(_(o) / g), 1 > o * (y = r(2, -h)) && (h--, y *= 2), o += 1 <= h + E ? w / y : w * r(2, 1 - E), 2 <= o * y && (h++, y /= 2), h + E >= R ? (b = 0, h = R) : 1 <= h + E ? (b = (o * y - 1) * r(2, p), h += E) : (b = o * r(2, E - 1) * r(2, p), h = 0)); 8 <= p; a[l + S] = 255 & b, S += T, b /= 256, p -= 8);
                    for(h = h << p | b, C += p; 0 < C; a[l + S] = 255 & h, S += T, h /= 256, C -= 8);
                    a[l + S - T] |= 128 * d;
                };
            },
            {}
        ],
        10: [
            function(e, t) {
                t.exports = "function" == typeof Object.create ? function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var n = function() {};
                        n.prototype = t.prototype, e.prototype = new n, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        11: [
            function(e, t) {
                var r = Math.round;
                function a(e) {
                    if (e += "", !(100 < e.length)) {
                        var t = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);
                        if (t) {
                            var r = parseFloat(t[1]), n = (t[2] || "ms").toLowerCase();
                            return "years" === n || "year" === n || "yrs" === n || "yr" === n || "y" === n ? 31557600000 * r : "weeks" === n || "week" === n || "w" === n ? 604800000 * r : "days" === n || "day" === n || "d" === n ? 86400000 * r : "hours" === n || "hour" === n || "hrs" === n || "hr" === n || "h" === n ? 3600000 * r : "minutes" === n || "minute" === n || "mins" === n || "min" === n || "m" === n ? 60000 * r : "seconds" === n || "second" === n || "secs" === n || "sec" === n || "s" === n ? 1000 * r : "milliseconds" === n || "millisecond" === n || "msecs" === n || "msec" === n || "ms" === n ? r : void 0;
                        }
                    }
                }
                function o(e) {
                    var t = n(e);
                    return 86400000 <= t ? r(e / 86400000) + "d" : 3600000 <= t ? r(e / 3600000) + "h" : 60000 <= t ? r(e / 60000) + "m" : 1000 <= t ? r(e / 1000) + "s" : e + "ms";
                }
                function i(e) {
                    var t = n(e);
                    return 86400000 <= t ? s(e, t, 86400000, "day") : 3600000 <= t ? s(e, t, 3600000, "hour") : 60000 <= t ? s(e, t, 60000, "minute") : 1000 <= t ? s(e, t, 1000, "second") : e + " ms";
                }
                function s(e, t, a, n) {
                    return r(e / a) + " " + n + (t >= 1.5 * a ? "s" : "");
                }
                var l = 86400000;
                t.exports = function(e, t) {
                    t = t || {};
                    var n = typeof e;
                    if ("string" == n && 0 < e.length) return a(e);
                    if ("number" === n && isFinite(e)) return t.long ? i(e) : o(e);
                    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
                };
            },
            {}
        ],
        12: [
            function(e, t) {
                function n() {
                    throw new Error("setTimeout has not been defined");
                }
                function r() {
                    throw new Error("clearTimeout has not been defined");
                }
                function a(t) {
                    if (c === setTimeout) return setTimeout(t, 0);
                    if ((c === n || !c) && setTimeout) return c = setTimeout, setTimeout(t, 0);
                    try {
                        return c(t, 0);
                    } catch (n) {
                        try {
                            return c.call(null, t, 0);
                        } catch (n) {
                            return c.call(this, t, 0);
                        }
                    }
                }
                function o(t) {
                    if (u === clearTimeout) return clearTimeout(t);
                    if ((u === r || !u) && clearTimeout) return u = clearTimeout, clearTimeout(t);
                    try {
                        return u(t);
                    } catch (n) {
                        try {
                            return u.call(null, t);
                        } catch (n) {
                            return u.call(this, t);
                        }
                    }
                }
                function i() {
                    _ && f && (_ = !1, f.length ? g = f.concat(g) : h = -1, g.length && d());
                }
                function d() {
                    if (!_) {
                        var e = a(i);
                        _ = !0;
                        for(var t = g.length; t;){
                            for(f = g, g = []; ++h < t;)f && f[h].run();
                            h = -1, t = g.length;
                        }
                        f = null, _ = !1, o(e);
                    }
                }
                function s(e, t) {
                    this.fun = e, this.array = t;
                }
                function l() {}
                var c, u, p = t.exports = {};
                (function() {
                    try {
                        c = "function" == typeof setTimeout ? setTimeout : n;
                    } catch (t) {
                        c = n;
                    }
                    try {
                        u = "function" == typeof clearTimeout ? clearTimeout : r;
                    } catch (t) {
                        u = r;
                    }
                })();
                var f, g = [], _ = !1, h = -1;
                p.nextTick = function(e) {
                    var t = Array(arguments.length - 1);
                    if (1 < arguments.length) for(var n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                    g.push(new s(e, t)), 1 !== g.length || _ || a(d);
                }, s.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = l, p.addListener = l, p.once = l, p.off = l, p.removeListener = l, p.removeAllListeners = l, p.emit = l, p.prependListener = l, p.prependOnceListener = l, p.listeners = function() {
                    return [];
                }, p.binding = function() {
                    throw new Error("process.binding is not supported");
                }, p.cwd = function() {
                    return "/";
                }, p.chdir = function() {
                    throw new Error("process.chdir is not supported");
                }, p.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        13: [
            function(e, t) {
                (function(e) {
                    (function() {
                        let n;
                        t.exports = "function" == typeof queueMicrotask ? queueMicrotask.bind("undefined" == typeof window ? e : window) : (e)=>(n || (n = Promise.resolve())).then(e).catch((e)=>setTimeout(()=>{
                                    throw e;
                                }, 0));
                    }).call(this);
                }).call(this, "undefined" == typeof $parcel$global ? "undefined" == typeof self ? "undefined" == typeof window ? {} : window : self : $parcel$global);
            },
            {}
        ],
        14: [
            function(e, t) {
                (function(n, r) {
                    (function() {
                        "use strict";
                        var a = e("safe-buffer").Buffer, o = r.crypto || r.msCrypto;
                        t.exports = o && o.getRandomValues ? function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var r = a.allocUnsafe(e);
                            if (0 < e) {
                                if (65536 < e) for(var i = 0; i < e; i += 65536)o.getRandomValues(r.slice(i, i + 65536));
                                else o.getRandomValues(r);
                            }
                            return "function" == typeof t ? n.nextTick(function() {
                                t(null, r);
                            }) : r;
                        } : function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" == typeof $parcel$global ? "undefined" == typeof self ? "undefined" == typeof window ? {} : window : self : $parcel$global);
            },
            {
                _process: 12,
                "safe-buffer": 30
            }
        ],
        15: [
            function(e, t) {
                "use strict";
                function n(e, t) {
                    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
                }
                function r(e, t, r) {
                    function a(e, n, r) {
                        return "string" == typeof t ? t : t(e, n, r);
                    }
                    r || (r = Error);
                    var o = function(e) {
                        function t(t, n, r) {
                            return e.call(this, a(t, n, r)) || this;
                        }
                        return n(t, e), t;
                    }(r);
                    o.prototype.name = r.name, o.prototype.code = e, s[e] = o;
                }
                function a(e, t) {
                    if (Array.isArray(e)) {
                        var n = e.length;
                        return e = e.map(function(e) {
                            return e + "";
                        }), 2 < n ? "one of ".concat(t, " ").concat(e.slice(0, n - 1).join(", "), ", or ") + e[n - 1] : 2 === n ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(e + "");
                }
                function o(e, t, n) {
                    return e.substr(!n || 0 > n ? 0 : +n, t.length) === t;
                }
                function i(e, t, n) {
                    return (void 0 === n || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
                }
                function d(e, t, n) {
                    return "number" != typeof n && (n = 0), !(n + t.length > e.length) && -1 !== e.indexOf(t, n);
                }
                var s = {};
                r("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), r("ERR_INVALID_ARG_TYPE", function(e, t, n) {
                    var r;
                    "string" == typeof t && o(t, "not ") ? (r = "must not be", t = t.replace(/^not /, "")) : r = "must be";
                    var s;
                    if (i(e, " argument")) s = "The ".concat(e, " ").concat(r, " ").concat(a(t, "type"));
                    else {
                        var l = d(e, ".") ? "property" : "argument";
                        s = 'The "'.concat(e, '" ').concat(l, " ").concat(r, " ").concat(a(t, "type"));
                    }
                    return s += ". Received type ".concat(typeof n), s;
                }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = s;
            },
            {}
        ],
        16: [
            function(e, t) {
                (function(n) {
                    (function() {
                        "use strict";
                        function r(e) {
                            return this instanceof r ? void (d.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", a)))) : new r(e);
                        }
                        function a() {
                            this._writableState.ended || n.nextTick(o, this);
                        }
                        function o(e) {
                            e.end();
                        }
                        var i = Object.keys || function(e) {
                            var t = [];
                            for(var n in e)t.push(n);
                            return t;
                        };
                        t.exports = r;
                        var d = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(r, d);
                        for(var l, c = i(s.prototype), u = 0; u < c.length; u++)l = c[u], r.prototype[l] || (r.prototype[l] = s.prototype[l]);
                        Object.defineProperty(r.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(r.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(r.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(r.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 === this._readableState || void 0 === this._writableState || (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 18,
                "./_stream_writable": 20,
                _process: 12,
                inherits: 10
            }
        ],
        17: [
            function(e, t) {
                "use strict";
                function n(e) {
                    return this instanceof n ? void r.call(this, e) : new n(e);
                }
                t.exports = n;
                var r = e("./_stream_transform");
                e("inherits")(n, r), n.prototype._transform = function(e, t, n) {
                    n(null, e);
                };
            },
            {
                "./_stream_transform": 19,
                inherits: 10
            }
        ],
        18: [
            function(e, t) {
                (function(n, r) {
                    (function() {
                        "use strict";
                        function a(e) {
                            return P.from(e);
                        }
                        function o(e) {
                            return P.isBuffer(e) || e instanceof M;
                        }
                        function i(e, t, n) {
                            return "function" == typeof e.prependListener ? e.prependListener(t, n) : void (e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [
                                n,
                                e._events[t]
                            ] : e.on(t, n));
                        }
                        function d(t, n, r) {
                            A = A || e("./_stream_duplex"), t = t || {}, "boolean" != typeof r && (r = n instanceof A), this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = H(this, t, "readableHighWaterMark", r), this.buffer = new j, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (!F && (F = e("string_decoder/").StringDecoder), this.decoder = new F(t.encoding), this.encoding = t.encoding);
                        }
                        function s(t) {
                            if (A = A || e("./_stream_duplex"), !(this instanceof s)) return new s(t);
                            var n = this instanceof A;
                            this._readableState = new d(t, this, n), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), I.call(this);
                        }
                        function l(e, t, n, r, o) {
                            x("readableAddChunk", t);
                            var i = e._readableState;
                            if (null === t) i.reading = !1, g(e, i);
                            else {
                                var d;
                                if (o || (d = u(i, t)), d) X(e, d);
                                else if (!(i.objectMode || t && 0 < t.length)) r || (i.reading = !1, m(e, i));
                                else if ("string" == typeof t || i.objectMode || Object.getPrototypeOf(t) === P.prototype || (t = a(t)), r) i.endEmitted ? X(e, new K) : c(e, i, t, !0);
                                else if (i.ended) X(e, new z);
                                else {
                                    if (i.destroyed) return !1;
                                    i.reading = !1, i.decoder && !n ? (t = i.decoder.write(t), i.objectMode || 0 !== t.length ? c(e, i, t, !1) : m(e, i)) : c(e, i, t, !1);
                                }
                            }
                            return !i.ended && (i.length < i.highWaterMark || 0 === i.length);
                        }
                        function c(e, t, n, r) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", n)) : (t.length += t.objectMode ? 1 : n.length, r ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && _(e)), m(e, t);
                        }
                        function u(e, t) {
                            var n;
                            return o(t) || "string" == typeof t || void 0 === t || e.objectMode || (n = new V("chunk", [
                                "string",
                                "Buffer",
                                "Uint8Array"
                            ], t)), n;
                        }
                        function p(e) {
                            return 1073741824 <= e ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                        }
                        function f(e, t) {
                            return 0 >= e || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e === e ? (e > t.highWaterMark && (t.highWaterMark = p(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0)) : t.flowing && t.length ? t.buffer.head.data.length : t.length;
                        }
                        function g(e, t) {
                            if (x("onEofChunk"), !t.ended) {
                                if (t.decoder) {
                                    var n = t.decoder.end();
                                    n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
                                }
                                t.ended = !0, t.sync ? _(e) : (t.needReadable = !1, !t.emittedReadable && (t.emittedReadable = !0, h(e)));
                            }
                        }
                        function _(e) {
                            var t = e._readableState;
                            x("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (x("emitReadable", t.flowing), t.emittedReadable = !0, n.nextTick(h, e));
                        }
                        function h(e) {
                            var t = e._readableState;
                            x("emitReadable_", t.destroyed, t.length, t.ended), !t.destroyed && (t.length || t.ended) && (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, S(e);
                        }
                        function m(e, t) {
                            t.readingMore || (t.readingMore = !0, n.nextTick(b, e, t));
                        }
                        function b(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var n = t.length;
                                if (x("maybeReadMore read 0"), e.read(0), n === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function y(e) {
                            return function() {
                                var t = e._readableState;
                                x("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && D(e, "data") && (t.flowing = !0, S(e));
                            };
                        }
                        function C(e) {
                            var t = e._readableState;
                            t.readableListening = 0 < e.listenerCount("readable"), t.resumeScheduled && !t.paused ? t.flowing = !0 : 0 < e.listenerCount("data") && e.resume();
                        }
                        function R(e) {
                            x("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.resumeScheduled || (t.resumeScheduled = !0, n.nextTick(w, e, t));
                        }
                        function w(e, t) {
                            x("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), S(e), t.flowing && !t.reading && e.read(0);
                        }
                        function S(e) {
                            var t = e._readableState;
                            for(x("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function T(e, t) {
                            if (0 === t.length) return null;
                            var n;
                            return t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : n = t.buffer.consume(e, t.decoder), n;
                        }
                        function v(e) {
                            var t = e._readableState;
                            x("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, n.nextTick(k, t, e));
                        }
                        function k(e, t) {
                            if (x("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var n = t._writableState;
                                (!n || n.autoDestroy && n.finished) && t.destroy();
                            }
                        }
                        function L(e, t) {
                            for(var n = 0, r = e.length; n < r; n++)if (e[n] === t) return n;
                            return -1;
                        }
                        t.exports = s;
                        var A;
                        s.ReadableState = d;
                        var x, N = e("events").EventEmitter, D = function(e, t) {
                            return e.listeners(t).length;
                        }, I = e("./internal/streams/stream"), P = e("buffer").Buffer, M = r.Uint8Array || function() {}, O = e("util");
                        x = O && O.debuglog ? O.debuglog("stream") : function() {};
                        var F, B, U, j = e("./internal/streams/buffer_list"), q = e("./internal/streams/destroy"), W = e("./internal/streams/state"), H = W.getHighWaterMark, Y = e("../errors").codes, V = Y.ERR_INVALID_ARG_TYPE, z = Y.ERR_STREAM_PUSH_AFTER_EOF, G = Y.ERR_METHOD_NOT_IMPLEMENTED, K = Y.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(s, I);
                        var X = q.errorOrDestroy, $ = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        Object.defineProperty(s.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), s.prototype.destroy = q.destroy, s.prototype._undestroy = q.undestroy, s.prototype._destroy = function(e, t) {
                            t(e);
                        }, s.prototype.push = function(e, t) {
                            var n, r = this._readableState;
                            return r.objectMode ? n = !0 : "string" == typeof e && (t = t || r.defaultEncoding, t !== r.encoding && (e = P.from(e, t), t = ""), n = !0), l(this, e, t, !1, n);
                        }, s.prototype.unshift = function(e) {
                            return l(this, e, null, !0, !1);
                        }, s.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, s.prototype.setEncoding = function(t) {
                            F || (F = e("string_decoder/").StringDecoder);
                            var n = new F(t);
                            this._readableState.decoder = n, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var r = this._readableState.buffer.head, a = ""; null !== r;)a += n.write(r.data), r = r.next;
                            return this._readableState.buffer.clear(), "" !== a && this._readableState.buffer.push(a), this._readableState.length = a.length, this;
                        };
                        s.prototype.read = function(e) {
                            x("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 === t.highWaterMark ? 0 < t.length : t.length >= t.highWaterMark) || t.ended)) return x("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? v(this) : _(this), null;
                            if (e = f(e, t), 0 === e && t.ended) return 0 === t.length && v(this), null;
                            var a = t.needReadable;
                            x("need readable", a), (0 === t.length || t.length - e < t.highWaterMark) && (a = !0, x("length less than watermark", a)), t.ended || t.reading ? (a = !1, x("reading or ended", a)) : a && (x("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, !t.reading && (e = f(r, t)));
                            var o;
                            return o = 0 < e ? T(e, t) : null, null === o ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (!t.ended && (t.needReadable = !0), r !== e && t.ended && v(this)), null !== o && this.emit("data", o), o;
                        }, s.prototype._read = function() {
                            X(this, new G("_read()"));
                        }, s.prototype.pipe = function(e, t) {
                            function r(e, t) {
                                x("onunpipe"), e === p && t && !1 === t.hasUnpiped && (t.hasUnpiped = !0, o());
                            }
                            function a() {
                                x("onend"), e.end();
                            }
                            function o() {
                                x("cleanup"), e.removeListener("close", l), e.removeListener("finish", c), e.removeListener("drain", h), e.removeListener("error", s), e.removeListener("unpipe", r), p.removeListener("end", a), p.removeListener("end", u), p.removeListener("data", d), m = !0, f.awaitDrain && (!e._writableState || e._writableState.needDrain) && h();
                            }
                            function d(t) {
                                x("ondata");
                                var n = e.write(t);
                                x("dest.write", n), !1 === n && ((1 === f.pipesCount && f.pipes === e || 1 < f.pipesCount && -1 !== L(f.pipes, e)) && !m && (x("false write response, pause", f.awaitDrain), f.awaitDrain++), p.pause());
                            }
                            function s(t) {
                                x("onerror", t), u(), e.removeListener("error", s), 0 === D(e, "error") && X(e, t);
                            }
                            function l() {
                                e.removeListener("finish", c), u();
                            }
                            function c() {
                                x("onfinish"), e.removeListener("close", l), u();
                            }
                            function u() {
                                x("unpipe"), p.unpipe(e);
                            }
                            var p = this, f = this._readableState;
                            switch(f.pipesCount){
                                case 0:
                                    f.pipes = e;
                                    break;
                                case 1:
                                    f.pipes = [
                                        f.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    f.pipes.push(e);
                            }
                            f.pipesCount += 1, x("pipe count=%d opts=%j", f.pipesCount, t);
                            var g = (!t || !1 !== t.end) && e !== n.stdout && e !== n.stderr, _ = g ? a : u;
                            f.endEmitted ? n.nextTick(_) : p.once("end", _), e.on("unpipe", r);
                            var h = y(p);
                            e.on("drain", h);
                            var m = !1;
                            return p.on("data", d), i(e, "error", s), e.once("close", l), e.once("finish", c), e.emit("pipe", p), f.flowing || (x("pipe resume"), p.resume()), e;
                        }, s.prototype.unpipe = function(e) {
                            var t = this._readableState, n = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, n), this);
                            if (!e) {
                                var r = t.pipes, a = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var o = 0; o < a; o++)r[o].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var d = L(t.pipes, e);
                            return -1 === d ? this : (t.pipes.splice(d, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, n), this);
                        }, s.prototype.on = function(e, t) {
                            var r = I.prototype.on.call(this, e, t), a = this._readableState;
                            return "data" === e ? (a.readableListening = 0 < this.listenerCount("readable"), !1 !== a.flowing && this.resume()) : "readable" == e && !a.endEmitted && !a.readableListening && (a.readableListening = a.needReadable = !0, a.flowing = !1, a.emittedReadable = !1, x("on readable", a.length, a.reading), a.length ? _(this) : !a.reading && n.nextTick(R, this)), r;
                        }, s.prototype.addListener = s.prototype.on, s.prototype.removeListener = function(e, t) {
                            var r = I.prototype.removeListener.call(this, e, t);
                            return "readable" === e && n.nextTick(C, this), r;
                        }, s.prototype.removeAllListeners = function(e) {
                            var t = I.prototype.removeAllListeners.apply(this, arguments);
                            return ("readable" === e || void 0 === e) && n.nextTick(C, this), t;
                        }, s.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (x("resume"), e.flowing = !e.readableListening, E(this, e)), e.paused = !1, this;
                        }, s.prototype.pause = function() {
                            return x("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (x("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, s.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, a = !1;
                            for(var o in e.on("end", function() {
                                if (x("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(n) {
                                if ((x("wrapped data"), r.decoder && (n = r.decoder.write(n)), !(r.objectMode && (null === n || void 0 === n))) && (r.objectMode || n && n.length)) {
                                    var o = t.push(n);
                                    o || (a = !0, e.pause());
                                }
                            }), e)void 0 === this[o] && "function" == typeof e[o] && (this[o] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(o));
                            for(var i = 0; i < $.length; i++)e.on($[i], this.emit.bind(this, $[i]));
                            return this._read = function(t) {
                                x("wrapped _read", t), a && (a = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (s.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === B && (B = e("./internal/streams/async_iterator")), B(this);
                        }), Object.defineProperty(s.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(s.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), s._fromList = T, Object.defineProperty(s.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (s.from = function(t, n) {
                            return void 0 === U && (U = e("./internal/streams/from")), U(s, t, n);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" == typeof $parcel$global ? "undefined" == typeof self ? "undefined" == typeof window ? {} : window : self : $parcel$global);
            },
            {
                "../errors": 15,
                "./_stream_duplex": 16,
                "./internal/streams/async_iterator": 21,
                "./internal/streams/buffer_list": 22,
                "./internal/streams/destroy": 23,
                "./internal/streams/from": 25,
                "./internal/streams/state": 27,
                "./internal/streams/stream": 28,
                _process: 12,
                buffer: 3,
                events: 7,
                inherits: 10,
                "string_decoder/": 31,
                util: 2
            }
        ],
        19: [
            function(e, t) {
                "use strict";
                function n(e, t) {
                    var n = this._transformState;
                    n.transforming = !1;
                    var r = n.writecb;
                    if (null === r) return this.emit("error", new s);
                    n.writechunk = null, n.writecb = null, null != t && this.push(t), r(e);
                    var a = this._readableState;
                    a.reading = !1, (a.needReadable || a.length < a.highWaterMark) && this._read(a.highWaterMark);
                }
                function r(e) {
                    return this instanceof r ? void (u.call(this, e), this._transformState = {
                        afterTransform: n.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a)) : new r(e);
                }
                function a() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? o(this, null, null) : this._flush(function(t, n) {
                        o(e, t, n);
                    });
                }
                function o(e, t, n) {
                    if (t) return e.emit("error", t);
                    if (null != n && e.push(n), e._writableState.length) throw new c;
                    if (e._transformState.transforming) throw new l;
                    return e.push(null);
                }
                t.exports = r;
                var i = e("../errors").codes, d = i.ERR_METHOD_NOT_IMPLEMENTED, s = i.ERR_MULTIPLE_CALLBACK, l = i.ERR_TRANSFORM_ALREADY_TRANSFORMING, c = i.ERR_TRANSFORM_WITH_LENGTH_0, u = e("./_stream_duplex");
                e("inherits")(r, u), r.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, u.prototype.push.call(this, e, t);
                }, r.prototype._transform = function(e, t, n) {
                    n(new d("_transform()"));
                }, r.prototype._write = function(e, t, n) {
                    var r = this._transformState;
                    if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
                        var a = this._readableState;
                        (r.needTransform || a.needReadable || a.length < a.highWaterMark) && this._read(a.highWaterMark);
                    }
                }, r.prototype._read = function() {
                    var e = this._transformState;
                    null === e.writechunk || e.transforming ? e.needTransform = !0 : (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform));
                }, r.prototype._destroy = function(e, t) {
                    u.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 15,
                "./_stream_duplex": 16,
                inherits: 10
            }
        ],
        20: [
            function(e, t) {
                (function(n, r) {
                    (function() {
                        "use strict";
                        function a(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                v(t, e);
                            };
                        }
                        function o(e) {
                            return x.from(e);
                        }
                        function i(e) {
                            return x.isBuffer(e) || e instanceof N;
                        }
                        function d() {}
                        function s(t, n, r) {
                            k = k || e("./_stream_duplex"), t = t || {}, "boolean" != typeof r && (r = n instanceof k), this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = P(this, t, "writableHighWaterMark", r), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var o = !1 === t.decodeStrings;
                            this.decodeStrings = !o, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                m(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
                        }
                        function l(t) {
                            k = k || e("./_stream_duplex");
                            var n = this instanceof k;
                            return n || V.call(l, this) ? void (this._writableState = new s(t, this, n), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), A.call(this)) : new l(t);
                        }
                        function c(e, t) {
                            var r = new W;
                            Y(e, r), n.nextTick(t, r);
                        }
                        function u(e, t, r, a) {
                            var o;
                            return null === r ? o = new q : "string" != typeof r && !t.objectMode && (o = new O("chunk", [
                                "string",
                                "Buffer"
                            ], r)), !o || (Y(e, o), n.nextTick(a, o), !1);
                        }
                        function p(e, t, n) {
                            return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = x.from(t, n)), t;
                        }
                        function f(e, t, n, r, a, o) {
                            if (!n) {
                                var i = p(t, r, a);
                                r !== i && (n = !0, a = "buffer", r = i);
                            }
                            var d = t.objectMode ? 1 : r.length;
                            t.length += d;
                            var s = t.length < t.highWaterMark;
                            if (s || (t.needDrain = !0), t.writing || t.corked) {
                                var l = t.lastBufferedRequest;
                                t.lastBufferedRequest = {
                                    chunk: r,
                                    encoding: a,
                                    isBuf: n,
                                    callback: o,
                                    next: null
                                }, l ? l.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                            } else g(e, t, !1, d, r, a, o);
                            return s;
                        }
                        function g(e, t, n, r, a, o, i) {
                            t.writelen = r, t.writecb = i, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new j("write")) : n ? e._writev(a, t.onwrite) : e._write(a, o, t.onwrite), t.sync = !1;
                        }
                        function _(e, t, r, a, o) {
                            --t.pendingcb, r ? (n.nextTick(o, a), n.nextTick(S, e, t), e._writableState.errorEmitted = !0, Y(e, a)) : (o(a), e._writableState.errorEmitted = !0, Y(e, a), S(e, t));
                        }
                        function h(e) {
                            e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                        }
                        function m(e, t) {
                            var r = e._writableState, a = r.sync, o = r.writecb;
                            if ("function" != typeof o) throw new B;
                            if (h(r), t) _(e, r, a, t, o);
                            else {
                                var i = R(r) || e.destroyed;
                                i || r.corked || r.bufferProcessing || !r.bufferedRequest || C(e, r), a ? n.nextTick(b, e, r, i, o) : b(e, r, i, o);
                            }
                        }
                        function b(e, t, n, r) {
                            n || y(e, t), t.pendingcb--, r(), S(e, t);
                        }
                        function y(e, t) {
                            0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                        }
                        function C(e, t) {
                            t.bufferProcessing = !0;
                            var n = t.bufferedRequest;
                            if (e._writev && n && n.next) {
                                var r = t.bufferedRequestCount, o = Array(r), i = t.corkedRequestsFree;
                                i.entry = n;
                                for(var d = 0, s = !0; n;)o[d] = n, n.isBuf || (s = !1), n = n.next, d += 1;
                                o.allBuffers = s, g(e, t, !0, t.length, o, "", i.finish), t.pendingcb++, t.lastBufferedRequest = null, i.next ? (t.corkedRequestsFree = i.next, i.next = null) : t.corkedRequestsFree = new a(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; n;){
                                    var l = n.chunk, c = n.encoding, u = n.callback, p = t.objectMode ? 1 : l.length;
                                    if (g(e, t, !1, p, l, c, u), n = n.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === n && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = n, t.bufferProcessing = !1;
                        }
                        function R(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function E(e, t) {
                            e._final(function(n) {
                                t.pendingcb--, n && Y(e, n), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function w(e, t) {
                            t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, n.nextTick(E, e, t)));
                        }
                        function S(e, t) {
                            var n = R(t);
                            if (n && (w(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var r = e._readableState;
                                (!r || r.autoDestroy && r.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        function T(e, t, r) {
                            t.ending = !0, S(e, t), r && (t.finished ? n.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
                        }
                        function v(e, t, n) {
                            var r = e.entry;
                            for(e.entry = null; r;){
                                var a = r.callback;
                                t.pendingcb--, a(n), r = r.next;
                            }
                            t.corkedRequestsFree.next = e;
                        }
                        t.exports = l;
                        var k;
                        l.WritableState = s;
                        var L = {
                            deprecate: e("util-deprecate")
                        }, A = e("./internal/streams/stream"), x = e("buffer").Buffer, N = r.Uint8Array || function() {}, D = e("./internal/streams/destroy"), I = e("./internal/streams/state"), P = I.getHighWaterMark, M = e("../errors").codes, O = M.ERR_INVALID_ARG_TYPE, F = M.ERR_METHOD_NOT_IMPLEMENTED, B = M.ERR_MULTIPLE_CALLBACK, U = M.ERR_STREAM_CANNOT_PIPE, j = M.ERR_STREAM_DESTROYED, q = M.ERR_STREAM_NULL_VALUES, W = M.ERR_STREAM_WRITE_AFTER_END, H = M.ERR_UNKNOWN_ENCODING, Y = D.errorOrDestroy;
                        e("inherits")(l, A), s.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(s.prototype, "buffer", {
                                    get: L.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }();
                        var V;
                        "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (V = Function.prototype[Symbol.hasInstance], Object.defineProperty(l, Symbol.hasInstance, {
                            value: function(e) {
                                return !!V.call(this, e) || !(this !== l) && e && e._writableState instanceof s;
                            }
                        })) : V = function(e) {
                            return e instanceof this;
                        }, l.prototype.pipe = function() {
                            Y(this, new U);
                        }, l.prototype.write = function(e, t, n) {
                            var r = this._writableState, a = !1, s = !r.objectMode && i(e);
                            return s && !x.isBuffer(e) && (e = o(e)), "function" == typeof t && (n = t, t = null), s ? t = "buffer" : !t && (t = r.defaultEncoding), "function" != typeof n && (n = d), r.ending ? c(this, n) : (s || u(this, r, e, n)) && (r.pendingcb++, a = f(this, r, s, e, t, n)), a;
                        }, l.prototype.cork = function() {
                            this._writableState.corked++;
                        }, l.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, !e.writing && !e.corked && !e.bufferProcessing && e.bufferedRequest && C(this, e));
                        }, l.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !(-1 < [
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()))) throw new H(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(l.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(l.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), l.prototype._write = function(e, t, n) {
                            n(new F("_write()"));
                        }, l.prototype._writev = null, l.prototype.end = function(e, t, n) {
                            var r = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null !== e && void 0 !== e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || T(this, r, n), this;
                        }, Object.defineProperty(l.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(l.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), l.prototype.destroy = D.destroy, l.prototype._undestroy = D.undestroy, l.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" == typeof $parcel$global ? "undefined" == typeof self ? "undefined" == typeof window ? {} : window : self : $parcel$global);
            },
            {
                "../errors": 15,
                "./_stream_duplex": 16,
                "./internal/streams/destroy": 23,
                "./internal/streams/state": 27,
                "./internal/streams/stream": 28,
                _process: 12,
                buffer: 3,
                inherits: 10,
                "util-deprecate": 32
            }
        ],
        21: [
            function(e, t) {
                (function(n) {
                    (function() {
                        "use strict";
                        function r(e, t, n) {
                            return t in e ? Object.defineProperty(e, t, {
                                value: n,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = n, e;
                        }
                        function a(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function o(e) {
                            var t = e[c];
                            if (null !== t) {
                                var n = e[h].read();
                                null !== n && (e[g] = null, e[c] = null, e[u] = null, t(a(n, !1)));
                            }
                        }
                        function i(e) {
                            n.nextTick(o, e);
                        }
                        function d(e, t) {
                            return function(n, r) {
                                e.then(function() {
                                    return t[f] ? void n(a(void 0, !0)) : void t[_](n, r);
                                }, r);
                            };
                        }
                        var s, l = e("./end-of-stream"), c = Symbol("lastResolve"), u = Symbol("lastReject"), p = Symbol("error"), f = Symbol("ended"), g = Symbol("lastPromise"), _ = Symbol("handlePromise"), h = Symbol("stream"), m = Object.getPrototypeOf(function() {}), b = Object.setPrototypeOf((s = {
                            get stream () {
                                return this[h];
                            },
                            next: function() {
                                var e = this, t = this[p];
                                if (null !== t) return Promise.reject(t);
                                if (this[f]) return Promise.resolve(a(void 0, !0));
                                if (this[h].destroyed) return new Promise(function(t, r) {
                                    n.nextTick(function() {
                                        e[p] ? r(e[p]) : t(a(void 0, !0));
                                    });
                                });
                                var r, o = this[g];
                                if (o) r = new Promise(d(o, this));
                                else {
                                    var i = this[h].read();
                                    if (null !== i) return Promise.resolve(a(i, !1));
                                    r = new Promise(this[_]);
                                }
                                return this[g] = r, r;
                            }
                        }, r(s, Symbol.asyncIterator, function() {
                            return this;
                        }), r(s, "return", function() {
                            var e = this;
                            return new Promise(function(t, n) {
                                e[h].destroy(null, function(e) {
                                    return e ? void n(e) : void t(a(void 0, !0));
                                });
                            });
                        }), s), m);
                        t.exports = function(e) {
                            var t, n = Object.create(b, (t = {}, r(t, h, {
                                value: e,
                                writable: !0
                            }), r(t, c, {
                                value: null,
                                writable: !0
                            }), r(t, u, {
                                value: null,
                                writable: !0
                            }), r(t, p, {
                                value: null,
                                writable: !0
                            }), r(t, f, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), r(t, _, {
                                value: function(e, t) {
                                    var r = n[h].read();
                                    r ? (n[g] = null, n[c] = null, n[u] = null, e(a(r, !1))) : (n[c] = e, n[u] = t);
                                },
                                writable: !0
                            }), t));
                            return n[g] = null, l(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = n[u];
                                    return null !== t && (n[g] = null, n[c] = null, n[u] = null, t(e)), void (n[p] = e);
                                }
                                var r = n[c];
                                null !== r && (n[g] = null, n[c] = null, n[u] = null, r(a(void 0, !0))), n[f] = !0;
                            }), e.on("readable", i.bind(null, n)), n;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 24,
                _process: 12
            }
        ],
        22: [
            function(e, t) {
                "use strict";
                function n(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function r(e) {
                    for(var t, r = 1; r < arguments.length; r++)t = null == arguments[r] ? {} : arguments[r], r % 2 ? n(Object(t), !0).forEach(function(n) {
                        a(e, n, t[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : n(Object(t)).forEach(function(n) {
                        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
                    });
                    return e;
                }
                function a(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function o(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function i(e, t) {
                    for(var n, r = 0; r < t.length; r++)n = t[r], n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
                function d(e, t, n) {
                    return t && i(e.prototype, t), n && i(e, n), e;
                }
                function s(e, t, n) {
                    u.prototype.copy.call(e, t, n);
                }
                var l = e("buffer"), u = l.Buffer, p = e("util"), f = p.inspect, g = f && f.custom || "inspect";
                t.exports = function() {
                    function e() {
                        o(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return d(e, [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                0 < this.length ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return this.head = 1 === this.length ? this.tail = null : this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, n = "" + t.data; t = t.next;)n += e + t.data;
                                return n;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return u.alloc(0);
                                for(var t = u.allocUnsafe(e >>> 0), n = this.head, r = 0; n;)s(n.data, t, r), r += n.data.length, n = n.next;
                                return t;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var n;
                                return e < this.head.data.length ? (n = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : e === this.head.data.length ? n = this.shift() : n = t ? this._getString(e) : this._getBuffer(e), n;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, a = t.data;
                                for(e -= a.length; t = t.next;){
                                    var o = t.data, i = e > o.length ? o.length : e;
                                    if (a += i === o.length ? o : o.slice(0, e), e -= i, 0 === e) {
                                        i === o.length ? (++r, this.head = t.next ? t.next : this.tail = null) : (this.head = t, t.data = o.slice(i));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, a;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = u.allocUnsafe(e), r = this.head, a = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var o = r.data, i = e > o.length ? o.length : e;
                                    if (o.copy(t, t.length - e, 0, i), e -= i, 0 === e) {
                                        i === o.length ? (++a, this.head = r.next ? r.next : this.tail = null) : (this.head = r, r.data = o.slice(i));
                                        break;
                                    }
                                    ++a;
                                }
                                return this.length -= a, t;
                            }
                        },
                        {
                            key: g,
                            value: function(e, t) {
                                return f(this, r({}, t, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ]), e;
                }();
            },
            {
                buffer: 3,
                util: 2
            }
        ],
        23: [
            function(e, t) {
                (function(e) {
                    (function() {
                        "use strict";
                        function n(e, t) {
                            a(e, t), r(e);
                        }
                        function r(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function a(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, o) {
                                var i = this, d = this._readableState && this._readableState.destroyed, s = this._writableState && this._writableState.destroyed;
                                return d || s ? (o ? o(t) : t && (this._writableState ? !this._writableState.errorEmitted && (this._writableState.errorEmitted = !0, e.nextTick(a, this, t)) : e.nextTick(a, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !o && t ? i._writableState ? i._writableState.errorEmitted ? e.nextTick(r, i) : (i._writableState.errorEmitted = !0, e.nextTick(n, i, t)) : e.nextTick(n, i, t) : o ? (e.nextTick(r, i), o(t)) : e.nextTick(r, i);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var n = e._readableState, r = e._writableState;
                                n && n.autoDestroy || r && r.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 12
            }
        ],
        24: [
            function(e, t) {
                "use strict";
                function n(e) {
                    var t = !1;
                    return function() {
                        if (!t) {
                            t = !0;
                            for(var n = arguments.length, r = Array(n), a = 0; a < n; a++)r[a] = arguments[a];
                            e.apply(this, r);
                        }
                    };
                }
                function r() {}
                function a(e) {
                    return e.setHeader && "function" == typeof e.abort;
                }
                function o(e, t, d) {
                    if ("function" == typeof t) return o(e, null, t);
                    t || (t = {}), d = n(d || r);
                    var s = t.readable || !1 !== t.readable && e.readable, l = t.writable || !1 !== t.writable && e.writable, c = function() {
                        e.writable || p();
                    }, u = e._writableState && e._writableState.finished, p = function() {
                        l = !1, u = !0, s || d.call(e);
                    }, f = e._readableState && e._readableState.endEmitted, g = function() {
                        s = !1, f = !0, l || d.call(e);
                    }, _ = function(t) {
                        d.call(e, t);
                    }, h = function() {
                        var t;
                        return s && !f ? (e._readableState && e._readableState.ended || (t = new i), d.call(e, t)) : l && !u ? (e._writableState && e._writableState.ended || (t = new i), d.call(e, t)) : void 0;
                    }, m = function() {
                        e.req.on("finish", p);
                    };
                    return a(e) ? (e.on("complete", p), e.on("abort", h), e.req ? m() : e.on("request", m)) : l && !e._writableState && (e.on("end", c), e.on("close", c)), e.on("end", g), e.on("finish", p), !1 !== t.error && e.on("error", _), e.on("close", h), function() {
                        e.removeListener("complete", p), e.removeListener("abort", h), e.removeListener("request", m), e.req && e.req.removeListener("finish", p), e.removeListener("end", c), e.removeListener("close", c), e.removeListener("finish", p), e.removeListener("end", g), e.removeListener("error", _), e.removeListener("close", h);
                    };
                }
                var i = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                t.exports = o;
            },
            {
                "../../../errors": 15
            }
        ],
        25: [
            function(e, t) {
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        26: [
            function(e, t) {
                "use strict";
                function n(e) {
                    var t = !1;
                    return function() {
                        t || (t = !0, e.apply(void 0, arguments));
                    };
                }
                function r(e) {
                    if (e) throw e;
                }
                function a(e) {
                    return e.setHeader && "function" == typeof e.abort;
                }
                function o(t, r, o, i) {
                    i = n(i);
                    var d = !1;
                    t.on("close", function() {
                        d = !0;
                    }), l === void 0 && (l = e("./end-of-stream")), l(t, {
                        readable: r,
                        writable: o
                    }, function(e) {
                        return e ? i(e) : void (d = !0, i());
                    });
                    var s = !1;
                    return function(e) {
                        if (!d) return s ? void 0 : (s = !0, a(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void i(e || new p("pipe")));
                    };
                }
                function i(e) {
                    e();
                }
                function d(e, t) {
                    return e.pipe(t);
                }
                function s(e) {
                    return e.length ? "function" == typeof e[e.length - 1] ? e.pop() : r : r;
                }
                var l, c = e("../../../errors").codes, u = c.ERR_MISSING_ARGS, p = c.ERR_STREAM_DESTROYED;
                t.exports = function() {
                    for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    var r = s(t);
                    if (Array.isArray(t[0]) && (t = t[0]), 2 > t.length) throw new u("streams");
                    var a, l = t.map(function(e, n) {
                        var d = n < t.length - 1;
                        return o(e, d, 0 < n, function(e) {
                            a || (a = e), e && l.forEach(i), d || (l.forEach(i), r(a));
                        });
                    });
                    return t.reduce(d);
                };
            },
            {
                "../../../errors": 15,
                "./end-of-stream": 24
            }
        ],
        27: [
            function(e, n) {
                "use strict";
                function r(e, t, n) {
                    return null == e.highWaterMark ? t ? e[n] : null : e.highWaterMark;
                }
                var a = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                n.exports = {
                    getHighWaterMark: function(e, n, o, i) {
                        var d = r(n, i, o);
                        if (null != d) {
                            if (!(isFinite(d) && t(d) === d) || 0 > d) {
                                var s = i ? o : "highWaterMark";
                                throw new a(s, d);
                            }
                            return t(d);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 15
            }
        ],
        28: [
            function(e, t) {
                t.exports = e("events").EventEmitter;
            },
            {
                events: 7
            }
        ],
        29: [
            function(e, t, n) {
                n = t.exports = e("./lib/_stream_readable.js"), n.Stream = n, n.Readable = n, n.Writable = e("./lib/_stream_writable.js"), n.Duplex = e("./lib/_stream_duplex.js"), n.Transform = e("./lib/_stream_transform.js"), n.PassThrough = e("./lib/_stream_passthrough.js"), n.finished = e("./lib/internal/streams/end-of-stream.js"), n.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 16,
                "./lib/_stream_passthrough.js": 17,
                "./lib/_stream_readable.js": 18,
                "./lib/_stream_transform.js": 19,
                "./lib/_stream_writable.js": 20,
                "./lib/internal/streams/end-of-stream.js": 24,
                "./lib/internal/streams/pipeline.js": 26
            }
        ],
        30: [
            function(e, t, n) {
                function r(e, t) {
                    for(var n in e)t[n] = e[n];
                }
                function a(e, t, n) {
                    return i(e, t, n);
                } /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ 
                var o = e("buffer"), i = o.Buffer;
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = o : (r(o, n), n.Buffer = a), a.prototype = Object.create(i.prototype), r(i, a), a.from = function(e, t, n) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, n);
                }, a.alloc = function(e, t, n) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var r = i(e);
                    return void 0 === t ? r.fill(0) : "string" == typeof n ? r.fill(t, n) : r.fill(t), r;
                }, a.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, a.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return o.SlowBuffer(e);
                };
            },
            {
                buffer: 3
            }
        ],
        31: [
            function(e, t, n) {
                "use strict";
                function r(e) {
                    if (!e) return "utf8";
                    for(var t;;)switch(e){
                        case "utf8":
                        case "utf-8":
                            return "utf8";
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return "utf16le";
                        case "latin1":
                        case "binary":
                            return "latin1";
                        case "base64":
                        case "ascii":
                        case "hex":
                            return e;
                        default:
                            if (t) return;
                            e = ("" + e).toLowerCase(), t = !0;
                    }
                }
                function a(e) {
                    var t = r(e);
                    if ("string" != typeof t && (m.isEncoding === b || !b(e))) throw new Error("Unknown encoding: " + e);
                    return t || e;
                }
                function o(e) {
                    this.encoding = a(e);
                    var t;
                    switch(this.encoding){
                        case "utf16le":
                            this.text = u, this.end = p, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = c, t = 4;
                            break;
                        case "base64":
                            this.text = f, this.end = g, t = 3;
                            break;
                        default:
                            return this.write = _, void (this.end = h);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = m.allocUnsafe(t);
                }
                function d(e) {
                    if (127 >= e) return 0;
                    return 6 == e >> 5 ? 2 : 14 == e >> 4 ? 3 : 30 == e >> 3 ? 4 : 2 == e >> 6 ? -1 : -2;
                }
                function s(e, t, n) {
                    var r = t.length - 1;
                    if (r < n) return 0;
                    var a = d(t[r]);
                    return 0 <= a ? (0 < a && (e.lastNeed = a - 1), a) : --r < n || -2 === a ? 0 : (a = d(t[r]), 0 <= a) ? (0 < a && (e.lastNeed = a - 2), a) : --r < n || -2 === a ? 0 : (a = d(t[r]), 0 <= a ? (0 < a && (2 === a ? a = 0 : e.lastNeed = a - 3), a) : 0);
                }
                function l(e, t) {
                    if (128 != (192 & t[0])) return e.lastNeed = 0, "�";
                    if (1 < e.lastNeed && 1 < t.length) {
                        if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
                        if (2 < e.lastNeed && 2 < t.length && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
                    }
                }
                function c(e) {
                    var t = this.lastTotal - this.lastNeed, n = l(this, e, t);
                    return void 0 === n ? this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : void (e.copy(this.lastChar, t, 0, e.length), this.lastNeed -= e.length) : n;
                }
                function u(e, t) {
                    if (0 == (e.length - t) % 2) {
                        var n = e.toString("utf16le", t);
                        if (n) {
                            var r = n.charCodeAt(n.length - 1);
                            if (55296 <= r && 56319 >= r) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], n.slice(0, -1);
                        }
                        return n;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function p(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var n = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, n);
                    }
                    return t;
                }
                function f(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 == r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 == r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function g(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function _(e) {
                    return e.toString(this.encoding);
                }
                function h(e) {
                    return e && e.length ? this.write(e) : "";
                }
                var m = e("safe-buffer").Buffer, b = m.isEncoding || function(e) {
                    switch(e = "" + e, e && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                n.StringDecoder = o, o.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, n;
                    if (this.lastNeed) {
                        if (t = this.fillLast(e), void 0 === t) return "";
                        n = this.lastNeed, this.lastNeed = 0;
                    } else n = 0;
                    return n < e.length ? t ? t + this.text(e, n) : this.text(e, n) : t || "";
                }, o.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "�" : t;
                }, o.prototype.text = function(e, t) {
                    var n = s(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = n;
                    var r = e.length - (n - this.lastNeed);
                    return e.copy(this.lastChar, 0, r), e.toString("utf8", t, r);
                }, o.prototype.fillLast = function(e) {
                    return this.lastNeed <= e.length ? (e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : void (e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length);
                };
            },
            {
                "safe-buffer": 30
            }
        ],
        32: [
            function(e, t) {
                (function(e) {
                    (function() {
                        function n(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var n = e.localStorage[t];
                            return null != n && "true" === (n + "").toLowerCase();
                        }
                        t.exports = function(e, t) {
                            function r() {
                                if (!a) {
                                    if (n("throwDeprecation")) throw new Error(t);
                                    else n("traceDeprecation") ? console.trace(t) : console.warn(t);
                                    a = !0;
                                }
                                return e.apply(this, arguments);
                            }
                            if (n("noDeprecation")) return e;
                            var a = !1;
                            return r;
                        };
                    }).call(this);
                }).call(this, "undefined" == typeof $parcel$global ? "undefined" == typeof self ? "undefined" == typeof window ? {} : window : self : $parcel$global);
            },
            {}
        ],
        "/": [
            function(e, t) {
                function n(e) {
                    return e.replace(/a=ice-options:trickle\s\n/g, "");
                }
                function r(e) {
                    console.warn(e);
                } /*! simple-peer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ 
                const a = e("debug")("simple-peer"), o = e("get-browser-rtc"), i = e("randombytes"), d = e("readable-stream"), s = e("queue-microtask"), l = e("err-code"), { Buffer: c  } = e("buffer"), u = 65536;
                class p extends d.Duplex {
                    constructor(e){
                        if (e = Object.assign({
                            allowHalfOpen: !1
                        }, e), super(e), this._id = i(4).toString("hex").slice(0, 7), this._debug("new peer %o", e), this.channelName = e.initiator ? e.channelName || i(20).toString("hex") : null, this.initiator = e.initiator || !1, this.channelConfig = e.channelConfig || p.channelConfig, this.channelNegotiated = this.channelConfig.negotiated, this.config = Object.assign({}, p.config, e.config), this.offerOptions = e.offerOptions || {}, this.answerOptions = e.answerOptions || {}, this.sdpTransform = e.sdpTransform || ((e)=>e), this.streams = e.streams || (e.stream ? [
                            e.stream
                        ] : []), this.trickle = void 0 === e.trickle || e.trickle, this.allowHalfTrickle = void 0 !== e.allowHalfTrickle && e.allowHalfTrickle, this.iceCompleteTimeout = e.iceCompleteTimeout || 5000, this.destroyed = !1, this.destroying = !1, this._connected = !1, this.remoteAddress = void 0, this.remoteFamily = void 0, this.remotePort = void 0, this.localAddress = void 0, this.localFamily = void 0, this.localPort = void 0, this._wrtc = e.wrtc && "object" == typeof e.wrtc ? e.wrtc : o(), !this._wrtc) {
                            if ("undefined" == typeof window) throw l(new Error("No WebRTC support: Specify `opts.wrtc` option in this environment"), "ERR_WEBRTC_SUPPORT");
                            else throw l(new Error("No WebRTC support: Not a supported browser"), "ERR_WEBRTC_SUPPORT");
                        }
                        this._pcReady = !1, this._channelReady = !1, this._iceComplete = !1, this._iceCompleteTimer = null, this._channel = null, this._pendingCandidates = [], this._isNegotiating = !1, this._firstNegotiation = !0, this._batchedNegotiation = !1, this._queuedNegotiation = !1, this._sendersAwaitingStable = [], this._senderMap = new Map, this._closingInterval = null, this._remoteTracks = [], this._remoteStreams = [], this._chunk = null, this._cb = null, this._interval = null;
                        try {
                            this._pc = new this._wrtc.RTCPeerConnection(this.config);
                        } catch (e) {
                            return void this.destroy(l(e, "ERR_PC_CONSTRUCTOR"));
                        }
                        this._isReactNativeWebrtc = "number" == typeof this._pc._peerConnectionId, this._pc.oniceconnectionstatechange = ()=>{
                            this._onIceStateChange();
                        }, this._pc.onicegatheringstatechange = ()=>{
                            this._onIceStateChange();
                        }, this._pc.onconnectionstatechange = ()=>{
                            this._onConnectionStateChange();
                        }, this._pc.onsignalingstatechange = ()=>{
                            this._onSignalingStateChange();
                        }, this._pc.onicecandidate = (e)=>{
                            this._onIceCandidate(e);
                        }, "object" == typeof this._pc.peerIdentity && this._pc.peerIdentity.catch((e)=>{
                            this.destroy(l(e, "ERR_PC_PEER_IDENTITY"));
                        }), this.initiator || this.channelNegotiated ? this._setupData({
                            channel: this._pc.createDataChannel(this.channelName, this.channelConfig)
                        }) : this._pc.ondatachannel = (e)=>{
                            this._setupData(e);
                        }, this.streams && this.streams.forEach((e)=>{
                            this.addStream(e);
                        }), this._pc.ontrack = (e)=>{
                            this._onTrack(e);
                        }, this._debug("initial negotiation"), this._needsNegotiation(), this._onFinishBound = ()=>{
                            this._onFinish();
                        }, this.once("finish", this._onFinishBound);
                    }
                    get bufferSize() {
                        return this._channel && this._channel.bufferedAmount || 0;
                    }
                    get connected() {
                        return this._connected && "open" === this._channel.readyState;
                    }
                    address() {
                        return {
                            port: this.localPort,
                            family: this.localFamily,
                            address: this.localAddress
                        };
                    }
                    signal(e) {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot signal after peer is destroyed"), "ERR_DESTROYED");
                            if ("string" == typeof e) try {
                                e = JSON.parse(e);
                            } catch (t) {
                                e = {};
                            }
                            this._debug("signal()"), e.renegotiate && this.initiator && (this._debug("got request to renegotiate"), this._needsNegotiation()), e.transceiverRequest && this.initiator && (this._debug("got request for transceiver"), this.addTransceiver(e.transceiverRequest.kind, e.transceiverRequest.init)), e.candidate && (this._pc.remoteDescription && this._pc.remoteDescription.type ? this._addIceCandidate(e.candidate) : this._pendingCandidates.push(e.candidate)), e.sdp && this._pc.setRemoteDescription(new this._wrtc.RTCSessionDescription(e)).then(()=>{
                                this.destroyed || (this._pendingCandidates.forEach((e)=>{
                                    this._addIceCandidate(e);
                                }), this._pendingCandidates = [], "offer" === this._pc.remoteDescription.type && this._createAnswer());
                            }).catch((e)=>{
                                this.destroy(l(e, "ERR_SET_REMOTE_DESCRIPTION"));
                            }), e.sdp || e.candidate || e.renegotiate || e.transceiverRequest || this.destroy(l(new Error("signal() called with invalid signal data"), "ERR_SIGNALING"));
                        }
                    }
                    _addIceCandidate(e) {
                        const t = new this._wrtc.RTCIceCandidate(e);
                        this._pc.addIceCandidate(t).catch((e)=>{
                            !t.address || t.address.endsWith(".local") ? r("Ignoring unsupported ICE candidate.") : this.destroy(l(e, "ERR_ADD_ICE_CANDIDATE"));
                        });
                    }
                    send(e) {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot send after peer is destroyed"), "ERR_DESTROYED");
                            this._channel.send(e);
                        }
                    }
                    addTransceiver(e, t) {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot addTransceiver after peer is destroyed"), "ERR_DESTROYED");
                            if (this._debug("addTransceiver()"), this.initiator) try {
                                this._pc.addTransceiver(e, t), this._needsNegotiation();
                            } catch (e) {
                                this.destroy(l(e, "ERR_ADD_TRANSCEIVER"));
                            }
                            else this.emit("signal", {
                                type: "transceiverRequest",
                                transceiverRequest: {
                                    kind: e,
                                    init: t
                                }
                            });
                        }
                    }
                    addStream(e) {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot addStream after peer is destroyed"), "ERR_DESTROYED");
                            this._debug("addStream()"), e.getTracks().forEach((t)=>{
                                this.addTrack(t, e);
                            });
                        }
                    }
                    addTrack(e, t) {
                        if (this.destroying) return;
                        if (this.destroyed) throw l(new Error("cannot addTrack after peer is destroyed"), "ERR_DESTROYED");
                        this._debug("addTrack()");
                        const n = this._senderMap.get(e) || new Map;
                        let r = n.get(t);
                        if (!r) r = this._pc.addTrack(e, t), n.set(t, r), this._senderMap.set(e, n), this._needsNegotiation();
                        else if (r.removed) throw l(new Error("Track has been removed. You should enable/disable tracks that you want to re-add."), "ERR_SENDER_REMOVED");
                        else throw l(new Error("Track has already been added to that stream."), "ERR_SENDER_ALREADY_ADDED");
                    }
                    replaceTrack(e, t, n) {
                        if (this.destroying) return;
                        if (this.destroyed) throw l(new Error("cannot replaceTrack after peer is destroyed"), "ERR_DESTROYED");
                        this._debug("replaceTrack()");
                        const r = this._senderMap.get(e), a = r ? r.get(n) : null;
                        if (!a) throw l(new Error("Cannot replace track that was never added."), "ERR_TRACK_NOT_ADDED");
                        t && this._senderMap.set(t, r), null == a.replaceTrack ? this.destroy(l(new Error("replaceTrack is not supported in this browser"), "ERR_UNSUPPORTED_REPLACETRACK")) : a.replaceTrack(t);
                    }
                    removeTrack(e, t) {
                        if (this.destroying) return;
                        if (this.destroyed) throw l(new Error("cannot removeTrack after peer is destroyed"), "ERR_DESTROYED");
                        this._debug("removeSender()");
                        const n = this._senderMap.get(e), r = n ? n.get(t) : null;
                        if (!r) throw l(new Error("Cannot remove track that was never added."), "ERR_TRACK_NOT_ADDED");
                        try {
                            r.removed = !0, this._pc.removeTrack(r);
                        } catch (e) {
                            "NS_ERROR_UNEXPECTED" === e.name ? this._sendersAwaitingStable.push(r) : this.destroy(l(e, "ERR_REMOVE_TRACK"));
                        }
                        this._needsNegotiation();
                    }
                    removeStream(e) {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot removeStream after peer is destroyed"), "ERR_DESTROYED");
                            this._debug("removeSenders()"), e.getTracks().forEach((t)=>{
                                this.removeTrack(t, e);
                            });
                        }
                    }
                    _needsNegotiation() {
                        this._debug("_needsNegotiation"), this._batchedNegotiation || (this._batchedNegotiation = !0, s(()=>{
                            this._batchedNegotiation = !1, this.initiator || !this._firstNegotiation ? (this._debug("starting batched negotiation"), this.negotiate()) : this._debug("non-initiator initial negotiation request discarded"), this._firstNegotiation = !1;
                        }));
                    }
                    negotiate() {
                        if (!this.destroying) {
                            if (this.destroyed) throw l(new Error("cannot negotiate after peer is destroyed"), "ERR_DESTROYED");
                            this.initiator ? this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("start negotiation"), setTimeout(()=>{
                                this._createOffer();
                            }, 0)) : this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("requesting negotiation from initiator"), this.emit("signal", {
                                type: "renegotiate",
                                renegotiate: !0
                            })), this._isNegotiating = !0;
                        }
                    }
                    destroy(e) {
                        this._destroy(e, ()=>{});
                    }
                    _destroy(e, t) {
                        this.destroyed || this.destroying || (this.destroying = !0, this._debug("destroying (error: %s)", e && (e.message || e)), s(()=>{
                            if (this.destroyed = !0, this.destroying = !1, this._debug("destroy (error: %s)", e && (e.message || e)), this.readable = this.writable = !1, this._readableState.ended || this.push(null), this._writableState.finished || this.end(), this._connected = !1, this._pcReady = !1, this._channelReady = !1, this._remoteTracks = null, this._remoteStreams = null, this._senderMap = null, clearInterval(this._closingInterval), this._closingInterval = null, clearInterval(this._interval), this._interval = null, this._chunk = null, this._cb = null, this._onFinishBound && this.removeListener("finish", this._onFinishBound), this._onFinishBound = null, this._channel) {
                                try {
                                    this._channel.close();
                                } catch (e) {}
                                this._channel.onmessage = null, this._channel.onopen = null, this._channel.onclose = null, this._channel.onerror = null;
                            }
                            if (this._pc) {
                                try {
                                    this._pc.close();
                                } catch (e) {}
                                this._pc.oniceconnectionstatechange = null, this._pc.onicegatheringstatechange = null, this._pc.onsignalingstatechange = null, this._pc.onicecandidate = null, this._pc.ontrack = null, this._pc.ondatachannel = null;
                            }
                            this._pc = null, this._channel = null, e && this.emit("error", e), this.emit("close"), t();
                        }));
                    }
                    _setupData(e) {
                        if (!e.channel) return this.destroy(l(new Error("Data channel event is missing `channel` property"), "ERR_DATA_CHANNEL"));
                        this._channel = e.channel, this._channel.binaryType = "arraybuffer", "number" == typeof this._channel.bufferedAmountLowThreshold && (this._channel.bufferedAmountLowThreshold = u), this.channelName = this._channel.label, this._channel.onmessage = (e)=>{
                            this._onChannelMessage(e);
                        }, this._channel.onbufferedamountlow = ()=>{
                            this._onChannelBufferedAmountLow();
                        }, this._channel.onopen = ()=>{
                            this._onChannelOpen();
                        }, this._channel.onclose = ()=>{
                            this._onChannelClose();
                        }, this._channel.onerror = (e)=>{
                            const t = e.error instanceof Error ? e.error : new Error(`Datachannel error: ${e.message} ${e.filename}:${e.lineno}:${e.colno}`);
                            this.destroy(l(t, "ERR_DATA_CHANNEL"));
                        };
                        let t = !1;
                        this._closingInterval = setInterval(()=>{
                            this._channel && "closing" === this._channel.readyState ? (t && this._onChannelClose(), t = !0) : t = !1;
                        }, 5000);
                    }
                    _read() {}
                    _write(e, t, n) {
                        if (this.destroyed) return n(l(new Error("cannot write after peer is destroyed"), "ERR_DATA_CHANNEL"));
                        if (this._connected) {
                            try {
                                this.send(e);
                            } catch (e) {
                                return this.destroy(l(e, "ERR_DATA_CHANNEL"));
                            }
                            this._channel.bufferedAmount > u ? (this._debug("start backpressure: bufferedAmount %d", this._channel.bufferedAmount), this._cb = n) : n(null);
                        } else this._debug("write before connect"), this._chunk = e, this._cb = n;
                    }
                    _onFinish() {
                        if (!this.destroyed) {
                            const e = ()=>{
                                setTimeout(()=>this.destroy(), 1e3);
                            };
                            this._connected ? e() : this.once("connect", e);
                        }
                    }
                    _startIceCompleteTimeout() {
                        this.destroyed || this._iceCompleteTimer || (this._debug("started iceComplete timeout"), this._iceCompleteTimer = setTimeout(()=>{
                            this._iceComplete || (this._iceComplete = !0, this._debug("iceComplete timeout completed"), this.emit("iceTimeout"), this.emit("_iceComplete"));
                        }, this.iceCompleteTimeout));
                    }
                    _createOffer() {
                        this.destroyed || this._pc.createOffer(this.offerOptions).then((e)=>{
                            if (this.destroyed) return;
                            this.trickle || this.allowHalfTrickle || (e.sdp = n(e.sdp)), e.sdp = this.sdpTransform(e.sdp);
                            const t = ()=>{
                                if (!this.destroyed) {
                                    const t = this._pc.localDescription || e;
                                    this._debug("signal"), this.emit("signal", {
                                        type: t.type,
                                        sdp: t.sdp
                                    });
                                }
                            };
                            this._pc.setLocalDescription(e).then(()=>{
                                this._debug("createOffer success"), this.destroyed || (this.trickle || this._iceComplete ? t() : this.once("_iceComplete", t));
                            }).catch((e)=>{
                                this.destroy(l(e, "ERR_SET_LOCAL_DESCRIPTION"));
                            });
                        }).catch((e)=>{
                            this.destroy(l(e, "ERR_CREATE_OFFER"));
                        });
                    }
                    _requestMissingTransceivers() {
                        this._pc.getTransceivers && this._pc.getTransceivers().forEach((e)=>{
                            e.mid || !e.sender.track || e.requested || (e.requested = !0, this.addTransceiver(e.sender.track.kind));
                        });
                    }
                    _createAnswer() {
                        this.destroyed || this._pc.createAnswer(this.answerOptions).then((e)=>{
                            if (this.destroyed) return;
                            this.trickle || this.allowHalfTrickle || (e.sdp = n(e.sdp)), e.sdp = this.sdpTransform(e.sdp);
                            const t = ()=>{
                                if (!this.destroyed) {
                                    const t = this._pc.localDescription || e;
                                    this._debug("signal"), this.emit("signal", {
                                        type: t.type,
                                        sdp: t.sdp
                                    }), this.initiator || this._requestMissingTransceivers();
                                }
                            };
                            this._pc.setLocalDescription(e).then(()=>{
                                this.destroyed || (this.trickle || this._iceComplete ? t() : this.once("_iceComplete", t));
                            }).catch((e)=>{
                                this.destroy(l(e, "ERR_SET_LOCAL_DESCRIPTION"));
                            });
                        }).catch((e)=>{
                            this.destroy(l(e, "ERR_CREATE_ANSWER"));
                        });
                    }
                    _onConnectionStateChange() {
                        this.destroyed || "failed" === this._pc.connectionState && this.destroy(l(new Error("Connection failed."), "ERR_CONNECTION_FAILURE"));
                    }
                    _onIceStateChange() {
                        if (this.destroyed) return;
                        const e = this._pc.iceConnectionState, t = this._pc.iceGatheringState;
                        this._debug("iceStateChange (connection: %s) (gathering: %s)", e, t), this.emit("iceStateChange", e, t), ("connected" === e || "completed" === e) && (this._pcReady = !0, this._maybeReady()), "failed" === e && this.destroy(l(new Error("Ice connection failed."), "ERR_ICE_CONNECTION_FAILURE")), "closed" === e && this.destroy(l(new Error("Ice connection closed."), "ERR_ICE_CONNECTION_CLOSED"));
                    }
                    getStats(e) {
                        const t = (e)=>("[object Array]" === Object.prototype.toString.call(e.values) && e.values.forEach((t)=>{
                                Object.assign(e, t);
                            }), e);
                        0 === this._pc.getStats.length || this._isReactNativeWebrtc ? this._pc.getStats().then((n)=>{
                            const r = [];
                            n.forEach((e)=>{
                                r.push(t(e));
                            }), e(null, r);
                        }, (t)=>e(t)) : 0 < this._pc.getStats.length ? this._pc.getStats((n)=>{
                            if (this.destroyed) return;
                            const r = [];
                            n.result().forEach((e)=>{
                                const n = {};
                                e.names().forEach((t)=>{
                                    n[t] = e.stat(t);
                                }), n.id = e.id, n.type = e.type, n.timestamp = e.timestamp, r.push(t(n));
                            }), e(null, r);
                        }, (t)=>e(t)) : e(null, []);
                    }
                    _maybeReady() {
                        if (this._debug("maybeReady pc %s channel %s", this._pcReady, this._channelReady), this._connected || this._connecting || !this._pcReady || !this._channelReady) return;
                        this._connecting = !0;
                        const e = ()=>{
                            this.destroyed || this.getStats((t, n)=>{
                                if (this.destroyed) return;
                                t && (n = []);
                                const r = {}, a = {}, o = {};
                                let i = !1;
                                n.forEach((e)=>{
                                    ("remotecandidate" === e.type || "remote-candidate" === e.type) && (r[e.id] = e), ("localcandidate" === e.type || "local-candidate" === e.type) && (a[e.id] = e), ("candidatepair" === e.type || "candidate-pair" === e.type) && (o[e.id] = e);
                                });
                                const d = (e)=>{
                                    i = !0;
                                    let t = a[e.localCandidateId];
                                    t && (t.ip || t.address) ? (this.localAddress = t.ip || t.address, this.localPort = +t.port) : t && t.ipAddress ? (this.localAddress = t.ipAddress, this.localPort = +t.portNumber) : "string" == typeof e.googLocalAddress && (t = e.googLocalAddress.split(":"), this.localAddress = t[0], this.localPort = +t[1]), this.localAddress && (this.localFamily = this.localAddress.includes(":") ? "IPv6" : "IPv4");
                                    let n = r[e.remoteCandidateId];
                                    n && (n.ip || n.address) ? (this.remoteAddress = n.ip || n.address, this.remotePort = +n.port) : n && n.ipAddress ? (this.remoteAddress = n.ipAddress, this.remotePort = +n.portNumber) : "string" == typeof e.googRemoteAddress && (n = e.googRemoteAddress.split(":"), this.remoteAddress = n[0], this.remotePort = +n[1]), this.remoteAddress && (this.remoteFamily = this.remoteAddress.includes(":") ? "IPv6" : "IPv4"), this._debug("connect local: %s:%s remote: %s:%s", this.localAddress, this.localPort, this.remoteAddress, this.remotePort);
                                };
                                if (n.forEach((e)=>{
                                    "transport" === e.type && e.selectedCandidatePairId && d(o[e.selectedCandidatePairId]), ("googCandidatePair" === e.type && "true" === e.googActiveConnection || ("candidatepair" === e.type || "candidate-pair" === e.type) && e.selected) && d(e);
                                }), !i && (!Object.keys(o).length || Object.keys(a).length)) return void setTimeout(e, 100);
                                if (this._connecting = !1, this._connected = !0, this._chunk) {
                                    try {
                                        this.send(this._chunk);
                                    } catch (e) {
                                        return this.destroy(l(e, "ERR_DATA_CHANNEL"));
                                    }
                                    this._chunk = null, this._debug('sent chunk from "write before connect"');
                                    const e = this._cb;
                                    this._cb = null, e(null);
                                }
                                "number" != typeof this._channel.bufferedAmountLowThreshold && (this._interval = setInterval(()=>this._onInterval(), 150), this._interval.unref && this._interval.unref()), this._debug("connect"), this.emit("connect");
                            });
                        };
                        e();
                    }
                    _onInterval() {
                        this._cb && this._channel && !(this._channel.bufferedAmount > u) && this._onChannelBufferedAmountLow();
                    }
                    _onSignalingStateChange() {
                        this.destroyed || ("stable" === this._pc.signalingState && (this._isNegotiating = !1, this._debug("flushing sender queue", this._sendersAwaitingStable), this._sendersAwaitingStable.forEach((e)=>{
                            this._pc.removeTrack(e), this._queuedNegotiation = !0;
                        }), this._sendersAwaitingStable = [], this._queuedNegotiation ? (this._debug("flushing negotiation queue"), this._queuedNegotiation = !1, this._needsNegotiation()) : (this._debug("negotiated"), this.emit("negotiated"))), this._debug("signalingStateChange %s", this._pc.signalingState), this.emit("signalingStateChange", this._pc.signalingState));
                    }
                    _onIceCandidate(e) {
                        this.destroyed || (e.candidate && this.trickle ? this.emit("signal", {
                            type: "candidate",
                            candidate: {
                                candidate: e.candidate.candidate,
                                sdpMLineIndex: e.candidate.sdpMLineIndex,
                                sdpMid: e.candidate.sdpMid
                            }
                        }) : !e.candidate && !this._iceComplete && (this._iceComplete = !0, this.emit("_iceComplete")), e.candidate && this._startIceCompleteTimeout());
                    }
                    _onChannelMessage(e) {
                        if (this.destroyed) return;
                        let t = e.data;
                        t instanceof ArrayBuffer && (t = c.from(t)), this.push(t);
                    }
                    _onChannelBufferedAmountLow() {
                        if (!this.destroyed && this._cb) {
                            this._debug("ending backpressure: bufferedAmount %d", this._channel.bufferedAmount);
                            const e = this._cb;
                            this._cb = null, e(null);
                        }
                    }
                    _onChannelOpen() {
                        this._connected || this.destroyed || (this._debug("on channel open"), this._channelReady = !0, this._maybeReady());
                    }
                    _onChannelClose() {
                        this.destroyed || (this._debug("on channel close"), this.destroy());
                    }
                    _onTrack(e) {
                        this.destroyed || e.streams.forEach((t)=>{
                            this._debug("on track"), this.emit("track", e.track, t), this._remoteTracks.push({
                                track: e.track,
                                stream: t
                            }), this._remoteStreams.some((e)=>e.id === t.id) || (this._remoteStreams.push(t), s(()=>{
                                this._debug("on stream"), this.emit("stream", t);
                            }));
                        });
                    }
                    _debug() {
                        const e = [].slice.call(arguments);
                        e[0] = "[" + this._id + "] " + e[0], a.apply(null, e);
                    }
                }
                p.WEBRTC_SUPPORT = !!o(), p.config = {
                    iceServers: [
                        {
                            urls: [
                                "stun:stun.l.google.com:19302",
                                "stun:global.stun.twilio.com:3478"
                            ]
                        }
                    ],
                    sdpSemantics: "unified-plan"
                }, p.channelConfig = {}, t.exports = p;
            },
            {
                buffer: 3,
                debug: 4,
                "err-code": 6,
                "get-browser-rtc": 8,
                "queue-microtask": 13,
                randombytes: 14,
                "readable-stream": 29
            }
        ]
    }, {}, [])("/");
});


/**
 * @module sync-protocol
 */ 

















/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $ffffb030a4f0944e$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $ffffb030a4f0944e$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $ffffb030a4f0944e$export$88f0b2eef157f31a = (iterator, filter)=>$ffffb030a4f0944e$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $ffffb030a4f0944e$export$1570d514f543056a = (iterator, fmap)=>$ffffb030a4f0944e$export$7342c78d7e13e778(()=>{
        const { done: done , value: value  } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });



/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {Observable<any>}
 */ class $b296f782f3ab7bd5$export$c3faceeb92aa39dd extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $b296f782f3ab7bd5$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $b296f782f3ab7bd5$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $b296f782f3ab7bd5$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(let i = 0; i < deletes.length; i++){
            const del = deletes[i];
            $b296f782f3ab7bd5$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $e8fac97060e7c35b$export$a3fe094919f356fd((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $b296f782f3ab7bd5$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $e8fac97060e7c35b$export$8960430cfd85939f(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $b296f782f3ab7bd5$var$mergeDeleteSets = (dss)=>{
    const merged = new $b296f782f3ab7bd5$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$5e5c19b0ad9b04d4$export$9ceefe31f12a3778(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $b296f782f3ab7bd5$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$addToDeleteSet = (ds, client, clock, length)=>{
    $b5584d8615cd2038$export$dccd489362a8619(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $b296f782f3ab7bd5$var$DeleteItem(clock, length));
};
const $b296f782f3ab7bd5$export$8cbac0d946238699 = ()=>new $b296f782f3ab7bd5$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$8450d668bec558e2 = (ss)=>{
    const ds = $b296f782f3ab7bd5$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $b296f782f3ab7bd5$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$writeDeleteSet = (encoder, ds)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $5e5c19b0ad9b04d4$export$6788812c4e6611e6(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, client);
        const len = dsitems.length;
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readDeleteSet = (decoder)=>{
    const ds = new $b296f782f3ab7bd5$var$DeleteSet();
    const numClients = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        const numberOfDeletes = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $b5584d8615cd2038$export$dccd489362a8619(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $b296f782f3ab7bd5$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $b296f782f3ab7bd5$var$DeleteSet();
    const numClients = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        const numberOfDeletes = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $b296f782f3ab7bd5$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $b296f782f3ab7bd5$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $b296f782f3ab7bd5$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $b296f782f3ab7bd5$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $b296f782f3ab7bd5$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $b296f782f3ab7bd5$var$UpdateEncoderV2();
        $7f295e825046a0c3$export$872f48c75febcd2b(ds.restEncoder, 0); // encode 0 structs
        $b296f782f3ab7bd5$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @module Y
 */ const $b296f782f3ab7bd5$var$generateNewClientId = $562771b566a9e573$export$de9ffb9418dd7d0d;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends Observable<string>
 */ class $b296f782f3ab7bd5$export$bceacc74c2212615 extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $562771b566a9e573$export$abe4376e1bf796d6() , collectionid: collectionid = null , gc: gc = true , gcFilter: gcFilter = ()=>true , meta: meta = null , autoLoad: autoLoad = false , shouldLoad: shouldLoad = true  } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $b296f782f3ab7bd5$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $b296f782f3ab7bd5$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        /**
     * Promise that resolves once the document has been loaded from a presistence provider.
     */ this.whenLoaded = $5719c92748a1df45$export$185802fd694ee1f5((resolve)=>{
            this.on("load", ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$5719c92748a1df45$export$185802fd694ee1f5((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off("sync", eventHandler);
                        resolve();
                    }
                };
                this.on("sync", eventHandler);
            });
        this.on("sync", (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (!this.isLoaded) this.emit("load", []);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $b296f782f3ab7bd5$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($5e5c19b0ad9b04d4$export$6788812c4e6611e6(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $b296f782f3ab7bd5$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `y.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `y.define(name, Y.Array) === y.define(name, Y.Array)`
   *
   * After this method is called, the type is also available on `y.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Yjs instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @example
   *   const y = new Y(..)
   *   const appState = {
   *     document: y.getText('document')
   *     comments: y.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Function} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {AbstractType<any>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = $b296f782f3ab7bd5$export$c265dc8338484497) {
        const type = $b5584d8615cd2038$export$dccd489362a8619(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $b296f782f3ab7bd5$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $b296f782f3ab7bd5$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = "") {
        // @ts-ignore
        return this.get(name, $b296f782f3ab7bd5$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = "") {
        // @ts-ignore
        return this.get(name, $b296f782f3ab7bd5$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = "") {
        // @ts-ignore
        return this.get(name, $b296f782f3ab7bd5$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = "") {
        // @ts-ignore
        return this.get(name, $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        $5e5c19b0ad9b04d4$export$6788812c4e6611e6(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $b296f782f3ab7bd5$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $b296f782f3ab7bd5$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        this.emit("destroyed", [
            true
        ]);
        this.emit("destroy", [
            this
        ]);
        super.destroy();
    }
    /**
   * @param {string} eventName
   * @param {function(...any):any} f
   */ on(eventName, f) {
        super.on(eventName, f);
    }
    /**
   * @param {string} eventName
   * @param {function} f
   */ off(eventName, f) {
        super.off(eventName, f);
    }
}
class $b296f782f3ab7bd5$var$DSDecoderV1 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
    }
}
class $b296f782f3ab7bd5$var$UpdateDecoderV1 extends $b296f782f3ab7bd5$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $b296f782f3ab7bd5$export$6c7d4e6171d008d0($902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder), $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $b296f782f3ab7bd5$export$6c7d4e6171d008d0($902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder), $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $902b843224f0f9d8$export$d5778a2beba4ceef(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $902b843224f0f9d8$export$3b64b4d753b81ec2(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $902b843224f0f9d8$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $0b91950191e72a08$export$fe6f60023cd5ffaf($902b843224f0f9d8$export$7418bbc18dee40f3(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($902b843224f0f9d8$export$3b64b4d753b81ec2(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $902b843224f0f9d8$export$3b64b4d753b81ec2(this.restDecoder);
    }
}
class $b296f782f3ab7bd5$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $902b843224f0f9d8$export$5a476e4dbe7923d5(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
}
class $b296f782f3ab7bd5$var$UpdateDecoderV2 extends $b296f782f3ab7bd5$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $902b843224f0f9d8$export$d502ab0bf048a596($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.clientDecoder = new $902b843224f0f9d8$export$2dc62fb2f864b82e($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.leftClockDecoder = new $902b843224f0f9d8$export$d502ab0bf048a596($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.rightClockDecoder = new $902b843224f0f9d8$export$d502ab0bf048a596($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.infoDecoder = new $902b843224f0f9d8$export$f1f1200492b832af($902b843224f0f9d8$export$7418bbc18dee40f3(decoder), $902b843224f0f9d8$export$d5778a2beba4ceef);
        this.stringDecoder = new $902b843224f0f9d8$export$63a7aa211a91ed69($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.parentInfoDecoder = new $902b843224f0f9d8$export$f1f1200492b832af($902b843224f0f9d8$export$7418bbc18dee40f3(decoder), $902b843224f0f9d8$export$d5778a2beba4ceef);
        this.typeRefDecoder = new $902b843224f0f9d8$export$2dc62fb2f864b82e($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
        this.lenDecoder = new $902b843224f0f9d8$export$2dc62fb2f864b82e($902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
    }
    /**
   * @return {ID}
   */ readLeftID() {
        return new $b296f782f3ab7bd5$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $b296f782f3ab7bd5$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $902b843224f0f9d8$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $902b843224f0f9d8$export$7418bbc18dee40f3(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $902b843224f0f9d8$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
}
class $b296f782f3ab7bd5$var$DSEncoderV1 {
    constructor(){
        this.restEncoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    }
    toUint8Array() {
        return $7f295e825046a0c3$export$73470fd2221e6aef(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, len);
    }
}
class $b296f782f3ab7bd5$export$99171b804d9c5b54 extends $b296f782f3ab7bd5$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, id.client);
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, id.client);
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $7f295e825046a0c3$export$826a1a6619653272(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $7f295e825046a0c3$export$dde49cb52d5f1650(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $7f295e825046a0c3$export$264b1e8551468ea(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $7f295e825046a0c3$export$f7d11515275e88a2(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $7f295e825046a0c3$export$dde49cb52d5f1650(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $7f295e825046a0c3$export$dde49cb52d5f1650(this.restEncoder, key);
    }
}
class $b296f782f3ab7bd5$var$DSEncoderV2 {
    constructor(){
        this.restEncoder = $7f295e825046a0c3$export$4e76eeb6df88c889(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    toUint8Array() {
        return $7f295e825046a0c3$export$73470fd2221e6aef(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $a12da43118d917e2$export$965b6bccecbd9673();
        $7f295e825046a0c3$export$872f48c75febcd2b(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
}
class $b296f782f3ab7bd5$var$UpdateEncoderV2 extends $b296f782f3ab7bd5$var$DSEncoderV2 {
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $7f295e825046a0c3$export$7542c66a59375c6f();
        this.clientEncoder = new $7f295e825046a0c3$export$785ebd3312c38061();
        this.leftClockEncoder = new $7f295e825046a0c3$export$7542c66a59375c6f();
        this.rightClockEncoder = new $7f295e825046a0c3$export$7542c66a59375c6f();
        this.infoEncoder = new $7f295e825046a0c3$export$8fa72bb4fa9409ff($7f295e825046a0c3$export$826a1a6619653272);
        this.stringEncoder = new $7f295e825046a0c3$export$7dcdc5c32f31c550();
        this.parentInfoEncoder = new $7f295e825046a0c3$export$8fa72bb4fa9409ff($7f295e825046a0c3$export$826a1a6619653272);
        this.typeRefEncoder = new $7f295e825046a0c3$export$785ebd3312c38061();
        this.lenEncoder = new $7f295e825046a0c3$export$785ebd3312c38061();
    }
    toUint8Array() {
        const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, 0); // this is a feature flag that we might use in the future
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.keyClockEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.clientEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.leftClockEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.rightClockEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $7f295e825046a0c3$export$73470fd2221e6aef(this.infoEncoder));
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.stringEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $7f295e825046a0c3$export$73470fd2221e6aef(this.parentInfoEncoder));
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.typeRefEncoder.toUint8Array());
        $7f295e825046a0c3$export$f7d11515275e88a2(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $7f295e825046a0c3$export$73b5e63e27d2b4c7(encoder, $7f295e825046a0c3$export$73470fd2221e6aef(this.restEncoder));
        return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $7f295e825046a0c3$export$264b1e8551468ea(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $7f295e825046a0c3$export$f7d11515275e88a2(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $7f295e825046a0c3$export$264b1e8551468ea(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $b296f782f3ab7bd5$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $e8fac97060e7c35b$export$8960430cfd85939f(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($b296f782f3ab7bd5$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $b296f782f3ab7bd5$var$getStateVector(store).forEach((clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $5e5c19b0ad9b04d4$export$6788812c4e6611e6(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        // @ts-ignore
        $b296f782f3ab7bd5$var$writeStructs(encoder, store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $b5584d8615cd2038$export$185802fd694ee1f5();
    const numOfStateUpdates = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($8d6ba0cc01579050$export$bc2aba63e4099c09 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $b296f782f3ab7bd5$export$12d259ff017e6b58($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
                        refs[i] = new $b296f782f3ab7bd5$var$Skip($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($8d6ba0cc01579050$export$eb5a8e0006ab4bb5 | $8d6ba0cc01579050$export$e25597372303a045)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), null, (info & $8d6ba0cc01579050$export$e25597372303a045) === $8d6ba0cc01579050$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $8d6ba0cc01579050$export$eb5a8e0006ab4bb5) === $8d6ba0cc01579050$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $8d6ba0cc01579050$export$daf23f774967089) === $8d6ba0cc01579050$export$daf23f774967089 ? decoder.readString() : null, $b296f782f3ab7bd5$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // leftd
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $5e5c19b0ad9b04d4$export$6788812c4e6611e6(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null && stack.length === 0) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $b296f782f3ab7bd5$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const unapplicableItems = clientsStructRefs.get(client);
            if (unapplicableItems) {
                // decrement because we weren't able to apply previous operation
                unapplicableItems.i--;
                restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
                clientsStructRefs.delete(client);
                unapplicableItems.i = 0;
                unapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $b296f782f3ab7bd5$var$Skip) {
            const localClock = $b5584d8615cd2038$export$dccd489362a8619(state, stackHead.id.client, ()=>$b296f782f3ab7bd5$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $b296f782f3ab7bd5$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $b296f782f3ab7bd5$var$UpdateEncoderV2();
        $b296f782f3ab7bd5$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$writeStructsFromTransaction = (encoder, transaction)=>$b296f782f3ab7bd5$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $b296f782f3ab7bd5$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $b296f782f3ab7bd5$var$UpdateDecoderV2(decoder))=>$b296f782f3ab7bd5$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $b296f782f3ab7bd5$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $b296f782f3ab7bd5$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $b296f782f3ab7bd5$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $b296f782f3ab7bd5$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $b296f782f3ab7bd5$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $b296f782f3ab7bd5$var$UpdateDecoderV2($902b843224f0f9d8$export$f8c898e83b60faaa(store.pendingDs));
            $902b843224f0f9d8$export$5a476e4dbe7923d5(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $b296f782f3ab7bd5$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $b296f782f3ab7bd5$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $b296f782f3ab7bd5$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $b296f782f3ab7bd5$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$b296f782f3ab7bd5$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $b296f782f3ab7bd5$var$UpdateDecoderV1(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $b296f782f3ab7bd5$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2)=>{
    const decoder = $902b843224f0f9d8$export$f8c898e83b60faaa(update);
    $b296f782f3ab7bd5$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $b296f782f3ab7bd5$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$b296f782f3ab7bd5$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $b296f782f3ab7bd5$var$UpdateDecoderV1);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $b296f782f3ab7bd5$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $b296f782f3ab7bd5$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $b296f782f3ab7bd5$var$writeDeleteSet(encoder, $b296f782f3ab7bd5$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $b296f782f3ab7bd5$var$UpdateEncoderV2())=>{
    const targetStateVector = $b296f782f3ab7bd5$export$324ac6fb20a844e3(encodedTargetStateVector);
    $b296f782f3ab7bd5$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($b296f782f3ab7bd5$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $b296f782f3ab7bd5$export$99171b804d9c5b54) return $b296f782f3ab7bd5$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $b296f782f3ab7bd5$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $b296f782f3ab7bd5$var$UpdateEncoderV2) return $b296f782f3ab7bd5$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$b296f782f3ab7bd5$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $b296f782f3ab7bd5$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $b296f782f3ab7bd5$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        const clock = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $b296f782f3ab7bd5$export$324ac6fb20a844e3 = (decodedState)=>$b296f782f3ab7bd5$var$readStateVector(new $b296f782f3ab7bd5$var$DSDecoderV1($902b843224f0f9d8$export$f8c898e83b60faaa(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $b296f782f3ab7bd5$var$writeStateVector = (encoder, sv)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, sv.size);
    $5e5c19b0ad9b04d4$export$6788812c4e6611e6(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $b296f782f3ab7bd5$var$writeDocumentStateVector = (encoder, doc)=>$b296f782f3ab7bd5$var$writeStateVector(encoder, $b296f782f3ab7bd5$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $b296f782f3ab7bd5$var$encodeStateVectorV2 = (doc, encoder = new $b296f782f3ab7bd5$var$DSEncoderV2())=>{
    if (doc instanceof Map) $b296f782f3ab7bd5$var$writeStateVector(encoder, doc);
    else $b296f782f3ab7bd5$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$3e2f5393f32e71f = (doc)=>$b296f782f3ab7bd5$var$encodeStateVectorV2(doc, new $b296f782f3ab7bd5$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $b296f782f3ab7bd5$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$createEventHandler = ()=>new $b296f782f3ab7bd5$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error("[yjs] Tried to remove event handler that doesn't exist.");
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$335a02b91f00a29d$export$9dd9a52f2dd5b9ce(eventHandler.l, [
        arg0,
        arg1
    ]);
class $b296f782f3ab7bd5$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$6c7d4e6171d008d0 = (client, clock)=>new $b296f782f3ab7bd5$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$writeID = (encoder, id)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, id.client);
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readID = (decoder)=>$b296f782f3ab7bd5$export$6c7d4e6171d008d0($902b843224f0f9d8$export$5a476e4dbe7923d5(decoder), $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $a12da43118d917e2$export$965b6bccecbd9673();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $b296f782f3ab7bd5$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log("Children: ", res);
    console.log("Children content: ", res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $b296f782f3ab7bd5$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap("users")){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get("ds");
            const ids = user.get("ids");
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $b296f782f3ab7bd5$var$mergeDeleteSets([
                            this.dss.get(userDescription) || $b296f782f3ab7bd5$export$8cbac0d946238699(),
                            $b296f782f3ab7bd5$var$readDeleteSet(new $b296f782f3ab7bd5$var$DSDecoderV1($902b843224f0f9d8$export$f8c898e83b60faaa(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $b296f782f3ab7bd5$var$mergeDeleteSets(ds.map((encodedDs)=>$b296f782f3ab7bd5$var$readDeleteSet(new $b296f782f3ab7bd5$var$DSDecoderV1($902b843224f0f9d8$export$f8c898e83b60faaa(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add intial data
        storeType.forEach(initUser);
    }
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true  } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $b296f782f3ab7bd5$export$a5c7b93649eaf8f8();
            user.set("ids", new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa());
            user.set("ds", new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get("ids").push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get("ids").push([
                            clientid
                        ]);
                    });
                    const encoder = new $b296f782f3ab7bd5$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $b296f782f3ab7bd5$var$writeDeleteSet(encoder, ds);
                        user.get("ds").push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on("afterTransaction", /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get("ds");
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $b296f782f3ab7bd5$var$DSEncoderV1();
                    $b296f782f3ab7bd5$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($b296f782f3ab7bd5$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $b296f782f3ab7bd5$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $b296f782f3ab7bd5$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$ddad8a1b8f7475d8 = (json)=>new $b296f782f3ab7bd5$export$da21a415c5907662(json.type == null ? null : $b296f782f3ab7bd5$export$6c7d4e6171d008d0(json.type.client, json.type.clock), json.tname || null, json.item == null ? null : $b296f782f3ab7bd5$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
class $b296f782f3ab7bd5$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $b296f782f3ab7bd5$var$createAbsolutePosition = (type, index, assoc = 0)=>new $b296f782f3ab7bd5$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $b296f782f3ab7bd5$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $b296f782f3ab7bd5$export$e726a40920d54663(type);
    else typeid = $b296f782f3ab7bd5$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $b296f782f3ab7bd5$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $b296f782f3ab7bd5$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $b296f782f3ab7bd5$var$createRelativePosition(type, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $b296f782f3ab7bd5$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $b296f782f3ab7bd5$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $b296f782f3ab7bd5$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type , tname: tname , item: item , assoc: assoc  } = rpos;
    if (item !== null) {
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, 0);
        $b296f782f3ab7bd5$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $7f295e825046a0c3$export$826a1a6619653272(encoder, 1);
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $7f295e825046a0c3$export$826a1a6619653272(encoder, 2);
        $b296f782f3ab7bd5$var$writeID(encoder, type);
    } else throw $a12da43118d917e2$export$965b6bccecbd9673();
    $7f295e825046a0c3$export$ff90f819e16cc9bb(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    $b296f782f3ab7bd5$var$writeRelativePosition(encoder, rpos);
    return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $b296f782f3ab7bd5$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($902b843224f0f9d8$export$5a476e4dbe7923d5(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $b296f782f3ab7bd5$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $902b843224f0f9d8$export$3b64b4d753b81ec2(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $b296f782f3ab7bd5$var$readID(decoder);
    }
    const assoc = $902b843224f0f9d8$export$7ad75c69830b76d7(decoder) ? $902b843224f0f9d8$export$1dd5b9ddf6575ae8(decoder) : 0;
    return new $b296f782f3ab7bd5$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $b296f782f3ab7bd5$export$58a46cebc90e7851 = (uint8Array)=>$b296f782f3ab7bd5$var$readRelativePosition($902b843224f0f9d8$export$f8c898e83b60faaa(uint8Array));
/**
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$8fc3152f62fb7ed1 = (rpos, doc)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($b296f782f3ab7bd5$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = $b296f782f3ab7bd5$var$followRedone(store, rightID);
        const right = res.item;
        if (!(right instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($b296f782f3ab7bd5$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item  } = $b296f782f3ab7bd5$var$followRedone(store, typeID);
            if (item instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && item.content instanceof $b296f782f3ab7bd5$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $a12da43118d917e2$export$965b6bccecbd9673();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $b296f782f3ab7bd5$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $b296f782f3ab7bd5$export$c0af976e7e459c02(a.item, b.item) && $b296f782f3ab7bd5$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $b296f782f3ab7bd5$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $b296f782f3ab7bd5$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$b946cadc55f8e512 = (snapshot, encoder = new $b296f782f3ab7bd5$var$DSEncoderV2())=>{
    $b296f782f3ab7bd5$var$writeDeleteSet(encoder, snapshot.ds);
    $b296f782f3ab7bd5$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$a6d29989648e995 = (snapshot)=>$b296f782f3ab7bd5$export$b946cadc55f8e512(snapshot, new $b296f782f3ab7bd5$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $b296f782f3ab7bd5$export$b0049fa299f4f58e = (buf, decoder = new $b296f782f3ab7bd5$var$DSDecoderV2($902b843224f0f9d8$export$f8c898e83b60faaa(buf)))=>{
    return new $b296f782f3ab7bd5$export$c963130a5525248f($b296f782f3ab7bd5$var$readDeleteSet(decoder), $b296f782f3ab7bd5$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $b296f782f3ab7bd5$export$5c696daccf32bd2e = (buf)=>$b296f782f3ab7bd5$export$b0049fa299f4f58e(buf, new $b296f782f3ab7bd5$var$DSDecoderV1($902b843224f0f9d8$export$f8c898e83b60faaa(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $b296f782f3ab7bd5$export$548fae0445f878fd = (ds, sm)=>new $b296f782f3ab7bd5$export$c963130a5525248f(ds, sm);
const $b296f782f3ab7bd5$export$d4568a81dd107a34 = $b296f782f3ab7bd5$export$548fae0445f878fd($b296f782f3ab7bd5$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $b296f782f3ab7bd5$export$b8801ea43165ed7d = (doc)=>$b296f782f3ab7bd5$export$548fae0445f878fd($b296f782f3ab7bd5$export$8450d668bec558e2(doc.store), $b296f782f3ab7bd5$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $b296f782f3ab7bd5$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$b296f782f3ab7bd5$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $b296f782f3ab7bd5$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $b5584d8615cd2038$export$dccd489362a8619(transaction.meta, $b296f782f3ab7bd5$var$splitSnapshotAffectedStructs, $9ea3ff85accf439d$export$185802fd694ee1f5);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $b296f782f3ab7bd5$export$50fdfeece43146fd(store, client)) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock));
        });
        $b296f782f3ab7bd5$export$8afefebbaf4e4c78(transaction, snapshot.ds, (item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $b296f782f3ab7bd5$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $b296f782f3ab7bd5$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error("Garbage-collection must be disabled in `originDoc`!");
    const { sv: sv , ds: ds  } = snapshot;
    const encoder = new $b296f782f3ab7bd5$var$UpdateEncoderV2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $b296f782f3ab7bd5$export$50fdfeece43146fd(originDoc.store, client)) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $b296f782f3ab7bd5$var$writeDeleteSet(encoder, ds);
    });
    $b296f782f3ab7bd5$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), "snapshot");
    return newDoc;
};
class $b296f782f3ab7bd5$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $b296f782f3ab7bd5$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $b296f782f3ab7bd5$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $a12da43118d917e2$export$965b6bccecbd9673();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $e8fac97060e7c35b$export$a3fe094919f356fd(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $e8fac97060e7c35b$export$a3fe094919f356fd((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $a12da43118d917e2$export$965b6bccecbd9673();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $b296f782f3ab7bd5$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $b296f782f3ab7bd5$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $b296f782f3ab7bd5$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$getItemCleanStart = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$b296f782f3ab7bd5$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$getItemCleanEnd = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $b296f782f3ab7bd5$export$12d259ff017e6b58) structs.splice(index + 1, 0, $b296f782f3ab7bd5$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $b296f782f3ab7bd5$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $b296f782f3ab7bd5$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $b296f782f3ab7bd5$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const map = y.define('map', YMap)
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * y.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $b296f782f3ab7bd5$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $b296f782f3ab7bd5$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $b296f782f3ab7bd5$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $b296f782f3ab7bd5$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$b5584d8615cd2038$export$4154a199d7d90455(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $b296f782f3ab7bd5$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $b296f782f3ab7bd5$var$writeStructsFromTransaction(encoder, transaction);
    $b296f782f3ab7bd5$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $b296f782f3ab7bd5$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $b5584d8615cd2038$export$dccd489362a8619(transaction.changed, type, $9ea3ff85accf439d$export$185802fd694ee1f5).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 */ const $b296f782f3ab7bd5$var$tryToMergeWithLeft = (structs, pos)=>{
    const left = structs[pos - 1];
    const right = structs[pos];
    if (left.deleted === right.deleted && left.constructor === right.constructor) {
        if (left.mergeWith(right)) {
            structs.splice(pos, 1);
            if (right instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $b296f782f3ab7bd5$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $b296f782f3ab7bd5$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiecy and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $e8fac97060e7c35b$export$96ec731ed4dcb222(structs.length - 1, 1 + $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[--si])$b296f782f3ab7bd5$var$tryToMergeWithLeft(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $b296f782f3ab7bd5$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $b296f782f3ab7bd5$var$tryGcDeleteSet(ds, store, gcFilter);
    $b296f782f3ab7bd5$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $b296f782f3ab7bd5$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $b296f782f3ab7bd5$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $b296f782f3ab7bd5$var$getStateVector(transaction.doc.store);
            doc.emit("beforeObserverCalls", [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>fs.push(()=>{
                        // We need to think about the possibility that the user transforms the
                        // Y.Doc in the event.
                        if (type._item === null || !type._item.deleted) {
                            events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                            events.forEach((event)=>{
                                event.currentTarget = type;
                            });
                            // sort events by path length so that top-level events are fired first.
                            events.sort((event1, event2)=>event1.path.length - event2.path.length);
                            // We don't need to check for events.length
                            // because we know it has at least one element
                            $b296f782f3ab7bd5$var$callEventHandlerListeners(type._dEH, events, transaction);
                        }
                    }));
                fs.push(()=>doc.emit("afterTransaction", [
                        transaction,
                        doc
                    ]));
            });
            (0, $335a02b91f00a29d$export$9dd9a52f2dd5b9ce)(fs, []);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $b296f782f3ab7bd5$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $b296f782f3ab7bd5$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $e8fac97060e7c35b$export$8960430cfd85939f($b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos; i--)$b296f782f3ab7bd5$var$tryToMergeWithLeft(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = 0; i < mergeStructs.length; i++){
                const { client: client , clock: clock  } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $b296f782f3ab7bd5$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) $b296f782f3ab7bd5$var$tryToMergeWithLeft(structs, replacedStructPos + 1);
                if (replacedStructPos > 0) $b296f782f3ab7bd5$var$tryToMergeWithLeft(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $73ec8bbf24ec5444$export$c2d084dc44961371($792d43f9d2752e68$export$3de5e29ed1757f9b, $792d43f9d2752e68$export$c1286c4c2a7c066, "[yjs] ", $792d43f9d2752e68$export$f0ce1666bb40789b, $792d43f9d2752e68$export$aa201224bb439d47, "Changed the client-id because another client seems to be using it.");
                doc.clientID = $b296f782f3ab7bd5$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit("afterTransactionCleanup", [
                transaction,
                doc
            ]);
            if (doc._observers.has("update")) {
                const encoder = new $b296f782f3ab7bd5$export$99171b804d9c5b54();
                const hasContent = $b296f782f3ab7bd5$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("update", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has("updateV2")) {
                const encoder = new $b296f782f3ab7bd5$var$UpdateEncoderV2();
                const hasContent = $b296f782f3ab7bd5$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("updateV2", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded , subdocsLoaded: subdocsLoaded , subdocsRemoved: subdocsRemoved  } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit("subdocs", [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit("afterAllTransactions", [
                    doc,
                    transactionCleanups
                ]);
            } else $b296f782f3ab7bd5$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $b296f782f3ab7bd5$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $b296f782f3ab7bd5$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit("beforeAllTransactions", [
            doc
        ]);
        doc.emit("beforeTransaction", [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $b296f782f3ab7bd5$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $b296f782f3ab7bd5$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $b296f782f3ab7bd5$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $b296f782f3ab7bd5$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && um.scope.some((type)=>$b296f782f3ab7bd5$export$3c81af374b054d6a(type, item))) $b296f782f3ab7bd5$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {string} eventType
 * @return {StackItem?}
 */ const $b296f782f3ab7bd5$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Whether a change happened
   * @type {StackItem?}
   */ let result = null;
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $b296f782f3ab7bd5$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && result === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $b296f782f3ab7bd5$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item , diff: diff  } = $b296f782f3ab7bd5$var$followRedone(store, struct.id);
                        if (diff > 0) item = $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>$b296f782f3ab7bd5$export$3c81af374b054d6a(type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $b296f782f3ab7bd5$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && scope.some((type)=>$b296f782f3ab7bd5$export$3c81af374b054d6a(type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$b296f782f3ab7bd5$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $b296f782f3ab7bd5$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            result = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    if (result != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit("stack-item-popped", [
            {
                stackItem: result,
                type: eventType,
                changedParentTypes: changedParentTypes
            },
            undoManager
        ]);
    }
    return result;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {Observable<'stack-item-added'|'stack-item-popped'|'stack-cleared'|'stack-item-updated'>}
 */ class $b296f782f3ab7bd5$export$932a3f9a7e88971c extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500 , captureTransaction: captureTransaction = (_tr)=>true , deleteFilter: deleteFilter = ()=>true , trackedOrigins: trackedOrigins = new Set([
        null
    ]) , ignoreRemoteMapChanges: ignoreRemoteMapChanges = false , doc: doc = /** @type {Doc} */ $5e5c19b0ad9b04d4$export$43bee75e5e14138e(typeScope) ? typeScope[0].doc : typeScope.doc  } = {}){
        super();
        /**
     * @type {Array<AbstractType<any>>}
     */ this.scope = [];
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        this.doc = doc;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(type)) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $b296f782f3ab7bd5$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $b296f782f3ab7bd5$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $a69ef2806e7968d3$export$1f77c0008d16313();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $b296f782f3ab7bd5$var$mergeDeleteSets([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $b296f782f3ab7bd5$var$mergeDeleteSets([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $b296f782f3ab7bd5$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $b296f782f3ab7bd5$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2 && this.scope.some((type)=>$b296f782f3ab7bd5$export$3c81af374b054d6a(type, item))) $b296f782f3ab7bd5$var$keepItem(item, true);
            });
            const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? "redo" : "undo",
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit("stack-item-added", changeEvent);
            else this.emit("stack-item-updated", changeEvent);
        };
        this.doc.on("afterTransaction", this.afterTransactionHandler);
        this.doc.on("destroy", ()=>{
            this.destroy();
        });
    }
    /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */ addToScope(ytypes) {
        ytypes = $5e5c19b0ad9b04d4$export$43bee75e5e14138e(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (this.scope.every((yt)=>yt !== ytype)) this.scope.push(ytype);
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$b296f782f3ab7bd5$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$b296f782f3ab7bd5$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit("stack-cleared", [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $b296f782f3ab7bd5$var$popStackItem(this, this.undoStack, "undo");
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $b296f782f3ab7bd5$var$popStackItem(this, this.redoStack, "redo");
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off("afterTransaction", this.afterTransactionHandler);
        super.destroy();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $b296f782f3ab7bd5$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder.restDecoder);
                yield new $b296f782f3ab7bd5$var$Skip($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($8d6ba0cc01579050$export$bc2aba63e4099c09 & info) !== 0) {
                const cantCopyParentInfo = (info & ($8d6ba0cc01579050$export$eb5a8e0006ab4bb5 | $8d6ba0cc01579050$export$e25597372303a045)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), null, (info & $8d6ba0cc01579050$export$e25597372303a045) === $8d6ba0cc01579050$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $8d6ba0cc01579050$export$eb5a8e0006ab4bb5) === $8d6ba0cc01579050$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $8d6ba0cc01579050$export$daf23f774967089) === $8d6ba0cc01579050$export$daf23f774967089 ? decoder.readString() : null, $b296f782f3ab7bd5$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $b296f782f3ab7bd5$export$12d259ff017e6b58($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $b296f782f3ab7bd5$var$LazyStructReader {
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $b296f782f3ab7bd5$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $b296f782f3ab7bd5$var$Skip);
        return this.curr;
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $b296f782f3ab7bd5$export$d6235ced6e55ace9 = (update)=>$b296f782f3ab7bd5$export$624b3f0248c2dc40(update, $b296f782f3ab7bd5$var$UpdateDecoderV1);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $b296f782f3ab7bd5$export$624b3f0248c2dc40 = (update, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2)=>{
    const structs = [];
    const updateDecoder = new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $b296f782f3ab7bd5$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $73ec8bbf24ec5444$export$c2d084dc44961371("Structs: ", structs);
    const ds = $b296f782f3ab7bd5$var$readDeleteSet(updateDecoder);
    $73ec8bbf24ec5444$export$c2d084dc44961371("DeleteSet: ", ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $b296f782f3ab7bd5$export$aa45cba8121663dc = (update)=>$b296f782f3ab7bd5$export$2fed33908eb23d71(update, $b296f782f3ab7bd5$var$UpdateDecoderV1);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $b296f782f3ab7bd5$export$2fed33908eb23d71 = (update, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2)=>{
    const structs = [];
    const updateDecoder = new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $b296f782f3ab7bd5$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $b296f782f3ab7bd5$var$readDeleteSet(updateDecoder)
    };
};
class $b296f782f3ab7bd5$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$6319871659fd2460 = (updates)=>$b296f782f3ab7bd5$export$ce273d78de0331d1(updates, $b296f782f3ab7bd5$var$UpdateDecoderV1, $b296f782f3ab7bd5$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$ed51750cf3ab2381 = (update, YEncoder = $b296f782f3ab7bd5$var$DSEncoderV2, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $b296f782f3ab7bd5$var$LazyStructReader(new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, currClient);
                    $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $b296f782f3ab7bd5$var$Skip) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, currClient);
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(enc, size);
        $7f295e825046a0c3$export$c029b62321ea3da(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$5c451fd8502b011f = (update)=>$b296f782f3ab7bd5$export$ed51750cf3ab2381(update, $b296f782f3ab7bd5$var$DSEncoderV1, $b296f782f3ab7bd5$var$UpdateDecoderV1);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $b296f782f3ab7bd5$export$8212a58b2178fdcf = (update, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $b296f782f3ab7bd5$var$LazyStructReader(new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $b296f782f3ab7bd5$export$e212b06fd4bf78fd = (update)=>$b296f782f3ab7bd5$export$8212a58b2178fdcf(update, $b296f782f3ab7bd5$var$UpdateDecoderV1);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $b296f782f3ab7bd5$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $b296f782f3ab7bd5$export$12d259ff017e6b58) {
        const { client: client , clock: clock  } = left.id;
        return new $b296f782f3ab7bd5$export$12d259ff017e6b58($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $b296f782f3ab7bd5$var$Skip) {
        const { client: client , clock: clock  } = left.id;
        return new $b296f782f3ab7bd5$var$Skip($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client , clock: clock  } = leftItem.id;
        return new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff), null, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $b296f782f3ab7bd5$export$ce273d78de0331d1 = (updates, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2, YEncoder = $b296f782f3ab7bd5$var$UpdateEncoderV2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $b296f782f3ab7bd5$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $b296f782f3ab7bd5$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $b296f782f3ab7bd5$var$Skip ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $b296f782f3ab7bd5$var$Skip) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $b296f782f3ab7bd5$var$Skip($b296f782f3ab7bd5$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $b296f782f3ab7bd5$var$Skip) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $b296f782f3ab7bd5$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $b296f782f3ab7bd5$var$Skip; next = currDecoder.next()){
            $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $b296f782f3ab7bd5$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$b296f782f3ab7bd5$var$readDeleteSet(decoder));
    const ds = $b296f782f3ab7bd5$var$mergeDeleteSets(dss);
    $b296f782f3ab7bd5$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $b296f782f3ab7bd5$export$a8143edf39d2ad8e = (update, sv, YDecoder = $b296f782f3ab7bd5$var$UpdateDecoderV2, YEncoder = $b296f782f3ab7bd5$var$UpdateEncoderV2)=>{
    const state = $b296f782f3ab7bd5$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $b296f782f3ab7bd5$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update));
    const reader = new $b296f782f3ab7bd5$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $b296f782f3ab7bd5$var$Skip) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $e8fac97060e7c35b$export$8960430cfd85939f(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $b296f782f3ab7bd5$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $b296f782f3ab7bd5$var$readDeleteSet(decoder);
    $b296f782f3ab7bd5$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $b296f782f3ab7bd5$export$bf60b51d6c283426 = (update, sv)=>$b296f782f3ab7bd5$export$a8143edf39d2ad8e(update, sv, $b296f782f3ab7bd5$var$UpdateDecoderV1, $b296f782f3ab7bd5$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $b296f782f3ab7bd5$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $7f295e825046a0c3$export$73470fd2221e6aef(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $b296f782f3ab7bd5$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $b296f782f3ab7bd5$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $7f295e825046a0c3$export$872f48c75febcd2b(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $b296f782f3ab7bd5$var$finishLazyStructWriting = (lazyWriter)=>{
    $b296f782f3ab7bd5$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $7f295e825046a0c3$export$872f48c75febcd2b(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $7f295e825046a0c3$export$872f48c75febcd2b(restEncoder, partStructs.written);
        // write the rest of the fragment
        $7f295e825046a0c3$export$73b5e63e27d2b4c7(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $b296f782f3ab7bd5$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($902b843224f0f9d8$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $b296f782f3ab7bd5$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $b296f782f3ab7bd5$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$b296f782f3ab7bd5$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $b296f782f3ab7bd5$var$finishLazyStructWriting(lazyWriter);
    const ds = $b296f782f3ab7bd5$var$readDeleteSet(updateDecoder);
    $b296f782f3ab7bd5$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $b296f782f3ab7bd5$var$createObfuscator = ({ formatting: formatting = true , subdocs: subdocs = true , yxml: yxml = true  } = {})=>{
    let i = 0;
    const mapKeyCache = $b5584d8615cd2038$export$185802fd694ee1f5();
    const nodeNameCache = $b5584d8615cd2038$export$185802fd694ee1f5();
    const formattingKeyCache = $b5584d8615cd2038$export$185802fd694ee1f5();
    const formattingValueCache = $b5584d8615cd2038$export$185802fd694ee1f5();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $b296f782f3ab7bd5$export$12d259ff017e6b58:
            case $b296f782f3ab7bd5$var$Skip:
                return block;
            case $b296f782f3ab7bd5$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $b296f782f3ab7bd5$export$3b06e0b3a2ece602:
                            break;
                        case $b296f782f3ab7bd5$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $b296f782f3ab7bd5$export$4db87581d3ca170d) type.nodeName = $b5584d8615cd2038$export$dccd489362a8619(nodeNameCache, type.nodeName, ()=>"node-" + i);
                                if (type instanceof $b296f782f3ab7bd5$export$ec64c1dd5e7a264) type.hookName = $b5584d8615cd2038$export$dccd489362a8619(nodeNameCache, type.hookName, ()=>"hook-" + i);
                            }
                            break;
                        case $b296f782f3ab7bd5$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $b296f782f3ab7bd5$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $b296f782f3ab7bd5$var$ContentDoc:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + "";
                                }
                                break;
                            }
                        case $b296f782f3ab7bd5$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $b296f782f3ab7bd5$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $b5584d8615cd2038$export$dccd489362a8619(formattingKeyCache, c.key, ()=>i + "");
                                    c.value = $b5584d8615cd2038$export$dccd489362a8619(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $b296f782f3ab7bd5$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $b296f782f3ab7bd5$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $8322690016f3fe63$export$76d90c956114f2c2(i % 10 + "", c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $a12da43118d917e2$export$965b6bccecbd9673();
                    }
                    if (item.parentSub) item.parentSub = $b5584d8615cd2038$export$dccd489362a8619(mapKeyCache, item.parentSub, ()=>i + "");
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $a12da43118d917e2$export$965b6bccecbd9673();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $b296f782f3ab7bd5$export$2dc24d59ec48a24e = (update, opts)=>$b296f782f3ab7bd5$var$convertUpdateFormat(update, $b296f782f3ab7bd5$var$createObfuscator(opts), $b296f782f3ab7bd5$var$UpdateDecoderV1, $b296f782f3ab7bd5$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $b296f782f3ab7bd5$export$90648fb14f8c31aa = (update, opts)=>$b296f782f3ab7bd5$var$convertUpdateFormat(update, $b296f782f3ab7bd5$var$createObfuscator(opts), $b296f782f3ab7bd5$var$UpdateDecoderV2, $b296f782f3ab7bd5$var$UpdateEncoderV2);
/**
 * @param {Uint8Array} update
 */ const $b296f782f3ab7bd5$export$162408325d5832c = (update)=>$b296f782f3ab7bd5$var$convertUpdateFormat(update, $335a02b91f00a29d$export$d560c7e4a29451c2, $b296f782f3ab7bd5$var$UpdateDecoderV1, $b296f782f3ab7bd5$var$UpdateEncoderV2);
/**
 * @param {Uint8Array} update
 */ const $b296f782f3ab7bd5$export$afffbdeed14adbd = (update)=>$b296f782f3ab7bd5$var$convertUpdateFormat(update, $335a02b91f00a29d$export$d560c7e4a29451c2, $b296f782f3ab7bd5$var$UpdateDecoderV2, $b296f782f3ab7bd5$export$99171b804d9c5b54);
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $b296f782f3ab7bd5$export$80fac438977fb51c {
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
    }
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        // @ts-ignore _item is defined because target is integrated
        return $b296f782f3ab7bd5$var$getPathTo(this.currentTarget, this.target);
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $b296f782f3ab7bd5$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = "delete";
                                oldValue = $5e5c19b0ad9b04d4$export$4c7897fafd92b108(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = "update";
                            oldValue = $5e5c19b0ad9b04d4$export$4c7897fafd92b108(prev.content.getContent());
                        } else {
                            action = "add";
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = "delete";
                            oldValue = $5e5c19b0ad9b04d4$export$4c7897fafd92b108(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            const target = this.target;
            const added = $9ea3ff85accf439d$export$185802fd694ee1f5();
            const deleted = $9ea3ff85accf439d$export$185802fd694ee1f5();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted) i++;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
const $b296f782f3ab7bd5$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $b296f782f3ab7bd5$var$globalSearchMarkerTimestamp = 0;
class $b296f782f3ab7bd5$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $b296f782f3ab7bd5$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $b296f782f3ab7bd5$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $b296f782f3ab7bd5$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $b296f782f3ab7bd5$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $b296f782f3ab7bd5$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $b296f782f3ab7bd5$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $b296f782f3ab7bd5$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $b296f782f3ab7bd5$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $b296f782f3ab7bd5$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $b296f782f3ab7bd5$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$e8fac97060e7c35b$export$2335f513bbd82c6d(index - a.index) < $e8fac97060e7c35b$export$2335f513bbd82c6d(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $b296f782f3ab7bd5$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengthes == null) {
    //     window.lengthes = []
    //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
    //   }
    //   window.lengthes.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $e8fac97060e7c35b$export$2335f513bbd82c6d(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $b296f782f3ab7bd5$var$maxSearchMarker) {
        // adjust existing marker
        $b296f782f3ab7bd5$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $b296f782f3ab7bd5$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $b296f782f3ab7bd5$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $e8fac97060e7c35b$export$8960430cfd85939f(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $b296f782f3ab7bd5$export$5418d693f13991b3 = (t)=>{
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $b296f782f3ab7bd5$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $b5584d8615cd2038$export$dccd489362a8619(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $b296f782f3ab7bd5$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $b296f782f3ab7bd5$export$c265dc8338484497 {
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $b296f782f3ab7bd5$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $b296f782f3ab7bd5$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $b296f782f3ab7bd5$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $b296f782f3ab7bd5$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $b296f782f3ab7bd5$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $b296f782f3ab7bd5$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListSlice = (type, start, end)=>{
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListToArray = (type)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $b296f782f3ab7bd5$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on overy element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $b296f782f3ab7bd5$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListGet = (type, index)=>{
    const marker = $b296f782f3ab7bd5$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $b296f782f3ab7bd5$export$bceacc74c2212615:
                        left = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$var$ContentDoc(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $b296f782f3ab7bd5$export$c265dc8338484497) {
                            left = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error("Unexpected content type in insert operation");
                }
        }
    });
    packJsonContent();
};
const $b296f782f3ab7bd5$var$lengthExceeded = $a12da43118d917e2$export$185802fd694ee1f5("Length exceeded!");
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $b296f782f3ab7bd5$var$lengthExceeded;
    if (index === 0) {
        if (parent._searchMarker) $b296f782f3ab7bd5$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $b296f782f3ab7bd5$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $b296f782f3ab7bd5$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $b296f782f3ab7bd5$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $b296f782f3ab7bd5$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $b296f782f3ab7bd5$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $b296f782f3ab7bd5$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $b296f782f3ab7bd5$var$lengthExceeded;
    if (parent._searchMarker) $b296f782f3ab7bd5$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $b296f782f3ab7bd5$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $b296f782f3ab7bd5$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $b296f782f3ab7bd5$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $b296f782f3ab7bd5$export$bceacc74c2212615:
            content = new $b296f782f3ab7bd5$var$ContentDoc(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $b296f782f3ab7bd5$export$c265dc8338484497) content = new $b296f782f3ab7bd5$export$e2e108cbe2e4f865(value);
            else throw new Error("Unexpected content type");
    }
    new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeMapGet = (parent, key)=>{
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$typeMapHas = (parent, key)=>{
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $b296f782f3ab7bd5$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {Map<string,Item>} map
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$createMapIterator = (map)=>$ffffb030a4f0944e$export$88f0b2eef157f31a(map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $b296f782f3ab7bd5$export$a095f7fee639264a extends $b296f782f3ab7bd5$export$80fac438977fb51c {
    /**
   * @param {YArray<T>} yarray The changed type
   * @param {Transaction} transaction The transaction object
   */ constructor(yarray, transaction){
        super(yarray, transaction);
        this._transaction = transaction;
    }
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $b296f782f3ab7bd5$export$c4be6576ca6fe4aa extends $b296f782f3ab7bd5$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa();
    }
    /**
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $b296f782f3ab7bd5$var$callTypeObservers(this, transaction, new $b296f782f3ab7bd5$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Preppends content to this YArray.
   *
   * @param {Array<T>} content Array of content to preppend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $b296f782f3ab7bd5$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $b296f782f3ab7bd5$var$typeListToArray(this);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $b296f782f3ab7bd5$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $b296f782f3ab7bd5$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on overy element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $b296f782f3ab7bd5$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $b296f782f3ab7bd5$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YArrayRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYArray = (_decoder)=>new $b296f782f3ab7bd5$export$c4be6576ca6fe4aa();
/**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $b296f782f3ab7bd5$export$33aab1b1a47c1cc3 extends $b296f782f3ab7bd5$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<MapType>}
 */ class $b296f782f3ab7bd5$export$a5c7b93649eaf8f8 extends $b296f782f3ab7bd5$export$c265dc8338484497 {
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $b296f782f3ab7bd5$export$a5c7b93649eaf8f8();
    }
    /**
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $b296f782f3ab7bd5$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $b296f782f3ab7bd5$var$callTypeObservers(this, transaction, new $b296f782f3ab7bd5$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$b296f782f3ab7bd5$var$createMapIterator(this._map)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $ffffb030a4f0944e$export$1570d514f543056a($b296f782f3ab7bd5$var$createMapIterator(this._map), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<any>}
   */ values() {
        return $ffffb030a4f0944e$export$1570d514f543056a($b296f782f3ab7bd5$var$createMapIterator(this._map), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */ entries() {
        return $ffffb030a4f0944e$export$1570d514f543056a($b296f782f3ab7bd5$var$createMapIterator(this._map), /** @param {any} v */ (v)=>[
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<any>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $b296f782f3ab7bd5$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $b296f782f3ab7bd5$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $b296f782f3ab7bd5$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YMapRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYMap = (_decoder)=>new $b296f782f3ab7bd5$export$a5c7b93649eaf8f8();
/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $b296f782f3ab7bd5$var$equalAttrs = (a, b)=>a === b || typeof a === "object" && typeof b === "object" && a && b && $3f96a8565a5b4a5a$export$4f1c34abb2bb4c8(a, b);
class $b296f782f3ab7bd5$var$ItemTextListPosition {
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $a12da43118d917e2$export$965b6bccecbd9673();
        switch(this.right.content.constructor){
            case $b296f782f3ab7bd5$export$3194899188fb5a88:
                if (!this.right.deleted) $b296f782f3ab7bd5$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $b296f782f3ab7bd5$export$3194899188fb5a88:
                if (!pos.right.deleted) $b296f782f3ab7bd5$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$findPosition = (transaction, parent, index)=>{
    const currentAttributes = new Map();
    const marker = $b296f782f3ab7bd5$var$findMarker(parent, index);
    if (marker) {
        const pos = new $b296f782f3ab7bd5$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $b296f782f3ab7bd5$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $b296f782f3ab7bd5$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $b296f782f3ab7bd5$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88 && $b296f782f3ab7bd5$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key , value: value  } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88 && $b296f782f3ab7bd5$var$equalAttrs(attributes[/** @type {ContentFormat} */ currPos.right.content.key] || null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $b296f782f3ab7bd5$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        const currentVal = currPos.currentAttributes.get(key) || null;
        if (!$b296f782f3ab7bd5$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left , right: right  } = currPos;
            currPos.right = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $b296f782f3ab7bd5$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $b296f782f3ab7bd5$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $b296f782f3ab7bd5$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $b296f782f3ab7bd5$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $b296f782f3ab7bd5$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? new $b296f782f3ab7bd5$export$e2e108cbe2e4f865(text) : new $b296f782f3ab7bd5$export$c3787ba7f6086664(text);
    let { left: left , right: right , index: index  } = currPos;
    if (parent._searchMarker) $b296f782f3ab7bd5$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $b296f782f3ab7bd5$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $b296f782f3ab7bd5$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $b296f782f3ab7bd5$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $b296f782f3ab7bd5$export$3194899188fb5a88:
                {
                    const { key: key , value: value  } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($b296f782f3ab7bd5$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = "";
        for(; length > 0; length--)newlines += "\n";
        currPos.right = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientId, $b296f782f3ab7bd5$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $b296f782f3ab7bd5$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $b296f782f3ab7bd5$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $b296f782f3ab7bd5$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $b5584d8615cd2038$export$185802fd694ee1f5();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $b296f782f3ab7bd5$export$3194899188fb5a88:
                    {
                        const { key: key , value: value  } = /** @type {ContentFormat} */ content;
                        const startAttrValue = startAttributes.get(key) || null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            if (!reachedCurr && (currAttributes.get(key) || null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $b296f782f3ab7bd5$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $b296f782f3ab7bd5$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $b296f782f3ab7bd5$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $b296f782f3ab7bd5$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $b5584d8615cd2038$export$185802fd694ee1f5();
        const currentAttributes = $b5584d8615cd2038$export$784d13d8ee351f07(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $b296f782f3ab7bd5$export$3194899188fb5a88:
                    $b296f782f3ab7bd5$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $b296f782f3ab7bd5$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $b5584d8615cd2038$export$784d13d8ee351f07(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $b5584d8615cd2038$export$784d13d8ee351f07(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $b296f782f3ab7bd5$export$e2e108cbe2e4f865:
            case $b296f782f3ab7bd5$export$c3787ba7f6086664:
            case $b296f782f3ab7bd5$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $b296f782f3ab7bd5$var$getItemCleanStart(transaction, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $b296f782f3ab7bd5$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $b296f782f3ab7bd5$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $b296f782f3ab7bd5$export$51155b8ebb74188a extends $b296f782f3ab7bd5$export$80fac438977fb51c {
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $b296f782f3ab7bd5$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = "";
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case "delete":
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case "insert":
                                if (typeof insert === "object" || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = "";
                                break;
                            case "retain":
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$3f96a8565a5b4a5a$export$dd1bc94b04021eeb(attributes)) op.attributes = $3f96a8565a5b4a5a$export$e6e34fd1f2686227({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $b296f782f3ab7bd5$export$e2e108cbe2e4f865:
                        case $b296f782f3ab7bd5$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = "insert";
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += 1;
                            }
                            break;
                        case $b296f782f3ab7bd5$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== "insert") {
                                        addOp();
                                        action = "insert";
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += item.length;
                            }
                            break;
                        case $b296f782f3ab7bd5$export$3194899188fb5a88:
                            {
                                const { key: key , value: value  } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        const curVal = currentAttributes.get(key) || null;
                                        if (!$b296f782f3ab7bd5$var$equalAttrs(curVal, value)) {
                                            if (action === "retain") addOp();
                                            if ($b296f782f3ab7bd5$var$equalAttrs(value, oldAttributes.get(key) || null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    const curVal = currentAttributes.get(key) || null;
                                    if (!$b296f782f3ab7bd5$var$equalAttrs(curVal, value)) {
                                        if (action === "retain") addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$b296f782f3ab7bd5$var$equalAttrs(attr, value)) {
                                            if (action === "retain") addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === "insert") addOp();
                                    $b296f782f3ab7bd5$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $b296f782f3ab7bd5$export$5f1af8db9871e1d6 extends $b296f782f3ab7bd5$export$c265dc8338484497 {
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $b296f782f3ab7bd5$export$5f1af8db9871e1d6();
    }
    /**
   * @return {YText}
   */ clone() {
        const text = new $b296f782f3ab7bd5$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $b296f782f3ab7bd5$export$51155b8ebb74188a(this, transaction, parentSubs);
        const doc = transaction.doc;
        $b296f782f3ab7bd5$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local) {
            // check if another formatting item was inserted
            let foundFormattingItem = false;
            for (const [client, afterClock] of transaction.afterState.entries()){
                const clock = transaction.beforeState.get(client) || 0;
                if (afterClock === clock) continue;
                $b296f782f3ab7bd5$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
                    if (!item.deleted && /** @type {Item} */ item.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88) foundFormattingItem = true;
                });
                if (foundFormattingItem) break;
            }
            if (!foundFormattingItem) $b296f782f3ab7bd5$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
                if (item instanceof $b296f782f3ab7bd5$export$12d259ff017e6b58 || foundFormattingItem) return;
                if (item.parent === this && item.content.constructor === $b296f782f3ab7bd5$export$3194899188fb5a88) foundFormattingItem = true;
            });
            $b296f782f3ab7bd5$export$dac1bad6146b2469(doc, (t)=>{
                if (foundFormattingItem) // If a formatting item was inserted, we simply clean the whole type.
                // We need to compute currentAttributes for the current position anyway.
                $b296f782f3ab7bd5$export$5d9f53c13ebffb65(this);
                else // If no formatting attribute was inserted, we can make due with contextless
                // formatting cleanups.
                // Contextless: it is not necessary to compute currentAttributes for the affected position.
                $b296f782f3ab7bd5$export$8afefebbaf4e4c78(t, t.deleteSet, (item)=>{
                    if (item instanceof $b296f782f3ab7bd5$export$12d259ff017e6b58) return;
                    if (item.parent === this) $b296f782f3ab7bd5$var$cleanupContextlessFormattingGap(t, item);
                });
            });
        }
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        let str = "";
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $b296f782f3ab7bd5$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true  } = {}) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $b296f782f3ab7bd5$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === "string" && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === "\n" ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== "string" || ins.length > 0) $b296f782f3ab7bd5$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $b296f782f3ab7bd5$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $b296f782f3ab7bd5$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = "";
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = "";
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($b296f782f3ab7bd5$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $b296f782f3ab7bd5$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $b296f782f3ab7bd5$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get("ychange");
                            if (snapshot !== undefined && !$b296f782f3ab7bd5$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "removed") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("removed", n.id) : {
                                        type: "removed"
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$b296f782f3ab7bd5$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "added") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("added", n.id) : {
                                        type: "added"
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete("ychange");
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $b296f782f3ab7bd5$export$e2e108cbe2e4f865:
                    case $b296f782f3ab7bd5$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $b296f782f3ab7bd5$export$3194899188fb5a88:
                        if ($b296f782f3ab7bd5$var$isVisible(n, snapshot)) {
                            packStr();
                            $b296f782f3ab7bd5$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $b296f782f3ab7bd5$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $b296f782f3ab7bd5$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $b296f782f3ab7bd5$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, "cleanup");
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $b296f782f3ab7bd5$var$findPosition(transaction, this, index);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $b296f782f3ab7bd5$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes = {}) {
        const y = this.doc;
        if (y !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $b296f782f3ab7bd5$var$findPosition(transaction, this, index);
            $b296f782f3ab7bd5$var$insertText(transaction, this, pos, embed, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(y, (transaction)=>{
            $b296f782f3ab7bd5$var$deleteText(transaction, $b296f782f3ab7bd5$var$findPosition(transaction, this, index), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $b296f782f3ab7bd5$var$findPosition(transaction, this, index);
            if (pos.right === null) return;
            $b296f782f3ab7bd5$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $b296f782f3ab7bd5$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $b296f782f3ab7bd5$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYText = (_decoder)=>new $b296f782f3ab7bd5$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $b296f782f3ab7bd5$var$YXmlTreeWalker {
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
    }
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $b296f782f3ab7bd5$export$4db87581d3ca170d || type.constructor === $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                if (n.right !== null) {
                    n = n.right;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7 extends $b296f782f3ab7bd5$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7();
    }
    /**
   * @return {YXmlFragment}
   */ clone() {
        const el = new $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $b296f782f3ab7bd5$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $b296f782f3ab7bd5$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $5e5c19b0ad9b04d4$export$6788812c4e6611e6(new $b296f782f3ab7bd5$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $b296f782f3ab7bd5$var$callTypeObservers(this, transaction, new $b296f782f3ab7bd5$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $b296f782f3ab7bd5$var$typeListMap(this, (xml)=>xml.toString()).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $b296f782f3ab7bd5$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? ref._item : ref;
            $b296f782f3ab7bd5$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $a12da43118d917e2$export$185802fd694ee1f5("Reference item not found");
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $b296f782f3ab7bd5$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Preppends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to preppend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $b296f782f3ab7bd5$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $b296f782f3ab7bd5$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on overy child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $b296f782f3ab7bd5$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YXmlFragmentRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYXmlFragment = (_decoder)=>new $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}.
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $b296f782f3ab7bd5$export$4db87581d3ca170d extends $b296f782f3ab7bd5$export$d5ce8c3e1731f1a7 {
    constructor(nodeName = "UNDEFINED"){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $b296f782f3ab7bd5$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $b296f782f3ab7bd5$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $3f96a8565a5b4a5a$export$4b80e395e36b5a56(attrs, (value, key)=>{
            if (typeof value === "string") el.setAttribute(key, value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $b296f782f3ab7bd5$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? " " + stringBuilder.join(" ") : "";
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $b296f782f3ab7bd5$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $b296f782f3ab7bd5$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $b296f782f3ab7bd5$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $b296f782f3ab7bd5$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return /** @type {any} */ $b296f782f3ab7bd5$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === "string") dom.setAttribute(key, value);
        }
        $b296f782f3ab7bd5$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $b296f782f3ab7bd5$var$readYXmlElement = (decoder)=>new $b296f782f3ab7bd5$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $b296f782f3ab7bd5$export$88c9145a0c3b556c extends $b296f782f3ab7bd5$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $b296f782f3ab7bd5$export$ec64c1dd5e7a264 extends $b296f782f3ab7bd5$export$a5c7b93649eaf8f8 {
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $b296f782f3ab7bd5$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * @return {YXmlHook}
   */ clone() {
        const el = new $b296f782f3ab7bd5$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute("data-yjs-hook", this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYXmlHook = (decoder)=>new $b296f782f3ab7bd5$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $b296f782f3ab7bd5$export$b35b8f45887823df extends $b296f782f3ab7bd5$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $b296f782f3ab7bd5$export$b35b8f45887823df();
    }
    /**
   * @return {YXmlText}
   */ clone() {
        const text = new $b296f782f3ab7bd5$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = "";
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += ">";
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($b296f782f3ab7bd5$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $b296f782f3ab7bd5$var$readYXmlText = (decoder)=>new $b296f782f3ab7bd5$export$b35b8f45887823df();
class $b296f782f3ab7bd5$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
    /**
   * @type {boolean}
   */ get deleted() {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
}
const $b296f782f3ab7bd5$var$structGCRefNumber = 0;
/**
 * @private
 */ class $b296f782f3ab7bd5$export$12d259ff017e6b58 extends $b296f782f3ab7bd5$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $b296f782f3ab7bd5$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($b296f782f3ab7bd5$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $b296f782f3ab7bd5$export$e8d530cdf62d1cbd {
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $b296f782f3ab7bd5$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $b296f782f3ab7bd5$var$readContentBinary = (decoder)=>new $b296f782f3ab7bd5$export$e8d530cdf62d1cbd(decoder.readBuf());
class $b296f782f3ab7bd5$export$3b06e0b3a2ece602 {
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $b296f782f3ab7bd5$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $b296f782f3ab7bd5$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $b296f782f3ab7bd5$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $b296f782f3ab7bd5$var$readContentDeleted = (decoder)=>new $b296f782f3ab7bd5$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $b296f782f3ab7bd5$var$createDocFromOpts = (guid, opts)=>new $b296f782f3ab7bd5$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $b296f782f3ab7bd5$var$ContentDoc {
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid.");
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $b296f782f3ab7bd5$var$ContentDoc($b296f782f3ab7bd5$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $b296f782f3ab7bd5$var$readContentDoc = (decoder)=>new $b296f782f3ab7bd5$var$ContentDoc($b296f782f3ab7bd5$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $b296f782f3ab7bd5$export$c3787ba7f6086664 {
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $b296f782f3ab7bd5$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $b296f782f3ab7bd5$var$readContentEmbed = (decoder)=>new $b296f782f3ab7bd5$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $b296f782f3ab7bd5$export$3194899188fb5a88 {
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $b296f782f3ab7bd5$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} offset
   * @return {ContentFormat}
   */ splice(offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentFormat} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        /** @type {AbstractType<any>} */ item.parent._searchMarker = null;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $b296f782f3ab7bd5$var$readContentFormat = (decoder)=>new $b296f782f3ab7bd5$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $b296f782f3ab7bd5$export$6a907ea8f733ecf3 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $b296f782f3ab7bd5$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $b296f782f3ab7bd5$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? "undefined" : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $b296f782f3ab7bd5$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === "undefined") cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $b296f782f3ab7bd5$export$6a907ea8f733ecf3(cs);
};
class $b296f782f3ab7bd5$export$1d788b93bbb631a0 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $b296f782f3ab7bd5$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $b296f782f3ab7bd5$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $b296f782f3ab7bd5$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $b296f782f3ab7bd5$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $b296f782f3ab7bd5$export$ee670b2cf091bbb6 {
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split("");
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $b296f782f3ab7bd5$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $b296f782f3ab7bd5$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "�";
            // replace right as well
            right.str = "�" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $b296f782f3ab7bd5$var$readContentString = (decoder)=>new $b296f782f3ab7bd5$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $b296f782f3ab7bd5$var$typeRefs = [
    $b296f782f3ab7bd5$var$readYArray,
    $b296f782f3ab7bd5$var$readYMap,
    $b296f782f3ab7bd5$var$readYText,
    $b296f782f3ab7bd5$var$readYXmlElement,
    $b296f782f3ab7bd5$var$readYXmlFragment,
    $b296f782f3ab7bd5$var$readYXmlHook,
    $b296f782f3ab7bd5$var$readYXmlText
];
const $b296f782f3ab7bd5$var$YArrayRefID = 0;
const $b296f782f3ab7bd5$var$YMapRefID = 1;
const $b296f782f3ab7bd5$var$YTextRefID = 2;
const $b296f782f3ab7bd5$var$YXmlElementRefID = 3;
const $b296f782f3ab7bd5$var$YXmlFragmentRefID = 4;
const $b296f782f3ab7bd5$var$YXmlHookRefID = 5;
const $b296f782f3ab7bd5$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $b296f782f3ab7bd5$export$e2e108cbe2e4f865 {
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $b296f782f3ab7bd5$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $a12da43118d917e2$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $b296f782f3ab7bd5$var$readContentType = (decoder)=>new $b296f782f3ab7bd5$export$e2e108cbe2e4f865($b296f782f3ab7bd5$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $b296f782f3ab7bd5$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $b296f782f3ab7bd5$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $b296f782f3ab7bd5$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $b296f782f3ab7bd5$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $b296f782f3ab7bd5$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $b296f782f3ab7bd5$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client , clock: clock  } = leftItem.id;
    const rightItem = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2($b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $b296f782f3ab7bd5$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $b296f782f3ab7bd5$var$isDeletedByUndoStack = (stack, id)=>$5e5c19b0ad9b04d4$export$ad14ef4001db2bcd(stack, /** @param {StackItem} s */ (s)=>$b296f782f3ab7bd5$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $b296f782f3ab7bd5$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $b296f782f3ab7bd5$var$getItemCleanStart(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $b296f782f3ab7bd5$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $b296f782f3ab7bd5$var$getItemCleanStart(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $b296f782f3ab7bd5$var$getItemCleanStart(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $b296f782f3ab7bd5$var$getItemCleanStart(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $b296f782f3ab7bd5$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $b296f782f3ab7bd5$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $b296f782f3ab7bd5$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $b296f782f3ab7bd5$var$getItemCleanStart(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $b296f782f3ab7bd5$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $b296f782f3ab7bd5$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $b296f782f3ab7bd5$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $b296f782f3ab7bd5$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $b296f782f3ab7bd5$export$6d08773d2e66f8f2 extends $b296f782f3ab7bd5$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $8d6ba0cc01579050$export$1f117f3b0edc2676 : 0;
    }
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $8d6ba0cc01579050$export$873ae8db4cef5125) > 0 !== isMarked) this.info ^= $8d6ba0cc01579050$export$873ae8db4cef5125;
    }
    get marker() {
        return (this.info & $8d6ba0cc01579050$export$873ae8db4cef5125) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $8d6ba0cc01579050$export$ee2c6657cb286da4) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $8d6ba0cc01579050$export$ee2c6657cb286da4;
    }
    get countable() {
        return (this.info & $8d6ba0cc01579050$export$1f117f3b0edc2676) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $8d6ba0cc01579050$export$e5294f8c78cf7711) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $8d6ba0cc01579050$export$e5294f8c78cf7711;
    }
    markDeleted() {
        this.info |= $8d6ba0cc01579050$export$e5294f8c78cf7711;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $b296f782f3ab7bd5$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $b296f782f3ab7bd5$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $b296f782f3ab7bd5$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $b296f782f3ab7bd5$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $b296f782f3ab7bd5$var$getItemCleanEnd(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $b296f782f3ab7bd5$var$getItemCleanStart(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $b296f782f3ab7bd5$export$12d259ff017e6b58 || this.right && this.right.constructor === $b296f782f3ab7bd5$export$12d259ff017e6b58) this.parent = null;
        // only set parent if this shouldn't be garbage collected
        if (!this.parent) {
            if (this.left && this.left.constructor === $b296f782f3ab7bd5$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            }
            if (this.right && this.right.constructor === $b296f782f3ab7bd5$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $b296f782f3ab7bd5$export$8be180ec26319f9f) {
            const parentItem = $b296f782f3ab7bd5$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $b296f782f3ab7bd5$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $b296f782f3ab7bd5$var$getItemCleanEnd(transaction, transaction.doc.store, $b296f782f3ab7bd5$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($b296f782f3ab7bd5$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($b296f782f3ab7bd5$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($b296f782f3ab7bd5$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($b296f782f3ab7bd5$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $b296f782f3ab7bd5$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $b296f782f3ab7bd5$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $b296f782f3ab7bd5$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $b296f782f3ab7bd5$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $b296f782f3ab7bd5$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $b296f782f3ab7bd5$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $b296f782f3ab7bd5$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $b296f782f3ab7bd5$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $a12da43118d917e2$export$965b6bccecbd9673();
        this.content.gc(store);
        if (parentGCd) $b296f782f3ab7bd5$var$replaceStruct(store, this, new $b296f782f3ab7bd5$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $b296f782f3ab7bd5$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $b296f782f3ab7bd5$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $8d6ba0cc01579050$export$bc2aba63e4099c09 | (origin === null ? 0 : $8d6ba0cc01579050$export$e25597372303a045) | // origin is defined
        (rightOrigin === null ? 0 : $8d6ba0cc01579050$export$eb5a8e0006ab4bb5) | // right origin is defined
        (parentSub === null ? 0 : $8d6ba0cc01579050$export$daf23f774967089); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $b296f782f3ab7bd5$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $b296f782f3ab7bd5$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $a12da43118d917e2$export$965b6bccecbd9673();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $b296f782f3ab7bd5$var$readItemContent = (decoder, info)=>$b296f782f3ab7bd5$var$contentRefs[info & $8d6ba0cc01579050$export$bc2aba63e4099c09](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $b296f782f3ab7bd5$var$contentRefs = [
    ()=>{
        $a12da43118d917e2$export$965b6bccecbd9673();
    },
    $b296f782f3ab7bd5$var$readContentDeleted,
    $b296f782f3ab7bd5$var$readContentJSON,
    $b296f782f3ab7bd5$var$readContentBinary,
    $b296f782f3ab7bd5$var$readContentString,
    $b296f782f3ab7bd5$var$readContentEmbed,
    $b296f782f3ab7bd5$var$readContentFormat,
    $b296f782f3ab7bd5$var$readContentType,
    $b296f782f3ab7bd5$var$readContentAny,
    $b296f782f3ab7bd5$var$readContentDoc,
    ()=>{
        $a12da43118d917e2$export$965b6bccecbd9673();
    } // 10 - Skip is not ItemContent
];
const $b296f782f3ab7bd5$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $b296f782f3ab7bd5$var$Skip extends $b296f782f3ab7bd5$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $a12da43118d917e2$export$965b6bccecbd9673();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($b296f782f3ab7bd5$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $b296f782f3ab7bd5$var$glo = /** @type {any} */ typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $b296f782f3ab7bd5$var$importIdentifier = "__ $YJS$ __";
if ($b296f782f3ab7bd5$var$glo[$b296f782f3ab7bd5$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
$b296f782f3ab7bd5$var$glo[$b296f782f3ab7bd5$var$importIdentifier] = true;


const $aff334e6d2778608$export$edbc8479a3fd0d51 = 0;
const $aff334e6d2778608$export$ff102031071a8f85 = 1;
const $aff334e6d2778608$export$f589a35bfce33e17 = 2;
const $aff334e6d2778608$export$2a4abf6cf2c7e66f = (encoder, doc)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $aff334e6d2778608$export$edbc8479a3fd0d51);
    const sv = $b296f782f3ab7bd5$export$3e2f5393f32e71f(doc);
    $7f295e825046a0c3$export$f7d11515275e88a2(encoder, sv);
};
const $aff334e6d2778608$export$b2b01faa10f64871 = (encoder, doc, encodedStateVector)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $aff334e6d2778608$export$ff102031071a8f85);
    $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $b296f782f3ab7bd5$export$e5848df80e65bd53(doc, encodedStateVector));
};
const $aff334e6d2778608$export$24e7fa74cb33e063 = (decoder, encoder, doc)=>$aff334e6d2778608$export$b2b01faa10f64871(encoder, doc, $902b843224f0f9d8$export$7418bbc18dee40f3(decoder));
const $aff334e6d2778608$export$60818ebea09048c1 = (decoder, doc, transactionOrigin)=>{
    try {
        $b296f782f3ab7bd5$export$c271737a9c02e925(doc, $902b843224f0f9d8$export$7418bbc18dee40f3(decoder), transactionOrigin);
    } catch (error) {
        // This catches errors that are thrown by event handlers
        console.error("Caught error while handling a Yjs update", error);
    }
};
const $aff334e6d2778608$export$72c173541034b28e = (encoder, update)=>{
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $aff334e6d2778608$export$f589a35bfce33e17);
    $7f295e825046a0c3$export$f7d11515275e88a2(encoder, update);
};
const $aff334e6d2778608$export$d67ac8d73b7d336c = $aff334e6d2778608$export$60818ebea09048c1;
const $aff334e6d2778608$export$26b589e63b591e96 = (decoder, encoder, doc, transactionOrigin)=>{
    const messageType = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    switch(messageType){
        case $aff334e6d2778608$export$edbc8479a3fd0d51:
            $aff334e6d2778608$export$24e7fa74cb33e063(decoder, encoder, doc);
            break;
        case $aff334e6d2778608$export$ff102031071a8f85:
            $aff334e6d2778608$export$60818ebea09048c1(decoder, doc, transactionOrigin);
            break;
        case $aff334e6d2778608$export$f589a35bfce33e17:
            $aff334e6d2778608$export$d67ac8d73b7d336c(decoder, doc, transactionOrigin);
            break;
        default:
            throw new Error("Unknown message type");
    }
    return messageType;
};


/**
 * @module awareness-protocol
 */ 






const $0b85c37db714c324$export$47b58b45939fff5e = 30000;
class $0b85c37db714c324$export$5bb40478b91fee65 extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {Y.Doc} doc
   */ constructor(doc){
        super();
        this.doc = doc;
        /**
     * @type {number}
     */ this.clientID = doc.clientID;
        /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */ this.states = new Map();
        /**
     * @type {Map<number, MetaClientState>}
     */ this.meta = new Map();
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            const now = $a69ef2806e7968d3$export$1f77c0008d16313();
            if (this.getLocalState() !== null && $0b85c37db714c324$export$47b58b45939fff5e / 2 <= now - /** @type {{lastUpdated:number}} */ this.meta.get(this.clientID).lastUpdated) // renew local clock
            this.setLocalState(this.getLocalState());
            /**
       * @type {Array<number>}
       */ const remove = [];
            this.meta.forEach((meta, clientid)=>{
                if (clientid !== this.clientID && $0b85c37db714c324$export$47b58b45939fff5e <= now - meta.lastUpdated && this.states.has(clientid)) remove.push(clientid);
            });
            if (remove.length > 0) $0b85c37db714c324$export$3edbfe2f45ae9ff8(this, remove, "timeout");
        }, $e8fac97060e7c35b$export$a3fe094919f356fd($0b85c37db714c324$export$47b58b45939fff5e / 10));
        doc.on("destroy", ()=>{
            this.destroy();
        });
        this.setLocalState({});
    }
    destroy() {
        this.emit("destroy", [
            this
        ]);
        this.setLocalState(null);
        super.destroy();
        clearInterval(this._checkInterval);
    }
    /**
   * @return {Object<string,any>|null}
   */ getLocalState() {
        return this.states.get(this.clientID) || null;
    }
    /**
   * @param {Object<string,any>|null} state
   */ setLocalState(state) {
        const clientID = this.clientID;
        const currLocalMeta = this.meta.get(clientID);
        const clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
        const prevState = this.states.get(clientID);
        if (state === null) this.states.delete(clientID);
        else this.states.set(clientID, state);
        this.meta.set(clientID, {
            clock: clock,
            lastUpdated: $a69ef2806e7968d3$export$1f77c0008d16313()
        });
        const added = [];
        const updated = [];
        const filteredUpdated = [];
        const removed = [];
        if (state === null) removed.push(clientID);
        else if (prevState == null) {
            if (state != null) added.push(clientID);
        } else {
            updated.push(clientID);
            if (!$335a02b91f00a29d$export$2ca9a723affd5d11(prevState, state)) filteredUpdated.push(clientID);
        }
        if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit("change", [
            {
                added: added,
                updated: filteredUpdated,
                removed: removed
            },
            "local"
        ]);
        this.emit("update", [
            {
                added: added,
                updated: updated,
                removed: removed
            },
            "local"
        ]);
    }
    /**
   * @param {string} field
   * @param {any} value
   */ setLocalStateField(field, value) {
        const state = this.getLocalState();
        if (state !== null) this.setLocalState({
            ...state,
            [field]: value
        });
    }
    /**
   * @return {Map<number,Object<string,any>>}
   */ getStates() {
        return this.states;
    }
}
const $0b85c37db714c324$export$3edbfe2f45ae9ff8 = (awareness, clients, origin)=>{
    const removed = [];
    for(let i = 0; i < clients.length; i++){
        const clientID = clients[i];
        if (awareness.states.has(clientID)) {
            awareness.states.delete(clientID);
            if (clientID === awareness.clientID) {
                const curMeta = /** @type {MetaClientState} */ awareness.meta.get(clientID);
                awareness.meta.set(clientID, {
                    clock: curMeta.clock + 1,
                    lastUpdated: $a69ef2806e7968d3$export$1f77c0008d16313()
                });
            }
            removed.push(clientID);
        }
    }
    if (removed.length > 0) {
        awareness.emit("change", [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
        awareness.emit("update", [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
    }
};
const $0b85c37db714c324$export$e194fa93ebd743e9 = (awareness, clients, states = awareness.states)=>{
    const len = clients.length;
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = clients[i];
        const state = states.get(clientID) || null;
        const clock = /** @type {MetaClientState} */ awareness.meta.get(clientID).clock;
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, clientID);
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, clock);
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, JSON.stringify(state));
    }
    return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
};
const $0b85c37db714c324$export$17dfc8fb4d274726 = (update, modify)=>{
    const decoder = $902b843224f0f9d8$export$f8c898e83b60faaa(update);
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    $7f295e825046a0c3$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        const clock = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        const state = JSON.parse($902b843224f0f9d8$export$3b64b4d753b81ec2(decoder));
        const modifiedState = modify(state);
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, clientID);
        $7f295e825046a0c3$export$872f48c75febcd2b(encoder, clock);
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoder, JSON.stringify(modifiedState));
    }
    return $7f295e825046a0c3$export$73470fd2221e6aef(encoder);
};
const $0b85c37db714c324$export$2f92845406d72d1a = (awareness, update, origin)=>{
    const decoder = $902b843224f0f9d8$export$f8c898e83b60faaa(update);
    const timestamp = $a69ef2806e7968d3$export$1f77c0008d16313();
    const added = [];
    const updated = [];
    const filteredUpdated = [];
    const removed = [];
    const len = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    for(let i = 0; i < len; i++){
        const clientID = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        let clock = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
        const state = JSON.parse($902b843224f0f9d8$export$3b64b4d753b81ec2(decoder));
        const clientMeta = awareness.meta.get(clientID);
        const prevState = awareness.states.get(clientID);
        const currClock = clientMeta === undefined ? 0 : clientMeta.clock;
        if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
            if (state === null) {
                // never let a remote client remove this local state
                if (clientID === awareness.clientID && awareness.getLocalState() != null) // remote client removed the local state. Do not remote state. Broadcast a message indicating
                // that this client still exists by increasing the clock
                clock++;
                else awareness.states.delete(clientID);
            } else awareness.states.set(clientID, state);
            awareness.meta.set(clientID, {
                clock: clock,
                lastUpdated: timestamp
            });
            if (clientMeta === undefined && state !== null) added.push(clientID);
            else if (clientMeta !== undefined && state === null) removed.push(clientID);
            else if (state !== null) {
                if (!$335a02b91f00a29d$export$2ca9a723affd5d11(state, prevState)) filteredUpdated.push(clientID);
                updated.push(clientID);
            }
        }
    }
    if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit("change", [
        {
            added: added,
            updated: filteredUpdated,
            removed: removed
        },
        origin
    ]);
    if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit("update", [
        {
            added: added,
            updated: updated,
            removed: removed
        },
        origin
    ]);
};


/* eslint-env browser */ 




const $923794c2749cc634$export$87770b6b245073b5 = (secret, roomName)=>{
    const secretBuffer = $8322690016f3fe63$export$8f647c2204da8484(secret).buffer;
    const salt = $8322690016f3fe63$export$8f647c2204da8484(roomName).buffer;
    return crypto.subtle.importKey("raw", secretBuffer, "PBKDF2", false, [
        "deriveKey"
    ]).then((keyMaterial)=>crypto.subtle.deriveKey({
            name: "PBKDF2",
            salt: salt,
            iterations: 100000,
            hash: "SHA-256"
        }, keyMaterial, {
            name: "AES-GCM",
            length: 256
        }, true, [
            "encrypt",
            "decrypt"
        ]));
};
const $923794c2749cc634$export$5b0f6292f11d1d18 = (data, key)=>{
    if (!key) return /** @type {PromiseLike<Uint8Array>} */ $5719c92748a1df45$export$f7ad0328861e2f03(data);
    const iv = crypto.getRandomValues(new Uint8Array(12));
    return crypto.subtle.encrypt({
        name: "AES-GCM",
        iv: iv
    }, key, data).then((cipher)=>{
        const encryptedDataEncoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$dde49cb52d5f1650(encryptedDataEncoder, "AES-GCM");
        $7f295e825046a0c3$export$f7d11515275e88a2(encryptedDataEncoder, iv);
        $7f295e825046a0c3$export$f7d11515275e88a2(encryptedDataEncoder, new Uint8Array(cipher));
        return $7f295e825046a0c3$export$73470fd2221e6aef(encryptedDataEncoder);
    });
};
const $923794c2749cc634$export$afc50bd9a9c5e54f = (data, key)=>{
    const dataEncoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    $7f295e825046a0c3$export$264b1e8551468ea(dataEncoder, data);
    return $923794c2749cc634$export$5b0f6292f11d1d18($7f295e825046a0c3$export$73470fd2221e6aef(dataEncoder), key);
};
const $923794c2749cc634$export$e85a0c9a1067c5d3 = (data, key)=>{
    if (!key) return /** @type {PromiseLike<Uint8Array>} */ $5719c92748a1df45$export$f7ad0328861e2f03(data);
    const dataDecoder = $902b843224f0f9d8$export$f8c898e83b60faaa(data);
    const algorithm = $902b843224f0f9d8$export$3b64b4d753b81ec2(dataDecoder);
    if (algorithm !== "AES-GCM") $5719c92748a1df45$export$2800f3ceda99eb84($a12da43118d917e2$export$185802fd694ee1f5("Unknown encryption algorithm"));
    const iv = $902b843224f0f9d8$export$7418bbc18dee40f3(dataDecoder);
    const cipher = $902b843224f0f9d8$export$7418bbc18dee40f3(dataDecoder);
    return crypto.subtle.decrypt({
        name: "AES-GCM",
        iv: iv
    }, key, cipher).then((data)=>new Uint8Array(data));
};
const $923794c2749cc634$export$efb11b8913a3b629 = (data, key)=>$923794c2749cc634$export$e85a0c9a1067c5d3(data, key).then((decryptedValue)=>$902b843224f0f9d8$export$82863139061f472f($902b843224f0f9d8$export$f8c898e83b60faaa(new Uint8Array(decryptedValue))));



const $4d01f1203e5c8378$var$log = $73ec8bbf24ec5444$export$c2977e725d59a2fd("y-webrtc");
const $4d01f1203e5c8378$var$messageSync = 0;
const $4d01f1203e5c8378$var$messageQueryAwareness = 3;
const $4d01f1203e5c8378$var$messageAwareness = 1;
const $4d01f1203e5c8378$var$messageBcPeerId = 4;
/**
 * @type {Map<string, SignalingConn>}
 */ const $4d01f1203e5c8378$var$signalingConns = new Map();
/**
 * @type {Map<string,Room>}
 */ const $4d01f1203e5c8378$var$rooms = new Map();
/**
 * @param {Room} room
 */ const $4d01f1203e5c8378$var$checkIsSynced = (room)=>{
    let synced = true;
    room.webrtcConns.forEach((peer)=>{
        if (!peer.synced) synced = false;
    });
    if (!synced && room.synced || synced && !room.synced) {
        room.synced = synced;
        room.provider.emit("synced", [
            {
                synced: synced
            }
        ]);
        $4d01f1203e5c8378$var$log("synced ", $792d43f9d2752e68$export$c1286c4c2a7c066, room.name, $792d43f9d2752e68$export$f0ce1666bb40789b, " with all peers");
    }
};
/**
 * @param {Room} room
 * @param {Uint8Array} buf
 * @param {function} syncedCallback
 * @return {encoding.Encoder?}
 */ const $4d01f1203e5c8378$var$readMessage = (room, buf, syncedCallback)=>{
    const decoder = $902b843224f0f9d8$export$f8c898e83b60faaa(buf);
    const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
    const messageType = $902b843224f0f9d8$export$5a476e4dbe7923d5(decoder);
    if (room === undefined) return null;
    const awareness = room.awareness;
    const doc = room.doc;
    let sendReply = false;
    switch(messageType){
        case $4d01f1203e5c8378$var$messageSync:
            {
                $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $4d01f1203e5c8378$var$messageSync);
                const syncMessageType = $aff334e6d2778608$export$26b589e63b591e96(decoder, encoder, doc, room);
                if (syncMessageType === $aff334e6d2778608$export$ff102031071a8f85 && !room.synced) syncedCallback();
                if (syncMessageType === $aff334e6d2778608$export$edbc8479a3fd0d51) sendReply = true;
                break;
            }
        case $4d01f1203e5c8378$var$messageQueryAwareness:
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $4d01f1203e5c8378$var$messageAwareness);
            $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $0b85c37db714c324$export$e194fa93ebd743e9(awareness, Array.from(awareness.getStates().keys())));
            sendReply = true;
            break;
        case $4d01f1203e5c8378$var$messageAwareness:
            $0b85c37db714c324$export$2f92845406d72d1a(awareness, $902b843224f0f9d8$export$7418bbc18dee40f3(decoder), room);
            break;
        case $4d01f1203e5c8378$var$messageBcPeerId:
            {
                const add = $902b843224f0f9d8$export$d5778a2beba4ceef(decoder) === 1;
                const peerName = $902b843224f0f9d8$export$3b64b4d753b81ec2(decoder);
                if (peerName !== room.peerId && (room.bcConns.has(peerName) && !add || !room.bcConns.has(peerName) && add)) {
                    const removed = [];
                    const added = [];
                    if (add) {
                        room.bcConns.add(peerName);
                        added.push(peerName);
                    } else {
                        room.bcConns.delete(peerName);
                        removed.push(peerName);
                    }
                    room.provider.emit("peers", [
                        {
                            added: added,
                            removed: removed,
                            webrtcPeers: Array.from(room.webrtcConns.keys()),
                            bcPeers: Array.from(room.bcConns)
                        }
                    ]);
                    $4d01f1203e5c8378$var$broadcastBcPeerId(room);
                }
                break;
            }
        default:
            console.error("Unable to compute message");
            return encoder;
    }
    if (!sendReply) // nothing has been written, no answer created
    return null;
    return encoder;
};
/**
 * @param {WebrtcConn} peerConn
 * @param {Uint8Array} buf
 * @return {encoding.Encoder?}
 */ const $4d01f1203e5c8378$var$readPeerMessage = (peerConn, buf)=>{
    const room = peerConn.room;
    $4d01f1203e5c8378$var$log("received message from ", $792d43f9d2752e68$export$c1286c4c2a7c066, peerConn.remotePeerId, $792d43f9d2752e68$export$7d278ca694634874, " (", room.name, ")", $792d43f9d2752e68$export$f0ce1666bb40789b, $792d43f9d2752e68$export$b586f81201748dd0);
    return $4d01f1203e5c8378$var$readMessage(room, buf, ()=>{
        peerConn.synced = true;
        $4d01f1203e5c8378$var$log("synced ", $792d43f9d2752e68$export$c1286c4c2a7c066, room.name, $792d43f9d2752e68$export$f0ce1666bb40789b, " with ", $792d43f9d2752e68$export$c1286c4c2a7c066, peerConn.remotePeerId);
        $4d01f1203e5c8378$var$checkIsSynced(room);
    });
};
/**
 * @param {WebrtcConn} webrtcConn
 * @param {encoding.Encoder} encoder
 */ const $4d01f1203e5c8378$var$sendWebrtcConn = (webrtcConn, encoder)=>{
    $4d01f1203e5c8378$var$log("send message to ", $792d43f9d2752e68$export$c1286c4c2a7c066, webrtcConn.remotePeerId, $792d43f9d2752e68$export$f0ce1666bb40789b, $792d43f9d2752e68$export$7d278ca694634874, " (", webrtcConn.room.name, ")", $792d43f9d2752e68$export$b586f81201748dd0);
    try {
        webrtcConn.peer.send($7f295e825046a0c3$export$73470fd2221e6aef(encoder));
    } catch (e) {}
};
/**
 * @param {Room} room
 * @param {Uint8Array} m
 */ const $4d01f1203e5c8378$var$broadcastWebrtcConn = (room, m)=>{
    $4d01f1203e5c8378$var$log("broadcast message in ", $792d43f9d2752e68$export$c1286c4c2a7c066, room.name, $792d43f9d2752e68$export$f0ce1666bb40789b);
    room.webrtcConns.forEach((conn)=>{
        try {
            conn.peer.send(m);
        } catch (e) {}
    });
};
class $4d01f1203e5c8378$export$f2f79372b3181730 {
    /**
   * @param {SignalingConn} signalingConn
   * @param {boolean} initiator
   * @param {string} remotePeerId
   * @param {Room} room
   */ constructor(signalingConn, initiator, remotePeerId, room){
        $4d01f1203e5c8378$var$log("establishing connection to ", $792d43f9d2752e68$export$c1286c4c2a7c066, remotePeerId);
        this.room = room;
        this.remotePeerId = remotePeerId;
        this.closed = false;
        this.connected = false;
        this.synced = false;
        /**
     * @type {any}
     */ this.peer = new (0, (/*@__PURE__*/$parcel$interopDefault($804372685f7be473$exports)))({
            initiator: initiator,
            ...room.provider.peerOpts
        });
        this.peer.on("signal", (signal)=>{
            $4d01f1203e5c8378$var$publishSignalingMessage(signalingConn, room, {
                to: remotePeerId,
                from: room.peerId,
                type: "signal",
                signal: signal
            });
        });
        this.peer.on("connect", ()=>{
            $4d01f1203e5c8378$var$log("connected to ", $792d43f9d2752e68$export$c1286c4c2a7c066, remotePeerId);
            this.connected = true;
            // send sync step 1
            const provider = room.provider;
            const doc = provider.doc;
            const awareness = room.awareness;
            const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $4d01f1203e5c8378$var$messageSync);
            $aff334e6d2778608$export$2a4abf6cf2c7e66f(encoder, doc);
            $4d01f1203e5c8378$var$sendWebrtcConn(this, encoder);
            const awarenessStates = awareness.getStates();
            if (awarenessStates.size > 0) {
                const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
                $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $4d01f1203e5c8378$var$messageAwareness);
                $7f295e825046a0c3$export$f7d11515275e88a2(encoder, $0b85c37db714c324$export$e194fa93ebd743e9(awareness, Array.from(awarenessStates.keys())));
                $4d01f1203e5c8378$var$sendWebrtcConn(this, encoder);
            }
        });
        this.peer.on("close", ()=>{
            this.connected = false;
            this.closed = true;
            if (room.webrtcConns.has(this.remotePeerId)) {
                room.webrtcConns.delete(this.remotePeerId);
                room.provider.emit("peers", [
                    {
                        removed: [
                            this.remotePeerId
                        ],
                        added: [],
                        webrtcPeers: Array.from(room.webrtcConns.keys()),
                        bcPeers: Array.from(room.bcConns)
                    }
                ]);
            }
            $4d01f1203e5c8378$var$checkIsSynced(room);
            this.peer.destroy();
            $4d01f1203e5c8378$var$log("closed connection to ", $792d43f9d2752e68$export$c1286c4c2a7c066, remotePeerId);
            $4d01f1203e5c8378$var$announceSignalingInfo(room);
        });
        this.peer.on("error", (err)=>{
            $4d01f1203e5c8378$var$log("Error in connection to ", $792d43f9d2752e68$export$c1286c4c2a7c066, remotePeerId, ": ", err);
            $4d01f1203e5c8378$var$announceSignalingInfo(room);
        });
        this.peer.on("data", (data)=>{
            const answer = $4d01f1203e5c8378$var$readPeerMessage(this, data);
            if (answer !== null) $4d01f1203e5c8378$var$sendWebrtcConn(this, answer);
        });
    }
    destroy() {
        this.peer.destroy();
    }
}
/**
 * @param {Room} room
 * @param {Uint8Array} m
 */ const $4d01f1203e5c8378$var$broadcastBcMessage = (room, m)=>$923794c2749cc634$export$5b0f6292f11d1d18(m, room.key).then((data)=>room.mux(()=>$264c0479ab4113a8$export$89b472e03be495df(room.name, data)));
/**
 * @param {Room} room
 * @param {Uint8Array} m
 */ const $4d01f1203e5c8378$var$broadcastRoomMessage = (room, m)=>{
    if (room.bcconnected) $4d01f1203e5c8378$var$broadcastBcMessage(room, m);
    $4d01f1203e5c8378$var$broadcastWebrtcConn(room, m);
};
/**
 * @param {Room} room
 */ const $4d01f1203e5c8378$var$announceSignalingInfo = (room)=>{
    $4d01f1203e5c8378$var$signalingConns.forEach((conn)=>{
        // only subcribe if connection is established, otherwise the conn automatically subscribes to all rooms
        if (conn.connected) {
            conn.send({
                type: "subscribe",
                topics: [
                    room.name
                ]
            });
            if (room.webrtcConns.size < room.provider.maxConns) $4d01f1203e5c8378$var$publishSignalingMessage(conn, room, {
                type: "announce",
                from: room.peerId
            });
        }
    });
};
/**
 * @param {Room} room
 */ const $4d01f1203e5c8378$var$broadcastBcPeerId = (room)=>{
    if (room.provider.filterBcConns) {
        // broadcast peerId via broadcastchannel
        const encoderPeerIdBc = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderPeerIdBc, $4d01f1203e5c8378$var$messageBcPeerId);
        $7f295e825046a0c3$export$826a1a6619653272(encoderPeerIdBc, 1);
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoderPeerIdBc, room.peerId);
        $4d01f1203e5c8378$var$broadcastBcMessage(room, $7f295e825046a0c3$export$73470fd2221e6aef(encoderPeerIdBc));
    }
};
class $4d01f1203e5c8378$export$525628e68e798fb4 {
    /**
   * @param {Y.Doc} doc
   * @param {WebrtcProvider} provider
   * @param {string} name
   * @param {CryptoKey|null} key
   */ constructor(doc, provider, name, key){
        /**
     * Do not assume that peerId is unique. This is only meant for sending signaling messages.
     *
     * @type {string}
     */ this.peerId = $562771b566a9e573$export$abe4376e1bf796d6();
        this.doc = doc;
        /**
     * @type {awarenessProtocol.Awareness}
     */ this.awareness = provider.awareness;
        this.provider = provider;
        this.synced = false;
        this.name = name;
        // @todo make key secret by scoping
        this.key = key;
        /**
     * @type {Map<string, WebrtcConn>}
     */ this.webrtcConns = new Map();
        /**
     * @type {Set<string>}
     */ this.bcConns = new Set();
        this.mux = (0, $7c1d0fbe479eb726$export$6cca8a222d1193d7)();
        this.bcconnected = false;
        /**
     * @param {ArrayBuffer} data
     */ this._bcSubscriber = (data)=>$923794c2749cc634$export$e85a0c9a1067c5d3(new Uint8Array(data), key).then((m)=>this.mux(()=>{
                    const reply = $4d01f1203e5c8378$var$readMessage(this, m, ()=>{});
                    if (reply) $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(reply));
                }));
        /**
     * Listens to Yjs updates and sends them to remote peers
     *
     * @param {Uint8Array} update
     * @param {any} origin
     */ this._docUpdateHandler = (update, origin)=>{
            const encoder = $7f295e825046a0c3$export$4e76eeb6df88c889();
            $7f295e825046a0c3$export$872f48c75febcd2b(encoder, $4d01f1203e5c8378$var$messageSync);
            $aff334e6d2778608$export$72c173541034b28e(encoder, update);
            $4d01f1203e5c8378$var$broadcastRoomMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoder));
        };
        /**
     * Listens to Awareness updates and sends them to remote peers
     *
     * @param {any} changed
     * @param {any} origin
     */ this._awarenessUpdateHandler = ({ added: added , updated: updated , removed: removed  }, origin)=>{
            const changedClients = added.concat(updated).concat(removed);
            const encoderAwareness = $7f295e825046a0c3$export$4e76eeb6df88c889();
            $7f295e825046a0c3$export$872f48c75febcd2b(encoderAwareness, $4d01f1203e5c8378$var$messageAwareness);
            $7f295e825046a0c3$export$f7d11515275e88a2(encoderAwareness, $0b85c37db714c324$export$e194fa93ebd743e9(this.awareness, changedClients));
            $4d01f1203e5c8378$var$broadcastRoomMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderAwareness));
        };
        this._beforeUnloadHandler = ()=>{
            $0b85c37db714c324$export$3edbfe2f45ae9ff8(this.awareness, [
                doc.clientID
            ], "window unload");
            $4d01f1203e5c8378$var$rooms.forEach((room)=>{
                room.disconnect();
            });
        };
        if (typeof window !== "undefined") window.addEventListener("beforeunload", this._beforeUnloadHandler);
        else if (typeof $8422df313e23a2a7$exports !== "undefined") $8422df313e23a2a7$exports.on("exit", this._beforeUnloadHandler);
    }
    connect() {
        this.doc.on("update", this._docUpdateHandler);
        this.awareness.on("update", this._awarenessUpdateHandler);
        // signal through all available signaling connections
        $4d01f1203e5c8378$var$announceSignalingInfo(this);
        const roomName = this.name;
        $264c0479ab4113a8$export$ec068583843480e7(roomName, this._bcSubscriber);
        this.bcconnected = true;
        // broadcast peerId via broadcastchannel
        $4d01f1203e5c8378$var$broadcastBcPeerId(this);
        // write sync step 1
        const encoderSync = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderSync, $4d01f1203e5c8378$var$messageSync);
        $aff334e6d2778608$export$2a4abf6cf2c7e66f(encoderSync, this.doc);
        $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderSync));
        // broadcast local state
        const encoderState = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderState, $4d01f1203e5c8378$var$messageSync);
        $aff334e6d2778608$export$b2b01faa10f64871(encoderState, this.doc);
        $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderState));
        // write queryAwareness
        const encoderAwarenessQuery = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderAwarenessQuery, $4d01f1203e5c8378$var$messageQueryAwareness);
        $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderAwarenessQuery));
        // broadcast local awareness state
        const encoderAwarenessState = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderAwarenessState, $4d01f1203e5c8378$var$messageAwareness);
        $7f295e825046a0c3$export$f7d11515275e88a2(encoderAwarenessState, $0b85c37db714c324$export$e194fa93ebd743e9(this.awareness, [
            this.doc.clientID
        ]));
        $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderAwarenessState));
    }
    disconnect() {
        // signal through all available signaling connections
        $4d01f1203e5c8378$var$signalingConns.forEach((conn)=>{
            if (conn.connected) conn.send({
                type: "unsubscribe",
                topics: [
                    this.name
                ]
            });
        });
        $0b85c37db714c324$export$3edbfe2f45ae9ff8(this.awareness, [
            this.doc.clientID
        ], "disconnect");
        // broadcast peerId removal via broadcastchannel
        const encoderPeerIdBc = $7f295e825046a0c3$export$4e76eeb6df88c889();
        $7f295e825046a0c3$export$872f48c75febcd2b(encoderPeerIdBc, $4d01f1203e5c8378$var$messageBcPeerId);
        $7f295e825046a0c3$export$826a1a6619653272(encoderPeerIdBc, 0) // remove peerId from other bc peers
        ;
        $7f295e825046a0c3$export$dde49cb52d5f1650(encoderPeerIdBc, this.peerId);
        $4d01f1203e5c8378$var$broadcastBcMessage(this, $7f295e825046a0c3$export$73470fd2221e6aef(encoderPeerIdBc));
        $264c0479ab4113a8$export$f500693cef883ffd(this.name, this._bcSubscriber);
        this.bcconnected = false;
        this.doc.off("update", this._docUpdateHandler);
        this.awareness.off("update", this._awarenessUpdateHandler);
        this.webrtcConns.forEach((conn)=>conn.destroy());
    }
    destroy() {
        this.disconnect();
        if (typeof window !== "undefined") window.removeEventListener("beforeunload", this._beforeUnloadHandler);
        else if (typeof $8422df313e23a2a7$exports !== "undefined") $8422df313e23a2a7$exports.off("exit", this._beforeUnloadHandler);
    }
}
/**
 * @param {Y.Doc} doc
 * @param {WebrtcProvider} provider
 * @param {string} name
 * @param {CryptoKey|null} key
 * @return {Room}
 */ const $4d01f1203e5c8378$var$openRoom = (doc, provider, name, key)=>{
    // there must only be one room
    if ($4d01f1203e5c8378$var$rooms.has(name)) throw $a12da43118d917e2$export$185802fd694ee1f5(`A Yjs Doc connected to room "${name}" already exists!`);
    const room = new $4d01f1203e5c8378$export$525628e68e798fb4(doc, provider, name, key);
    $4d01f1203e5c8378$var$rooms.set(name, /** @type {Room} */ room);
    return room;
};
/**
 * @param {SignalingConn} conn
 * @param {Room} room
 * @param {any} data
 */ const $4d01f1203e5c8378$var$publishSignalingMessage = (conn, room, data)=>{
    if (room.key) $923794c2749cc634$export$afc50bd9a9c5e54f(data, room.key).then((data)=>{
        conn.send({
            type: "publish",
            topic: room.name,
            data: $0b91950191e72a08$export$37cc283d8fbd3462(data)
        });
    });
    else conn.send({
        type: "publish",
        topic: room.name,
        data: data
    });
};
class $4d01f1203e5c8378$export$81d9ce43ae9572b4 extends $f1811bf482b3826c$export$4d57ced7551703ba {
    constructor(url){
        super(url);
        /**
     * @type {Set<WebrtcProvider>}
     */ this.providers = new Set();
        this.on("connect", ()=>{
            $4d01f1203e5c8378$var$log(`connected (${url})`);
            const topics = Array.from($4d01f1203e5c8378$var$rooms.keys());
            this.send({
                type: "subscribe",
                topics: topics
            });
            $4d01f1203e5c8378$var$rooms.forEach((room)=>$4d01f1203e5c8378$var$publishSignalingMessage(this, room, {
                    type: "announce",
                    from: room.peerId
                }));
        });
        this.on("message", (m)=>{
            switch(m.type){
                case "publish":
                    {
                        const roomName = m.topic;
                        const room = $4d01f1203e5c8378$var$rooms.get(roomName);
                        if (room == null || typeof roomName !== "string") return;
                        const execMessage = (data)=>{
                            const webrtcConns = room.webrtcConns;
                            const peerId = room.peerId;
                            if (data == null || data.from === peerId || data.to !== undefined && data.to !== peerId || room.bcConns.has(data.from)) // ignore messages that are not addressed to this conn, or from clients that are connected via broadcastchannel
                            return;
                            const emitPeerChange = webrtcConns.has(data.from) ? ()=>{} : ()=>room.provider.emit("peers", [
                                    {
                                        removed: [],
                                        added: [
                                            data.from
                                        ],
                                        webrtcPeers: Array.from(room.webrtcConns.keys()),
                                        bcPeers: Array.from(room.bcConns)
                                    }
                                ]);
                            switch(data.type){
                                case "announce":
                                    if (webrtcConns.size < room.provider.maxConns) {
                                        $b5584d8615cd2038$export$dccd489362a8619(webrtcConns, data.from, ()=>new $4d01f1203e5c8378$export$f2f79372b3181730(this, true, data.from, room));
                                        emitPeerChange();
                                    }
                                    break;
                                case "signal":
                                    if (data.to === peerId) {
                                        $b5584d8615cd2038$export$dccd489362a8619(webrtcConns, data.from, ()=>new $4d01f1203e5c8378$export$f2f79372b3181730(this, false, data.from, room)).peer.signal(data.signal);
                                        emitPeerChange();
                                    }
                                    break;
                            }
                        };
                        if (room.key) {
                            if (typeof m.data === "string") $923794c2749cc634$export$efb11b8913a3b629($0b91950191e72a08$export$c537b38001c583b7(m.data), room.key).then(execMessage);
                        } else execMessage(m.data);
                    }
            }
        });
        this.on("disconnect", ()=>$4d01f1203e5c8378$var$log(`disconnect (${url})`));
    }
}
class $4d01f1203e5c8378$export$17ea0273445cf4f6 extends (0, $63276599c498ea37$export$77cea355fa80b5f4) {
    /**
   * @param {string} roomName
   * @param {Y.Doc} doc
   * @param {ProviderOptions?} opts
   */ constructor(roomName, doc, { signaling: signaling = [
        "wss://y-webrtc-eu.fly.dev"
    ] , password: password = null , awareness: awareness = new $0b85c37db714c324$export$5bb40478b91fee65(doc) , maxConns: maxConns = 20 + $e8fac97060e7c35b$export$a3fe094919f356fd($562771b566a9e573$export$bb0a9c36cf454ea0() * 15) , filterBcConns: filterBcConns = true , peerOpts: peerOpts = {} // simple-peer options. See https://github.com/feross/simple-peer#peer--new-peeropts
      } = {}){
        super();
        this.roomName = roomName;
        this.doc = doc;
        this.filterBcConns = filterBcConns;
        /**
     * @type {awarenessProtocol.Awareness}
     */ this.awareness = awareness;
        this.shouldConnect = false;
        this.signalingUrls = signaling;
        this.signalingConns = [];
        this.maxConns = maxConns;
        this.peerOpts = peerOpts;
        /**
     * @type {PromiseLike<CryptoKey | null>}
     */ this.key = password ? $923794c2749cc634$export$87770b6b245073b5(password, roomName) : /** @type {PromiseLike<null>} */ $5719c92748a1df45$export$f7ad0328861e2f03(null);
        /**
     * @type {Room|null}
     */ this.room = null;
        this.key.then((key)=>{
            this.room = $4d01f1203e5c8378$var$openRoom(doc, this, roomName, key);
            if (this.shouldConnect) this.room.connect();
            else this.room.disconnect();
        });
        this.connect();
        this.destroy = this.destroy.bind(this);
        doc.on("destroy", this.destroy);
    }
    /**
   * @type {boolean}
   */ get connected() {
        return this.room !== null && this.shouldConnect;
    }
    connect() {
        this.shouldConnect = true;
        this.signalingUrls.forEach((url)=>{
            const signalingConn = $b5584d8615cd2038$export$dccd489362a8619($4d01f1203e5c8378$var$signalingConns, url, ()=>new $4d01f1203e5c8378$export$81d9ce43ae9572b4(url));
            this.signalingConns.push(signalingConn);
            signalingConn.providers.add(this);
        });
        if (this.room) this.room.connect();
    }
    disconnect() {
        this.shouldConnect = false;
        this.signalingConns.forEach((conn)=>{
            conn.providers.delete(this);
            if (conn.providers.size === 0) {
                conn.destroy();
                $4d01f1203e5c8378$var$signalingConns.delete(conn.url);
            }
        });
        if (this.room) this.room.disconnect();
    }
    destroy() {
        this.doc.off("destroy", this.destroy);
        // need to wait for key before deleting room
        this.key.then(()=>{
            /** @type {Room} */ this.room.destroy();
            $4d01f1203e5c8378$var$rooms.delete(this.roomName);
        });
        super.destroy();
    }
}




var $7Pt2h = parcelRequire("7Pt2h");
function $df7691265ce0ba97$export$43b4ce1c76a790d1(value) {
    const ref = (0, $7Pt2h.useRef)(value);
    (0, $7Pt2h.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}


/**
 * Yjs document.
 */ const $538c9eb2b35762df$var$doc = new $b296f782f3ab7bd5$export$bceacc74c2212615();
const $538c9eb2b35762df$export$841858b892ce1f4c = /*#__PURE__*/ (0, $7Pt2h.createContext)(null);
function $538c9eb2b35762df$export$2881499e37b75b9a({ roomId: roomId , children: children  }) {
    const [provider, setProvider] = (0, $7Pt2h.useState)();
    (0, $7Pt2h.useEffect)(()=>{
        if (!roomId) return;
        const provider = new (0, $4d01f1203e5c8378$export$17ea0273445cf4f6)(roomId, $538c9eb2b35762df$var$doc, {
            signaling: [
                "wss://signaling.crz.li"
            ]
        });
        setProvider(provider);
        return ()=>{
            provider.destroy();
        };
    }, [
        roomId
    ]);
    if (!provider) return null;
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)($538c9eb2b35762df$export$841858b892ce1f4c.Provider, {
        value: {
            doc: $538c9eb2b35762df$var$doc,
            provider: provider
        },
        children: children
    });
}
/**
 * Get Yjs context value.
 */ function $538c9eb2b35762df$var$useYjs() {
    const context = (0, $7Pt2h.useContext)($538c9eb2b35762df$export$841858b892ce1f4c);
    if (!context) throw new Error("Context has no value. Did you forget the provider?");
    return context;
}
function $538c9eb2b35762df$export$d669bac2eff79277() {
    const { provider: provider  } = $538c9eb2b35762df$var$useYjs();
    return String(provider.awareness.clientID);
}
/**
 * Get snapshot of given awareness state.
 */ function $538c9eb2b35762df$var$getAwarenessStateSnapshot(awareness) {
    const state = Object.fromEntries(awareness.getStates().entries());
    return state;
}
function $538c9eb2b35762df$export$a77e33fa6f2bba71() {
    const { provider: { awareness: awareness  }  } = $538c9eb2b35762df$var$useYjs();
    const [state, setState] = (0, $7Pt2h.useState)($538c9eb2b35762df$var$getAwarenessStateSnapshot(awareness));
    (0, $7Pt2h.useEffect)(()=>{
        const onChange = ()=>{
            setState($538c9eb2b35762df$var$getAwarenessStateSnapshot(awareness));
        };
        awareness.on("change", onChange);
        return ()=>{
            awareness.off("change", onChange);
        };
    }, [
        awareness
    ]);
    const setLocalState = (0, $7Pt2h.useCallback)((mixed)=>{
        if (typeof mixed === "function") awareness.setLocalState(mixed(awareness.getLocalState()));
        else awareness.setLocalState(mixed);
    }, [
        awareness
    ]);
    return {
        state: state,
        count: Object.keys(state).length,
        setLocalState: setLocalState
    };
}
/**
 * Get snapshot from a shared map.
 */ function $538c9eb2b35762df$var$getSharedMapSnapshot(map) {
    return map.toJSON();
}
function $538c9eb2b35762df$export$7043bb1ecc2aff71(name) {
    const { doc: doc  } = $538c9eb2b35762df$var$useYjs();
    const map = doc.getMap(name);
    const [snapshot, setSnapshot] = (0, $7Pt2h.useState)($538c9eb2b35762df$var$getSharedMapSnapshot(map));
    (0, $7Pt2h.useEffect)(()=>{
        const onChange = ()=>{
            setSnapshot($538c9eb2b35762df$var$getSharedMapSnapshot(map));
        };
        map.observe(onChange);
        return ()=>{
            map.unobserve(onChange);
        };
    }, [
        map
    ]);
    return snapshot;
}
function $538c9eb2b35762df$export$376a8b987431202c(name, defaultValue) {
    const { value: value = defaultValue  } = $538c9eb2b35762df$export$7043bb1ecc2aff71(name);
    return value;
}
function $538c9eb2b35762df$export$2eac60dffedc39a1(update) {
    const { doc: doc  } = $538c9eb2b35762df$var$useYjs();
    const updateRef = (0, $df7691265ce0ba97$export$43b4ce1c76a790d1)(update);
    return (0, $7Pt2h.useCallback)((...args)=>{
        doc.transact((transaction)=>updateRef.current(transaction, ...args));
    }, [
        doc,
        updateRef
    ]);
}


function $13953a1b10e0563f$export$7149c6ffc9994c32() {
    return (0, $adfe6d1e67b75ecb$export$c34778236461ea95)().toLocaleLowerCase();
}
var $13953a1b10e0563f$export$9b7f9b96dba63bd2;
(function(SharedState) {
    SharedState["Stage"] = "stage";
    SharedState["Hands"] = "hands";
})($13953a1b10e0563f$export$9b7f9b96dba63bd2 || ($13953a1b10e0563f$export$9b7f9b96dba63bd2 = {}));
function $13953a1b10e0563f$export$b33a393274d59d25() {
    const { stage: stage = "voting"  } = (0, $538c9eb2b35762df$export$7043bb1ecc2aff71)($13953a1b10e0563f$export$9b7f9b96dba63bd2.Stage);
    const hands = (0, $538c9eb2b35762df$export$7043bb1ecc2aff71)($13953a1b10e0563f$export$9b7f9b96dba63bd2.Hands);
    const clientId = (0, $538c9eb2b35762df$export$d669bac2eff79277)();
    const setStage = (0, $538c9eb2b35762df$export$2eac60dffedc39a1)(({ doc: doc  }, stage)=>{
        doc.getMap($13953a1b10e0563f$export$9b7f9b96dba63bd2.Stage).set("stage", stage);
        if (stage === "voting") doc.getMap($13953a1b10e0563f$export$9b7f9b96dba63bd2.Hands).forEach((hand, key)=>{
            if (hand !== "w") doc.getMap($13953a1b10e0563f$export$9b7f9b96dba63bd2.Hands).delete(key);
        });
    });
    const setHand = (0, $538c9eb2b35762df$export$2eac60dffedc39a1)(({ doc: doc  }, hand)=>{
        if (hand === undefined) doc.getMap($13953a1b10e0563f$export$9b7f9b96dba63bd2.Hands).delete(clientId);
        else doc.getMap($13953a1b10e0563f$export$9b7f9b96dba63bd2.Hands).set(clientId, hand);
    });
    return {
        stage: stage,
        hands: hands,
        setStage: setStage,
        setHand: setHand
    };
}
function $13953a1b10e0563f$export$97d7b0fb39788ac() {
    const clientId = (0, $538c9eb2b35762df$export$d669bac2eff79277)();
    const { count: count , state: state , setLocalState: setLocalState  } = (0, $538c9eb2b35762df$export$a77e33fa6f2bba71)();
    const setName = (0, $7Pt2h.useCallback)((name)=>{
        setLocalState((state)=>({
                ...state,
                name: name
            }));
    }, [
        setLocalState
    ]);
    return {
        clientId: clientId,
        count: count,
        players: Object.fromEntries(Object.keys(state).map((key)=>[
                key,
                state[key] ?? {}
            ])),
        setName: setName
    };
}


function $de2d3e0d12f3fc2f$var$Profile() {
    const [editing, setEditing] = (0, $7Pt2h.useState)(false);
    const { clientId: clientId , players: players , setName: setName  } = (0, $13953a1b10e0563f$export$97d7b0fb39788ac)();
    const { name: name = ""  } = players[clientId] ?? {};
    const handleSubmit = (e)=>{
        e.preventDefault();
        const inputs = e.currentTarget.elements;
        setName(inputs.name.value);
        setEditing(false);
    };
    const handleCancel = ()=>{
        setEditing(false);
    };
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "Escape":
                handleCancel();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    const handleFocus = (e)=>{
        e.currentTarget.select();
    };
    if (editing) return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        as: "form",
        gap: ".5rem",
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("input", {
            type: "text",
            name: "name",
            defaultValue: name,
            placeholder: "Anonymous",
            "aria-label": "Your name",
            onKeyDown: handleKeyDown,
            onBlur: handleCancel,
            onFocus: handleFocus,
            autoComplete: "off",
            maxLength: 24,
            style: {
                fontWeight: "bolder",
                textAlign: "right"
            },
            required: true,
            autoFocus: true
        })
    });
    const handleEdit = ()=>{
        setEditing(true);
    };
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("button", {
        onClick: handleEdit,
        title: "Edit profile",
        "aria-label": "Edit profile",
        style: {
            cursor: "pointer",
            fontWeight: "bolder"
        },
        children: name
    });
}
function $de2d3e0d12f3fc2f$export$c84671f46d6a1ca({ children: children  }) {
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)("div", {
        className: $7d9ea64bceb18642$export$b3219800bda33a1f,
        children: [
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
                as: "header",
                justify: "space-between",
                className: $7d9ea64bceb18642$export$42c68d6252221cac,
                children: [
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("a", {
                            href: "/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)("svg", {
                                viewBox: "0 0 188 25",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-label": "Planning poker",
                                children: [
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M9.816 14.18V5.77998H6.216V14.18H9.816ZM9.192 19.34H0V18.428H1.056V5.01198H0V4.09998H8.448C10.096 4.09998 11.104 4.15598 11.472 4.26798C11.856 4.37998 12.224 4.49998 12.576 4.62798C12.928 4.75598 13.2 4.92398 13.392 5.13198C13.6 5.32398 13.816 5.57198 14.04 5.87598C14.28 6.16398 14.456 6.49998 14.568 6.88398C14.68 7.26798 14.776 7.72398 14.856 8.25198C14.936 8.76398 14.976 9.33998 14.976 9.97998C14.976 10.62 14.936 11.204 14.856 11.732C14.776 12.26 14.672 12.724 14.544 13.124C14.432 13.508 14.256 13.852 14.016 14.156C13.792 14.444 13.576 14.692 13.368 14.9C13.176 15.092 12.904 15.252 12.552 15.38C12.2 15.508 11.896 15.612 11.64 15.692C11.4 15.756 11.056 15.804 10.608 15.836C9.936 15.884 9.192 15.908 8.376 15.908H6.216V18.428H9.192V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M16.4147 1.84398H21.9347V18.428H22.8947V19.34H16.4147V18.428H17.3747V2.75598H16.4147V1.84398Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M26.0739 10.244L25.4979 6.49998C27.3059 6.01998 29.1219 5.77998 30.9459 5.77998C33.0099 5.77998 34.5059 6.09198 35.4339 6.71598C35.8179 6.95598 36.1379 7.30798 36.3939 7.77198C36.6499 8.21998 36.7779 8.75598 36.7779 9.37998V18.428H37.7379V19.34H34.7859L33.8259 17.516H33.5139C33.1939 18.444 32.8019 19.044 32.3379 19.316C31.8739 19.572 31.2259 19.7 30.3939 19.7C29.5779 19.7 29.0259 19.692 28.7379 19.676C28.4499 19.66 28.0579 19.62 27.5619 19.556C27.0659 19.492 26.6819 19.38 26.4099 19.22C26.1379 19.044 25.8499 18.812 25.5459 18.524C24.9859 17.996 24.7059 17.068 24.7059 15.74C24.7059 14.076 25.2259 12.972 26.2659 12.428C26.7779 12.172 27.2979 12.004 27.8259 11.924C28.3699 11.828 29.0259 11.78 29.7939 11.78H32.2179V7.57998H29.4819L28.8339 10.244H26.0739ZM32.2179 17.516V13.58H28.9299V17.516H32.2179Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M54.3499 19.34H48.8299V7.96398H45.3019V19.34H39.7819V18.428H40.7419V7.05198H39.7819V6.13998H42.9739L43.8139 7.96398H44.1259C44.4619 7.06798 44.9659 6.48398 45.6379 6.21198C46.3259 5.92398 47.3899 5.77998 48.8299 5.77998C50.2699 5.77998 51.3899 6.05198 52.1899 6.59598C52.9899 7.12398 53.3899 8.05198 53.3899 9.37998V18.428H54.3499V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M70.9671 19.34H65.4471V7.96398H61.9191V19.34H56.3991V18.428H57.3591V7.05198H56.3991V6.13998H59.5911L60.4311 7.96398H60.7431C61.0791 7.06798 61.5831 6.48398 62.2551 6.21198C62.9431 5.92398 64.0071 5.77998 65.4471 5.77998C66.8871 5.77998 68.0071 6.05198 68.8071 6.59598C69.6071 7.12398 70.0071 8.05198 70.0071 9.37998V18.428H70.9671V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M79.4963 19.34H73.0163V18.428H73.9762V7.05198H73.0163V6.13998H78.5362V18.428H79.4963V19.34ZM78.3203 1.31598C78.6083 1.53998 78.7523 2.09198 78.7523 2.97198C78.7523 3.85198 78.6083 4.40398 78.3203 4.62798C78.0323 4.85198 77.3603 4.96398 76.3043 4.96398C75.2483 4.96398 74.5522 4.85198 74.2162 4.62798C73.8962 4.40398 73.7363 3.85198 73.7363 2.97198C73.7363 2.09198 73.8962 1.53998 74.2162 1.31598C74.5522 1.09198 75.2483 0.97998 76.3043 0.97998C77.3603 0.97998 78.0323 1.09198 78.3203 1.31598Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M96.1155 19.34H90.5955V7.96398H87.0675V19.34H81.5475V18.428H82.5075V7.05198H81.5475V6.13998H84.7395L85.5795 7.96398H85.8915C86.2275 7.06798 86.7315 6.48398 87.4035 6.21198C88.0915 5.92398 89.1555 5.77998 90.5955 5.77998C92.0355 5.77998 93.1555 6.05198 93.9555 6.59598C94.7555 7.12398 95.1555 8.05198 95.1555 9.37998V18.428H96.1155V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M98.5967 23.228C98.1647 22.908 97.8847 22.532 97.7567 22.1C97.6287 21.684 97.5647 21.004 97.5647 20.06C97.5647 19.132 97.7647 18.42 98.1647 17.924C98.5647 17.412 99.0047 17.156 99.4847 17.156H101.285V16.844C100.469 16.684 100.061 16.18 100.061 15.332V13.844C98.6687 13.38 97.9727 12.284 97.9727 10.556V10.052C97.9727 8.62798 98.2287 7.62798 98.7407 7.05198C98.9327 6.82798 99.1087 6.65198 99.2687 6.52398C99.4287 6.37998 99.6527 6.25998 99.9407 6.16398C100.245 6.06798 100.493 5.99598 100.685 5.94798C100.893 5.89998 101.181 5.85998 101.549 5.82798C101.917 5.79598 102.205 5.77998 102.413 5.77998H103.373C104.477 5.77998 105.285 5.91598 105.797 6.18798C106.325 6.45998 106.589 6.97198 106.589 7.72398H106.901L107.141 6.73998C107.317 6.01998 107.533 5.53998 107.789 5.29998C108.045 5.05998 108.517 4.93998 109.205 4.93998H110.261V7.07598H109.997C109.693 7.07598 109.541 7.29998 109.541 7.74798V10.556C109.541 11.452 109.325 12.22 108.893 12.86C108.637 13.276 108.077 13.628 107.213 13.916C106.669 14.092 105.421 14.18 103.469 14.18H102.605V14.756C102.605 15.252 102.661 15.604 102.773 15.812C102.885 16.004 103.101 16.1 103.421 16.1H106.997C107.813 16.1 108.549 16.388 109.205 16.964C109.877 17.524 110.213 18.46 110.213 19.772C110.213 21.436 109.773 22.556 108.893 23.132C108.013 23.724 106.285 24.02 103.709 24.02C102.333 24.02 101.245 23.964 100.445 23.852C99.6447 23.756 99.0287 23.548 98.5967 23.228ZM105.413 12.212V7.72398H102.125V12.212H105.413ZM106.757 19.1H100.949V21.62H106.757V19.1Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M127.988 14.18V5.77998H124.388V14.18H127.988ZM127.364 19.34H118.172V18.428H119.228V5.01198H118.172V4.09998H126.62C128.268 4.09998 129.276 4.15598 129.644 4.26798C130.028 4.37998 130.396 4.49998 130.748 4.62798C131.1 4.75598 131.372 4.92398 131.564 5.13198C131.772 5.32398 131.988 5.57198 132.212 5.87598C132.452 6.16398 132.628 6.49998 132.74 6.88398C132.852 7.26798 132.948 7.72398 133.028 8.25198C133.108 8.76398 133.148 9.33998 133.148 9.97998C133.148 10.62 133.108 11.204 133.028 11.732C132.948 12.26 132.844 12.724 132.716 13.124C132.604 13.508 132.428 13.852 132.188 14.156C131.964 14.444 131.748 14.692 131.54 14.9C131.348 15.092 131.076 15.252 130.724 15.38C130.372 15.508 130.068 15.612 129.812 15.692C129.572 15.756 129.228 15.804 128.78 15.836C128.108 15.884 127.364 15.908 126.548 15.908H124.388V18.428H127.364V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M147.595 11.804V13.676C147.595 15.692 147.275 17.108 146.635 17.924C146.395 18.228 146.179 18.476 145.987 18.668C145.795 18.86 145.515 19.028 145.147 19.172C144.779 19.3 144.475 19.396 144.235 19.46C143.995 19.54 143.651 19.596 143.203 19.628C141.715 19.74 140.523 19.756 139.627 19.676C138.747 19.612 138.195 19.54 137.971 19.46C137.747 19.396 137.467 19.3 137.131 19.172C136.811 19.028 136.563 18.86 136.387 18.668C136.211 18.476 136.011 18.228 135.787 17.924C135.579 17.62 135.427 17.268 135.331 16.868C135.075 15.908 134.947 14.844 134.947 13.676V11.804C134.947 9.78798 135.267 8.37198 135.907 7.55598C136.147 7.25198 136.363 7.00398 136.555 6.81198C136.747 6.61998 137.027 6.45998 137.395 6.33198C137.763 6.18798 138.067 6.08398 138.307 6.01998C138.547 5.93998 138.899 5.88398 139.363 5.85198C140.035 5.80398 140.691 5.77998 141.331 5.77998C141.971 5.77998 142.403 5.78798 142.627 5.80398C142.867 5.80398 143.195 5.81998 143.611 5.85198C144.027 5.88398 144.347 5.93998 144.571 6.01998C144.795 6.08398 145.067 6.18798 145.387 6.33198C145.723 6.45998 145.979 6.61998 146.155 6.81198C146.331 7.00398 146.523 7.25198 146.731 7.55598C146.955 7.85998 147.123 8.21198 147.235 8.61198C147.475 9.57198 147.595 10.636 147.595 11.804ZM143.035 17.9V7.57998H139.507V17.9H143.035Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M155.526 19.34H150.006V18.428H150.966V2.75598H150.006V1.84398H156.174V5.41998L155.718 5.58798C155.446 5.68398 155.27 5.77998 155.19 5.87598C155.126 5.95598 155.094 6.09998 155.094 6.30798V10.724H155.526C156.054 8.93198 156.638 7.68398 157.278 6.97998C157.918 6.27598 158.774 5.92398 159.846 5.92398C160.918 5.92398 161.75 5.98798 162.342 6.11598L161.862 9.88398H158.934V11.156C158.934 11.348 158.974 11.492 159.054 11.588C159.166 11.716 159.366 11.78 159.654 11.78H161.694L163.278 18.428H164.214V19.34H158.43L157.278 12.908H155.526V19.34Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M170.444 7.57998V11.9H173.732V7.57998H170.444ZM170.444 17.9H173.444L174.068 15.236H176.636L177.188 18.98C175.3 19.46 173.5 19.7 171.788 19.7C171.132 19.7 170.572 19.676 170.108 19.628C169.644 19.596 169.124 19.492 168.548 19.316C167.972 19.124 167.508 18.868 167.156 18.548C166.804 18.212 166.5 17.74 166.244 17.132C166.004 16.508 165.884 15.772 165.884 14.924V11.804C165.884 9.80398 166.204 8.38798 166.844 7.55598C167.068 7.25198 167.276 7.00398 167.468 6.81198C167.676 6.61998 167.956 6.45998 168.308 6.33198C168.66 6.18798 168.956 6.08398 169.196 6.01998C169.436 5.93998 169.78 5.88398 170.228 5.85198C170.9 5.80398 171.556 5.77998 172.196 5.77998C172.836 5.77998 173.284 5.78798 173.54 5.80398C173.796 5.80398 174.14 5.82798 174.572 5.87598C175.004 5.92398 175.324 5.99598 175.532 6.09198C175.756 6.18798 176.012 6.33198 176.3 6.52398C176.604 6.71598 176.82 6.94798 176.948 7.21998C177.092 7.49198 177.212 7.84398 177.308 8.27598C177.42 8.69198 177.476 9.17998 177.476 9.73998C177.476 10.3 177.42 10.796 177.308 11.228C177.212 11.644 177.092 11.988 176.948 12.26C176.82 12.532 176.604 12.764 176.3 12.956C176.012 13.148 175.756 13.292 175.532 13.388C175.324 13.484 175.004 13.556 174.572 13.604C173.996 13.668 173.268 13.7 172.388 13.7H170.444V17.9Z"
                                    }),
                                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
                                        d: "M179.751 6.13998H182.655L183.135 7.96398H183.327C183.599 7.16398 183.951 6.60398 184.383 6.28398C184.831 5.94798 185.343 5.77998 185.919 5.77998C186.495 5.77998 187.055 5.82798 187.599 5.92398L187.095 9.88398H183.687V11.156C183.687 11.348 183.727 11.492 183.807 11.588C183.919 11.716 184.119 11.78 184.407 11.78H185.271V18.428H187.215V19.34H179.751V18.428H180.711V7.05198H179.751V6.13998Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)($de2d3e0d12f3fc2f$var$Profile, {})
                ]
            }),
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("main", {
                className: $7d9ea64bceb18642$export$f22da7240b7add18,
                children: children
            }),
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
                as: "footer",
                justify: "center",
                className: $7d9ea64bceb18642$export$adb608be33961c98,
                children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)("p", {
                    children: [
                        "Made by",
                        " ",
                        /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("a", {
                            href: "https://twitter.com/haggen",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "me"
                        }),
                        ". Source and feedback on",
                        " ",
                        /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("a", {
                            href: "https://github.com/haggen/planningpoker",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "GitHub"
                        }),
                        "."
                    ]
                })
            })
        ]
    });
}



// import * as classes from "./style.module.css";


var $7Pt2h = parcelRequire("7Pt2h");


var $7Pt2h = parcelRequire("7Pt2h");
var $792dc4e5a8ead846$exports = {};

$parcel$defineInteropFlag($792dc4e5a8ead846$exports);

$parcel$export($792dc4e5a8ead846$exports, "button", () => $792dc4e5a8ead846$export$2ba01fb71ed41cb6, (v) => $792dc4e5a8ead846$export$2ba01fb71ed41cb6 = v);
$parcel$export($792dc4e5a8ead846$exports, "default", () => $792dc4e5a8ead846$export$2e2bcd8739ae039, (v) => $792dc4e5a8ead846$export$2e2bcd8739ae039 = v);
$parcel$export($792dc4e5a8ead846$exports, "hollow", () => $792dc4e5a8ead846$export$9e73077d7bacc506, (v) => $792dc4e5a8ead846$export$9e73077d7bacc506 = v);
var $792dc4e5a8ead846$export$2ba01fb71ed41cb6;
var $792dc4e5a8ead846$export$2e2bcd8739ae039;
var $792dc4e5a8ead846$export$9e73077d7bacc506;
$792dc4e5a8ead846$export$2ba01fb71ed41cb6 = `RsMs9W_button`;
$792dc4e5a8ead846$export$2e2bcd8739ae039 = `RsMs9W_default`;
$792dc4e5a8ead846$export$9e73077d7bacc506 = `RsMs9W_hollow`;



function $a3e1c50526e090ff$var$Button({ as: as , variant: variant = "default" , ...props }, ref) {
    const Component = as ?? "button";
    const classList = new (0, $aeb56eb7cfd854c1$export$3ec9c6f9cd353016)();
    classList.add($792dc4e5a8ead846$exports.button);
    classList.add($792dc4e5a8ead846$exports[variant]);
    props.type ??= "button";
    props.className ??= classList.toString();
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)(Component, {
        ref: ref,
        ...props
    });
}
// Fix the type of the forwarded component.
const $a3e1c50526e090ff$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $7Pt2h.forwardRef)($a3e1c50526e090ff$var$Button);




var $ff8ca86136440862$export$aa3e815946b80764;
var $ff8ca86136440862$export$d90250155de6d7e7;
$ff8ca86136440862$export$aa3e815946b80764 = `iFw43G_card`;
$ff8ca86136440862$export$d90250155de6d7e7 = `iFw43G_selected`;




var $f3f69f2c3420c125$export$cce012181fa841df;
$f3f69f2c3420c125$export$cce012181fa841df = `_9-NHQq_face`;



var $789ed1c76dd99083$export$1ca1ec8b29a4ce27;
$789ed1c76dd99083$export$1ca1ec8b29a4ce27 = `vtsT4W_icon`;



parcelRequire("7Pt2h");
const $35a828930246f8b4$var$SvgApproximate = (props)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
            d: "M22.412 19.544c.1.374.273.772.52 1.193.247.374.643.561 1.188.561.395 0 .89-.21 1.484-.631l8.81-6.134a1 1 0 0 1 1.35.194l1.576 1.961a1 1 0 0 1-.193 1.437l-8.277 5.98c-.693.515-1.435.96-2.227 1.334-.742.374-1.682.561-2.82.561-1.93 0-3.316-.468-4.157-1.404-.841-.982-1.534-2.292-2.078-3.93a4.547 4.547 0 0 0-.52-1.262c-.198-.468-.594-.702-1.188-.702-.445 0-1.014.257-1.707.772l-8.586 5.991a1 1 0 0 1-1.352-.193l-1.575-1.96a1 1 0 0 1 .193-1.437l8.277-5.98a10.416 10.416 0 0 1 2.3-1.334c.793-.374 1.708-.561 2.747-.561 1.88 0 3.242.515 4.083 1.544.89.982 1.608 2.316 2.152 4Z"
        })
    });
var $35a828930246f8b4$export$2e2bcd8739ae039 = $35a828930246f8b4$var$SvgApproximate;



parcelRequire("7Pt2h");
const $fe2b8a7e30d6c828$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
            d: "M19.047 26.547a2.193 2.193 0 0 1-3.094 0l-5-5a2.193 2.193 0 0 1 0-3.094 2.193 2.193 0 0 1 3.094 0l3.453 3.453 8.453-8.453a2.193 2.193 0 0 1 3.094 0 2.193 2.193 0 0 1 0 3.094l-10 10ZM40 20c0 11.047-8.953 20-20 20S0 31.047 0 20 8.953 0 20 0s20 8.953 20 20ZM20 3.75C11.023 3.75 3.75 11.023 3.75 20S11.023 36.25 20 36.25 36.25 28.977 36.25 20 28.977 3.75 20 3.75Z"
        })
    });
var $fe2b8a7e30d6c828$export$2e2bcd8739ae039 = $fe2b8a7e30d6c828$var$SvgCheck;



parcelRequire("7Pt2h");
const $e440d46a30dbd46a$var$SvgEye = (props)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
            d: "M19.418 13.37a6.629 6.629 0 0 1 7.25 6.639A6.669 6.669 0 0 1 20 26.675a6.629 6.629 0 0 1-6.64-7.25c.647.313 1.397.584 2.195.584A4.449 4.449 0 0 0 20 15.564c0-.798-.271-1.548-.584-2.194Zm13.958-3.32c3.25 3.014 5.424 6.563 6.452 9.104.23.55.23 1.16 0 1.709-1.028 2.479-3.201 6.028-6.452 9.104-3.27 3.042-7.764 5.597-13.375 5.597-5.612 0-10.105-2.555-13.374-5.597-3.25-3.076-5.423-6.625-6.456-9.104a2.22 2.22 0 0 1 0-1.709c1.033-2.541 3.206-6.09 6.456-9.104C9.897 7.011 14.39 4.453 20 4.453c5.611 0 10.104 2.558 13.375 5.597Zm-13.375-.041c-5.521 0-10 4.479-10 10 0 5.52 4.479 10 10 10 5.52 0 10-4.48 10-10 0-5.521-4.48-10-10-10Z"
        })
    });
var $e440d46a30dbd46a$export$2e2bcd8739ae039 = $e440d46a30dbd46a$var$SvgEye;



parcelRequire("7Pt2h");
const $5df7f69d3d67821b$var$SvgThinking = (props)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("path", {
            d: "M11.875 20A4.376 4.376 0 0 1 7.5 24.375 4.376 4.376 0 0 1 3.125 20 4.376 4.376 0 0 1 7.5 15.625 4.376 4.376 0 0 1 11.875 20Zm12.5 0A4.378 4.378 0 0 1 20 24.375 4.378 4.378 0 0 1 15.625 20 4.378 4.378 0 0 1 20 15.625 4.378 4.378 0 0 1 24.375 20Zm3.75 0a4.378 4.378 0 0 1 4.375-4.375A4.378 4.378 0 0 1 36.875 20a4.378 4.378 0 0 1-4.375 4.375A4.378 4.378 0 0 1 28.125 20Z"
        })
    });
var $5df7f69d3d67821b$export$2e2bcd8739ae039 = $5df7f69d3d67821b$var$SvgThinking;



function $1b69cb80ff935db0$export$f04a61298a47a40f({ variant: variant , ...props }) {
    const classList = new (0, $aeb56eb7cfd854c1$export$3ec9c6f9cd353016)($789ed1c76dd99083$export$1ca1ec8b29a4ce27);
    if (props.className) classList.add(props.className);
    props.className = classList.toString();
    switch(variant){
        case "approximate":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $35a828930246f8b4$export$2e2bcd8739ae039), {
                ...props
            });
        case "check":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $fe2b8a7e30d6c828$export$2e2bcd8739ae039), {
                ...props
            });
        case "eye":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $e440d46a30dbd46a$export$2e2bcd8739ae039), {
                ...props
            });
        case "thinking":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $5df7f69d3d67821b$export$2e2bcd8739ae039), {
                ...props
            });
        default:
            return null;
    }
}


function $153baba59a97a3b6$var$getContent(value) {
    switch(value){
        case "?":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $0f1d8188a7c97c70$exports.Fragment), {
                children: "?"
            });
        case "w":
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $1b69cb80ff935db0$export$f04a61298a47a40f), {
                variant: "eye",
                "aria-label": "Spectator"
            });
        case 0.5:
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $0f1d8188a7c97c70$exports.Fragment), {
                children: "\xbd"
            });
        case undefined:
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $0f1d8188a7c97c70$exports.Fragment), {
                children: "-"
            });
        default:
            return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $0f1d8188a7c97c70$exports.Fragment), {
                children: value
            });
    }
}
function $153baba59a97a3b6$export$aa6504bc3c7c25a1(props) {
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("span", {
        className: $f3f69f2c3420c125$export$cce012181fa841df,
        children: "value" in props ? $153baba59a97a3b6$var$getContent(props.value) : props.children
    });
}


function $2079168dd3f16116$export$60332b2344f7fe41({ value: value , selected: selected = false , onSelect: onSelect  }) {
    const handleClick = ()=>{
        onSelect?.(selected ? undefined : value);
    };
    const classList = new (0, $aeb56eb7cfd854c1$export$3ec9c6f9cd353016)($ff8ca86136440862$export$aa3e815946b80764);
    if (selected) classList.add($ff8ca86136440862$export$d90250155de6d7e7);
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("button", {
        onClick: handleClick,
        disabled: !onSelect,
        className: classList.toString(),
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $153baba59a97a3b6$export$aa6504bc3c7c25a1), {
            value: value
        })
    });
}



const $b2873df953a0bed2$var$deck = [
    0.5,
    1,
    2,
    3,
    5,
    8,
    13,
    21,
    34,
    55,
    "?",
    "w"
];
function $b2873df953a0bed2$export$9b013bad9d0245d0({ hand: hand , onSelect: onSelect  }) {
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        as: "menu",
        gap: ".5rem",
        justify: "center",
        children: $b2873df953a0bed2$var$deck.map((value)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $2079168dd3f16116$export$60332b2344f7fe41), {
                    value: value,
                    selected: hand === value,
                    onSelect: onSelect
                })
            }, value))
    });
}




var $f293b65d8828068e$export$cc6710ee5f037d57;
var $f293b65d8828068e$export$e55b6242cf16bbb8;
$f293b65d8828068e$export$cc6710ee5f037d57 = `eXhapG_average`;
$f293b65d8828068e$export$e55b6242cf16bbb8 = `eXhapG_score`;





function $3a4dc66ac6786290$export$6735cf84ecd2736({ hands: hands  }) {
    const score = Object.values(hands).reduce((score, hand)=>{
        if (typeof hand === "number") score.set(hand, (score.get(hand) ?? 0) + 1);
        return score;
    }, new Map());
    const average = Array.from(score.entries()).reduce(([sum, total], [value, amount])=>{
        return [
            sum + value * amount,
            total + amount
        ];
    }, [
        0,
        0
    ]);
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        gap: "1.5rem",
        className: $f293b65d8828068e$export$e55b6242cf16bbb8,
        children: [
            Array.from(score.keys()).map((hand)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
                    gap: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $2079168dd3f16116$export$60332b2344f7fe41), {
                            value: hand
                        }),
                        "\xd7",
                        score.get(hand)
                    ]
                }, hand)),
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
                gap: "0.5rem",
                className: $f293b65d8828068e$export$cc6710ee5f037d57,
                children: [
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $1b69cb80ff935db0$export$f04a61298a47a40f), {
                        variant: "approximate"
                    }),
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("output", {
                        children: (average[0] / average[1]).toFixed(2)
                    })
                ]
            })
        ]
    });
}


// import * as classes from "./style.module.css";



var $18db51ee5f607ec6$export$a1e9ea939af011fa;
var $18db51ee5f607ec6$export$615455393ee443ca;
$18db51ee5f607ec6$export$a1e9ea939af011fa = `_2cX8Ya_faded`;
$18db51ee5f607ec6$export$615455393ee443ca = `_2cX8Ya_player`;






function $433a21afd1eb09e5$var$Hand({ hand: hand , covered: covered  }) {
    if (hand === "w") return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $153baba59a97a3b6$export$aa6504bc3c7c25a1), {
        value: "w"
    });
    if (covered) {
        if (hand) return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $153baba59a97a3b6$export$aa6504bc3c7c25a1), {
            children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $1b69cb80ff935db0$export$f04a61298a47a40f), {
                variant: "check"
            })
        });
        return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $153baba59a97a3b6$export$aa6504bc3c7c25a1), {
            children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $1b69cb80ff935db0$export$f04a61298a47a40f), {
                variant: "thinking"
            })
        });
    }
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $153baba59a97a3b6$export$aa6504bc3c7c25a1), {
        value: hand
    });
}
function $433a21afd1eb09e5$export$2616165974278734({ name: name , hand: hand , covered: covered  }) {
    const classList = new (0, $aeb56eb7cfd854c1$export$3ec9c6f9cd353016)($18db51ee5f607ec6$export$615455393ee443ca);
    if (hand === "w") classList.add($18db51ee5f607ec6$export$a1e9ea939af011fa);
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        as: "figure",
        gap: "0.5rem",
        align: "center",
        direction: "column",
        className: classList.toString(),
        children: [
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)($433a21afd1eb09e5$var$Hand, {
                hand: hand,
                covered: covered
            }),
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("figcaption", {
                children: name
            })
        ]
    });
}


/**
 * Get table width. 7.5 = 6rem + 1.5rem gap.
 */ function $32dba03a67662854$var$getWidth(count) {
    if (count < 5) return `${count * 7.5 - 1.5}rem`;
    return `${Math.ceil(count / 2) * 7.5 - 1.5}rem`;
}
function $32dba03a67662854$export$54ec01a60f47d33d({ clients: clients , hands: hands , stage: stage  }) {
    const width = $32dba03a67662854$var$getWidth(Object.keys(clients).length);
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        gap: "1.5rem",
        justify: "center",
        wrap: "wrap",
        style: {
            width: width
        },
        children: Object.keys(clients).map((key)=>/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $433a21afd1eb09e5$export$2616165974278734), {
                name: clients[key].name,
                hand: hands[key],
                covered: stage === "voting"
            }, key))
    });
}



const $3fa66c857ff493ef$var$profileKey = "profile";
const $3fa66c857ff493ef$var$handKey = "hand";
function $3fa66c857ff493ef$var$getStoredValue(key, defaultValue) {
    const stored = localStorage.getItem(key);
    if (stored) return JSON.parse(stored);
    return defaultValue ?? null;
}
function $3fa66c857ff493ef$var$setStoredValue(key, value) {
    if (value !== undefined) localStorage.setItem(key, JSON.stringify(value));
}
function $3fa66c857ff493ef$export$985739bfa5723e08() {
    const { stage: stage , hands: hands , setStage: setStage , setHand: setHand  } = (0, $13953a1b10e0563f$export$b33a393274d59d25)();
    const { clientId: clientId , players: state , setName: setName  } = (0, $13953a1b10e0563f$export$97d7b0fb39788ac)();
    (0, $7Pt2h.useEffect)(()=>{
        if (state[clientId]?.name) {
            $3fa66c857ff493ef$var$setStoredValue($3fa66c857ff493ef$var$profileKey, state[clientId]);
            $3fa66c857ff493ef$var$setStoredValue($3fa66c857ff493ef$var$handKey, hands[clientId]);
            return;
        }
        const profile = $3fa66c857ff493ef$var$getStoredValue($3fa66c857ff493ef$var$profileKey, {
            name: clientId
        });
        setName(profile.name);
        // Remmeber last watchers.
        const hand = $3fa66c857ff493ef$var$getStoredValue($3fa66c857ff493ef$var$handKey);
        if (hand === "w") setHand(hand);
    }, [
        clientId,
        hands,
        setHand,
        setName,
        state
    ]);
    const handleSelect = (value)=>{
        setHand(value);
    };
    const handleStageChange = ()=>{
        if (stage === "voting") setStage("reveal");
        else setStage("voting");
    };
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
        direction: "column",
        align: "center",
        gap: "3rem",
        children: [
            /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsxs)((0, $650ff5719fa0105d$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                justify: "center",
                gap: "3rem",
                style: {
                    flex: "1 0 auto"
                },
                children: [
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $32dba03a67662854$export$54ec01a60f47d33d), {
                        clients: state,
                        hands: hands,
                        stage: stage
                    }),
                    /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)("div", {
                        children: stage === "voting" ? /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $a3e1c50526e090ff$export$353f5b6fc5456de1), {
                            onClick: handleStageChange,
                            children: "Reveal"
                        }) : /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $a3e1c50526e090ff$export$353f5b6fc5456de1), {
                            variant: "hollow",
                            onClick: handleStageChange,
                            children: "Restart"
                        })
                    })
                ]
            }),
            stage === "voting" ? /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $b2873df953a0bed2$export$9b013bad9d0245d0), {
                hand: hands[clientId],
                onSelect: handleSelect
            }) : /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $3a4dc66ac6786290$export$6735cf84ecd2736), {
                hands: hands
            })
        ]
    });
}



function $9c20d2527a8274b5$export$86fbec116b87613f() {
    const [, setLocation] = (0, $6f835274ba21d132$export$45d76561a5302f2b)();
    const [match, params] = (0, $6f835274ba21d132$export$3f79f0b98112cf57)("/:gameId");
    if (!match) setLocation(`/${(0, $13953a1b10e0563f$export$7149c6ffc9994c32)()}`, {
        replace: true
    });
    if (!params) return null;
    return /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $538c9eb2b35762df$export$2881499e37b75b9a), {
        roomId: params.gameId,
        children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $de2d3e0d12f3fc2f$export$c84671f46d6a1ca), {
            children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $3fa66c857ff493ef$export$985739bfa5723e08), {})
        })
    });
}


const $c9117c04cf6c81a4$var$element = document.getElementById("root");
if ($c9117c04cf6c81a4$var$element === null) throw new Error("Root element wasn't found");
const $c9117c04cf6c81a4$var$root = (0, $552e0568a1d67e84$export$882461b6382ed46c)($c9117c04cf6c81a4$var$element);
$c9117c04cf6c81a4$var$root.render(/*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $7Pt2h.StrictMode), {
    children: /*#__PURE__*/ (0, $0f1d8188a7c97c70$exports.jsx)((0, $9c20d2527a8274b5$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.59d3f629.js.map
